// Copyright (c) 2020 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

export default {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      properties: {OBJECTID: 1, ZIP_CODE: 94107, ID: 94107},
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-122.401159718585049, 37.782024266952142],
            [-122.400374366843309, 37.782644515545172],
            [-122.400019020063766, 37.782925153640136],
            [-122.399891477967842, 37.783025880124256],
            [-122.398930331092998, 37.783784933304034],
            [-122.397811613142864, 37.784666586003652],
            [-122.396705177550587, 37.785542130425938],
            [-122.395895701657864, 37.784896929203114],
            [-122.395160622349934, 37.78431101230386],
            [-122.394398389309941, 37.783701667981575],
            [-122.39343711789931, 37.784459123881106],
            [-122.39286959393705, 37.78478280203197],
            [-122.39285700396303, 37.784773072758867],
            [-122.392216553530702, 37.784278123341721],
            [-122.392215026316663, 37.784279352365694],
            [-122.392118766536498, 37.784205306785267],
            [-122.392032919786118, 37.784168354830349],
            [-122.391600764141245, 37.783823989838545],
            [-122.391599105853345, 37.783822668268179],
            [-122.390856721023212, 37.784410569188324],
            [-122.389846392025618, 37.783609176617361],
            [-122.389843136047602, 37.783611740842574],
            [-122.388306939892615, 37.782385221520776],
            [-122.388304301898813, 37.782356717503951],
            [-122.388231340039766, 37.782146697467269],
            [-122.388106738902522, 37.781931906493995],
            [-122.388094863959623, 37.781887241816527],
            [-122.387765464889313, 37.78194244138043],
            [-122.387754811744713, 37.781795652877442],
            [-122.385560654233757, 37.781935833609538],
            [-122.385544999019174, 37.781932650370386],
            [-122.38553439339303, 37.781923892586839],
            [-122.385511671392734, 37.781778670688965],
            [-122.384922372713746, 37.781810068903333],
            [-122.384901998602373, 37.781825502544642],
            [-122.384858074907243, 37.781799422577222],
            [-122.384893494062709, 37.781763146995921],
            [-122.38491634743859, 37.781777202531266],
            [-122.38550727073536, 37.781741658296774],
            [-122.385491676395333, 37.781604563077408],
            [-122.385493075388183, 37.781591492690396],
            [-122.38550321006835, 37.781581716485675],
            [-122.385518655734231, 37.781576662678262],
            [-122.38762837564704, 37.781450881969413],
            [-122.387583140105036, 37.780964719298666],
            [-122.387467577483136, 37.780979617487112],
            [-122.387479366190874, 37.781103038700273],
            [-122.387462086323822, 37.781104002067416],
            [-122.387450297298699, 37.780980580858106],
            [-122.387337984465276, 37.780987185935416],
            [-122.387348026094102, 37.781109948402708],
            [-122.387330746223768, 37.781110911750616],
            [-122.387320704623349, 37.780988149281868],
            [-122.387206644553231, 37.780994095205941],
            [-122.387216703416328, 37.781117544403045],
            [-122.387199423542512, 37.781118507731705],
            [-122.387189364714985, 37.780995058807726],
            [-122.387068420460224, 37.78100248851576],
            [-122.387080191758074, 37.781125223313062],
            [-122.387062911534741, 37.78112618662724],
            [-122.387051140611234, 37.78100345182272],
            [-122.386937097943829, 37.781010084204837],
            [-122.386948869025886, 37.781132819015049],
            [-122.386931588799087, 37.78113378231],
            [-122.386919818091386, 37.781011047492527],
            [-122.386812677010425, 37.7810168822962],
            [-122.386824465334769, 37.781140303837503],
            [-122.386807185104601, 37.781141267114201],
            [-122.386795397161777, 37.781017845840225],
            [-122.386676165495402, 37.781024560738594],
            [-122.386687953248156, 37.781147982298883],
            [-122.386670672668515, 37.781148945561135],
            [-122.386658885297223, 37.781025524268173],
            [-122.386543112789369, 37.781032183675542],
            [-122.386554900668202, 37.781155605243434],
            [-122.386537620431014, 37.781156568480647],
            [-122.386525832933643, 37.781033147180089],
            [-122.386411790166775, 37.781039778779515],
            [-122.386423577828609, 37.781163200360375],
            [-122.386406297587911, 37.781164163578339],
            [-122.386394510307582, 37.7810407422648],
            [-122.386282162758775, 37.781045973167615],
            [-122.386293984730017, 37.781170767655468],
            [-122.386276704139945, 37.78117173085996],
            [-122.386264917419695, 37.781048309528096],
            [-122.386147415421732, 37.781054996216575],
            [-122.386159201954754, 37.781178417834589],
            [-122.386141922053085, 37.781179381008279],
            [-122.386130135209612, 37.78105595966862],
            [-122.386019552249252, 37.781062535536719],
            [-122.386031321484509, 37.781185270717479],
            [-122.386014040887659, 37.781186233883489],
            [-122.386002272033735, 37.781063498970049],
            [-122.385879580345062, 37.78107026841095],
            [-122.385891367127385, 37.781193690044354],
            [-122.385874086872718, 37.781194653184308],
            [-122.385862300471871, 37.781071231818238],
            [-122.385755176650932, 37.781077752105325],
            [-122.385766945797698, 37.781200487306606],
            [-122.385749665539848, 37.78120145042832],
            [-122.385737896774387, 37.781078715494381],
            [-122.385622107018349, 37.781084687547477],
            [-122.385633892683231, 37.781208109217374],
            [-122.385616612767805, 37.781209072314041],
            [-122.385604844221021, 37.781086337366979],
            [-122.385487342103474, 37.781093023397624],
            [-122.385499110464124, 37.781215758630843],
            [-122.38548182985329, 37.781216721718849],
            [-122.385470061873946, 37.781093986752957],
            [-122.385352559732169, 37.781100672649266],
            [-122.38536432752538, 37.781223407901315],
            [-122.385347047602892, 37.781224370958491],
            [-122.385335279499117, 37.781101635984861],
            [-122.385219507099919, 37.781108294087041],
            [-122.385231275020445, 37.781231029346657],
            [-122.385213994748526, 37.781231992389863],
            [-122.385202226517421, 37.781109257408659],
            [-122.385086454440369, 37.781115915374649],
            [-122.385098222142247, 37.781238650647374],
            [-122.385080941520883, 37.781239613676604],
            [-122.385069174200339, 37.781116878671227],
            [-122.38495511409829, 37.781122822411653],
            [-122.384966899006869, 37.781246244141819],
            [-122.384949618382038, 37.781247207151821],
            [-122.384937851277286, 37.781124472133506],
            [-122.384823791153082, 37.781130415746894],
            [-122.384835575844662, 37.781253837490027],
            [-122.384818295216348, 37.781254800480774],
            [-122.384792264836477, 37.780979154238715],
            [-122.384809545055035, 37.780978191257269],
            [-122.384831743135436, 37.781102819695278],
            [-122.384925045670656, 37.781097207947639],
            [-122.384923587517477, 37.780971560938383],
            [-122.384940867732567, 37.780970597937682],
            [-122.384963066031062, 37.781095226351141],
            [-122.385056368546813, 37.781089614499592],
            [-122.385054910171618, 37.780963967491779],
            [-122.385072190383269, 37.780963004471836],
            [-122.385094388899816, 37.781087632860746],
            [-122.385189421508272, 37.781081993240349],
            [-122.385187962562227, 37.780956346239556],
            [-122.385205242424405, 37.780955383205644],
            [-122.38522744150788, 37.781080011564157],
            [-122.385322474096498, 37.781074371836517],
            [-122.385321014925523, 37.780948724837195],
            [-122.385338295130154, 37.780947761778229],
            [-122.385360493742681, 37.78107239012293],
            [-122.385457256077231, 37.781066722624757],
            [-122.385455797024363, 37.780941075621371],
            [-122.38547307722547, 37.78094011254268],
            [-122.385495276407823, 37.781064740856642],
            [-122.385592038722095, 37.781059073247853],
            [-122.385590579095435, 37.780933426251508],
            [-122.385607859293003, 37.780932463153057],
            [-122.385630058353271, 37.781057091447337],
            [-122.38572509122794, 37.781051451389651],
            [-122.385723631030388, 37.780925804400319],
            [-122.385740911570423, 37.780924841276843],
            [-122.385763111197619, 37.781049469540704],
            [-122.385849512311808, 37.781044654171389],
            [-122.385848051896943, 37.78091900690886],
            [-122.385865332440758, 37.780918044041726],
            [-122.385887514843574, 37.781041985837916],
            [-122.385989466046908, 37.781036234899503],
            [-122.385988006094351, 37.780910587902042],
            [-122.386005286281474, 37.780909624745334],
            [-122.386027486347686, 37.781034252959756],
            [-122.38611734695634, 37.781029382050761],
            [-122.386115886434652, 37.78090373478566],
            [-122.386133166625513, 37.780902771884811],
            [-122.386155349124707, 37.781026713636507],
            [-122.386250399355106, 37.78102175959976],
            [-122.386248938262554, 37.780896112341686],
            [-122.386266218795839, 37.780895149415798],
            [-122.386288401860739, 37.781019091137082],
            [-122.386381721962337, 37.781014164675518],
            [-122.386380260647812, 37.780888517418902],
            [-122.386397541177601, 37.780887554473743],
            [-122.386419741895395, 37.781012182614816],
            [-122.386513044542724, 37.781006569605005],
            [-122.386511583006197, 37.780880922349844],
            [-122.386528863532533, 37.780879959385452],
            [-122.386551064468406, 37.781004587501954],
            [-122.386646096514042, 37.780998946712984],
            [-122.386644635444497, 37.780873299448245],
            [-122.386661915621403, 37.780872336469891],
            [-122.386684116778227, 37.780996964561524],
            [-122.386782608677009, 37.780991268294322],
            [-122.386781146684797, 37.780865621042153],
            [-122.386798427204084, 37.780864658038261],
            [-122.386820628587657, 37.780989286104372],
            [-122.386907012122748, 37.780983783515829],
            [-122.386905549920243, 37.780858136265046],
            [-122.386922830436163, 37.780857173242921],
            [-122.386945032026247, 37.780981801285769],
            [-122.387038334595715, 37.780976187860247],
            [-122.387036872171194, 37.780850540610921],
            [-122.387054152683675, 37.780849577569541],
            [-122.387076354491839, 37.780974205587825],
            [-122.387174846330339, 37.780968508992949],
            [-122.387173384021025, 37.7808428617396],
            [-122.387190664183962, 37.780841898683754],
            [-122.387212865872911, 37.78096652668205],
            [-122.387306168748907, 37.78096091303906],
            [-122.387304706217577, 37.780835265787175],
            [-122.387321986377088, 37.780834302712059],
            [-122.387344188284104, 37.780958930685784],
            [-122.387435761378228, 37.780953344631229],
            [-122.387434316073197, 37.780828383824961],
            [-122.387451578437933, 37.780826734292219],
            [-122.387473781252041, 37.780951362230645],
            [-122.387582651602727, 37.780945499137275],
            [-122.38754001837809, 37.780493630652451],
            [-122.38744131821305, 37.780491090765793],
            [-122.387419058221624, 37.780500374265543],
            [-122.387330736209734, 37.780497667864211],
            [-122.387308476209526, 37.780506951617653],
            [-122.387208063026961, 37.780505125406954],
            [-122.387184073602839, 37.780514436820333],
            [-122.387081931006932, 37.780512638185321],
            [-122.387059670971126, 37.780521921891747],
            [-122.386964429936867, 37.780519325963184],
            [-122.386942169884378, 37.780528609647433],
            [-122.386852118103619, 37.780525930572708],
            [-122.386829875474817, 37.780535900680007],
            [-122.386736346744712, 37.780532590439464],
            [-122.386712374345294, 37.780542588206671],
            [-122.386618863049748, 37.780539964317235],
            [-122.386594873201545, 37.780549275890777],
            [-122.386499632141522, 37.780546679312224],
            [-122.386475659366695, 37.780556677311395],
            [-122.386383878154234, 37.780554025277233],
            [-122.386359888272054, 37.780563336802956],
            [-122.386266376955888, 37.780560712359396],
            [-122.386242404491071, 37.780570710305611],
            [-122.386143703562112, 37.780568168794694],
            [-122.386119713984229, 37.780577479991436],
            [-122.386022743164474, 37.78057491124985],
            [-122.386000500402702, 37.780584880926071],
            [-122.385901799477139, 37.780582339761835],
            [-122.385877827288269, 37.780592337079185],
            [-122.385784298190572, 37.780589026363579],
            [-122.38576205573851, 37.780598995989244],
            [-122.385668544412525, 37.780596371620753],
            [-122.385646283822041, 37.780605654791167],
            [-122.385554502585677, 37.780603002386016],
            [-122.385532242331863, 37.780612285803919],
            [-122.385433541724893, 37.780609743967645],
            [-122.385411298534606, 37.78061971381274],
            [-122.385310868512505, 37.780617199530866],
            [-122.385288625649494, 37.780627169347277],
            [-122.385191654786624, 37.780624599647666],
            [-122.38516766472523, 37.780633910656128],
            [-122.385079342290652, 37.780631202574007],
            [-122.385057082314987, 37.780640485896626],
            [-122.384960111442751, 37.78063791600659],
            [-122.384936138770243, 37.780647913412501],
            [-122.384835917442729, 37.780653636341071],
            [-122.384842007573795, 37.78075723388941],
            [-122.384817825799914, 37.78075899421075],
            [-122.38480325384981, 37.78052574104445],
            [-122.384827435209161, 37.780523981006105],
            [-122.384843799331136, 37.780623294238858],
            [-122.384923281326039, 37.780618589884874],
            [-122.384925926962097, 37.780518286009212],
            [-122.384957841591557, 37.780616663880899],
            [-122.385044241908545, 37.780611849106826],
            [-122.385045157967028, 37.780511572605498],
            [-122.385078784737303, 37.780609236348262],
            [-122.385154824277294, 37.780605273878329],
            [-122.385157469939188, 37.780504969717121],
            [-122.38518938452367, 37.780603347531915],
            [-122.385275768076681, 37.780597846132551],
            [-122.385276683130513, 37.780497569640254],
            [-122.385310328316436, 37.780595919750695],
            [-122.385398458680143, 37.78059107677575],
            [-122.385399356494702, 37.780490114106904],
            [-122.385433018927529, 37.78058915090709],
            [-122.385519402086118, 37.780583648785594],
            [-122.385520317170744, 37.78048337283478],
            [-122.385553962326881, 37.780581722881479],
            [-122.385633443879414, 37.780577017779677],
            [-122.385634358810009, 37.780476741827854],
            [-122.385666274013943, 37.780575119514069],
            [-122.385749215060514, 37.780570359001402],
            [-122.385750112750941, 37.780469396598548],
            [-122.385783775282164, 37.780568432755352],
            [-122.385864986912736, 37.780563700098369],
            [-122.385865884092837, 37.780462737425502],
            [-122.38589954712829, 37.780561773818384],
            [-122.385987659981154, 37.780556243958578],
            [-122.385988556648442, 37.780455281290152],
            [-122.386022220190043, 37.78055431764264],
            [-122.386106890951012, 37.780549529481313],
            [-122.386107787802118, 37.780448566806321],
            [-122.386141451153719, 37.780547603130415],
            [-122.386229563971753, 37.780542073089819],
            [-122.386232190406915, 37.780441082739081],
            [-122.386264124167781, 37.780540146702961],
            [-122.386347065143937, 37.780535386044313],
            [-122.386349691419113, 37.78043439569084],
            [-122.386381625333826, 37.780533459623001],
            [-122.386462836549086, 37.780528726834362],
            [-122.386465444877402, 37.780427049764754],
            [-122.386497396725886, 37.780526800104532],
            [-122.386582067431817, 37.780522011876563],
            [-122.386584675942643, 37.78042033479867],
            [-122.386616627602407, 37.780520085111789],
            [-122.386699551102055, 37.78051463803542],
            [-122.386702159451801, 37.78041296095477],
            [-122.386734111266165, 37.780512711236199],
            [-122.386817052181556, 37.780507950246935],
            [-122.386817930281353, 37.780406301126988],
            [-122.386851612353468, 37.780506023962438],
            [-122.386929363990731, 37.7805013456708],
            [-122.386930242282716, 37.780399696544364],
            [-122.386963924156646, 37.780499419353383],
            [-122.387046865035501, 37.780494657927875],
            [-122.387047743173568, 37.78039300907502],
            [-122.387081425188285, 37.780492731301436],
            [-122.387171267622861, 37.780487172869918],
            [-122.387173875339855, 37.780385496327504],
            [-122.387205827768923, 37.780485246207022],
            [-122.387295687629134, 37.780480374124949],
            [-122.387296547982558, 37.780378038825731],
            [-122.387330247768816, 37.780478447425573],
            [-122.387406269602806, 37.780473796784797],
            [-122.38740712980379, 37.780371461484656],
            [-122.38744082973659, 37.78047187005302],
            [-122.387527230063114, 37.780467053179258],
            [-122.38749949992625, 37.780056836734332],
            [-122.387400782538194, 37.780053609825671],
            [-122.387378540131436, 37.780063580311925],
            [-122.387290201196578, 37.780060187435744],
            [-122.387267941315415, 37.780069470907662],
            [-122.387167511635454, 37.780066958487033],
            [-122.387143539437361, 37.780076956068172],
            [-122.387041380009435, 37.780074471228168],
            [-122.387019120092901, 37.780083754653084],
            [-122.386922167327057, 37.780081873095298],
            [-122.386901619695664, 37.780090442368873],
            [-122.386811551008179, 37.78008707681861],
            [-122.386787578762636, 37.780097074601919],
            [-122.386695780329632, 37.780093736646045],
            [-122.386671790289242, 37.780103048241536],
            [-122.386578279887487, 37.780100424039603],
            [-122.386554289830215, 37.78010973561117],
            [-122.386459049681108, 37.780107138994076],
            [-122.386435059945711, 37.780116450261254],
            [-122.386343278946669, 37.780113798749966],
            [-122.386319288841676, 37.780123109724549],
            [-122.386225778441045, 37.780120485792217],
            [-122.386201788319156, 37.780129796742877],
            [-122.38610135893272, 37.780127283134078],
            [-122.386079098889809, 37.780136566656026],
            [-122.385982128640109, 37.780133997606264],
            [-122.38595813883623, 37.780143308776367],
            [-122.385859438837869, 37.78014076729638],
            [-122.385837196191162, 37.780150737217127],
            [-122.385743667990269, 37.780147426188911],
            [-122.385719678159148, 37.780156737585067],
            [-122.385627896776001, 37.780154084973319],
            [-122.385603907274145, 37.780163396340377],
            [-122.385513855977493, 37.78016071596884],
            [-122.385489865760334, 37.780170027049152],
            [-122.385392895494292, 37.780167457789418],
            [-122.385368905944745, 37.780176768559457],
            [-122.385270205929046, 37.780174226860836],
            [-122.385246216015972, 37.78018353761145],
            [-122.385150975133058, 37.78018094022346],
            [-122.385126985555786, 37.780190251218855],
            [-122.385038663996198, 37.78018754310051],
            [-122.385014674056748, 37.780196854078561],
            [-122.384919433510831, 37.780194256498035],
            [-122.38489544320835, 37.780203567457356],
            [-122.384795222823172, 37.780209290346271],
            [-122.384801312515108, 37.780312887910483],
            [-122.384777113810173, 37.780313961773459],
            [-122.384762559495741, 37.780081395028191],
            [-122.384786741057312, 37.780079634992532],
            [-122.384803105027004, 37.780178948238863],
            [-122.384882586203048, 37.780174243917422],
            [-122.384885231532309, 37.780073940040232],
            [-122.384917146262893, 37.780172317925249],
            [-122.385001816666616, 37.780167530831704],
            [-122.385004462173583, 37.780067226671626],
            [-122.385036376713245, 37.780165604530019],
            [-122.38511414553922, 37.780161614154224],
            [-122.385116790908242, 37.780061310540667],
            [-122.385148705594133, 37.780159688368748],
            [-122.385233375608649, 37.780154900565314],
            [-122.385236021162356, 37.780054596943422],
            [-122.385267935657353, 37.780152974744887],
            [-122.385356065837257, 37.780148131521123],
            [-122.385358710872126, 37.780047827627314],
            [-122.385390625872631, 37.780146205390146],
            [-122.385477025953321, 37.780141390018422],
            [-122.385479653051561, 37.780040399682747],
            [-122.385511585982442, 37.780139463852002],
            [-122.385591067071402, 37.78013475905297],
            [-122.385593711788431, 37.78003445515364],
            [-122.38562562709447, 37.78013283285312],
            [-122.385706855349099, 37.780128787029341],
            [-122.385709482473402, 37.780027796408206],
            [-122.385741415359448, 37.780126860520987],
            [-122.385824355914565, 37.780122100504215],
            [-122.385825252791648, 37.780021137554606],
            [-122.38585891591876, 37.780120173961421],
            [-122.385945315592835, 37.780115358252047],
            [-122.385947942745361, 37.780014367894388],
            [-122.38597987560469, 37.780113432222926],
            [-122.386066275948011, 37.78010861613928],
            [-122.38606717251001, 37.780007653736739],
            [-122.38610083595357, 37.78010669007471],
            [-122.386188965678286, 37.780101846233919],
            [-122.386191574380462, 37.780000169711762],
            [-122.386223525670573, 37.780099919858799],
            [-122.386306466157762, 37.780095159228338],
            [-122.386309092126623, 37.77999416887333],
            [-122.386341026143853, 37.780093232818778],
            [-122.386422253963318, 37.780089186233084],
            [-122.386424863030612, 37.77998750941989],
            [-122.386456813943639, 37.780087259789596],
            [-122.386541484497073, 37.780082471584841],
            [-122.386544092702067, 37.77998079450537],
            [-122.386576044464221, 37.780080544831833],
            [-122.386658984914163, 37.780075784227932],
            [-122.386661592958049, 37.779974107145748],
            [-122.386693544875143, 37.780073857440478],
            [-122.386776485303088, 37.780069096479352],
            [-122.386777363799169, 37.779967447346195],
            [-122.386809315183925, 37.780067197895306],
            [-122.386888813892412, 37.780063178385696],
            [-122.386889674448653, 37.77996084281277],
            [-122.38692337384856, 37.780061251805442],
            [-122.387006314247685, 37.780056490682639],
            [-122.387007174648929, 37.779954155383322],
            [-122.38704087419768, 37.780054564067953],
            [-122.387130733547679, 37.78004969211122],
            [-122.387133323862429, 37.779947329117419],
            [-122.38716529349125, 37.780047765460061],
            [-122.387255152824864, 37.780042893408485],
            [-122.387256012876136, 37.779940557832525],
            [-122.387289712762055, 37.78004096672084],
            [-122.387365734157797, 37.780036316380411],
            [-122.387366594049666, 37.779933980528931],
            [-122.387400294082084, 37.78003438938579],
            [-122.387486693563403, 37.780029572821469],
            [-122.387461810378028, 37.779663260524117],
            [-122.387378661112308, 37.779659784635669],
            [-122.387356418813553, 37.779669754843859],
            [-122.387276728664503, 37.779666223506673],
            [-122.387252739526915, 37.779675535209975],
            [-122.387173049376599, 37.779672003802716],
            [-122.387150789943092, 37.779681287247612],
            [-122.387067640671745, 37.779677811139862],
            [-122.387043668592767, 37.779687808975972],
            [-122.386969150543408, 37.779683507921064],
            [-122.386945178103403, 37.779693505742671],
            [-122.386868930320873, 37.779689232309579],
            [-122.386844958564382, 37.779699230374298],
            [-122.386765268401049, 37.779695698416859],
            [-122.386741279182857, 37.779705009741512],
            [-122.386659859644624, 37.77970150593859],
            [-122.386635887496141, 37.77971150341719],
            [-122.386556180245535, 37.77970728514304],
            [-122.386533937822136, 37.779717255195997],
            [-122.386452518273302, 37.779713750975354],
            [-122.386428528664126, 37.77972306224185],
            [-122.38635402805015, 37.779719447242712],
            [-122.386331768168034, 37.779728731087609],
            [-122.386245159413448, 37.779725309752138],
            [-122.386222916935935, 37.779735279471808],
            [-122.386151858355305, 37.779730922551266],
            [-122.386127868702886, 37.77974023375657],
            [-122.386048178882604, 37.779736701583559],
            [-122.386025936036276, 37.779746671546171],
            [-122.385946246559868, 37.779743139298724],
            [-122.385922256538748, 37.779752450742315],
            [-122.385842567054112, 37.779748918150233],
            [-122.385818577011165, 37.779758229298103],
            [-122.385742346663463, 37.779754641855682],
            [-122.385718357291026, 37.779763952697529],
            [-122.385635207994184, 37.779760475579685],
            [-122.385611235349785, 37.779770473129936],
            [-122.385528086050684, 37.779766995936541],
            [-122.385504096654358, 37.779776307009364],
            [-122.38542267708938, 37.779772802077623],
            [-122.385400434501221, 37.779782772191204],
            [-122.385319014927063, 37.779779266913316],
            [-122.385296754890703, 37.779788550288139],
            [-122.385225696313427, 37.779784192809487],
            [-122.385201723952207, 37.779794190270913],
            [-122.385120304035951, 37.779790685135936],
            [-122.38509804431726, 37.779799968467685],
            [-122.385020084218212, 37.779796407941809],
            [-122.38499609406378, 37.779805719196837],
            [-122.384916404566042, 37.779802185978852],
            [-122.384894161901101, 37.779812155996879],
            [-122.38480257260197, 37.779817053634027],
            [-122.384809835241697, 37.779898657585051],
            [-122.384782194261888, 37.779900472932383],
            [-122.384761383067243, 37.779694102231538],
            [-122.384789023963819, 37.779692286614427],
            [-122.384808725038937, 37.779786739726958],
            [-122.384879557453601, 37.779782173395887],
            [-122.384880595342565, 37.779686702548538],
            [-122.384914117331078, 37.779780247404453],
            [-122.384983237080689, 37.779776395391224],
            [-122.384984274829336, 37.77968092426827],
            [-122.385017796952795, 37.779774469369393],
            [-122.385085186616962, 37.779770645233363],
            [-122.38508622457347, 37.779675173829325],
            [-122.385119746476775, 37.779768718907071],
            [-122.385188848787607, 37.77976418060323],
            [-122.385189886610789, 37.779668709198148],
            [-122.385223408641721, 37.779762254246563],
            [-122.385283897452879, 37.779759226795328],
            [-122.385284934821826, 37.779663755944007],
            [-122.385318457309211, 37.779757300685375],
            [-122.385385847281285, 37.779753476097383],
            [-122.385386866740049, 37.779657318531406],
            [-122.3854203897058, 37.77975086351293],
            [-122.385491239136826, 37.779746983539091],
            [-122.385492276232114, 37.779651512411178],
            [-122.385525798982087, 37.779745057368359],
            [-122.385598378143868, 37.779741149940357],
            [-122.385599415094418, 37.779645678536831],
            [-122.385632937976666, 37.779739223463643],
            [-122.385705499691042, 37.779734629250548],
            [-122.385706536510781, 37.779639158120546],
            [-122.385740059531955, 37.779732703291586],
            [-122.385805719718547, 37.779728905856508],
            [-122.385806756416358, 37.779633435000086],
            [-122.385840279547224, 37.779726979593605],
            [-122.385909399199221, 37.7797231270374],
            [-122.385910435756728, 37.779627655905408],
            [-122.385943959022555, 37.779721200744085],
            [-122.386013061231836, 37.779716661682606],
            [-122.386014097656016, 37.779621190549562],
            [-122.386047621049443, 37.779714735358894],
            [-122.38611501060636, 37.779710910634236],
            [-122.386116047238417, 37.779615439220123],
            [-122.386149570411703, 37.779708984006099],
            [-122.386208311974158, 37.779705297309562],
            [-122.386211077885747, 37.779609798774842],
            [-122.386242871788397, 37.779703371203219],
            [-122.386317180591391, 37.779699435108718],
            [-122.38631821662446, 37.77960396397274],
            [-122.386351740393124, 37.779697508695882],
            [-122.386415670790853, 37.779693738872112],
            [-122.386416706351284, 37.779598267740703],
            [-122.386450230587357, 37.779691812430414],
            [-122.386519350181956, 37.779687959791211],
            [-122.386520385602097, 37.779592488384218],
            [-122.386553892529193, 37.77968534660009],
            [-122.386623012105417, 37.779681493625532],
            [-122.386624047399195, 37.779586022492111],
            [-122.386657571897828, 37.779679567397658],
            [-122.386728421189233, 37.779675686405767],
            [-122.386729456700351, 37.779580215540342],
            [-122.386762980969223, 37.779673759872402],
            [-122.386832100523861, 37.779669906775261],
            [-122.386833135894662, 37.779574435634252],
            [-122.386866660298466, 37.779667980211499],
            [-122.386932302936756, 37.779663495979172],
            [-122.386933338178679, 37.779568024837168],
            [-122.386966862705819, 37.779661569386036],
            [-122.387030793048368, 37.779657799503305],
            [-122.38704566565184, 37.779562106599087],
            [-122.387054991513921, 37.779656725452249],
            [-122.387136202059708, 37.779651991644378],
            [-122.387139193519673, 37.77956541658935],
            [-122.387170761825075, 37.779650065266061],
            [-122.387239881329535, 37.779646211655297],
            [-122.387241125495137, 37.779558977842669],
            [-122.387274441082525, 37.779644284971994],
            [-122.387341830851355, 37.779640459266005],
            [-122.387344804633926, 37.779553198035785],
            [-122.387376373154481, 37.7796378461085],
            [-122.387448951768221, 37.779633937546841],
            [-122.387428243590108, 37.779295714050406],
            [-122.387339905566151, 37.779292321211003],
            [-122.38731766337223, 37.779302291412563],
            [-122.387236244241279, 37.77929878773282],
            [-122.387212254525394, 37.779308099439604],
            [-122.387132565463105, 37.779304567993648],
            [-122.387108575718415, 37.779313879130164],
            [-122.387028886654846, 37.779310347614164],
            [-122.387004914343294, 37.779320345448582],
            [-122.386932126735232, 37.779316016678415],
            [-122.386908154408829, 37.779326014493151],
            [-122.386828447902374, 37.779321796397241],
            [-122.386804475567118, 37.779331794465456],
            [-122.386726516216612, 37.779328234787421],
            [-122.3867025267663, 37.779337546110341],
            [-122.386624566736728, 37.779333986925117],
            [-122.386600577610722, 37.779343297947158],
            [-122.386520887847865, 37.7793397660989],
            [-122.386496916150335, 37.779349763818921],
            [-122.386417208949837, 37.779345545456096],
            [-122.386393237236504, 37.77935554315502],
            [-122.386318719558147, 37.779351241688801],
            [-122.386296477216476, 37.779361211972173],
            [-122.386211598617734, 37.779357762936172],
            [-122.386187609086349, 37.779367073879669],
            [-122.386113108495195, 37.779363458733613],
            [-122.386089119302554, 37.779372769926113],
            [-122.386011159604379, 37.779369210055243],
            [-122.385987187482783, 37.779379207677103],
            [-122.385909210351812, 37.779374961294259],
            [-122.385885237875669, 37.779384959175481],
            [-122.385802088988314, 37.779381481900515],
            [-122.385778099750866, 37.779390793029705],
            [-122.385698409983121, 37.779387260900187],
            [-122.385676150450635, 37.779396544067176],
            [-122.385598190747288, 37.779392983923266],
            [-122.385574218216505, 37.779402981466639],
            [-122.3854945117032, 37.779398762469064],
            [-122.3854705391566, 37.779408759991362],
            [-122.38538912034204, 37.779405255030689],
            [-122.385366860087544, 37.779414538699463],
            [-122.385285441271535, 37.779411033667223],
            [-122.385261469031803, 37.779421030866885],
            [-122.385190410808178, 37.779416673366669],
            [-122.38516642079081, 37.779425984382435],
            [-122.385088461426918, 37.77942242389598],
            [-122.38506448916398, 37.779432421330149],
            [-122.384984782302112, 37.779428201993547],
            [-122.384960810030293, 37.779438199681202],
            [-122.384881120582591, 37.779434666444651],
            [-122.38485713086655, 37.779443977391921],
            [-122.384765559446308, 37.779449561719943],
            [-122.384771214222269, 37.779535998445006],
            [-122.384747015071127, 37.779537072038458],
            [-122.38473308847739, 37.779329217537743],
            [-122.384757287215081, 37.779328143952647],
            [-122.384773494195869, 37.779421279213679],
            [-122.384846073080865, 37.779417372248531],
            [-122.384848858140316, 37.779322559636441],
            [-122.384880632782526, 37.779415445992221],
            [-122.384949752194402, 37.77941159399834],
            [-122.384952537135234, 37.779316781932884],
            [-122.384984294475274, 37.779408981541515],
            [-122.385051684148522, 37.779405157144254],
            [-122.385056216100068, 37.779311003588973],
            [-122.385086243853095, 37.779403231376833],
            [-122.385155363235981, 37.779399378987847],
            [-122.385158147906921, 37.779304566642743],
            [-122.38518992292822, 37.779397452915447],
            [-122.385248663600038, 37.779393766707848],
            [-122.385253195301217, 37.779299613144822],
            [-122.385283223287274, 37.779391840608099],
            [-122.385354072735922, 37.779387960985474],
            [-122.385358586870339, 37.779293120699045],
            [-122.385388632410709, 37.779386034580241],
            [-122.385459481495417, 37.779382154625232],
            [-122.385462265784483, 37.779287342547207],
            [-122.385494023751633, 37.779379542293618],
            [-122.385561413364954, 37.77937571733046],
            [-122.385565944668585, 37.779281563755077],
            [-122.385595973035649, 37.779373791139029],
            [-122.385663362299539, 37.779369966397688],
            [-122.385667876044934, 37.779275126373676],
            [-122.385697921964919, 37.779368040176379],
            [-122.385765311917211, 37.779364215640285],
            [-122.385769825525102, 37.779269375337698],
            [-122.385799871570299, 37.779362289114509],
            [-122.385874162638899, 37.779357667403531],
            [-122.38587696382136, 37.779263541485342],
            [-122.385908722286104, 37.779355740845865],
            [-122.385976111863471, 37.779351915920223],
            [-122.385978912570593, 37.779257790005062],
            [-122.386010671519301, 37.779349989881837],
            [-122.386078060733283, 37.77934616462889],
            [-122.386080844570401, 37.779251352255542],
            [-122.386112620376821, 37.779344238286029],
            [-122.386174820757347, 37.779340496265526],
            [-122.386179333847906, 37.779245656221427],
            [-122.386209380395755, 37.779338569894314],
            [-122.386283671761092, 37.779333947919731],
            [-122.386288202139696, 37.779239794041324],
            [-122.386318231386639, 37.779332021242034],
            [-122.386380431746588, 37.779328279113052],
            [-122.386384962016137, 37.779234125779993],
            [-122.386414991380946, 37.77932635295614],
            [-122.38648584000218, 37.779322472115325],
            [-122.386488640754166, 37.779228346176467],
            [-122.386520399624118, 37.779320545652922],
            [-122.386589518862621, 37.779316692697755],
            [-122.386592302045827, 37.779221880311852],
            [-122.386624078479215, 37.779314766204962],
            [-122.386691468335471, 37.779310941139499],
            [-122.386694251035379, 37.779216128482069],
            [-122.386726027939744, 37.77930901434226],
            [-122.386793400000514, 37.779304502779596],
            [-122.38679620001615, 37.779210376838677],
            [-122.386827959599159, 37.779302575952464],
            [-122.386897078804992, 37.779298722816996],
            [-122.386901608410881, 37.779204569189005],
            [-122.386931638412193, 37.779296796508632],
            [-122.386992108980877, 37.779293081467337],
            [-122.386996638465945, 37.779198927835616],
            [-122.387026668576013, 37.779291154856551],
            [-122.387095787760913, 37.779287301604562],
            [-122.38710029967234, 37.779192461524332],
            [-122.387130347350677, 37.779285374963401],
            [-122.387199466531811, 37.779281521925199],
            [-122.387204309717603, 37.779199724010219],
            [-122.387234026109212, 37.779279594979052],
            [-122.387304857552181, 37.779275027470717],
            [-122.387309700628478, 37.779193229825893],
            [-122.387339417137795, 37.779273101042833],
            [-122.387415455175415, 37.779269136564935],
            [-122.387394991136247, 37.778940523542531],
            [-122.387315302113649, 37.778936992225411],
            [-122.387291312863496, 37.778946303668732],
            [-122.387218525259328, 37.778941975080627],
            [-122.38719628281504, 37.778951945540015],
            [-122.38712349555685, 37.77894761688772],
            [-122.387099505926273, 37.778956928022971],
            [-122.387025006394012, 37.778953313441747],
            [-122.387002746472433, 37.778962597145551],
            [-122.386929976655324, 37.778958954818265],
            [-122.386905987003843, 37.778968266188713],
            [-122.386836658833175, 37.778963881995679],
            [-122.386812687306417, 37.778973880055133],
            [-122.386736440270226, 37.778969606535817],
            [-122.386712468022296, 37.778979604036806],
            [-122.386637951048542, 37.77897530276654],
            [-122.386613979138446, 37.778985300516517],
            [-122.386549822682738, 37.778980146669305],
            [-122.386527580483204, 37.778990116996944],
            [-122.386449603383866, 37.778985870976705],
            [-122.386425631783965, 37.778995868408273],
            [-122.386356303615884, 37.778991483932835],
            [-122.386332313881979, 37.779000795186512],
            [-122.386256084279836, 37.778997207801154],
            [-122.386233824940902, 37.779006491348653],
            [-122.386164496774228, 37.779002106760423],
            [-122.386140524798748, 37.779012104688697],
            [-122.386067737197138, 37.779007775390234],
            [-122.386043765192852, 37.779017772749661],
            [-122.385962346433857, 37.779014268190103],
            [-122.385938356643209, 37.779023579363574],
            [-122.385865569388116, 37.779019249934791],
            [-122.385841597013936, 37.779029247533202],
            [-122.385768809758915, 37.779024918044691],
            [-122.385744837376848, 37.779034915898023],
            [-122.385675509212518, 37.779030531022293],
            [-122.385651520065593, 37.779039841851741],
            [-122.385578749547165, 37.77903619870164],
            [-122.385554760393234, 37.779045509785973],
            [-122.385481989874023, 37.779041866576151],
            [-122.385458000713072, 37.779051177915363],
            [-122.385385212767062, 37.779046848201126],
            [-122.385361223578457, 37.779056158971507],
            [-122.385286723685297, 37.779052543297539],
            [-122.385262734143524, 37.779061854327978],
            [-122.385195135701593, 37.77905744150933],
            [-122.385171163224882, 37.779067438971381],
            [-122.385094916187072, 37.779063164390635],
            [-122.385070944393846, 37.779073162095791],
            [-122.385001616233609, 37.779068776823863],
            [-122.38497935636353, 37.77907805986537],
            [-122.384906586186588, 37.779074416294911],
            [-122.384884326309916, 37.779083699593059],
            [-122.384796197708141, 37.779088542459625],
            [-122.384801451464668, 37.77915919068996],
            [-122.384780712232896, 37.779160209251955],
            [-122.384765734942761, 37.778979153747279],
            [-122.384786456703722, 37.778977448743071],
            [-122.384804149136215, 37.779060946405302],
            [-122.384871538841949, 37.779057121830682],
            [-122.384874585188271, 37.778972606432866],
            [-122.384906098382288, 37.779055195841352],
            [-122.384966568862538, 37.779051482113282],
            [-122.384969632515677, 37.778967652883104],
            [-122.385001128397789, 37.779049556096091],
            [-122.385058156860921, 37.779046584353601],
            [-122.385061202980566, 37.778962068401654],
            [-122.385092716384577, 37.779044658035005],
            [-122.385158376003019, 37.779040861234485],
            [-122.38516315173905, 37.77895631817001],
            [-122.385192918111116, 37.779038248990936],
            [-122.385249946543951, 37.779035276606521],
            [-122.385253009876607, 37.778951447368748],
            [-122.385284506064338, 37.779033350506261],
            [-122.385350165317007, 37.779029553604488],
            [-122.385353228882295, 37.778945724358508],
            [-122.385382995459778, 37.779027655131593],
            [-122.385445195618914, 37.779023913770359],
            [-122.385448258723784, 37.778940084252753],
            [-122.385479755121978, 37.779021987338304],
            [-122.385541972691954, 37.779018932096108],
            [-122.385545018273902, 37.778934416680386],
            [-122.385576532197149, 37.779017005910269],
            [-122.385638732330676, 37.779013264172356],
            [-122.385641777795314, 37.77892874847948],
            [-122.385673291830699, 37.779011337958153],
            [-122.38573203252615, 37.779007651778535],
            [-122.385735094960694, 37.77892382225879],
            [-122.385766592014193, 37.779005725262394],
            [-122.385828792128677, 37.779001983424223],
            [-122.385831854467739, 37.778918154451013],
            [-122.385863351625531, 37.779000057428874],
            [-122.385925569154423, 37.778997001709705],
            [-122.385930344007448, 37.778912458338894],
            [-122.385960128639468, 37.778995075411409],
            [-122.386030959889439, 37.778990508668088],
            [-122.386034022338819, 37.778906679409381],
            [-122.386065519368728, 37.778988582338918],
            [-122.386127736893627, 37.778985527062204],
            [-122.386132511508848, 37.778900983408484],
            [-122.386162278927955, 37.778982913985502],
            [-122.386221036657432, 37.7789799137378],
            [-122.386224081811065, 37.778895398298431],
            [-122.386255596133822, 37.778977987627471],
            [-122.386319526256145, 37.778974217575232],
            [-122.386322588033238, 37.778890388314295],
            [-122.38635408572037, 37.778972291161459],
            [-122.386412826344156, 37.778968604368089],
            [-122.386417618076294, 37.778884747421706],
            [-122.386447385803351, 37.778966677926974],
            [-122.386514775006972, 37.77896285296778],
            [-122.386517836902243, 37.778879023421496],
            [-122.386549334453889, 37.778960926222204],
            [-122.386602903347566, 37.778958008816609],
            [-122.386605964804218, 37.778874179548069],
            [-122.386637462796912, 37.778956082319787],
            [-122.386699662825961, 37.778952340022151],
            [-122.386702724173148, 37.778868510751018],
            [-122.386734222270135, 37.778950413496958],
            [-122.386799881728336, 37.778946616056871],
            [-122.386804673015121, 37.778862758819848],
            [-122.386834441160303, 37.778944689227728],
            [-122.386894928894066, 37.778941660955091],
            [-122.38689797293344, 37.778857145503274],
            [-122.386929488335198, 37.77893973464726],
            [-122.386989958613299, 37.77893601960681],
            [-122.386993002191389, 37.778851503883409],
            [-122.387024518042367, 37.778934092996543],
            [-122.387086718033501, 37.778930350494704],
            [-122.387091509002346, 37.778846493520362],
            [-122.387121277457396, 37.778928423856051],
            [-122.387183477445888, 37.778924681577777],
            [-122.387186764992791, 37.77884977579707],
            [-122.387218036857675, 37.778922754636191],
            [-122.387280254273051, 37.778919698476713],
            [-122.387283524285621, 37.778844106523373],
            [-122.387314813687013, 37.77891777178133],
            [-122.387382202448663, 37.778913946057301],
            [-122.387364166474967, 37.778612763090031],
            [-122.387286207520319, 37.778609204336291],
            [-122.387262218365407, 37.778618515499687],
            [-122.387185989110648, 37.778614928715285],
            [-122.387161999948319, 37.778624240132871],
            [-122.387092672083611, 37.778619856090089],
            [-122.387070429718904, 37.778629826526299],
            [-122.386994183021031, 37.778625553173391],
            [-122.386971941319302, 37.778635523030793],
            [-122.386900883746804, 37.778631166560793],
            [-122.386876911637231, 37.778641164370391],
            [-122.38679893557611, 37.778636918569845],
            [-122.386774963796881, 37.778646916353182],
            [-122.386707365642749, 37.778642504401184],
            [-122.386683376072511, 37.77865181600145],
            [-122.386614065647606, 37.778648118121843],
            [-122.386590076741811, 37.778657429142889],
            [-122.386510387715276, 37.778653897287107],
            [-122.386486398801594, 37.778663208561632],
            [-122.386417070940411, 37.778658824121642],
            [-122.386393098756784, 37.778668821832838],
            [-122.38631686949239, 37.77866523448656],
            [-122.386292880557747, 37.778674545996267],
            [-122.38622009293212, 37.778670216797138],
            [-122.386197851113138, 37.778680186508431],
            [-122.386125063833461, 37.778675857245105],
            [-122.38610282131512, 37.778685827224102],
            [-122.386028304671399, 37.778681525568288],
            [-122.38600433277405, 37.778691523194873],
            [-122.385931545494543, 37.77868719381209],
            [-122.385909285516078, 37.778696477309893],
            [-122.385834786309914, 37.778692862251056],
            [-122.385810796946046, 37.778702173118987],
            [-122.385741486517588, 37.778698474726497],
            [-122.385717497147184, 37.778707785850045],
            [-122.385642980157812, 37.778703483956278],
            [-122.385619007862559, 37.778713481784578],
            [-122.385549680005639, 37.778709096834618],
            [-122.385525708373962, 37.778719094083733],
            [-122.385451191384348, 37.778714792068747],
            [-122.385428949109837, 37.778724761915029],
            [-122.385354432120124, 37.778720459838901],
            [-122.385330442694098, 37.778729770883643],
            [-122.385257672841163, 37.778726127529652],
            [-122.385235413119702, 37.778735411169237],
            [-122.385147302363819, 37.778740940194126],
            [-122.385154355852308, 37.778814307082541],
            [-122.385130156934849, 37.778815380480168],
            [-122.385113449499144, 37.778634352661491],
            [-122.385137630588289, 37.778632592828004],
            [-122.385155236200447, 37.778712657669637],
            [-122.385222625586081, 37.778708833443275],
            [-122.385225758626859, 37.778627749705855],
            [-122.38525718494833, 37.778706907076334],
            [-122.38531938483824, 37.778703165506691],
            [-122.385322517780125, 37.778622082041188],
            [-122.385352214498553, 37.778701267322347],
            [-122.385416144082598, 37.778697497765265],
            [-122.385419276918626, 37.778616414297126],
            [-122.385450703441506, 37.77869557161619],
            [-122.38551290331219, 37.778691829944421],
            [-122.385517765757882, 37.778610719084014],
            [-122.38554746266594, 37.778689903767003],
            [-122.385606220534413, 37.778686903820002],
            [-122.385611082870923, 37.77860579268107],
            [-122.385640779890451, 37.778684977889775],
            [-122.385704709445832, 37.778681208176224],
            [-122.385707841966195, 37.778600124700183],
            [-122.385739268789678, 37.778679281942566],
            [-122.385798008866331, 37.778675595460832],
            [-122.385801141637501, 37.77859451225126],
            [-122.385832568205146, 37.778673669199819],
            [-122.385896498100962, 37.77866989992588],
            [-122.385899630058546, 37.778588816175542],
            [-122.385931057427598, 37.778667973361443],
            [-122.385991527195401, 37.778664259112972],
            [-122.385994659747908, 37.778583175623524],
            [-122.386026086530904, 37.778662333069811],
            [-122.386090016393183, 37.778658563141803],
            [-122.386093148146045, 37.778577479660726],
            [-122.386124575716508, 37.778656636795191],
            [-122.386185062898718, 37.778653608892128],
            [-122.386202015472293, 37.778571617834082],
            [-122.386209244307707, 37.778651848558759],
            [-122.386280092656236, 37.778647968384718],
            [-122.386284954247373, 37.778566856942867],
            [-122.386314651962735, 37.778646041707809],
            [-122.386380311166334, 37.778642244226567],
            [-122.386385172654656, 37.778561133055092],
            [-122.386414870481516, 37.778640318069463],
            [-122.386473610832795, 37.778636630970986],
            [-122.386476742511945, 37.778555547473879],
            [-122.386508170135954, 37.778634704511973],
            [-122.386577288736902, 37.778630851563484],
            [-122.386580420309613, 37.778549768338095],
            [-122.386611848034704, 37.778628925074045],
            [-122.386670588381151, 37.778625238426613],
            [-122.386673719491867, 37.778544154655052],
            [-122.386705147666916, 37.778623311635243],
            [-122.386762158289017, 37.778619652349228],
            [-122.386765307091096, 37.778539255288756],
            [-122.386796717583763, 37.778617726080171],
            [-122.386864106438878, 37.778613900371958],
            [-122.386867237344845, 37.778532816869664],
            [-122.386898665721333, 37.778611973798455],
            [-122.386959152842579, 37.77860894577281],
            [-122.386962284329485, 37.778527861982276],
            [-122.38699369467254, 37.778606332452348],
            [-122.387057641885832, 37.778603248718746],
            [-122.387060772580114, 37.778522165211164],
            [-122.387092183716675, 37.778600635643997],
            [-122.38715094145212, 37.778597634927166],
            [-122.387154334023649, 37.778526848079068],
            [-122.387183771011991, 37.778595735958248],
            [-122.38724942978078, 37.778591937998534],
            [-122.387254551963991, 37.778521123457843],
            [-122.387283989043027, 37.778590011312069],
            [-122.387351378207768, 37.778586185868939],
            [-122.387340432224974, 37.778359741993853],
            [-122.385336224880277, 37.778480397809368],
            [-122.385292215885698, 37.77845088576418],
            [-122.385332752982109, 37.778411780987071],
            [-122.385371486072913, 37.77843794377425],
            [-122.387505436887736, 37.778315896876499],
            [-122.387507690304943, 37.778336462786434],
            [-122.387691125877438, 37.77833695908997],
            [-122.387623881872372, 37.778210305157842],
            [-122.390410335866818, 37.777142437885963],
            [-122.390374260520773, 37.777113759158638],
            [-122.390348522259259, 37.777093298197975],
            [-122.389857561580598, 37.776499598895249],
            [-122.389810930692391, 37.776503093591124],
            [-122.389821814335647, 37.776590819837281],
            [-122.38767762612953, 37.776716506820485],
            [-122.387616143310936, 37.776748393866363],
            [-122.387584974466847, 37.776747519757691],
            [-122.387567625478937, 37.776745737093393],
            [-122.387552006163176, 37.776743927007061],
            [-122.387536369402838, 37.776741430474004],
            [-122.387505026105131, 37.776733691622944],
            [-122.387489337013818, 37.776729135749626],
            [-122.387475360143554, 37.776723865736592],
            [-122.387461365830632, 37.776717909277224],
            [-122.387447354082425, 37.776711266646082],
            [-122.387419295684069, 37.77669660766567],
            [-122.387406978711525, 37.776688564173618],
            [-122.387394643958672, 37.776679834515676],
            [-122.387373399569938, 37.776660946088832],
            [-122.387362760285328, 37.776650815560998],
            [-122.38735385031967, 37.776640657346583],
            [-122.387344922566982, 37.776629812692306],
            [-122.387335978065309, 37.776618281581548],
            [-122.387328762881694, 37.776606722784834],
            [-122.387323277015341, 37.77659513630249],
            [-122.387316044392662, 37.776582891060237],
            [-122.387312271446064, 37.776570590705511],
            [-122.387306768480713, 37.776558317497482],
            [-122.387304707400645, 37.776545302738185],
            [-122.387302663771393, 37.776532974698164],
            [-122.387298541607819, 37.776506944904682],
            [-122.387299939508821, 37.776493875044565],
            [-122.387299608083069, 37.776480832320061],
            [-122.387311076202096, 37.776319268586136],
            [-122.387103587414643, 37.776325337046984],
            [-122.387082386717438, 37.776103864569507],
            [-122.385027425864848, 37.776335891081246],
            [-122.385011788936296, 37.776333394493314],
            [-122.384999507467228, 37.776326723359297],
            [-122.384988868215274, 37.776316592896777],
            [-122.385025875302759, 37.776274797468226],
            [-122.384827030762366, 37.775394163410851],
            [-122.384880527469605, 37.775388501004997],
            [-122.384877317104468, 37.775330181090084],
            [-122.386995863440688, 37.775082030997162],
            [-122.386923061819843, 37.774327799469994],
            [-122.381813822024597, 37.774615486663201],
            [-122.381456516831207, 37.771917559332238],
            [-122.384671101595274, 37.773340605158566],
            [-122.384690336061794, 37.773348538332996],
            [-122.384706059111224, 37.773354467747083],
            [-122.38472349432422, 37.773359682786399],
            [-122.384740912113955, 37.773364211103086],
            [-122.384758312493929, 37.773368053246259],
            [-122.384775695456668, 37.773371208941398],
            [-122.384793061001673, 37.77337367818847],
            [-122.384812120957065, 37.773374747168276],
            [-122.384829452003999, 37.773375843238945],
            [-122.384848494879705, 37.773376225487283],
            [-122.38486577332894, 37.77337526249628],
            [-122.386759568868584, 37.773272861257844],
            [-122.386575835242937, 37.772851405934894],
            [-122.38657206225551, 37.772839105279289],
            [-122.386575190127743, 37.772826007459408],
            [-122.386581812023351, 37.772814227444925],
            [-122.386593692364443, 37.772805109622055],
            [-122.386717419519911, 37.772771540111776],
            [-122.386708370613761, 37.772755890279406],
            [-122.386704597609267, 37.772743589627844],
            [-122.386699094688865, 37.772731316663254],
            [-122.386691548686684, 37.772706715359256],
            [-122.38668746217553, 37.772682058686371],
            [-122.386685401318488, 37.772669044181889],
            [-122.386683357538772, 37.772656715579039],
            [-122.386682694959006, 37.772630630932561],
            [-122.386684111009814, 37.772618246955815],
            [-122.386683779716421, 37.772605204495207],
            [-122.386685195434609, 37.772592821073083],
            [-122.386688340360166, 37.772580409425913],
            [-122.386661929793348, 37.772494305123679],
            [-122.386659886368264, 37.772481976514491],
            [-122.386661302081109, 37.772469592817821],
            [-122.38666965348915, 37.772457784842032],
            [-122.386681551212874, 37.772449354004202],
            [-122.386714186256512, 37.772439903990914],
            [-122.386679336788333, 37.772362175448528],
            [-122.386644902453284, 37.772368906802633],
            [-122.386631976023693, 37.772336837636807],
            [-122.386620901217455, 37.772309545906367],
            [-122.386592865526183, 37.772227587668034],
            [-122.386585249868389, 37.772200240573625],
            [-122.386577616780784, 37.772172207033208],
            [-122.386570001134302, 37.772144859937534],
            [-122.386558193761417, 37.772088737774723],
            [-122.386541497954923, 37.771976381892166],
            [-122.386539053911875, 37.771948265304715],
            [-122.386438565499603, 37.771943006477983],
            [-122.386459543589496, 37.771678968587629],
            [-122.386414488196351, 37.771676255706971],
            [-122.386416883827636, 37.771634327179655],
            [-122.386370064064607, 37.77163026961771],
            [-122.386370799901215, 37.771591114275026],
            [-122.386346586274058, 37.771591501747267],
            [-122.386349295737674, 37.771561929239198],
            [-122.386373509355195, 37.77156154176641],
            [-122.386383018231356, 37.77145906765827],
            [-122.386277185313745, 37.771447713434846],
            [-122.386286481744634, 37.771404987761201],
            [-122.386248187810011, 37.771395986654248],
            [-122.386213474980906, 37.771391735029944],
            [-122.386175916991888, 37.77134357828146],
            [-122.386158586399219, 37.771342482408336],
            [-122.386142916299207, 37.771338612516935],
            [-122.386128940538697, 37.771333342339254],
            [-122.386116624249169, 37.771325298710295],
            [-122.38610598590013, 37.771315168059481],
            [-122.386097059315517, 37.771304323294956],
            [-122.386091556948031, 37.771292050293354],
            [-122.386142815223778, 37.771266508342599],
            [-122.38608534348306, 37.771183647247369],
            [-122.386039082134474, 37.771201555805888],
            [-122.386023428808656, 37.771198372355109],
            [-122.386011095814837, 37.771189642258307],
            [-122.386041843996964, 37.771174042639558],
            [-122.38589549059256, 37.770997835524099],
            [-122.385920430782591, 37.770821635056869],
            [-122.385847920885212, 37.770691630725352],
            [-122.385837299399952, 37.770682186505887],
            [-122.385823306356514, 37.770676229845748],
            [-122.385795755972097, 37.770681477661917],
            [-122.3857856231634, 37.770691253905198],
            [-122.385782477468226, 37.770703665268918],
            [-122.385798079922523, 37.771250048587049],
            [-122.385622255652152, 37.772162083932052],
            [-122.385554576344688, 37.772154239361129],
            [-122.385681891861481, 37.771444190077446],
            [-122.385515420224039, 37.771429684819722],
            [-122.38546780756441, 37.771530707856108],
            [-122.385335917119292, 37.771651620630855],
            [-122.385287036807085, 37.771634547559174],
            [-122.385642517132254, 37.770847369439849],
            [-122.385683664105002, 37.770764304300435],
            [-122.385720236601344, 37.770637361956886],
            [-122.385724274638122, 37.77059197382043],
            [-122.385559320924514, 37.770637189122013],
            [-122.383154992189901, 37.769708715839762],
            [-122.383375582677616, 37.76933298733065],
            [-122.385570199525418, 37.770179656618097],
            [-122.385492733315886, 37.769990673321502],
            [-122.38547497668678, 37.769836444052352],
            [-122.38501929687861, 37.768856908704215],
            [-122.384893636964136, 37.768882266758567],
            [-122.384787561607197, 37.76865665734794],
            [-122.38500549801104, 37.768585873156887],
            [-122.385007528170945, 37.768529529274218],
            [-122.385037840293677, 37.768496768478933],
            [-122.385006697245259, 37.768428594043755],
            [-122.38508052413836, 37.768406124957501],
            [-122.385042550658142, 37.768341493386622],
            [-122.38510771303342, 37.768318476117585],
            [-122.385167686616882, 37.76829554179551],
            [-122.385149073018809, 37.768175662662372],
            [-122.385147029970554, 37.768163334292169],
            [-122.385144812710706, 37.768144141461285],
            [-122.38470084491486, 37.768171155877575],
            [-122.384624005099198, 37.768074869544797],
            [-122.383881223535184, 37.768121766230543],
            [-122.383842264982363, 37.767745376829602],
            [-122.382456893000523, 37.767832748125578],
            [-122.382439473722869, 37.767691561099248],
            [-122.384901003015941, 37.7675361686969],
            [-122.384848518174209, 37.767018283287165],
            [-122.384847918040649, 37.767012360130963],
            [-122.382854528282635, 37.767138299649837],
            [-122.382800567665527, 37.766784124750316],
            [-122.385859942984411, 37.766599245791156],
            [-122.385894343938588, 37.766523155929399],
            [-122.385924379700455, 37.76641142564803],
            [-122.385933483994975, 37.766361149056699],
            [-122.385914237836445, 37.766284543788501],
            [-122.385992644580284, 37.766169979928648],
            [-122.386291877422522, 37.765689977677845],
            [-122.386372587962043, 37.765598038596792],
            [-122.386520103480208, 37.765411635088689],
            [-122.386541125110512, 37.765285627921941],
            [-122.386469993174757, 37.765277839225583],
            [-122.386436744413672, 37.76505861928149],
            [-122.386447302231559, 37.764929345689509],
            [-122.386483096429387, 37.76490817106005],
            [-122.386501478211272, 37.764814482226171],
            [-122.386491269379732, 37.764616868735338],
            [-122.38644793023208, 37.764613442288407],
            [-122.386451155646682, 37.764399819097633],
            [-122.386482284438713, 37.7643993208899],
            [-122.386481482527714, 37.764367744084808],
            [-122.386603169586195, 37.764322532741204],
            [-122.386601548243974, 37.76425869323451],
            [-122.386585931922852, 37.764256883010674],
            [-122.386571940029569, 37.764250926432666],
            [-122.38656131971895, 37.764241482262236],
            [-122.38655581779787, 37.764229209267128],
            [-122.38655550400469, 37.764216853507875],
            [-122.386720358990686, 37.764100218114386],
            [-122.386739211018067, 37.764025063281011],
            [-122.386733691302794, 37.764012103852934],
            [-122.38672476584992, 37.764001259116526],
            [-122.386714128120815, 37.763991128513133],
            [-122.38670010140504, 37.763983799331974],
            [-122.386686126988522, 37.763978529213567],
            [-122.386670492591179, 37.763976032291019],
            [-122.386649740182264, 37.763976364463595],
            [-122.386634036749314, 37.763971122014347],
            [-122.386621721632579, 37.763963078702353],
            [-122.386611066835059, 37.763952261637705],
            [-122.386603852994298, 37.763940702770881],
            [-122.386600062668251, 37.763927715381541],
            [-122.386601461140231, 37.763914645215138],
            [-122.386604606072254, 37.763902234094914],
            [-122.386738907102767, 37.763808749639459],
            [-122.386828889531799, 37.763741383598706],
            [-122.386840716091143, 37.763730206671987],
            [-122.386855983933643, 37.763718287929905],
            [-122.386869539846316, 37.763707083316298],
            [-122.386884824769794, 37.763695851022327],
            [-122.386900145253236, 37.763685991607943],
            [-122.38691721218359, 37.763676790958648],
            [-122.386934296546428, 37.763668276753165],
            [-122.386951398349183, 37.763660449266119],
            [-122.386970246931185, 37.763653279988162],
            [-122.386989112953756, 37.763646797428088],
            [-122.387007996064526, 37.763641001316863],
            [-122.387026897301666, 37.763635891637833],
            [-122.387047562432002, 37.763632127441824],
            [-122.387066515625051, 37.76362907682639],
            [-122.387271786163467, 37.763605188503739],
            [-122.387241692331358, 37.763510215504958],
            [-122.386905339639924, 37.763549936808673],
            [-122.386894896912324, 37.763479371256736],
            [-122.386775626938885, 37.763415354890846],
            [-122.386725141086345, 37.763471101073094],
            [-122.386629276523749, 37.763443106355105],
            [-122.386635775530237, 37.763426520918784],
            [-122.386503316054672, 37.763388124513462],
            [-122.386596764100844, 37.763184731253212],
            [-122.386314395824243, 37.763102036396099],
            [-122.386214308919619, 37.763316522997265],
            [-122.385510514730285, 37.763329843761532],
            [-122.385502904472929, 37.763234510683318],
            [-122.385278141497096, 37.763240166132988],
            [-122.385288368966343, 37.763370480347639],
            [-122.38518118352205, 37.763373568175126],
            [-122.385104258477085, 37.762319301701545],
            [-122.384682038971576, 37.762111108737756],
            [-122.384291646501694, 37.762134518628663],
            [-122.384461265879253, 37.764047083641032],
            [-122.384304084745608, 37.764057150214732],
            [-122.384132119672074, 37.762256559028991],
            [-122.383427389000644, 37.762300785113965],
            [-122.383450606038608, 37.762465914870035],
            [-122.383630300057192, 37.762456862777178],
            [-122.3836690703355, 37.762553071423532],
            [-122.383744969614881, 37.762544304446941],
            [-122.383904907669475, 37.764143878058199],
            [-122.383832343655854, 37.764147784454543],
            [-122.383810360659879, 37.764236036587789],
            [-122.383580701961776, 37.764253441592125],
            [-122.383538646212543, 37.764164152408867],
            [-122.383462623420698, 37.764168114122675],
            [-122.383459954192517, 37.764131073630139],
            [-122.383299279201026, 37.764139821513076],
            [-122.383109557752064, 37.762320284660944],
            [-122.382290828789408, 37.762371818989514],
            [-122.38251353675102, 37.764606298459128],
            [-122.382344144468703, 37.764612437347246],
            [-122.382121545934865, 37.762382076243206],
            [-122.38174844490716, 37.762405201559091],
            [-122.381695087947634, 37.764738170521944],
            [-122.381631135065035, 37.764740565182315],
            [-122.381630936164214, 37.764801000118787],
            [-122.381492672008349, 37.764806640579245],
            [-122.381450941763589, 37.76493503772344],
            [-122.381172352882004, 37.76493330344676],
            [-122.381123981911756, 37.764799477425129],
            [-122.380983831900423, 37.764798967139676],
            [-122.381029346103958, 37.762223710202747],
            [-122.38330764917707, 37.762081573209855],
            [-122.382185556454559, 37.760879873475361],
            [-122.382168402620636, 37.760885641207267],
            [-122.382152908506868, 37.760888635257665],
            [-122.382137362223574, 37.760889570238476],
            [-122.382121780810863, 37.760889132328003],
            [-122.38210441862546, 37.760886662951151],
            [-122.382090445117498, 37.760881392285128],
            [-122.382076454213362, 37.760875434895482],
            [-122.382064140442054, 37.760867390822959],
            [-122.382053521188098, 37.760857946240883],
            [-122.382044596105573, 37.76084710115525],
            [-122.382023253267107, 37.760824093302155],
            [-122.382014294110562, 37.760811875582888],
            [-122.382005317206719, 37.760798970871889],
            [-122.381998069607818, 37.76078603882209],
            [-122.381986997879679, 37.76075874660679],
            [-122.381983174441103, 37.760744386430567],
            [-122.381981079958692, 37.760729998921875],
            [-122.381980366958516, 37.760701854577775],
            [-122.381981731049137, 37.76068741129496],
            [-122.381984824092612, 37.760672940679711],
            [-122.38198793521687, 37.760659156500736],
            [-122.381992775285752, 37.760645344714604],
            [-122.381695267558513, 37.760647347915544],
            [-122.381838070964363, 37.762118779804872],
            [-122.381335375976406, 37.762148093200558],
            [-122.381148296266858, 37.760157516712624],
            [-122.380611046370689, 37.760188065470565],
            [-122.380912187127535, 37.763336013717719],
            [-122.380701275367471, 37.763342126118935],
            [-122.380400282533174, 37.760199669192616],
            [-122.379507164112297, 37.760250310896886],
            [-122.379808005517475, 37.763456637815253],
            [-122.379779318273378, 37.763485250755494],
            [-122.379565016753276, 37.763494162073435],
            [-122.379533176547326, 37.763466514378344],
            [-122.379201704975202, 37.759937914686475],
            [-122.381256986630419, 37.759667520373661],
            [-122.381256577752055, 37.759583059710486],
            [-122.381469121143184, 37.759573486743299],
            [-122.381446760180623, 37.75930533388199],
            [-122.381389798546991, 37.759310363785765],
            [-122.381303248927566, 37.759308311423226],
            [-122.381202252005025, 37.758325846274602],
            [-122.381200105587652, 37.758309399127988],
            [-122.381197941449869, 37.758292265813587],
            [-122.381197089710227, 37.758258629870305],
            [-122.381199679398975, 37.758224251997007],
            [-122.381200991455458, 37.758207749648136],
            [-122.38120401536365, 37.75819053325035],
            [-122.381207056652954, 37.758174003300283],
            [-122.381221367866601, 37.758124330651064],
            [-122.381234402126012, 37.75809253323947],
            [-122.381242648836448, 37.758076607200529],
            [-122.381262669528837, 37.75804744489573],
            [-122.381289433303067, 37.758011307974613],
            [-122.381302797797105, 37.757992553063836],
            [-122.381314432708805, 37.757973825759706],
            [-122.381327797196747, 37.757955071120548],
            [-122.381337703552219, 37.757936371131194],
            [-122.381360938912749, 37.75789754361324],
            [-122.381380716140868, 37.757858771292213],
            [-122.381390587715856, 37.757838698951588],
            [-122.381398729699725, 37.757818653670306],
            [-122.381408600911726, 37.757798581058942],
            [-122.381416742893265, 37.757778536050878],
            [-122.381423155645805, 37.757758518646433],
            [-122.381431297626008, 37.7577384739118],
            [-122.381444088336707, 37.757697065930351],
            [-122.381450501074838, 37.757677048524144],
            [-122.381464499104396, 37.757615019779642],
            [-122.381469148185403, 37.757593657075738],
            [-122.381475021977749, 37.757552359783979],
            [-122.381477941486636, 37.757531024690024],
            [-122.381480843608969, 37.757509003148037],
            [-122.381427480867771, 37.75751946944429],
            [-122.381405721286413, 37.757343328372727],
            [-122.381468641764485, 37.757300433411309],
            [-122.381446638421224, 37.75711468207534],
            [-122.381323864533158, 37.757116641937891],
            [-122.381323169199888, 37.757089184020202],
            [-122.381364426846005, 37.75707891127486],
            [-122.381321992818584, 37.756564544822638],
            [-122.381321662531036, 37.756551502035926],
            [-122.38132307883005, 37.756539118369027],
            [-122.381326206602509, 37.756526020931318],
            [-122.381331099013835, 37.756514268226432],
            [-122.381339449129754, 37.756502460600949],
            [-122.381347834701543, 37.756492025859821],
            [-122.381357966510507, 37.756482250242897],
            [-122.381369844881263, 37.756473132920476],
            [-122.381383504601786, 37.756466047611781],
            [-122.381397181710526, 37.756459649024094],
            [-122.381399266420004, 37.75640536415446],
            [-122.381383669266881, 37.756404239961626],
            [-122.381368019603769, 37.756401055879024],
            [-122.381354081758502, 37.756397158017677],
            [-122.381338379955181, 37.756391914861666],
            [-122.381324389963666, 37.756385957652711],
            [-122.38129976407464, 37.756369869336808],
            [-122.381289145560629, 37.756360424678547],
            [-122.381280238512659, 37.756350265974667],
            [-122.381265813968113, 37.756327147557755],
            [-122.381260331236177, 37.756315560741236],
            [-122.381258271437829, 37.756302546110341],
            [-122.381256229700497, 37.756290217367201],
            [-122.381255916815178, 37.756277861302344],
            [-122.381240855709805, 37.755888041607285],
            [-122.381237067430561, 37.75587505429101],
            [-122.381229855216972, 37.755863495353786],
            [-122.381219219049328, 37.755853363971241],
            [-122.381205211793798, 37.755846720574091],
            [-122.381189545219783, 37.75584285001387],
            [-122.381023178934683, 37.755831084166076],
            [-122.381005052890941, 37.755798410637965],
            [-122.380939344081298, 37.755799459348452],
            [-122.380938179657051, 37.755753467322073],
            [-122.381031311951133, 37.755742366765169],
            [-122.381010248974547, 37.755730341878809],
            [-122.38098743910173, 37.755717658143908],
            [-122.380924145958886, 37.755677464760758],
            [-122.380881915817497, 37.755649296531168],
            [-122.380862530269653, 37.755635184397235],
            [-122.380841397836633, 37.755620413687737],
            [-122.380821994593731, 37.755605615653565],
            [-122.380802573973469, 37.755590130893374],
            [-122.38078488252836, 37.755574618260482],
            [-122.380758354080839, 37.755551693216646],
            [-122.380751124581494, 37.755539447252119],
            [-122.380745589509232, 37.755525801070959],
            [-122.38074007147074, 37.755512841343261],
            [-122.380736283298162, 37.75549985401004],
            [-122.38073074823852, 37.755486208102681],
            [-122.380728671510397, 37.755472506457778],
            [-122.380724865279745, 37.755458832961516],
            [-122.380718635462969, 37.755417728569704],
            [-122.380718270538722, 37.755403313156876],
            [-122.380719652161702, 37.755389556598288],
            [-122.380719304614729, 37.755375827633614],
            [-122.380722067512963, 37.755348314521783],
            [-122.380728289091294, 37.755320746216135],
            [-122.380731417602021, 37.755307648505891],
            [-122.380736257562816, 37.755293837033165],
            [-122.38074597221329, 37.755267586159846],
            [-122.380759145196464, 37.755241280371166],
            [-122.380767425749198, 37.755226726990642],
            [-122.380777557807846, 37.755216951415953],
            [-122.380789436047536, 37.755207834150042],
            [-122.3808030608416, 37.755199376285184],
            [-122.380814973485883, 37.755191631918663],
            [-122.380828633023739, 37.75518454667273],
            [-122.380844056826504, 37.755178806720394],
            [-122.380857751116352, 37.755173094367549],
            [-122.380873209326097, 37.755168727313375],
            [-122.380888684919853, 37.755165046980004],
            [-122.380905907041537, 37.755162024947012],
            [-122.380921434762783, 37.75516040367944],
            [-122.380952524623297, 37.755158534314724],
            [-122.380976698502963, 37.755156774772679],
            [-122.380999125498533, 37.755154356655588],
            [-122.381021534766717, 37.755151252091551],
            [-122.381043927344422, 37.755147461063977],
            [-122.381066302193489, 37.755142983589487],
            [-122.38108865965917, 37.755137819662529],
            [-122.38111099939502, 37.755131969288627],
            [-122.38113332243789, 37.755125432451251],
            [-122.381153915967687, 37.755118923215505],
            [-122.381176203900949, 37.755111013753655],
            [-122.38119676265265, 37.755103131339425],
            [-122.381225828164943, 37.755089619604064],
            [-122.381246943141264, 37.755103703797808],
            [-122.381242963358787, 37.755083165829973],
            [-122.38126015068255, 37.755078770848776],
            [-122.381277355393678, 37.755075062587856],
            [-122.381292865706087, 37.755072754823154],
            [-122.38131010484075, 37.755070419733926],
            [-122.381327362035009, 37.75506877053013],
            [-122.381361945276268, 37.755068218467898],
            [-122.381396598051168, 37.755070412188203],
            [-122.381413958860932, 37.755072881946376],
            [-122.381448715950555, 37.755079194614936],
            [-122.381480084590436, 37.755088307721437],
            [-122.381497532329476, 37.755094209708098],
            [-122.381511539483228, 37.755100853620512],
            [-122.381527276134307, 37.755107469370813],
            [-122.381548321633034, 37.755118807717949],
            [-122.381562363566104, 37.755126824520609],
            [-122.381579829044853, 37.755133412663042],
            [-122.381595565024199, 37.755140028689837],
            [-122.381612996090695, 37.755145244200165],
            [-122.381630391696547, 37.755149086822691],
            [-122.381647770609987, 37.755152242983492],
            [-122.381665131447221, 37.755154712704652],
            [-122.381684187368847, 37.755155781907895],
            [-122.38170149639484, 37.755156192273823],
            [-122.382833235564902, 37.755035795269471],
            [-122.383668861276263, 37.754971624407645],
            [-122.383685978819074, 37.754964483555838],
            [-122.38372028351472, 37.754952947636127],
            [-122.383737470668777, 37.75494855256818],
            [-122.383756404038564, 37.75494481631263],
            [-122.383773626345388, 37.754941794129564],
            [-122.383792594868737, 37.754939430758334],
            [-122.383811580457817, 37.754937754111957],
            [-122.38384268824322, 37.754936570147059],
            [-122.383861726388119, 37.754936952556008],
            [-122.383880781586896, 37.754938021140639],
            [-122.383896396575224, 37.754939831714687],
            [-122.384073136269635, 37.754951427650568],
            [-122.384099862744918, 37.754913917176538],
            [-122.384076095308828, 37.754658835300546],
            [-122.383998950777894, 37.754618177983438],
            [-122.383899356302948, 37.754647239093948],
            [-122.383797997440993, 37.754674954869053],
            [-122.383696604385719, 37.754701297650087],
            [-122.383569360630759, 37.75473148712782],
            [-122.383548680403266, 37.754734564546567],
            [-122.3835279827709, 37.754736955513799],
            [-122.383505538587656, 37.754738687938882],
            [-122.38348480614728, 37.754739706002738],
            [-122.383441577306456, 37.754740396857535],
            [-122.383400008003704, 37.754738313997002],
            [-122.38337920595491, 37.754736586250608],
            [-122.383356657006146, 37.754734199690795],
            [-122.383335820163737, 37.754731099315492],
            [-122.383314965907985, 37.754727311939398],
            [-122.383295841160447, 37.754723497196949],
            [-122.383254063070865, 37.754713177184357],
            [-122.383234885782983, 37.75470730309371],
            [-122.383213961945074, 37.754700770182538],
            [-122.383194767270453, 37.754694209911989],
            [-122.383175537439726, 37.754686276198775],
            [-122.383158037470992, 37.754678315390812],
            [-122.383138807994129, 37.754670381666052],
            [-122.383103737780345, 37.754651713981168],
            [-122.383086185277548, 37.75464169354953],
            [-122.383068615380594, 37.754630986667287],
            [-122.383052774639708, 37.754620252154247],
            [-122.383036916504807, 37.754608831191064],
            [-122.383015731729387, 37.754592001250259],
            [-122.38299259130558, 37.754566275663684],
            [-122.382971180378888, 37.754540521890775],
            [-122.382949752076243, 37.754514081940449],
            [-122.382930053282664, 37.754487614354218],
            [-122.382908625009904, 37.754461174396191],
            [-122.382888908501968, 37.754434020360335],
            [-122.382870920808742, 37.754406838701115],
            [-122.382842850708954, 37.754363390808408],
            [-122.382816907001839, 37.754323234339928],
            [-122.382797016608123, 37.754289216082142],
            [-122.382791480900465, 37.754275569725095],
            [-122.382785928504248, 37.754261237457797],
            [-122.38278210489284, 37.754246877022375],
            [-122.382781722177867, 37.754231775164968],
            [-122.382784449823419, 37.754202889097733],
            [-122.382789271581657, 37.754188390821014],
            [-122.382795840220822, 37.754174551362205],
            [-122.382804155740061, 37.754161370721022],
            [-122.382814217447034, 37.754148848908173],
            [-122.382826043083483, 37.754137672365715],
            [-122.382839615252593, 37.75412715464509],
            [-122.382853204821586, 37.754117323645531],
            [-122.382868575702929, 37.754109523814002],
            [-122.382885693124038, 37.754102383077345],
            [-122.382904591526582, 37.754097274061955],
            [-122.382896892098685, 37.754066494402807],
            [-122.382890922160428, 37.754035687111681],
            [-122.382884969278336, 37.754005566273698],
            [-122.382876487005475, 37.753943896449059],
            [-122.382873975008934, 37.75391303391072],
            [-122.382869733880582, 37.753882198997694],
            [-122.382868951022118, 37.753851308833418],
            [-122.382866421635015, 37.753819759846344],
            [-122.382865638778583, 37.753788869681728],
            [-122.38286753098933, 37.753727034381221],
            [-122.382869667430043, 37.75367480879347],
            [-122.382867485984363, 37.753656988767865],
            [-122.382865286797127, 37.753638482299571],
            [-122.382861376571569, 37.753620689893637],
            [-122.382850096841622, 37.753585160622798],
            [-122.382842745420064, 37.753568109920103],
            [-122.382833665214591, 37.753551086561764],
            [-122.382822855548582, 37.753534091107603],
            [-122.382812063283737, 37.753517782100509],
            [-122.382801288419827, 37.753502159540567],
            [-122.382788801838672, 37.753487251326646],
            [-122.382774586124242, 37.75347237018628],
            [-122.382742765715449, 37.753445409495008],
            [-122.382726873440859, 37.753432615860532],
            [-122.382709269084074, 37.753420535751609],
            [-122.382691682135089, 37.753409142362763],
            [-122.382672383117907, 37.753398463047603],
            [-122.382653119587403, 37.753389156614546],
            [-122.382611168393765, 37.753371971889877],
            [-122.382590227592559, 37.7533647524183],
            [-122.382569321590282, 37.753358906113988],
            [-122.382546703510585, 37.753353773605845],
            [-122.382524103512239, 37.753349327255975],
            [-122.382501520571083, 37.75334556763007],
            [-122.382478972425403, 37.753343181170841],
            [-122.382456441314361, 37.753341480611873],
            [-122.382433945688362, 37.753341153208574],
            [-122.382402821501856, 37.753341650348268],
            [-122.38237864858533, 37.753343409903252],
            [-122.382356222188207, 37.753345828558139],
            [-122.382297501266095, 37.753349513077993],
            [-122.38226810654271, 37.753349982559506],
            [-122.382240423203967, 37.753349737974666],
            [-122.382210993352999, 37.753348834550927],
            [-122.382181546112378, 37.753347244671602],
            [-122.382152081137065, 37.753344968342162],
            [-122.382124328241176, 37.753341977937026],
            [-122.382094811792641, 37.753337642237426],
            [-122.38206700673382, 37.753332592473967],
            [-122.382039184289724, 37.753326856255676],
            [-122.38201134446112, 37.753320433582523],
            [-122.38200001736864, 37.75331754288009],
            [-122.381983487255724, 37.753313324729064],
            [-122.381957341428489, 37.753305501265011],
            [-122.3819294494578, 37.75329701950217],
            [-122.38187705455077, 37.753277254112369],
            [-122.381850839550978, 37.753266685100435],
            [-122.3818017982653, 37.753242746046119],
            [-122.381777242861062, 37.753229403614625],
            [-122.381754416238635, 37.753216033574361],
            [-122.381731572936843, 37.753201977344837],
            [-122.381708677132991, 37.753185861496782],
            [-122.381985040410456, 37.753169774197133],
            [-122.382560765120331, 37.753136419940226],
            [-122.382560989570067, 37.75313671714089],
            [-122.382951309683904, 37.753114103639163],
            [-122.383438933023925, 37.753085850281579],
            [-122.383914427464433, 37.753058600498669],
            [-122.384879974685347, 37.753002645165687],
            [-122.385845520438053, 37.752946681373402],
            [-122.385845731512404, 37.752946669205699],
            [-122.386811064397406, 37.752890709951139],
            [-122.386811676199414, 37.752890674609837],
            [-122.387755875750031, 37.752835749697695],
            [-122.387756291326852, 37.752835725460692],
            [-122.387756280477618, 37.752835611637821],
            [-122.387633974640565, 37.751559603455405],
            [-122.387585270262662, 37.750263378063039],
            [-122.388507729357968, 37.750205975353602],
            [-122.389478017653872, 37.750145107673561],
            [-122.390433038183829, 37.750118341633915],
            [-122.391418367221192, 37.750140606282606],
            [-122.391693805117924, 37.750111668488358],
            [-122.391705979739527, 37.750110389401705],
            [-122.391714686151033, 37.750109474739723],
            [-122.391929934247997, 37.750086859865874],
            [-122.392350740047519, 37.750026024134087],
            [-122.392354048972692, 37.750025545503377],
            [-122.392381992909165, 37.750021506018193],
            [-122.393314555211816, 37.749918012051069],
            [-122.393322792145199, 37.749917097944952],
            [-122.393340265733656, 37.749915158351328],
            [-122.395231400136637, 37.749808114846253],
            [-122.395307862010839, 37.749803786070743],
            [-122.396273544250747, 37.74974560058007],
            [-122.397285415820363, 37.749684622841229],
            [-122.40206163398004, 37.749396678541473],
            [-122.402063015501824, 37.749396333205695],
            [-122.402215286387033, 37.749358244852793],
            [-122.402746245055127, 37.749375020002113],
            [-122.402866303074774, 37.749478453789486],
            [-122.402866309087059, 37.749478458911533],
            [-122.402968925612569, 37.749550036933734],
            [-122.403054692816028, 37.74954427306843],
            [-122.403203674195439, 37.749534260068266],
            [-122.403260968692152, 37.749530409553117],
            [-122.403568849778438, 37.749475672986911],
            [-122.403592456970202, 37.749471475909672],
            [-122.403667613571599, 37.749458113882532],
            [-122.403783562755194, 37.749432891426196],
            [-122.403735650894049, 37.749583872707518],
            [-122.403514246938869, 37.750281563827826],
            [-122.403378511001179, 37.750679445903444],
            [-122.403214572776321, 37.751164169122518],
            [-122.403175027775376, 37.751281093014263],
            [-122.403072643662085, 37.751794247946641],
            [-122.403060331379024, 37.751915861053995],
            [-122.403006670294943, 37.752445905732571],
            [-122.402978169178084, 37.75275045704997],
            [-122.40301031565609, 37.753201877425177],
            [-122.403011715723153, 37.753221541143297],
            [-122.403127143734139, 37.75447773377249],
            [-122.403244936870763, 37.755759623462495],
            [-122.403245024221292, 37.755760575231484],
            [-122.403305530792395, 37.756165877853867],
            [-122.403395700993769, 37.756471262485057],
            [-122.403543859417937, 37.75680412126377],
            [-122.403689260967766, 37.757015002579273],
            [-122.403774084903432, 37.757138026202746],
            [-122.403774405770974, 37.757138490742172],
            [-122.404168659910013, 37.75752977302043],
            [-122.404441730762329, 37.757748221369937],
            [-122.40472107938929, 37.757950649275713],
            [-122.404835145723425, 37.7580339263735],
            [-122.405048169961901, 37.758189448369819],
            [-122.405545221503274, 37.758536929330724],
            [-122.405903135660481, 37.758934413706449],
            [-122.406103779268008, 37.759196479511928],
            [-122.406247868764623, 37.759429354319998],
            [-122.406261953936678, 37.75945211819198],
            [-122.406389357641601, 37.759804405761585],
            [-122.406492391998796, 37.760255279712112],
            [-122.406492697683589, 37.760686469836571],
            [-122.406479479731502, 37.760730932047331],
            [-122.4062826701159, 37.761392945250627],
            [-122.406147061407296, 37.7616371808829],
            [-122.406021608630979, 37.761863123291867],
            [-122.405925510731336, 37.762011914887523],
            [-122.405653838302513, 37.762432552128487],
            [-122.405384490436404, 37.76297005284507],
            [-122.40532469627189, 37.76313750682079],
            [-122.405258413683796, 37.763323129887908],
            [-122.405203088479681, 37.763478066930332],
            [-122.405104592203571, 37.763852244172895],
            [-122.405059622300016, 37.764310557738277],
            [-122.405089602982216, 37.764628538373131],
            [-122.404841911264157, 37.764643492872132],
            [-122.404496977488066, 37.764664317561468],
            [-122.403527034519726, 37.764722870371436],
            [-122.402563396844656, 37.764781034314389],
            [-122.401598999326723, 37.764839236400867],
            [-122.401604204317508, 37.764894634517518],
            [-122.401720515816834, 37.766132520250999],
            [-122.40075504647362, 37.766190486570189],
            [-122.399760960198876, 37.766250252443854],
            [-122.39980174760619, 37.766587745781216],
            [-122.399677637243116, 37.766695444602661],
            [-122.4004285874814, 37.76730030349627],
            [-122.400680751363893, 37.767503407870436],
            [-122.400877239583821, 37.76748837440357],
            [-122.401842503677628, 37.76743077711658],
            [-122.401962350744, 37.768706209224241],
            [-122.402926809989424, 37.76864812762463],
            [-122.403037758616776, 37.769828657390953],
            [-122.403406518421917, 37.769807099957397],
            [-122.403615112128733, 37.769893190404822],
            [-122.403877699904385, 37.770062866265505],
            [-122.403531054507056, 37.770336670466769],
            [-122.401656665936628, 37.77181711392474],
            [-122.399647849152032, 37.773403860176856],
            [-122.399516440682405, 37.773507653276255],
            [-122.399433130909728, 37.773573455617395],
            [-122.400212340411557, 37.77419510487973],
            [-122.400592319049849, 37.774498244536282],
            [-122.400981567656032, 37.774808775969753],
            [-122.402524096584528, 37.776039321403807],
            [-122.40337073826143, 37.776714700215486],
            [-122.403505778866929, 37.776822422431877],
            [-122.403673439982725, 37.776956165214415],
            [-122.404070256642925, 37.777272702482797],
            [-122.404605505853894, 37.777699659794813],
            [-122.405068508898097, 37.778068981419388],
            [-122.405615266425855, 37.778505104539292],
            [-122.404431250807633, 37.779440334605447],
            [-122.403387209275081, 37.78026497235011],
            [-122.401159718585049, 37.782024266952142]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {OBJECTID: 2, ZIP_CODE: 94105, ID: 94105},
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-122.39249932896719, 37.793768814133983],
            [-122.391890260341384, 37.794278544568918],
            [-122.391788865572423, 37.794170982455135],
            [-122.39173429034625, 37.79420276052317],
            [-122.391666728649753, 37.794132425256194],
            [-122.391723034266192, 37.79410061945832],
            [-122.391673228351905, 37.794047854124599],
            [-122.391982015107928, 37.793871906128679],
            [-122.391589022782, 37.793527982873798],
            [-122.391723231555744, 37.793429001692992],
            [-122.390805927608938, 37.792657675413892],
            [-122.388808599369057, 37.790978116182679],
            [-122.388930714411984, 37.790880018842998],
            [-122.388611692601799, 37.790313089306778],
            [-122.388048971491713, 37.790507516256234],
            [-122.388012417064502, 37.790431188672287],
            [-122.388369268465311, 37.790308044637399],
            [-122.388285919009036, 37.790161047422416],
            [-122.388320274159014, 37.790150883121463],
            [-122.388243932142601, 37.790007207265845],
            [-122.388219415789919, 37.789995925591761],
            [-122.388076857804336, 37.790038725053051],
            [-122.38779803320179, 37.790149885537438],
            [-122.385731305877229, 37.790973806479329],
            [-122.385715648397209, 37.790970622998962],
            [-122.385703294724394, 37.790961206457723],
            [-122.385509561738004, 37.790556391724344],
            [-122.385507518014222, 37.790544063409705],
            [-122.385514141658973, 37.790532283492631],
            [-122.385686917933171, 37.79045260764569],
            [-122.387606646474296, 37.789787359176458],
            [-122.387348795424046, 37.789311467853956],
            [-122.38734757309517, 37.78931176210844],
            [-122.385363735345749, 37.789788908162748],
            [-122.385346470166525, 37.789790557672781],
            [-122.385330865935444, 37.789789433734306],
            [-122.3853151742195, 37.789784877582385],
            [-122.385301142770246, 37.789777548268411],
            [-122.385290501190326, 37.789767417313975],
            [-122.385283285054584, 37.789755858694043],
            [-122.385108047186435, 37.789329458915937],
            [-122.385106003217075, 37.789317130597112],
            [-122.385109132387825, 37.789304032849302],
            [-122.385115773404124, 37.789292939120834],
            [-122.385127656568173, 37.78928382174719],
            [-122.385141339390941, 37.789277422487608],
            [-122.385148542800621, 37.789220309385662],
            [-122.387188020139192, 37.788773590697055],
            [-122.387049561519532, 37.788228488916552],
            [-122.385265755459955, 37.788520039162925],
            [-122.385250134063114, 37.78851822849537],
            [-122.385234425193858, 37.78851298588809],
            [-122.385222089078539, 37.788504256015905],
            [-122.385214890495845, 37.788493383558084],
            [-122.385126670096767, 37.788154179856562],
            [-122.385126356426341, 37.788141823596902],
            [-122.385129502623784, 37.788129412294914],
            [-122.385137873116122, 37.788118290909864],
            [-122.385149773868434, 37.788109860244717],
            [-122.385165203482913, 37.788104119771369],
            [-122.38712311120571, 37.787785749180493],
            [-122.387152415559953, 37.787781160094404],
            [-122.38716964498991, 37.787778137163613],
            [-122.38718858690207, 37.78777440037284],
            [-122.387205798545097, 37.787770691273494],
            [-122.387224740799539, 37.787766954471365],
            [-122.387241935339802, 37.787762558917869],
            [-122.387260859452994, 37.787758135677656],
            [-122.387278054335084, 37.787753740113331],
            [-122.387312408509445, 37.787743576101576],
            [-122.387329567801103, 37.787737807654125],
            [-122.387346745228243, 37.787732725636424],
            [-122.387363887068403, 37.787726270740649],
            [-122.38738104704403, 37.787720502274603],
            [-122.38740694457185, 37.787241442038656],
            [-122.387019444956891, 37.787247644385083],
            [-122.384558944804354, 37.787400993480382],
            [-122.384543323667074, 37.787399182993411],
            [-122.384527632511421, 37.787394627009306],
            [-122.384515296650974, 37.787385896512234],
            [-122.384504655873897, 37.787375765751548],
            [-122.384499135159118, 37.787362806267062],
            [-122.384342210870813, 37.785748083262355],
            [-122.384341897348037, 37.785735727269817],
            [-122.384346773449252, 37.785723288336335],
            [-122.38435689108006, 37.785712825798925],
            [-122.384370521056837, 37.785704367292539],
            [-122.384385968349036, 37.785699313626168],
            [-122.387217967726542, 37.785525599931667],
            [-122.387242186237785, 37.785525212275893],
            [-122.387269846695702, 37.785524082797316],
            [-122.387295742393547, 37.78552160811531],
            [-122.387323367958444, 37.785519105736952],
            [-122.387349245861117, 37.785515944605116],
            [-122.387375089561743, 37.785511410569285],
            [-122.387402662781668, 37.785506848841521],
            [-122.387454279688384, 37.785495034977437],
            [-122.387478323373855, 37.785487782842686],
            [-122.387504079475306, 37.785479816566138],
            [-122.387528105357717, 37.785471877983142],
            [-122.387553826899222, 37.785462538802953],
            [-122.387580894103834, 37.785438070169313],
            [-122.387630346985745, 37.78486455148672],
            [-122.385458308223278, 37.78499338709468],
            [-122.385413881876744, 37.784606785946664],
            [-122.387221366105805, 37.784501641660896],
            [-122.387418079949683, 37.784479264504995],
            [-122.38743876829875, 37.784476186423468],
            [-122.387483534893533, 37.784467229088612],
            [-122.387528231689217, 37.784455525961853],
            [-122.387550562288524, 37.78444898795393],
            [-122.387571145938807, 37.78444179118685],
            [-122.387593442333781, 37.784433880546885],
            [-122.387613991073025, 37.784425310610295],
            [-122.38765505365474, 37.784406798388098],
            [-122.387673819852623, 37.78439619708557],
            [-122.387677823231684, 37.784349435820396],
            [-122.387709046749492, 37.783875783688671],
            [-122.386286930602978, 37.783958976243902],
            [-122.386236533710786, 37.783405597391891],
            [-122.387525601081578, 37.78333071590594],
            [-122.387695596747974, 37.783278550154108],
            [-122.387751878035047, 37.783246059476667],
            [-122.387776877347846, 37.78286796141245],
            [-122.3875502225155, 37.782801544578085],
            [-122.387525883466154, 37.782797127453357],
            [-122.387484228568439, 37.78279230054234],
            [-122.387463418560699, 37.782790573250665],
            [-122.387440913647538, 37.782790246810194],
            [-122.387420138539767, 37.78278989267335],
            [-122.387388984601131, 37.782789704683182],
            [-122.387368261829351, 37.782791409869013],
            [-122.387347521611616, 37.782792428607252],
            [-122.384758972173714, 37.782940280456494],
            [-122.384743316428853, 37.782937096842417],
            [-122.384732711445736, 37.782928338977264],
            [-122.384679972094801, 37.782554918115103],
            [-122.384681388329753, 37.782542534464426],
            [-122.384691505480149, 37.782532071892298],
            [-122.384705187096728, 37.782525672675533],
            [-122.387509249137921, 37.78234690330077],
            [-122.387528224534123, 37.782344539065186],
            [-122.387554136561661, 37.78234275076899],
            [-122.38762294594062, 37.782322839482177],
            [-122.387787765874378, 37.782275144853472],
            [-122.387765464889313, 37.78194244138043],
            [-122.388106738902522, 37.781931906493995],
            [-122.388231340039766, 37.782146697467269],
            [-122.388304301898813, 37.782356717503951],
            [-122.388306939892615, 37.782385221520776],
            [-122.389843136047602, 37.783611740842574],
            [-122.389846392025618, 37.783609176617361],
            [-122.390856721023212, 37.784410569188324],
            [-122.391599105853345, 37.783822668268179],
            [-122.391600764141245, 37.783823989838545],
            [-122.392032919786118, 37.784168354830349],
            [-122.392118766536498, 37.784205306785267],
            [-122.392215026316663, 37.784279352365694],
            [-122.392216553530702, 37.784278123341721],
            [-122.39285700396303, 37.784773072758867],
            [-122.39286959393705, 37.78478280203197],
            [-122.39343711789931, 37.784459123881106],
            [-122.394398389309941, 37.783701667981575],
            [-122.395160622349934, 37.78431101230386],
            [-122.395895701657864, 37.784896929203114],
            [-122.396705177550587, 37.785542130425938],
            [-122.397811613142864, 37.784666586003652],
            [-122.399369533643153, 37.785899247741973],
            [-122.400468483886854, 37.785030285141588],
            [-122.400994549885382, 37.785441790992316],
            [-122.400998469557948, 37.785444857061968],
            [-122.401480059865179, 37.785821567351917],
            [-122.401489835489045, 37.785829214187501],
            [-122.402025419766176, 37.786248152290575],
            [-122.402575227394536, 37.786678208153539],
            [-122.403028193190352, 37.787024418822838],
            [-122.403028734856406, 37.78702485040828],
            [-122.403342641535644, 37.787274627660381],
            [-122.403430800369534, 37.787641848645734],
            [-122.403239953883428, 37.787802352067843],
            [-122.40290309900054, 37.788085647297414],
            [-122.402903089488873, 37.788085654318181],
            [-122.402404665507532, 37.788463925757384],
            [-122.402065730098272, 37.788721152097366],
            [-122.401375490979433, 37.789264321921429],
            [-122.400067228055164, 37.790303858609981],
            [-122.399919790020746, 37.790414442896498],
            [-122.399480001759599, 37.790744297277485],
            [-122.399222136170906, 37.790956214990921],
            [-122.39914859901539, 37.791016648609592],
            [-122.399148598683425, 37.79101664916432],
            [-122.398264448861653, 37.791716058450703],
            [-122.39826444614279, 37.791716060417308],
            [-122.397840810091907, 37.792047595331439],
            [-122.39738344591872, 37.792405521295422],
            [-122.396504486670068, 37.793097082520163],
            [-122.396376076969489, 37.793198086984006],
            [-122.396302004629632, 37.793256350149633],
            [-122.396302004290646, 37.793256350429786],
            [-122.395983670970253, 37.793501461560965],
            [-122.395622922555773, 37.793779228585429],
            [-122.39533276386878, 37.794011429145591],
            [-122.395317307728533, 37.794023797689903],
            [-122.394971722038662, 37.794300351169447],
            [-122.394747579547172, 37.794479718347191],
            [-122.394745733667804, 37.794478246556643],
            [-122.394745701490038, 37.794478274267938],
            [-122.394150899798674, 37.794987788593353],
            [-122.39270797067924, 37.793614415765255],
            [-122.392702063215523, 37.793608792659974],
            [-122.39249932896719, 37.793768814133983]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {OBJECTID: 3, ZIP_CODE: 94129, ID: 94129},
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-122.470990721149789, 37.787534455433345],
            [-122.472290534181823, 37.787395917162272],
            [-122.472401902490546, 37.787384046501884],
            [-122.47254342327507, 37.787368961705944],
            [-122.472782224474642, 37.787331534391747],
            [-122.473316434470121, 37.787247805418339],
            [-122.474432824368861, 37.787072820298278],
            [-122.474584006514732, 37.787049123020516],
            [-122.47616220885665, 37.786978730627588],
            [-122.478707989065171, 37.78691405835],
            [-122.481375583614479, 37.787198893328011],
            [-122.483910676418589, 37.787705653817092],
            [-122.483911841345289, 37.78771598691722],
            [-122.484019551359538, 37.788671434543716],
            [-122.484071292407094, 37.789571562974182],
            [-122.484214987310182, 37.789767611906584],
            [-122.484758163249651, 37.789969442365155],
            [-122.485095392905748, 37.790094746949087],
            [-122.486221786002261, 37.790513270391187],
            [-122.486196663014411, 37.790544596769486],
            [-122.486148110204482, 37.790605847513199],
            [-122.486108757859654, 37.790687545376898],
            [-122.486034586054117, 37.790761588869977],
            [-122.48595999185838, 37.790819844471812],
            [-122.485896199163861, 37.790893713055688],
            [-122.485740384038749, 37.791021323419344],
            [-122.48558351329909, 37.791238913899868],
            [-122.485411383576832, 37.791468435611826],
            [-122.485284654257228, 37.791712987869268],
            [-122.484994993901111, 37.791948608146861],
            [-122.484752903676167, 37.79221570331633],
            [-122.484541285320944, 37.792522116372695],
            [-122.484363647892437, 37.79274005429609],
            [-122.484183607122475, 37.793062416612024],
            [-122.484072129345151, 37.793295035940602],
            [-122.483858237133077, 37.793646123471206],
            [-122.483593432919847, 37.794035150786577],
            [-122.48329368676049, 37.794671303481294],
            [-122.483518531231283, 37.794730014502065],
            [-122.48308859662535, 37.79561146099627],
            [-122.482999467368202, 37.795903449272551],
            [-122.48285101972256, 37.796177893057802],
            [-122.482765752291186, 37.796484924353678],
            [-122.482667211606753, 37.796813467545597],
            [-122.482504820847737, 37.797149264997877],
            [-122.482349642968302, 37.797495928150028],
            [-122.482180347467406, 37.797832527598885],
            [-122.482169137762298, 37.797996159399602],
            [-122.482136359830861, 37.798129936813986],
            [-122.482085493238017, 37.798234488898757],
            [-122.482121580114068, 37.798289507917929],
            [-122.482129545147487, 37.798328517967903],
            [-122.482111649834962, 37.798371396374968],
            [-122.482102148276397, 37.798404519393337],
            [-122.482087585279373, 37.798442534909526],
            [-122.482079722552115, 37.798472196426395],
            [-122.482040900643639, 37.798509246213612],
            [-122.481958513784505, 37.798535353148957],
            [-122.481870239865685, 37.798535463289312],
            [-122.481831454802517, 37.798573885582073],
            [-122.48191348856912, 37.79872908258961],
            [-122.481933747767386, 37.798774753652147],
            [-122.481894064444091, 37.798779540742402],
            [-122.481782518807989, 37.79868595916038],
            [-122.481759479485277, 37.798795537302446],
            [-122.481735532663109, 37.798806240772073],
            [-122.481729674725472, 37.79884616987701],
            [-122.481697076819628, 37.79885701872184],
            [-122.481553967429107, 37.798748172710248],
            [-122.481544740366218, 37.798791592096414],
            [-122.481675391067768, 37.798887599511232],
            [-122.481685177680191, 37.798930012650303],
            [-122.481641997341171, 37.798933485499177],
            [-122.481619981772425, 37.798951710306021],
            [-122.481601609693158, 37.798976741512377],
            [-122.481583384160913, 37.799007264136819],
            [-122.481561643359143, 37.799035785621555],
            [-122.481552599461594, 37.799086069282282],
            [-122.48153672724159, 37.799139901359283],
            [-122.481507471077649, 37.799211126714575],
            [-122.481470873600131, 37.799266680501994],
            [-122.481417267273812, 37.799333507835762],
            [-122.481380082795965, 37.799367095921824],
            [-122.481394839952742, 37.799401184738606],
            [-122.48138749011072, 37.799450066445814],
            [-122.481313103352264, 37.799516556146521],
            [-122.481199920275785, 37.799556228466017],
            [-122.481106226731853, 37.799612741364335],
            [-122.481068868952889, 37.799704704484391],
            [-122.481063386681015, 37.799823601791012],
            [-122.481042139949025, 37.799870656721012],
            [-122.48098682060791, 37.799938199625082],
            [-122.480980184705871, 37.800013851703859],
            [-122.480977156432658, 37.800224730569639],
            [-122.480974804661557, 37.800331213761126],
            [-122.480860274222692, 37.800385329797535],
            [-122.480757965088657, 37.800443360304584],
            [-122.48067857879505, 37.800582040732152],
            [-122.48065611449222, 37.800648344612128],
            [-122.480592381330325, 37.800724956178229],
            [-122.480537665874181, 37.800815150409605],
            [-122.480468568377589, 37.800950224199951],
            [-122.480375485908439, 37.801094628286094],
            [-122.480295978813317, 37.801293743123836],
            [-122.480202328037436, 37.801416867810858],
            [-122.480181840275407, 37.801557305763211],
            [-122.480071801739967, 37.801844835145566],
            [-122.480027318791514, 37.802059156846411],
            [-122.480044134726015, 37.802235365083838],
            [-122.480004943470632, 37.80238847850972],
            [-122.479965705600534, 37.802604771748101],
            [-122.479928024203545, 37.802749618690633],
            [-122.479899085376999, 37.802897752511299],
            [-122.479813341330441, 37.803057827736559],
            [-122.479734279947053, 37.803208863153962],
            [-122.479678141843124, 37.803310755542739],
            [-122.479612025097651, 37.803427923840943],
            [-122.479496444899141, 37.803572704736546],
            [-122.479357004588351, 37.803861413494445],
            [-122.479173928312875, 37.80433146553451],
            [-122.479146809127258, 37.804483001950985],
            [-122.479060667102701, 37.804693214811543],
            [-122.478953175659996, 37.804881810346664],
            [-122.478815220557294, 37.805291358623961],
            [-122.47872883882674, 37.805492647931004],
            [-122.478723432948883, 37.805679530333919],
            [-122.47869664200617, 37.805843422292654],
            [-122.478685946257201, 37.805961720018743],
            [-122.478628322791295, 37.806008011253461],
            [-122.478654742843744, 37.806089976088074],
            [-122.478631304779441, 37.806119899160173],
            [-122.478660343597923, 37.806170230012903],
            [-122.478638955177018, 37.806277032642242],
            [-122.478627125019798, 37.806352771870088],
            [-122.478625044107972, 37.806469551574978],
            [-122.47857586751384, 37.806637939992576],
            [-122.478562516078711, 37.80678649853526],
            [-122.478544650108333, 37.806960541692234],
            [-122.478526703332861, 37.807066600081164],
            [-122.478526389161814, 37.807184723319764],
            [-122.478521297177736, 37.807253482414033],
            [-122.478488208711909, 37.807311036148292],
            [-122.478483958170003, 37.807411370608691],
            [-122.478496304822514, 37.807549883734964],
            [-122.478476156109295, 37.807833156107016],
            [-122.478405186887699, 37.808093245296376],
            [-122.478343748883177, 37.808126216988313],
            [-122.478060427750734, 37.808278265895638],
            [-122.477897062640963, 37.80844925522419],
            [-122.477885395973601, 37.808531172189731],
            [-122.477923697644769, 37.808669250052077],
            [-122.477956528906134, 37.809251736581921],
            [-122.477922196862778, 37.80978247039468],
            [-122.477956931601639, 37.810111519960003],
            [-122.477924513902849, 37.810324264541741],
            [-122.477975357212003, 37.810543166576302],
            [-122.477691959274622, 37.810627579828761],
            [-122.477738440983671, 37.81094269802653],
            [-122.477669662799912, 37.810960332923507],
            [-122.477465352217308, 37.810997758254302],
            [-122.4773147668257, 37.811025342092201],
            [-122.476951827952391, 37.810983355163785],
            [-122.476621797907725, 37.810876948869407],
            [-122.47656163509636, 37.810893065263848],
            [-122.476466638674822, 37.81083628492037],
            [-122.47639876264958, 37.810757761311969],
            [-122.476244453139699, 37.810423848047549],
            [-122.476192907539087, 37.810243414175943],
            [-122.47615497008627, 37.809858792499412],
            [-122.47604874198008, 37.809640130705603],
            [-122.475967371125094, 37.809574880888988],
            [-122.475790153494444, 37.809485827869665],
            [-122.475539966877108, 37.809387008587656],
            [-122.474949730564461, 37.809260233883315],
            [-122.474802168498073, 37.809179610065499],
            [-122.474477490769161, 37.809143842083898],
            [-122.474059299537672, 37.809106891534391],
            [-122.473248913495638, 37.809099164155811],
            [-122.472667246163553, 37.80903404071298],
            [-122.472248345244111, 37.80897031306057],
            [-122.471807567969009, 37.808865058985567],
            [-122.471692590128313, 37.808861156356251],
            [-122.471577117792876, 37.808857237159089],
            [-122.471241422813662, 37.80879760884919],
            [-122.470932885927255, 37.808717610499883],
            [-122.47066006806898, 37.808613665617798],
            [-122.470600816238615, 37.80859886080146],
            [-122.470032562336371, 37.809430372877515],
            [-122.469989867152222, 37.809452374737276],
            [-122.469923620349192, 37.809434939483481],
            [-122.469403337873828, 37.809203958897747],
            [-122.469386781047135, 37.809167151824653],
            [-122.469446470968407, 37.809067952374448],
            [-122.469513627885206, 37.809054469737255],
            [-122.470046113471852, 37.809288679655658],
            [-122.470536336868321, 37.808582769832967],
            [-122.47042036446561, 37.808452854807648],
            [-122.470227327454069, 37.808354443608728],
            [-122.470098624189163, 37.80826663136105],
            [-122.470013817898405, 37.808202121652926],
            [-122.469815463486142, 37.808098991213633],
            [-122.469586546186093, 37.807953106986339],
            [-122.469305300471973, 37.807727061403774],
            [-122.469233592741006, 37.807568936815628],
            [-122.469112342826094, 37.807370435141976],
            [-122.46886886007195, 37.807066844008062],
            [-122.468789265438318, 37.807002933173059],
            [-122.468641769161479, 37.806924361175163],
            [-122.468442727148087, 37.806860383444018],
            [-122.468303117397753, 37.806818075943092],
            [-122.46814816670377, 37.806980670547468],
            [-122.46804250856195, 37.806913074050627],
            [-122.468204198687829, 37.806743499513175],
            [-122.468154584727131, 37.80670037662253],
            [-122.467927641872478, 37.806563383834956],
            [-122.4677672527434, 37.806455496134681],
            [-122.467355591928154, 37.806141659736177],
            [-122.467203291926239, 37.806012347645776],
            [-122.466996296046148, 37.805909356729394],
            [-122.466671493417238, 37.805802836197401],
            [-122.466463320033583, 37.805982110961864],
            [-122.466652133036774, 37.805790797867139],
            [-122.466274152924925, 37.805653990321176],
            [-122.466075349709101, 37.80558203392561],
            [-122.465895016150796, 37.805570618742252],
            [-122.465648753037854, 37.805488195293123],
            [-122.46546102999136, 37.805393808021854],
            [-122.464551731906468, 37.805113664168701],
            [-122.464230324554308, 37.805004333527904],
            [-122.463987997870177, 37.804939695859083],
            [-122.463579617827847, 37.804879883064366],
            [-122.463271699005631, 37.804887756693624],
            [-122.462952230341088, 37.804917109899002],
            [-122.4624302743036, 37.805013698161765],
            [-122.462214023782167, 37.805018669869817],
            [-122.462027122615794, 37.804955166469341],
            [-122.461896643188638, 37.804930554615567],
            [-122.461601325019004, 37.804956755736356],
            [-122.461272453201914, 37.805023344559039],
            [-122.461007547032963, 37.805086808651389],
            [-122.459772513833471, 37.805253612450713],
            [-122.45957795006224, 37.805293241948746],
            [-122.459540191073017, 37.805305543773983],
            [-122.45950068434351, 37.805317187894794],
            [-122.459462907558404, 37.805328803259258],
            [-122.459423363879012, 37.805339074505127],
            [-122.45938555118417, 37.805349316978521],
            [-122.459306427886148, 37.805368486538775],
            [-122.459227232780066, 37.805384910313265],
            [-122.459185886621981, 37.805392464497949],
            [-122.459106618316682, 37.805406142481793],
            [-122.459065217794489, 37.805411637333286],
            [-122.459025547917307, 37.805417103422087],
            [-122.458984129270405, 37.80542191181479],
            [-122.458944422811243, 37.805426005021417],
            [-122.458902967930442, 37.80542944052501],
            [-122.458861494934339, 37.805432189583698],
            [-122.458788912310027, 37.805436828799479],
            [-122.458735345621889, 37.80544046541047],
            [-122.458683526998115, 37.80544475969581],
            [-122.458631726477662, 37.805449740388731],
            [-122.458578213760234, 37.805455436499734],
            [-122.458526449095928, 37.805461790012899],
            [-122.458474703215558, 37.805468829647623],
            [-122.458371283182728, 37.805485655405761],
            [-122.458319609004732, 37.805495440705506],
            [-122.458269665819927, 37.805505197514321],
            [-122.45821802818655, 37.805516356173719],
            [-122.458168120492331, 37.805527485811837],
            [-122.458116519376176, 37.805540017007239],
            [-122.458066648197928, 37.805552519182882],
            [-122.457989327072951, 37.805574405126777],
            [-122.45793619470966, 37.805594515430641],
            [-122.457883043876322, 37.805613939560359],
            [-122.457829874920449, 37.805632677510189],
            [-122.457774957510779, 37.805650757180459],
            [-122.457721751946011, 37.805668121951648],
            [-122.457666780196845, 37.805684142829186],
            [-122.457610078443324, 37.805700191847833],
            [-122.457500062415335, 37.80572948720183],
            [-122.457443287865871, 37.805742790973085],
            [-122.457386495190917, 37.805755408011883],
            [-122.457329684053221, 37.805767338598564],
            [-122.457272855492562, 37.805778582715845],
            [-122.457186701695477, 37.805793746855791],
            [-122.457077909022615, 37.805803793319789],
            [-122.456970882463025, 37.805815183288864],
            [-122.456862180533747, 37.805828661426311],
            [-122.456755226634087, 37.80584279746536],
            [-122.456648326952561, 37.805858992150092],
            [-122.456541463411881, 37.805876559873688],
            [-122.456434635998889, 37.805895500361686],
            [-122.45632959276756, 37.805916471347693],
            [-122.456224568256204, 37.805938128659257],
            [-122.456119597596228, 37.80596184517497],
            [-122.456014644961741, 37.805986248302439],
            [-122.45591147681688, 37.806012681382633],
            [-122.455806614105612, 37.806040516209428],
            [-122.455705248815832, 37.806069666405428],
            [-122.455564429228914, 37.806112518618505],
            [-122.45530695988451, 37.806195761893825],
            [-122.454600415883462, 37.806430130022392],
            [-122.454483234784888, 37.806468999744823],
            [-122.454353658700001, 37.806478701096999],
            [-122.454308145719423, 37.806459540393945],
            [-122.454293829263207, 37.806375996256122],
            [-122.454085665791084, 37.806359530611644],
            [-122.454069929877903, 37.806353610767474],
            [-122.453815604080873, 37.806293271483817],
            [-122.453295386032664, 37.806259311412973],
            [-122.452781551105744, 37.806270567825713],
            [-122.452438711570082, 37.806267316310901],
            [-122.451653324871984, 37.806353109244483],
            [-122.450906745259303, 37.80653233722969],
            [-122.450459653590798, 37.806646175036533],
            [-122.44991286747026, 37.806721142700994],
            [-122.449819483247254, 37.806724746830461],
            [-122.449720673642986, 37.806719513093618],
            [-122.449631038513971, 37.806734042766898],
            [-122.449554038474531, 37.806768278664137],
            [-122.44947869660497, 37.806799740182214],
            [-122.449399659671798, 37.806822335243758],
            [-122.449304851007483, 37.806837636909691],
            [-122.449171524916196, 37.806836407131136],
            [-122.449109070409847, 37.806831258752986],
            [-122.449048183710957, 37.806819903592029],
            [-122.449010891791161, 37.806784123494651],
            [-122.448891660899136, 37.806726348099637],
            [-122.448806459828916, 37.806711961234221],
            [-122.448728288255808, 37.806701578532227],
            [-122.448565239272398, 37.806755090545202],
            [-122.448529100304583, 37.806763241657009],
            [-122.448455091339923, 37.806133486140737],
            [-122.448455258275729, 37.806133277363898],
            [-122.448323332142422, 37.805007750605469],
            [-122.448321161555853, 37.804993824977359],
            [-122.448279145759457, 37.80472422506687],
            [-122.44824552349904, 37.804508484024247],
            [-122.448240728857812, 37.804477717258706],
            [-122.448240723025904, 37.804477679722268],
            [-122.448245764546613, 37.8044754914729],
            [-122.448316879890498, 37.804444627382082],
            [-122.448814547024654, 37.804228638340902],
            [-122.448954929708933, 37.80412855834809],
            [-122.449124213448584, 37.804007874392056],
            [-122.449253815658196, 37.803861977230383],
            [-122.449388062152011, 37.803710849923448],
            [-122.449495662264184, 37.803470319431604],
            [-122.449583722697156, 37.803153095621241],
            [-122.449583713807527, 37.803152915295549],
            [-122.449565462756809, 37.802791419060213],
            [-122.449536106109235, 37.802697377072583],
            [-122.449460220896157, 37.80245428555321],
            [-122.449178591741017, 37.802073857413127],
            [-122.449043488821943, 37.801965383441527],
            [-122.448802640091088, 37.801772003872607],
            [-122.448359651469772, 37.801586782043685],
            [-122.447921599691895, 37.801532283988202],
            [-122.447857007904148, 37.801596177616553],
            [-122.447819731578562, 37.801633051558142],
            [-122.447819572978844, 37.801633208279924],
            [-122.447802865090509, 37.801525678628579],
            [-122.447614227653389, 37.80032479990944],
            [-122.447613279369918, 37.80032370169468],
            [-122.447466030932901, 37.799389886853575],
            [-122.447400275900733, 37.798948048802856],
            [-122.447341437979304, 37.798552685345861],
            [-122.447327769221047, 37.798519415660031],
            [-122.447303043858923, 37.798459232650295],
            [-122.447209582420982, 37.797849561838987],
            [-122.44715829626513, 37.797515005478481],
            [-122.44715829625072, 37.79751500492933],
            [-122.447014738232738, 37.796578510197754],
            [-122.447014738218328, 37.796578509648619],
            [-122.446928896449293, 37.796018515191513],
            [-122.44687098056005, 37.795640691997477],
            [-122.446751148304088, 37.794858932799087],
            [-122.446727777275527, 37.794706465308671],
            [-122.446727777261131, 37.794706464759514],
            [-122.446587862952981, 37.793765120337646],
            [-122.446446456540414, 37.792813716046261],
            [-122.446446033268856, 37.792810866507708],
            [-122.446299573716246, 37.791878694429421],
            [-122.446299547924625, 37.791878529215651],
            [-122.44720637942703, 37.791763091830468],
            [-122.447679208068394, 37.79170289872647],
            [-122.449367313308201, 37.791487980191171],
            [-122.449385188501296, 37.791484927305568],
            [-122.450995459060991, 37.791209906278311],
            [-122.452035629818212, 37.790998907609811],
            [-122.454248357567437, 37.79059310209788],
            [-122.455878319348855, 37.790294143976332],
            [-122.457498733292852, 37.789996912625632],
            [-122.459011873160264, 37.789719335764374],
            [-122.459028627866218, 37.789715983297555],
            [-122.459250455476877, 37.789713291862398],
            [-122.45947565027717, 37.789710559160014],
            [-122.459781586189493, 37.789596250165474],
            [-122.459925547070256, 37.789542753604124],
            [-122.468653534340191, 37.787783523544832],
            [-122.470990721149789, 37.787534455433345]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {OBJECTID: 4, ZIP_CODE: 94121, ID: 94121},
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-122.504456509027335, 37.788067554312491],
            [-122.504150949920984, 37.788096097763379],
            [-122.504066815467581, 37.788120877294119],
            [-122.504049145771674, 37.78810744254686],
            [-122.503997231067004, 37.788107638193928],
            [-122.503846231021797, 37.788091662877633],
            [-122.503713944876083, 37.788063694207068],
            [-122.503612889329972, 37.788038628655784],
            [-122.503526395190363, 37.78804009845387],
            [-122.503485137277139, 37.78805041389267],
            [-122.503463545305024, 37.78801987747579],
            [-122.503373498826377, 37.788017973822534],
            [-122.503335534005146, 37.788022052592311],
            [-122.503263415949803, 37.788043193399247],
            [-122.503234378285072, 37.788057421563131],
            [-122.503243398050046, 37.788071003120102],
            [-122.503209152201507, 37.78808463302547],
            [-122.503179577522019, 37.788078954832578],
            [-122.503144887269229, 37.788076110778647],
            [-122.503077958752755, 37.78809716302807],
            [-122.503049013609541, 37.788114823274398],
            [-122.503006581160705, 37.78814576070333],
            [-122.502956321560973, 37.788143180813591],
            [-122.502925535751373, 37.788156752131144],
            [-122.502902751007483, 37.788146151342978],
            [-122.502865053026014, 37.788095972678335],
            [-122.502836115946863, 37.78804976589835],
            [-122.502789020665148, 37.78803614434397],
            [-122.502704311593945, 37.788039643712104],
            [-122.502589076168022, 37.788066323379901],
            [-122.502515190951499, 37.788086120259166],
            [-122.502425496104195, 37.788097257971025],
            [-122.502376106845503, 37.788126939838207],
            [-122.502316846531585, 37.7881114644726],
            [-122.502255070395776, 37.788131055545016],
            [-122.502169528699341, 37.788103665363288],
            [-122.502105689513968, 37.788110929794158],
            [-122.50207398762231, 37.788154733004774],
            [-122.502071249254328, 37.788181562090124],
            [-122.501989944924048, 37.788182942633284],
            [-122.501951813392949, 37.78818084312524],
            [-122.501912664088508, 37.788140990459205],
            [-122.501912016401619, 37.788116965280736],
            [-122.501877326179624, 37.788114120853955],
            [-122.501877973840479, 37.788138145483494],
            [-122.501858399507697, 37.788182429188559],
            [-122.501842192404723, 37.788223222019695],
            [-122.501801304245816, 37.788247265660054],
            [-122.501766151357245, 37.788227260005755],
            [-122.501756965310037, 37.788207500503631],
            [-122.50172600293584, 37.788150340007959],
            [-122.501700517223497, 37.788167941185236],
            [-122.50167957356264, 37.788161429621908],
            [-122.501619212555269, 37.788169321478662],
            [-122.501569767420492, 37.788196943730178],
            [-122.501591358665465, 37.788227480492822],
            [-122.501533078675976, 37.788248385310276],
            [-122.501514596042369, 37.788204747707923],
            [-122.50145942465268, 37.788212551659868],
            [-122.501437657642668, 37.788239704012419],
            [-122.501335150234794, 37.788224962263008],
            [-122.501268313574613, 37.788249445888859],
            [-122.50115878458611, 37.788295256277053],
            [-122.501091780980232, 37.788313561975109],
            [-122.501021937979715, 37.788290711431223],
            [-122.501006184350814, 37.78828411139213],
            [-122.50097195648992, 37.788298427073251],
            [-122.500993621505359, 37.788331709648567],
            [-122.500947376526028, 37.788349663239131],
            [-122.500879097304491, 37.788320605139283],
            [-122.500861336013799, 37.788303738053742],
            [-122.500826830696198, 37.788307757577726],
            [-122.500806349431429, 37.788318405959657],
            [-122.500754452719278, 37.788319286610971],
            [-122.500738328529678, 37.78829895802815],
            [-122.500712935348687, 37.788319991115557],
            [-122.500640723790397, 37.788337698187455],
            [-122.500593831459696, 37.788331626454848],
            [-122.500550140713713, 37.78831588602435],
            [-122.500538567416584, 37.788335997845735],
            [-122.50048939950284, 37.78837391630227],
            [-122.500458095017024, 37.788368266503305],
            [-122.500446429574566, 37.788384946179491],
            [-122.50034045177307, 37.788434129242091],
            [-122.500272801380206, 37.788428409551436],
            [-122.500256870701349, 37.788479498553457],
            [-122.500250772830086, 37.788574372083048],
            [-122.500192399744307, 37.788591844106463],
            [-122.500174472488098, 37.788568799078057],
            [-122.500178293975864, 37.788517915512088],
            [-122.500130319126384, 37.788535897847389],
            [-122.500091521884229, 37.788509086399898],
            [-122.500099172636652, 37.788471872673249],
            [-122.500066212558522, 37.788468998362944],
            [-122.50006658231419, 37.788482726609828],
            [-122.500011040812936, 37.788476801362307],
            [-122.499966794796208, 37.788440467945314],
            [-122.499878115891249, 37.788489357153694],
            [-122.499810631863213, 37.788489815307436],
            [-122.499785570748472, 37.78852320387022],
            [-122.499760324750355, 37.788549727891812],
            [-122.499797151337432, 37.788567645255235],
            [-122.499803450517931, 37.788608742793357],
            [-122.49976162645244, 37.788662331112889],
            [-122.499733393517658, 37.788642207768127],
            [-122.499727335024716, 37.788610033760072],
            [-122.49968724080243, 37.78866359271359],
            [-122.499634371443463, 37.788692645687142],
            [-122.499577562358439, 37.788703910220832],
            [-122.499554630056736, 37.788687817377856],
            [-122.499511356576448, 37.788623310977023],
            [-122.499481164550005, 37.788530426400044],
            [-122.499432590648397, 37.788461889419303],
            [-122.499336411156918, 37.788425062960037],
            [-122.499266771879846, 37.788409762065221],
            [-122.499202877060384, 37.788414965914313],
            [-122.499128103233858, 37.788401812217707],
            [-122.499099500985864, 37.788367960195586],
            [-122.499041638784547, 37.788340098176221],
            [-122.498955421371278, 37.788351861015244],
            [-122.498920128036829, 37.788390916780045],
            [-122.498889600061332, 37.788414096736403],
            [-122.498846352726645, 37.788414829911119],
            [-122.498829249780883, 37.788358120749585],
            [-122.498858133988094, 37.78827384858316],
            [-122.49881028141921, 37.788232082242921],
            [-122.498779365121052, 37.788240846950437],
            [-122.498721638945739, 37.788282343161484],
            [-122.498684745303493, 37.788326233159403],
            [-122.498610415395817, 37.78832955335983],
            [-122.498598336042235, 37.788266578082698],
            [-122.498619439354101, 37.78821471490064],
            [-122.498602392043921, 37.788160064708592],
            [-122.498537684539031, 37.788135065438439],
            [-122.498508608985759, 37.788147919585676],
            [-122.498480069151427, 37.788180680090115],
            [-122.498393075984339, 37.788163612611328],
            [-122.498359007071954, 37.788119551978269],
            [-122.498367465612489, 37.788047987710556],
            [-122.498258002596998, 37.788031987711385],
            [-122.498205083784299, 37.787930560386634],
            [-122.498141496631646, 37.787882879514228],
            [-122.498020127555392, 37.787874635204304],
            [-122.497965657850202, 37.7879085217278],
            [-122.497937733854386, 37.787835513791961],
            [-122.497862794972676, 37.787816181447418],
            [-122.497833152644503, 37.787872309616162],
            [-122.497858996475657, 37.787932304773527],
            [-122.497838976582202, 37.787960113577462],
            [-122.497779058543074, 37.787984477979037],
            [-122.497727525397508, 37.787934532426668],
            [-122.4976806523715, 37.787929145955836],
            [-122.497620549305267, 37.78794664601778],
            [-122.497594065916346, 37.787927179270163],
            [-122.49754290189, 37.78789096244769],
            [-122.49750382929264, 37.787853853467084],
            [-122.497544349339876, 37.787816083058736],
            [-122.497526053110533, 37.787779309105126],
            [-122.497500930399411, 37.787746084497506],
            [-122.497517139436695, 37.787705292265386],
            [-122.497507659501551, 37.787674549599402],
            [-122.497485331532715, 37.787616555022737],
            [-122.497458570647495, 37.787586791856477],
            [-122.497406323956653, 37.787574629197884],
            [-122.49735786900257, 37.787574763042187],
            [-122.497315176016556, 37.787596088453697],
            [-122.497275259657627, 37.787591957457558],
            [-122.497216443565691, 37.787592953772126],
            [-122.497168648080745, 37.787553245760044],
            [-122.497138187607533, 37.787514617578381],
            [-122.497106127216909, 37.787480823939255],
            [-122.497044990964866, 37.787459883810421],
            [-122.496999885071403, 37.787455840347057],
            [-122.496923235404381, 37.787437223130333],
            [-122.496894579157143, 37.787401311287425],
            [-122.49685734707576, 37.787368291637833],
            [-122.496811927818939, 37.787352579117055],
            [-122.496751769988833, 37.787368019451996],
            [-122.496728617227618, 37.787343688934776],
            [-122.496685721170834, 37.787357463425209],
            [-122.496639544906756, 37.787313607347343],
            [-122.496583690806744, 37.787296011229486],
            [-122.496547105206147, 37.787287016686854],
            [-122.496516354783793, 37.787301958649365],
            [-122.49646797383916, 37.787304838384266],
            [-122.496443903661216, 37.787310739875238],
            [-122.496383616604291, 37.787321374760424],
            [-122.496337075877918, 37.787328343443079],
            [-122.496276530804948, 37.787329368567015],
            [-122.496247565545247, 37.787346340725328],
            [-122.496197934785357, 37.787367096454552],
            [-122.496141439524379, 37.787390028597343],
            [-122.496086747911505, 37.787415677408667],
            [-122.496068420456311, 37.787442083500181],
            [-122.496016690354622, 37.787449139908034],
            [-122.495972174940263, 37.787467062259353],
            [-122.495951842506244, 37.787478615416269],
            [-122.495939786703687, 37.787485465489738],
            [-122.495905650481646, 37.787503211836551],
            [-122.495879794980965, 37.787507083489736],
            [-122.495820979283494, 37.78750807910243],
            [-122.49579201419597, 37.787525051142431],
            [-122.495771716907484, 37.787542562920031],
            [-122.495716453167731, 37.787546932051697],
            [-122.495690597288615, 37.78755080339463],
            [-122.495618108578682, 37.787558210990248],
            [-122.495602871400223, 37.787570830192877],
            [-122.495572047584162, 37.787583026463722],
            [-122.495539604212951, 37.787599370571847],
            [-122.495514135330879, 37.787617657121146],
            [-122.495483182354334, 37.787625048105859],
            [-122.495437195053938, 37.787652609233902],
            [-122.495395954684781, 37.787663608544698],
            [-122.495370190617706, 37.787670911683094],
            [-122.495333314088882, 37.787715487058371],
            [-122.495282044474621, 37.787739703822119],
            [-122.495193913200154, 37.787744628911668],
            [-122.495147390885393, 37.787752283545302],
            [-122.495107603658113, 37.787752956804084],
            [-122.495081894872186, 37.787762319709344],
            [-122.495049506978233, 37.787780722682484],
            [-122.494942531016747, 37.787792833838672],
            [-122.494936422880045, 37.787823153702263],
            [-122.49487624549289, 37.787837906657984],
            [-122.494850021018962, 37.787828049271276],
            [-122.494803406419749, 37.787832271634258],
            [-122.494754880927445, 37.787894212652994],
            [-122.494747761584406, 37.787951332156055],
            [-122.494723178126165, 37.788002566741419],
            [-122.494687204176572, 37.788080776838861],
            [-122.494700862218465, 37.788138231843071],
            [-122.494641953469724, 37.788135794738686],
            [-122.494554921507401, 37.788052798168373],
            [-122.494515868416002, 37.788016374906285],
            [-122.4945350783522, 37.787958364153376],
            [-122.494513047598829, 37.787911351574522],
            [-122.494517883781597, 37.787833668269109],
            [-122.494492854234224, 37.787803875161934],
            [-122.494463538439888, 37.787807804761236],
            [-122.494432676774579, 37.787818627891369],
            [-122.494408993418205, 37.787838943934148],
            [-122.494413448366132, 37.787875952476604],
            [-122.494396887310245, 37.787903702167263],
            [-122.49434981175834, 37.787890763675087],
            [-122.494353194757167, 37.787823406042577],
            [-122.494335895597104, 37.78782369865479],
            [-122.49430957902598, 37.787810409012593],
            [-122.494266331651687, 37.787811140513561],
            [-122.49416034840992, 37.787795764612234],
            [-122.494129594818148, 37.787746152815927],
            [-122.494106737724252, 37.787732804619111],
            [-122.494080878906914, 37.78767212220432],
            [-122.494005791021607, 37.787582742860096],
            [-122.49397989817011, 37.78758524069908],
            [-122.493937148914341, 37.787604505606133],
            [-122.49390314117592, 37.787627056362858],
            [-122.493853140270886, 37.787634082573049],
            [-122.493776804515477, 37.787627132573334],
            [-122.493743568607016, 37.787613959813378],
            [-122.493738061048077, 37.787613306047696],
            [-122.493682801772195, 37.787606746485388],
            [-122.493586205100101, 37.787618680905503],
            [-122.493496509486093, 37.787629812101237],
            [-122.493461856653141, 37.787628337503875],
            [-122.493419162517711, 37.787649661504638],
            [-122.493384362282285, 37.787642696015901],
            [-122.493336275791464, 37.787656556752133],
            [-122.493293636533849, 37.787679939994845],
            [-122.493241832649318, 37.78768424947036],
            [-122.493193617141287, 37.7876933054322],
            [-122.493182042295089, 37.787713416527986],
            [-122.493127220447846, 37.787734258699906],
            [-122.493090653466112, 37.787725949238315],
            [-122.493056424336842, 37.787740262623288],
            [-122.493004582859115, 37.787743199151691],
            [-122.492969929990394, 37.787741724684366],
            [-122.492955061461288, 37.787768072078173],
            [-122.492913931184304, 37.787783188809769],
            [-122.492855170492433, 37.787786242224989],
            [-122.492860417128782, 37.787852767193691],
            [-122.492830071355925, 37.787882810136729],
            [-122.492771255320051, 37.787883804228279],
            [-122.492769800087729, 37.787829576197716],
            [-122.492735920840914, 37.787856931882516],
            [-122.49268687433684, 37.78777054473629],
            [-122.492679439061774, 37.787751441716487],
            [-122.492627892968244, 37.787765361179233],
            [-122.492565672509713, 37.787768472646512],
            [-122.492506929887313, 37.787772212321414],
            [-122.492446513322577, 37.787778040470201],
            [-122.492381054094224, 37.787789447708391],
            [-122.492305602297094, 37.78781544526975],
            [-122.492216274554934, 37.787840303764064],
            [-122.492178548608294, 37.787853302497936],
            [-122.492118555140365, 37.787874918314273],
            [-122.492079412316457, 37.787899615509929],
            [-122.492057605141056, 37.787925393277668],
            [-122.491876207129678, 37.788001938945712],
            [-122.491812827679937, 37.788026359033061],
            [-122.491772083659185, 37.788055890066879],
            [-122.491719745560601, 37.788104846164785],
            [-122.491654323091851, 37.788117625573307],
            [-122.491646041850075, 37.7881315002275],
            [-122.491614039214184, 37.788164317512276],
            [-122.491501375628616, 37.788222533071625],
            [-122.491447583651606, 37.788217260993214],
            [-122.491404851437281, 37.788237211413325],
            [-122.491281422016286, 37.788281187084038],
            [-122.491218428658357, 37.788320021552913],
            [-122.491190014384841, 37.788357585284182],
            [-122.491137087049111, 37.788384575161345],
            [-122.491061983912687, 37.788423614320799],
            [-122.490946338544006, 37.788499734606098],
            [-122.490859530409139, 37.788554079246722],
            [-122.490843207112334, 37.788590751992317],
            [-122.490818381167585, 37.788633062206074],
            [-122.490696422877051, 37.78873195173508],
            [-122.490605105739689, 37.78881178134435],
            [-122.490527498874997, 37.788886572527467],
            [-122.490413287423564, 37.788951680519325],
            [-122.490407103746506, 37.78897925443183],
            [-122.490354139232181, 37.78900487109366],
            [-122.490306437661019, 37.789033145843504],
            [-122.490251889996458, 37.789064283086574],
            [-122.490252239550742, 37.789077325209703],
            [-122.490220015123754, 37.789101904980171],
            [-122.490046709329732, 37.789222262378196],
            [-122.489918657120555, 37.789352156846768],
            [-122.489828681483118, 37.789482095324693],
            [-122.489700630133797, 37.789482882790033],
            [-122.489592566089883, 37.789454489856745],
            [-122.489300670464104, 37.789412030065776],
            [-122.489191447548507, 37.789340391834585],
            [-122.488990889258972, 37.789283342302205],
            [-122.48848285911852, 37.789442306771541],
            [-122.488100013149761, 37.789428847345718],
            [-122.488028309941384, 37.789530320047362],
            [-122.487863707315668, 37.789588034282978],
            [-122.487736999824023, 37.789574375465854],
            [-122.487584402186499, 37.78949866010057],
            [-122.487564674856429, 37.789472896340307],
            [-122.487563664349921, 37.78943514280558],
            [-122.487464302267156, 37.789473215069947],
            [-122.48744759425297, 37.789430918694578],
            [-122.487369692668253, 37.789430171560369],
            [-122.487296628705792, 37.789480848156245],
            [-122.487120114954962, 37.789610869819036],
            [-122.487051777894393, 37.789708851205745],
            [-122.4869376141597, 37.789840568479555],
            [-122.486809390152729, 37.789964281705743],
            [-122.486730121786451, 37.790041845235905],
            [-122.486553036429143, 37.790150586495734],
            [-122.486429009493079, 37.790237144752382],
            [-122.486335272657072, 37.790356155991162],
            [-122.486245109599949, 37.790414674064778],
            [-122.486236878145661, 37.790495160989501],
            [-122.486221786002261, 37.790513270391187],
            [-122.485095392905748, 37.790094746949087],
            [-122.484316748868366, 37.789805424389257],
            [-122.484214987310182, 37.789767611906584],
            [-122.484071292407094, 37.789571562974182],
            [-122.484019551359538, 37.788671434543716],
            [-122.483911841345289, 37.78771598691722],
            [-122.483910676418589, 37.787705653817092],
            [-122.481375583614479, 37.787198893328011],
            [-122.479861181106074, 37.787037199203986],
            [-122.478707989065171, 37.78691405835],
            [-122.477707716230128, 37.786939475526701],
            [-122.476637454822679, 37.786966661899442],
            [-122.476572244768761, 37.786128658440397],
            [-122.476575166016133, 37.786128513873635],
            [-122.476575148769683, 37.786128282045887],
            [-122.476436803741322, 37.784271125057622],
            [-122.476306551695615, 37.782405954593735],
            [-122.476169188584777, 37.78047585000003],
            [-122.476025278884237, 37.778553841183147],
            [-122.475888270951586, 37.776692974324831],
            [-122.475750968701433, 37.774828017958995],
            [-122.475613644972711, 37.772962670675476],
            [-122.475613625589148, 37.772962410314676],
            [-122.476694205661246, 37.772912858094969],
            [-122.477069824745385, 37.772895630732648],
            [-122.477766947236773, 37.772863655180586],
            [-122.478836951668541, 37.772814568639937],
            [-122.47883762078969, 37.772814536530767],
            [-122.478848715172788, 37.772814028898644],
            [-122.479904580478745, 37.772765580938412],
            [-122.480978851643016, 37.772716079930653],
            [-122.481947659007389, 37.77267180789157],
            [-122.482048961146063, 37.772667157434498],
            [-122.483119121668807, 37.772618024364625],
            [-122.483119139145145, 37.772618264154566],
            [-122.484194219251819, 37.772569315707138],
            [-122.484194201052048, 37.772569061919981],
            [-122.485152053625171, 37.772525429693054],
            [-122.485261332297384, 37.772520422109807],
            [-122.485262022888591, 37.772520390701253],
            [-122.486334053115812, 37.772471462244795],
            [-122.486678527930636, 37.772455879683093],
            [-122.487398288926627, 37.772423078182946],
            [-122.487398306387334, 37.772423316873983],
            [-122.487399123482518, 37.77242327974907],
            [-122.488470602075608, 37.772374307055074],
            [-122.488471323394165, 37.772374169626119],
            [-122.489539486385709, 37.772325343661755],
            [-122.49061689309373, 37.772276279654356],
            [-122.490617013718605, 37.772276274046327],
            [-122.491688031137627, 37.772227293012065],
            [-122.492761363210761, 37.772178246338406],
            [-122.493316307377469, 37.772153213706439],
            [-122.493832479293559, 37.77212966191987],
            [-122.493832498174271, 37.772129926957135],
            [-122.493833180817205, 37.772129896182108],
            [-122.494902921073546, 37.772080894286702],
            [-122.494903299427449, 37.772080795311069],
            [-122.495971990075716, 37.772031913255347],
            [-122.497046812008847, 37.771982808835908],
            [-122.497412740335307, 37.771966238858134],
            [-122.498113882732468, 37.771934487449556],
            [-122.499183042122894, 37.771885392463027],
            [-122.500200291234236, 37.771838923903807],
            [-122.500257545202601, 37.771836308607973],
            [-122.501327700223527, 37.771787274197017],
            [-122.502399595949868, 37.771738155153713],
            [-122.502399732131124, 37.771738148994636],
            [-122.503472688521128, 37.771689380410749],
            [-122.503472690942445, 37.771689380369601],
            [-122.504544396347384, 37.771640577944709],
            [-122.505611140464779, 37.771591516134151],
            [-122.50668530503512, 37.771542352938617],
            [-122.506685577396198, 37.771542340610623],
            [-122.506991972993774, 37.771528822999358],
            [-122.507750664399296, 37.771495034126787],
            [-122.507750665782908, 37.771495034103232],
            [-122.508780633594597, 37.771447480819759],
            [-122.508823169175031, 37.771445503888728],
            [-122.508823330922013, 37.771445496187766],
            [-122.508867990729883, 37.771443447055226],
            [-122.509894749698645, 37.771396032095495],
            [-122.509894781266311, 37.771396329054475],
            [-122.511053819156686, 37.771347546731022],
            [-122.511055400217217, 37.771347479926334],
            [-122.512571364940968, 37.771283657974607],
            [-122.51313192303401, 37.771260053409627],
            [-122.51314077587368, 37.771331323581165],
            [-122.513103639776702, 37.771429475690731],
            [-122.513116974838326, 37.771538439951165],
            [-122.5131111559662, 37.771706791559524],
            [-122.513101727800077, 37.771741976505247],
            [-122.513108516285712, 37.771800920539754],
            [-122.513097415135022, 37.771902061732895],
            [-122.513158379126494, 37.77223615155534],
            [-122.513150048202618, 37.772247968474822],
            [-122.513145175599931, 37.772259726057939],
            [-122.513142070416649, 37.772272827219133],
            [-122.513140694405962, 37.772285899124284],
            [-122.513142777404809, 37.77229891140734],
            [-122.51314831943732, 37.772311864891819],
            [-122.513155553774638, 37.772323415987366],
            [-122.513162806726825, 37.772335653782996],
            [-122.513171807785298, 37.772348547918142],
            [-122.513179470052052, 37.772375886809904],
            [-122.513181590285754, 37.772390272493183],
            [-122.513180232870297, 37.772404030275354],
            [-122.513177164205956, 37.772418504300951],
            [-122.513164035088622, 37.772444825057953],
            [-122.513153956021, 37.772455985088065],
            [-122.513145624725894, 37.77246780201267],
            [-122.513139041542303, 37.772480275551658],
            [-122.513134206485844, 37.772493406254469],
            [-122.513132830469672, 37.772506478159016],
            [-122.513133202560653, 37.772520206404018],
            [-122.513137015097556, 37.772533189699409],
            [-122.513142557139105, 37.772546142909071],
            [-122.513149791498321, 37.772557694004483],
            [-122.513128650263695, 37.772862969521874],
            [-122.513143974877181, 37.772917647305441],
            [-122.513134546565453, 37.772952831971672],
            [-122.513140759176039, 37.773054363934854],
            [-122.513127629925961, 37.773080684410282],
            [-122.513121083909837, 37.773094531347873],
            [-122.513117996938973, 37.773108318663766],
            [-122.513113180104355, 37.773122136070647],
            [-122.513110502783931, 37.773151024750284],
            [-122.513109145348821, 37.773164782804365],
            [-122.513109926760848, 37.773193612966814],
            [-122.513112046989562, 37.773207998100119],
            [-122.513115877809639, 37.773221667551859],
            [-122.513119727927929, 37.77323602341751],
            [-122.513123558750877, 37.773249692868944],
            [-122.513130848990954, 37.773263303241755],
            [-122.513136372841529, 37.773275570567371],
            [-122.513136837962776, 37.773292730939929],
            [-122.513139032281771, 37.773309862056486],
            [-122.513139962541018, 37.773344183350439],
            [-122.513137434071865, 37.77337856371112],
            [-122.513137899208886, 37.773395724632501],
            [-122.51313663480029, 37.773412914815644],
            [-122.513133622247153, 37.773429448109219],
            [-122.513132357829548, 37.773446638017631],
            [-122.513129363533338, 37.773463857742755],
            [-122.513124956674076, 37.773492776231812],
            [-122.513123636099678, 37.773507907142864],
            [-122.513125756700802, 37.773522292818349],
            [-122.513127895547086, 37.773537364376381],
            [-122.513130108829742, 37.773555182186904],
            [-122.51313457258631, 37.77359218983559],
            [-122.513137102897502, 37.773685543750098],
            [-122.51313464849045, 37.773722669817865],
            [-122.513133402680765, 37.77374054642582],
            [-122.513130445590789, 37.773759139276294],
            [-122.513129218723165, 37.773777702029449],
            [-122.513126261969134, 37.773796294599215],
            [-122.513121575665878, 37.773814916705028],
            [-122.513118599957409, 37.773832822854594],
            [-122.513113913995852, 37.773851444954062],
            [-122.513110938637425, 37.773869351371971],
            [-122.513106251972374, 37.773887973208282],
            [-122.513098199929146, 37.77391008650784],
            [-122.513115558504083, 37.774550522030069],
            [-122.513135161617555, 37.77469921031755],
            [-122.513164585532962, 37.774890995995399],
            [-122.513170483591551, 37.775108592933201],
            [-122.513148799533084, 37.77520236034195],
            [-122.513166877896921, 37.775294761967629],
            [-122.513138108336719, 37.775382469681844],
            [-122.513154511511672, 37.775413093012311],
            [-122.513118656446565, 37.775494741304421],
            [-122.513116560550898, 37.775991978980805],
            [-122.513220716743945, 37.77664260637399],
            [-122.513262136135666, 37.776766199546913],
            [-122.513273147342474, 37.776853227885702],
            [-122.513301250635152, 37.776996277263876],
            [-122.513336088063554, 37.777196211308791],
            [-122.513350113009579, 37.777330573444466],
            [-122.513418927986152, 37.77744339753194],
            [-122.513485622738756, 37.777541836186963],
            [-122.513511493535475, 37.777602514461641],
            [-122.513605787519069, 37.777633867571893],
            [-122.513789576977686, 37.777711077145469],
            [-122.513970390041706, 37.777742325491253],
            [-122.514130469394843, 37.777902348781886],
            [-122.514271487815051, 37.77812519117407],
            [-122.514413862528215, 37.778270408245596],
            [-122.514604595643718, 37.77847591891544],
            [-122.51462964838835, 37.778506394234036],
            [-122.514661065627067, 37.778643892998048],
            [-122.514636184118331, 37.778747329407956],
            [-122.514564452996041, 37.778846072735902],
            [-122.514578405995934, 37.778977688986053],
            [-122.51449838155861, 37.779153489214309],
            [-122.5144938833634, 37.779242842682805],
            [-122.514567855611702, 37.77941807161681],
            [-122.514670725915678, 37.779446530659044],
            [-122.514854558211539, 37.779525111397355],
            [-122.514948079566921, 37.779719234525949],
            [-122.514897941861832, 37.779848512679017],
            [-122.514749765647835, 37.779872333834206],
            [-122.514641072918508, 37.779820625636908],
            [-122.514565266573783, 37.77989677577483],
            [-122.514533951466817, 37.780082044762075],
            [-122.514511340895595, 37.780269225221183],
            [-122.514474054726847, 37.780425753002312],
            [-122.51446673230646, 37.780602371059075],
            [-122.514648527113849, 37.780860913612862],
            [-122.51472341591213, 37.781133644263413],
            [-122.514586047991969, 37.781300809991649],
            [-122.514468426928062, 37.781302819849991],
            [-122.514292998946104, 37.781279034300063],
            [-122.514303621052633, 37.781351647553429],
            [-122.514284968188448, 37.781429568185636],
            [-122.514242655950966, 37.781464628517519],
            [-122.513867881152649, 37.781428452669296],
            [-122.513760174171992, 37.78147699096975],
            [-122.513883322187127, 37.781614982927096],
            [-122.513812238767187, 37.78173775061245],
            [-122.513697000270085, 37.781891489394212],
            [-122.513670014693673, 37.78198122658408],
            [-122.513522169917209, 37.782081269425682],
            [-122.513466336763443, 37.782192101792845],
            [-122.513546762127802, 37.782286185176545],
            [-122.513589561336119, 37.782396706497991],
            [-122.513504004159799, 37.782432504856651],
            [-122.51345966482603, 37.782520478406092],
            [-122.513490615272289, 37.782576949453883],
            [-122.51349907897729, 37.782633804536587],
            [-122.513499154475824, 37.782700417272132],
            [-122.513444212427984, 37.782780331251374],
            [-122.513311970586869, 37.782817613200059],
            [-122.513176844047379, 37.782748499450129],
            [-122.513099674895386, 37.782774539876293],
            [-122.513082211268937, 37.782896391754747],
            [-122.512985625061674, 37.783036075867919],
            [-122.513019551763222, 37.783138507955194],
            [-122.513026396706579, 37.783199511429288],
            [-122.512878567398928, 37.783236372275823],
            [-122.512854035372925, 37.783352850568228],
            [-122.512805434943459, 37.783475233699562],
            [-122.512705462306386, 37.783553855572684],
            [-122.512518627902452, 37.783620225547125],
            [-122.512466567525493, 37.783742667306889],
            [-122.512644903191074, 37.783873537806549],
            [-122.512713964283492, 37.783931418677646],
            [-122.512652381073622, 37.784021746473734],
            [-122.512681006779928, 37.784120148680003],
            [-122.512565948104239, 37.784153016218092],
            [-122.512295468592697, 37.783942683042248],
            [-122.512111442218099, 37.7837933668308],
            [-122.511916645881882, 37.783949148187006],
            [-122.511936379260646, 37.784102641671865],
            [-122.512002036912364, 37.7841626409828],
            [-122.51201098319315, 37.784237343198853],
            [-122.511976089219957, 37.784290817818842],
            [-122.511911287292179, 37.784326260764388],
            [-122.511796674312308, 37.784311734732256],
            [-122.511643280924901, 37.784334954352396],
            [-122.511486279442096, 37.784288874386938],
            [-122.511300968574147, 37.78428379521467],
            [-122.511334223422679, 37.784425383212891],
            [-122.511306545033449, 37.784553589399493],
            [-122.511229614678896, 37.784588552121491],
            [-122.51102434727656, 37.784485608568794],
            [-122.510971002039966, 37.784496819600761],
            [-122.510838401528204, 37.784584923981406],
            [-122.510747296660981, 37.784671633775218],
            [-122.510491862112929, 37.784697278857706],
            [-122.510370776300974, 37.784699343616424],
            [-122.510236724687886, 37.784733906185757],
            [-122.510168389422006, 37.784702794445394],
            [-122.510020323714343, 37.784723420804994],
            [-122.509994254968106, 37.784727052267002],
            [-122.509808028924709, 37.784816069670107],
            [-122.509716922917022, 37.784902778658349],
            [-122.509665899527562, 37.784999792217178],
            [-122.509574233553352, 37.78512977535155],
            [-122.509483405510977, 37.78522678080374],
            [-122.50935080157798, 37.785314883231258],
            [-122.509270075574662, 37.785337547981477],
            [-122.509233168789549, 37.785444621876991],
            [-122.509117710773396, 37.785590805131108],
            [-122.508796514633275, 37.785744614237508],
            [-122.508661532747013, 37.785744853745925],
            [-122.508565980602214, 37.785795240243836],
            [-122.508486275275231, 37.785855657828165],
            [-122.50845217664569, 37.785938647661681],
            [-122.508258558155333, 37.786074486851589],
            [-122.50824179847983, 37.786094687819457],
            [-122.508218230136194, 37.78611912520401],
            [-122.508132741023516, 37.786157665329803],
            [-122.508102962554631, 37.786144437693665],
            [-122.508035220497703, 37.78613529033418],
            [-122.507963402235234, 37.786167416830274],
            [-122.507918608664951, 37.786238914034136],
            [-122.507884921314982, 37.786273138055307],
            [-122.507810998339579, 37.786355432403496],
            [-122.507791149628716, 37.786389420730835],
            [-122.507786702460081, 37.786416966109108],
            [-122.507753742643061, 37.786414093677742],
            [-122.507723143657557, 37.786434530234523],
            [-122.507686905785704, 37.786502447942446],
            [-122.50771513615085, 37.786586436657288],
            [-122.507634122264022, 37.786726537606768],
            [-122.507529970492527, 37.786842996798164],
            [-122.507416802174745, 37.786882007667536],
            [-122.507337150418977, 37.786944484013162],
            [-122.507251469686537, 37.787040025961154],
            [-122.50719904571541, 37.787149423517022],
            [-122.507107186903028, 37.787272540712486],
            [-122.507053654233644, 37.787276885429115],
            [-122.506971891727119, 37.787453396158277],
            [-122.506896872053431, 37.78749519083452],
            [-122.50673936089315, 37.787494438084011],
            [-122.506717248362293, 37.787444682355584],
            [-122.506653688773341, 37.787462245895419],
            [-122.506526049480186, 37.787478152978885],
            [-122.506492546406875, 37.787519241120947],
            [-122.506427084531083, 37.787594522862221],
            [-122.506343785965981, 37.787650192878154],
            [-122.506284872420196, 37.787711628562818],
            [-122.506271997783998, 37.787747558158287],
            [-122.506258863502353, 37.787773877799495],
            [-122.50624035413243, 37.787793421492793],
            [-122.506219873800518, 37.787804071365088],
            [-122.506177628287418, 37.787841873914068],
            [-122.506131292484596, 37.787856397132735],
            [-122.506163876746712, 37.787909408764172],
            [-122.506122372558949, 37.787974668305665],
            [-122.506121008614969, 37.788052293211784],
            [-122.506089600492331, 37.788170947004069],
            [-122.506052098981115, 37.788192187283286],
            [-122.505852340805589, 37.788229236102978],
            [-122.505747263058424, 37.788247505451196],
            [-122.505657587040744, 37.788259332046266],
            [-122.505605226952582, 37.788243054476361],
            [-122.505520554840288, 37.788247928168715],
            [-122.505423328958457, 37.788236533825454],
            [-122.505330267621474, 37.78825116471306],
            [-122.505202440987361, 37.788260206114757],
            [-122.505107748523827, 37.788214431400775],
            [-122.505021260444238, 37.788152035322256],
            [-122.50498134335804, 37.788147906935059],
            [-122.504941407743146, 37.788143092108974],
            [-122.504896245414301, 37.788136992665024],
            [-122.504877161086682, 37.788135256957062],
            [-122.504859843370596, 37.788134864962309],
            [-122.504835625333357, 37.788135276762382],
            [-122.504801138826153, 37.7881399833256],
            [-122.504785514269201, 37.788138188774688],
            [-122.504771508408268, 37.788132246255898],
            [-122.504759158308161, 37.788123528620481],
            [-122.5047502309164, 37.788113379306509],
            [-122.504739555111996, 37.788102572979582],
            [-122.504727204674595, 37.788093855346673],
            [-122.504711432227211, 37.788086569376937],
            [-122.504695715029484, 37.788081342687157],
            [-122.504680053426, 37.788078175271465],
            [-122.50466269900177, 37.788076410116517],
            [-122.50464541869988, 37.788077390660611],
            [-122.504626408521617, 37.788078400888217],
            [-122.504609090805303, 37.788078008307494],
            [-122.504591755258659, 37.788076929561612],
            [-122.504576093667978, 37.788073762406697],
            [-122.504558683651112, 37.788069937685613],
            [-122.504543003526479, 37.788066083826294],
            [-122.504525593174549, 37.788062259380773],
            [-122.504508220574564, 37.788059807771766],
            [-122.50449088434911, 37.788058729297397],
            [-122.504468396217547, 37.788059111612547],
            [-122.504456509027335, 37.788067554312491]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {OBJECTID: 5, ZIP_CODE: 94118, ID: 94118},
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-122.448885763577039, 37.778388598994987],
            [-122.449767079183658, 37.778277008331997],
            [-122.450654812483819, 37.778164598609756],
            [-122.450826415883952, 37.778142868140662],
            [-122.451543139139602, 37.778052106408275],
            [-122.452431111623397, 37.777939652339285],
            [-122.453384996187339, 37.777826863341367],
            [-122.45318832797058, 37.776853425180988],
            [-122.452963825070867, 37.775750129254348],
            [-122.452810237317621, 37.774995318605924],
            [-122.453003330637316, 37.774970754669006],
            [-122.45468264773983, 37.77475548474694],
            [-122.454683295611602, 37.774755406979118],
            [-122.455033749574639, 37.77471323536281],
            [-122.45525254468275, 37.774686906456331],
            [-122.455898178089939, 37.774604132119862],
            [-122.456283639851293, 37.774554711848936],
            [-122.456283671603558, 37.774554866249353],
            [-122.456283917173579, 37.774554834704738],
            [-122.457134751103212, 37.774454490912483],
            [-122.458371099123696, 37.774308895694055],
            [-122.458795325509186, 37.774254885425997],
            [-122.459486118442314, 37.77416693399686],
            [-122.459486145343419, 37.77416729779403],
            [-122.459486938645284, 37.774167197254911],
            [-122.460552700773292, 37.774031358657659],
            [-122.460552661960989, 37.774031133779268],
            [-122.461619755154771, 37.7738952534419],
            [-122.461619775372085, 37.773895534117642],
            [-122.461620188227315, 37.77389548164836],
            [-122.462535340858068, 37.773778657528119],
            [-122.462683796526321, 37.773759751788596],
            [-122.463749210177951, 37.773624065149079],
            [-122.464811670328331, 37.773488744378348],
            [-122.465331676538511, 37.773422509669793],
            [-122.465883163277454, 37.773398204721545],
            [-122.466373346760548, 37.773376599548058],
            [-122.466951728424362, 37.773351356945881],
            [-122.466952500298319, 37.773351323464517],
            [-122.468023916207073, 37.773303833556405],
            [-122.468348575135167, 37.773289518371953],
            [-122.469092496140973, 37.773256712542192],
            [-122.469517084069324, 37.773237987003441],
            [-122.470162692059887, 37.773209510586071],
            [-122.470162712316579, 37.773209791534974],
            [-122.471240089434815, 37.773162280380667],
            [-122.47124006836178, 37.773161981865066],
            [-122.471762122569857, 37.773138947752848],
            [-122.472219951938214, 37.773117969260745],
            [-122.472297341321692, 37.773114423074823],
            [-122.473427836194134, 37.773062613687692],
            [-122.473737577092777, 37.773048416620476],
            [-122.474550910293516, 37.773011133644289],
            [-122.474550931211951, 37.773011425844139],
            [-122.47455168367884, 37.773011391539193],
            [-122.475612802305008, 37.772962709520556],
            [-122.475613644972711, 37.772962670675476],
            [-122.475750968701433, 37.774828017958995],
            [-122.475888270951586, 37.776692974324831],
            [-122.476025278884237, 37.778553841183147],
            [-122.476169188584777, 37.78047585000003],
            [-122.476306551695615, 37.782405954593735],
            [-122.476436803741322, 37.784271125057622],
            [-122.476575148769683, 37.786128282045887],
            [-122.476575166016133, 37.786128513873635],
            [-122.476572244768761, 37.786128658440397],
            [-122.476637454822679, 37.786966661899442],
            [-122.47616220885665, 37.786978730627588],
            [-122.475567725323828, 37.787005248954515],
            [-122.475136959985235, 37.787024462123846],
            [-122.474584006514732, 37.787049123020516],
            [-122.474432824368861, 37.787072820298278],
            [-122.473333621918172, 37.787245111436654],
            [-122.473316434470121, 37.787247805418339],
            [-122.472782224474642, 37.787331534391747],
            [-122.47254342327507, 37.787368961705944],
            [-122.472401902490546, 37.787384046501884],
            [-122.472290534181823, 37.787395917162272],
            [-122.468653534340191, 37.787783523544832],
            [-122.466942641213976, 37.788133153852705],
            [-122.465882841138949, 37.788349715761562],
            [-122.4648365613821, 37.788563504283978],
            [-122.463771243725489, 37.788781172337565],
            [-122.459781586189493, 37.789596250165474],
            [-122.45947565027717, 37.789710559160014],
            [-122.459250455476877, 37.789713291862398],
            [-122.459028627866218, 37.789715983297555],
            [-122.459011873160264, 37.789719335764374],
            [-122.457498733292852, 37.789996912625632],
            [-122.455878319348855, 37.790294143976332],
            [-122.454248357567437, 37.79059310209788],
            [-122.452035629818212, 37.790998907609811],
            [-122.450995459060991, 37.791209906278311],
            [-122.449385188501296, 37.791484927305568],
            [-122.449367313308201, 37.791487980191171],
            [-122.449189583391288, 37.790608108274284],
            [-122.449011564525605, 37.789726786022129],
            [-122.448835781299294, 37.788856511426609],
            [-122.448656220796209, 37.787977164570449],
            [-122.4469741664482, 37.788186460801001],
            [-122.446792779960703, 37.787261853518181],
            [-122.446610465639836, 37.786302298311156],
            [-122.446738337622591, 37.786243163870765],
            [-122.446849274413296, 37.786186897081585],
            [-122.447533801639068, 37.785411415165207],
            [-122.447605133356163, 37.785275579171099],
            [-122.447621599012791, 37.785194684567394],
            [-122.447620107068687, 37.785083635258417],
            [-122.447578549915917, 37.784998355250835],
            [-122.447549635601661, 37.784906798974511],
            [-122.447149436147441, 37.783030677550911],
            [-122.447173033991248, 37.782710075581413],
            [-122.447225622636566, 37.782575775503396],
            [-122.447283893261542, 37.782434393634787],
            [-122.447301513844337, 37.78239164221629],
            [-122.447450898997985, 37.782195217632704],
            [-122.447637300982407, 37.781719177617617],
            [-122.447655108274333, 37.781537309189886],
            [-122.447576361567485, 37.781175778551805],
            [-122.447517982733274, 37.781069510753063],
            [-122.447351927163439, 37.780152061280916],
            [-122.447039806751391, 37.778622307248391],
            [-122.447997721370214, 37.778501033647089],
            [-122.448879206948348, 37.778389428728616],
            [-122.448885763577039, 37.778388598994987]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {OBJECTID: 6, ZIP_CODE: 94123, ID: 94123},
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-122.438402484723895, 37.794806973138577],
            [-122.440045216960385, 37.794597761146619],
            [-122.440868123190498, 37.794493055920753],
            [-122.440870170501768, 37.794492795601883],
            [-122.441712771485612, 37.794385578392699],
            [-122.443384198876302, 37.794172877898092],
            [-122.445035345747925, 37.79396273368863],
            [-122.446587034424141, 37.793765298555968],
            [-122.446446456540414, 37.792813716046261],
            [-122.446587862952981, 37.793765120337646],
            [-122.446727777261131, 37.794706464759514],
            [-122.446727777275527, 37.794706465308671],
            [-122.446751148304088, 37.794858932799087],
            [-122.44687098056005, 37.795640691997477],
            [-122.446928896449293, 37.796018515191513],
            [-122.447014738218328, 37.796578509648619],
            [-122.447014738232738, 37.796578510197754],
            [-122.44715829625072, 37.79751500492933],
            [-122.44715829626513, 37.797515005478481],
            [-122.447209582420982, 37.797849561838987],
            [-122.447303043858923, 37.798459232650295],
            [-122.447327769221047, 37.798519415660031],
            [-122.447341437979304, 37.798552685345861],
            [-122.447400275900733, 37.798948048802856],
            [-122.447466030932901, 37.799389886853575],
            [-122.447613279369918, 37.80032370169468],
            [-122.447614227653389, 37.80032479990944],
            [-122.447802865090509, 37.801525678628579],
            [-122.447819572978844, 37.801633208279924],
            [-122.447819731578562, 37.801633051558142],
            [-122.447857007904148, 37.801596177616553],
            [-122.447921599691895, 37.801532283988202],
            [-122.448359651469772, 37.801586782043685],
            [-122.448802640091088, 37.801772003872607],
            [-122.449043488821943, 37.801965383441527],
            [-122.449178591741017, 37.802073857413127],
            [-122.449460220896157, 37.80245428555321],
            [-122.449536106109235, 37.802697377072583],
            [-122.449565462756809, 37.802791419060213],
            [-122.449583713807527, 37.803152915295549],
            [-122.449583722697156, 37.803153095621241],
            [-122.449495662264184, 37.803470319431604],
            [-122.449388062152011, 37.803710849923448],
            [-122.449253815658196, 37.803861977230383],
            [-122.449124213448584, 37.804007874392056],
            [-122.448954929708933, 37.80412855834809],
            [-122.448814547024654, 37.804228638340902],
            [-122.448316879890498, 37.804444627382082],
            [-122.448245764546613, 37.8044754914729],
            [-122.448240723025904, 37.804477679722268],
            [-122.448240728857812, 37.804477717258706],
            [-122.44824552349904, 37.804508484024247],
            [-122.448279145759457, 37.80472422506687],
            [-122.448321161555853, 37.804993824977359],
            [-122.448323332142422, 37.805007750605469],
            [-122.448455258275729, 37.806133277363898],
            [-122.448456716038393, 37.806145711376217],
            [-122.448529100304583, 37.806763241657009],
            [-122.448398315024306, 37.806792871575105],
            [-122.448372486009177, 37.806798105392311],
            [-122.448348405000459, 37.806803997055574],
            [-122.44832261235274, 37.806810603719661],
            [-122.448274523063262, 37.806825132736471],
            [-122.448250514438882, 37.806833770101044],
            [-122.448204281209826, 37.806853075532878],
            [-122.448182039290586, 37.806863057432189],
            [-122.448159833037835, 37.806874411921982],
            [-122.448139357121818, 37.80688573782485],
            [-122.448117186873532, 37.806898464895561],
            [-122.448103560271292, 37.806906930735266],
            [-122.447833857922845, 37.807052164926837],
            [-122.447528276286675, 37.807250818574119],
            [-122.447180260711605, 37.80747705551984],
            [-122.446637954280746, 37.807525151443585],
            [-122.446476742583258, 37.807516824572637],
            [-122.445255735074412, 37.807626931568663],
            [-122.444832951299077, 37.807611928844082],
            [-122.444812115030089, 37.807609525524043],
            [-122.444789548054757, 37.807607150739592],
            [-122.443882698723485, 37.807700913966812],
            [-122.443762319418525, 37.807713359922936],
            [-122.443684632386478, 37.807721507559208],
            [-122.442739197031372, 37.807965235732532],
            [-122.442711389346584, 37.807972404225552],
            [-122.442625660786931, 37.808004032657479],
            [-122.442524054141913, 37.808024247618199],
            [-122.442354908341343, 37.808043514915532],
            [-122.441767928096084, 37.808104685164672],
            [-122.44153654297466, 37.808127036445633],
            [-122.441200035212404, 37.808167598495942],
            [-122.44095148917647, 37.808195724629321],
            [-122.44065270005224, 37.808288542686931],
            [-122.440627067703531, 37.808301325835579],
            [-122.440575873699515, 37.808329637315019],
            [-122.440528212527582, 37.808360637280757],
            [-122.440504418161254, 37.808377510253422],
            [-122.440482353473598, 37.808394354762264],
            [-122.440462037446096, 37.808411857223902],
            [-122.440440008975642, 37.808430074859068],
            [-122.440419728804599, 37.808448949904253],
            [-122.440401196955307, 37.808468483183979],
            [-122.440382683383717, 37.808488702887828],
            [-122.440369270902693, 37.808505405024498],
            [-122.440221248842576, 37.808670595014306],
            [-122.440123020723803, 37.808753931536479],
            [-122.440031607015868, 37.808833035512706],
            [-122.439928060968157, 37.808779113775664],
            [-122.440270312303127, 37.808229595265985],
            [-122.440282155842453, 37.808219099502388],
            [-122.440294017657806, 37.80820928989008],
            [-122.440307609508267, 37.808199452089056],
            [-122.440319488926107, 37.808190329461823],
            [-122.440334864961784, 37.808182522213436],
            [-122.440348510624844, 37.808174743706033],
            [-122.440379298231178, 37.808160502620083],
            [-122.440394728431826, 37.80815475493111],
            [-122.440410176225527, 37.808149693678615],
            [-122.440427371995767, 37.808145290667582],
            [-122.440444586383592, 37.808141573526278],
            [-122.440470613795014, 37.808143892481645],
            [-122.440632371579539, 37.808106894262245],
            [-122.440777543613365, 37.808097638147814],
            [-122.441785658321223, 37.807988336182923],
            [-122.441808099289275, 37.807985906519384],
            [-122.441799274649981, 37.807913258896662],
            [-122.441490202960892, 37.807943755875684],
            [-122.441489843938655, 37.807930027497129],
            [-122.441472521937172, 37.807929625920565],
            [-122.441480832705722, 37.807916441000579],
            [-122.441399010156047, 37.807832633902123],
            [-122.441414331805831, 37.807822767220159],
            [-122.441512177188741, 37.807923479293905],
            [-122.44162439956051, 37.807912017357232],
            [-122.441545678197272, 37.807814424464247],
            [-122.441557557740268, 37.807805301431408],
            [-122.441658935146762, 37.807908701878773],
            [-122.441779792066384, 37.807896411186228],
            [-122.441788084829597, 37.807882540086432],
            [-122.441704477043643, 37.807796702127824],
            [-122.441718086585212, 37.807787550596132],
            [-122.44181950044613, 37.807892323765437],
            [-122.441935183814792, 37.807880804821842],
            [-122.441943476554428, 37.807866933985672],
            [-122.441859851343693, 37.807780409692931],
            [-122.441873460855945, 37.807771257868716],
            [-122.441976640855827, 37.807877375557908],
            [-122.441977107703579, 37.807895222530654],
            [-122.441816542778795, 37.807911600852826],
            [-122.441823637077619, 37.807984277513498],
            [-122.442320834639688, 37.807932139640414],
            [-122.442377595612399, 37.807918156721222],
            [-122.442423345751081, 37.807880319904761],
            [-122.442454552098894, 37.807815940203007],
            [-122.442446930178193, 37.807789283331502],
            [-122.442372794146465, 37.807800805256427],
            [-122.442345413582302, 37.807812930576347],
            [-122.442346006240967, 37.807835582850217],
            [-122.442033707111619, 37.807875062158132],
            [-122.442009243703154, 37.807733999234173],
            [-122.442027954502791, 37.807721329750571],
            [-122.442048400903616, 37.807841170516582],
            [-122.442059070073554, 37.807851982482966],
            [-122.442207469058346, 37.807833743991878],
            [-122.442217473805144, 37.807819158213746],
            [-122.442189585584913, 37.807679524627673],
            [-122.44220852946296, 37.807675779293724],
            [-122.442236490235743, 37.807818158319698],
            [-122.442248872177956, 37.807828255059988],
            [-122.442314446214397, 37.807820307862364],
            [-122.442321008509211, 37.807806465496753],
            [-122.442293084181387, 37.807665459069689],
            [-122.442311884371406, 37.807656221984004],
            [-122.442337612108403, 37.807779409372287],
            [-122.442355041151117, 37.807783929703042],
            [-122.442395115206907, 37.807727644711157],
            [-122.442384613878218, 37.807657084644539],
            [-122.44241012033585, 37.80763949635341],
            [-122.442685954576561, 37.807595809313327],
            [-122.442711892175168, 37.807793159839584],
            [-122.442714242657956, 37.807793886686525],
            [-122.442762503926971, 37.807808807618663],
            [-122.442779771325021, 37.807807149719757],
            [-122.442902339949939, 37.807794142945916],
            [-122.442998755417392, 37.807774012900218],
            [-122.44305537242154, 37.807754538469467],
            [-122.44312779660163, 37.807743731320251],
            [-122.443201717191158, 37.807723971451296],
            [-122.443260064122327, 37.807704468417526],
            [-122.443291085252142, 37.807699150180341],
            [-122.443284905918816, 37.807661481932094],
            [-122.443264195467847, 37.807663883640146],
            [-122.443274020298077, 37.807642433173122],
            [-122.443270056810988, 37.807623269807593],
            [-122.44314383017317, 37.807628783225987],
            [-122.443254016387542, 37.807605679164965],
            [-122.44326198542305, 37.807579452177009],
            [-122.443135758859114, 37.807584965586791],
            [-122.443242483942598, 37.807561918560637],
            [-122.443256021380762, 37.807550021121365],
            [-122.443252111820613, 37.807532917601364],
            [-122.443237999416624, 37.807522848927505],
            [-122.443246112189684, 37.807502113399792],
            [-122.443244040453081, 37.807489099968812],
            [-122.443229963993403, 37.807480404158795],
            [-122.443238040829058, 37.80745829576658],
            [-122.443234130578546, 37.807441191982505],
            [-122.443218162072228, 37.807426347064215],
            [-122.443264702406339, 37.807418712940589],
            [-122.443256517776859, 37.807436702740098],
            [-122.443274647533997, 37.807467993526231],
            [-122.44326455321054, 37.80747914750733],
            [-122.443284610988869, 37.807517960537304],
            [-122.443274498692247, 37.807528428086727],
            [-122.443278390296598, 37.807544845448142],
            [-122.443294466994871, 37.807563808946817],
            [-122.443284389944367, 37.807575649647809],
            [-122.443286551537625, 37.807592095514579],
            [-122.443302628241014, 37.807611058737429],
            [-122.443292551178217, 37.80762289916445],
            [-122.443296353650368, 37.807635884626045],
            [-122.443302173270908, 37.807659823956676],
            [-122.443308298708217, 37.807695432906783],
            [-122.443434058250361, 37.807672072344801],
            [-122.443672727711146, 37.807597406163168],
            [-122.443654441112585, 37.80749401124762],
            [-122.443659326683914, 37.80748225662078],
            [-122.443872884696731, 37.807440280106206],
            [-122.443843293810986, 37.807367974319583],
            [-122.44370731452436, 37.807397684591926],
            [-122.443671444290359, 37.807416130974829],
            [-122.443653888762242, 37.807406805822907],
            [-122.443615857187666, 37.807408806048031],
            [-122.443601726794256, 37.807398051259632],
            [-122.443646374280576, 37.807384267621238],
            [-122.443657912040536, 37.807362102160489],
            [-122.443677395248955, 37.807378949282132],
            [-122.443708397548889, 37.807372944513865],
            [-122.443719917316642, 37.807350092614648],
            [-122.443739400535989, 37.807366939726066],
            [-122.443768690788104, 37.807361649886793],
            [-122.443780246134452, 37.8073401708521],
            [-122.443799711046125, 37.807356331526904],
            [-122.443829001635834, 37.807351041666962],
            [-122.443838790315425, 37.807328218286891],
            [-122.443858291875273, 37.807345751805421],
            [-122.443944431867095, 37.807329910704055],
            [-122.443955915261199, 37.807305685922557],
            [-122.44397716482635, 37.807323877338213],
            [-122.444023687043469, 37.8073155564826],
            [-122.444033511615373, 37.807294106225484],
            [-122.444052976916183, 37.807310266852966],
            [-122.444104672197867, 37.807301173690028],
            [-122.444114316981555, 37.807272858828142],
            [-122.444139117510247, 37.80729442532332],
            [-122.444173580792466, 37.807288363378881],
            [-122.444194201234893, 37.80728252962394],
            [-122.444071355206816, 37.80715270277112],
            [-122.444216516082363, 37.807275294750141],
            [-122.444262912050363, 37.807262168504906],
            [-122.444272682607831, 37.807238658656139],
            [-122.444290381984246, 37.807253474900222],
            [-122.444329892128806, 37.807241835878372],
            [-122.444341267517572, 37.807213492465038],
            [-122.444362535128633, 37.807232370243902],
            [-122.44440375797123, 37.807220016231902],
            [-122.444415151652876, 37.807192359237938],
            [-122.444436401305339, 37.807210550845831],
            [-122.444546334776021, 37.807177835248929],
            [-122.444557764011307, 37.807151551111282],
            [-122.444577265002437, 37.807169084522954],
            [-122.444645975607855, 37.807148723180354],
            [-122.444656807573693, 37.807165712792234],
            [-122.444442095756031, 37.807229685090327],
            [-122.444483781319875, 37.807301104324431],
            [-122.444798026960797, 37.807203901149613],
            [-122.445256739502199, 37.807070664930905],
            [-122.445225848727588, 37.807014862399406],
            [-122.445091259282876, 37.807031503517287],
            [-122.445058382323012, 37.807032045740513],
            [-122.44505631062799, 37.807019032334502],
            [-122.445158131368714, 37.807007052095038],
            [-122.44517833798561, 37.806985429952121],
            [-122.445116858617496, 37.806951420767781],
            [-122.445030629048986, 37.806963830570979],
            [-122.445058875964975, 37.806918727340673],
            [-122.445006173970214, 37.806889380441703],
            [-122.444888888156058, 37.806905735960221],
            [-122.444874654156408, 37.80682493696483],
            [-122.444919463246819, 37.806817330453363],
            [-122.445007311205075, 37.806866699909307],
            [-122.444974402625263, 37.806799942930326],
            [-122.444993292526533, 37.806794137571423],
            [-122.445038942963123, 37.806884719639513],
            [-122.445121510119179, 37.806930742460146],
            [-122.445046609432765, 37.806780897144854],
            [-122.445065498977499, 37.806775091780075],
            [-122.445153141586133, 37.806948762165227],
            [-122.44523217658535, 37.806992095976476],
            [-122.44535586222473, 37.80695571941591],
            [-122.445247620593648, 37.806722643522114],
            [-122.445266510453877, 37.806716838119371],
            [-122.445374751789728, 37.806949914001784],
            [-122.445469219634987, 37.806921573283674],
            [-122.445352433919155, 37.8066927587953],
            [-122.445373036116507, 37.806686238401404],
            [-122.44548810952854, 37.806915767845673],
            [-122.445561992695104, 37.80689463390474],
            [-122.445445188748025, 37.806665133074851],
            [-122.445464060244248, 37.8066586412139],
            [-122.445580882228484, 37.806888828457545],
            [-122.44570454953481, 37.806851765098479],
            [-122.445651671462073, 37.806749628119896],
            [-122.44565282578796, 37.806727633749716],
            [-122.445895754405569, 37.806815647477016],
            [-122.445736019894767, 37.806863607021306],
            [-122.445754222526631, 37.806897643432812],
            [-122.446384760166481, 37.806715556411739],
            [-122.446258463322081, 37.806718327435846],
            [-122.446193213892712, 37.806738632616792],
            [-122.446170395914976, 37.806726648309962],
            [-122.445981443875837, 37.806782644077451],
            [-122.445970540045622, 37.80676290912637],
            [-122.445598235532685, 37.806626211997774],
            [-122.445606509444289, 37.806611653919497],
            [-122.446001524256076, 37.806756217316881],
            [-122.446149253941641, 37.806712575605459],
            [-122.445708764584751, 37.806550221539489],
            [-122.445717038134546, 37.806535664008109],
            [-122.446176741453044, 37.806704568267236],
            [-122.446283248720263, 37.80667328102048],
            [-122.446005194935296, 37.806500006546784],
            [-122.446020461726192, 37.80648808024214],
            [-122.446305581169554, 37.806666731908173],
            [-122.446420668040176, 37.806632556303882],
            [-122.446151409366294, 37.806464630848126],
            [-122.446166694812902, 37.806453390945222],
            [-122.446443000465095, 37.806626007165498],
            [-122.446554662537906, 37.806593261684583],
            [-122.446391023698155, 37.806492266360543],
            [-122.446406290771549, 37.806480340000242],
            [-122.446524184932926, 37.806553247425605],
            [-122.446620237835958, 37.806519385773647],
            [-122.446642693746213, 37.806583567659246],
            [-122.44670978090322, 37.806567352265269],
            [-122.446939773843297, 37.806492135834091],
            [-122.446948929215651, 37.806511213110113],
            [-122.446720738906919, 37.806589146719396],
            [-122.446733553252031, 37.806615717634571],
            [-122.446996260681743, 37.80653378052115],
            [-122.44699045975274, 37.806444601492437],
            [-122.446974562378131, 37.806432503088267],
            [-122.446987792972394, 37.806408935599343],
            [-122.446983774594216, 37.806387713332704],
            [-122.44696966191627, 37.806377645652319],
            [-122.446979503500458, 37.806356881028954],
            [-122.446973448766144, 37.806324017983009],
            [-122.446942374816217, 37.806327277888172],
            [-122.44695713738291, 37.806296131639499],
            [-122.446941332573715, 37.806221538794638],
            [-122.446922047288439, 37.806212242955326],
            [-122.446935223870369, 37.806186616724325],
            [-122.446919473110199, 37.806114083171188],
            [-122.446903683817155, 37.806106103074534],
            [-122.446913508081977, 37.806084652286692],
            [-122.446909453048207, 37.80606205716353],
            [-122.446700318081568, 37.806074437190453],
            [-122.446888239127603, 37.80604523913599],
            [-122.446903488381423, 37.806032626547122],
            [-122.446899451700631, 37.806010717849745],
            [-122.446881914446337, 37.806002079602202],
            [-122.446893486335398, 37.805981286694831],
            [-122.446879430339621, 37.805907352248376],
            [-122.446670313096035, 37.805920418116813],
            [-122.446859964791457, 37.805891192083081],
            [-122.446873519346127, 37.805879980657039],
            [-122.446859427027746, 37.80580467279912],
            [-122.446845404479788, 37.805798037263322],
            [-122.446855228367411, 37.805776586210264],
            [-122.446849425403357, 37.805753333484326],
            [-122.446649086514796, 37.805771061515294],
            [-122.446833420536592, 37.805737116186556],
            [-122.446845280397781, 37.805727305922368],
            [-122.446841244096817, 37.805705397216052],
            [-122.446823724582785, 37.805697445671754],
            [-122.446835297139998, 37.805676653032066],
            [-122.446831332492664, 37.805657489784885],
            [-122.446817327967949, 37.805651540403126],
            [-122.446825403536536, 37.805629431757723],
            [-122.446805830072663, 37.805609152989824],
            [-122.446817348267402, 37.805586300786253],
            [-122.446809113007006, 37.805536305492353],
            [-122.446789863569947, 37.805528382500277],
            [-122.446803112068949, 37.805505501734793],
            [-122.446787107265692, 37.805489284429996],
            [-122.446700807332093, 37.805498949734627],
            [-122.446698645389645, 37.80548250391827],
            [-122.446795308825045, 37.805471980811141],
            [-122.446771068810406, 37.805405768207393],
            [-122.446462225224153, 37.805444515694951],
            [-122.445989505497494, 37.805505194954378],
            [-122.446003707846955, 37.805518695189633],
            [-122.4460087518259, 37.805579044127001],
            [-122.446547025898894, 37.805509728799308],
            [-122.446550972467278, 37.805528205624398],
            [-122.446518204506802, 37.805532866567553],
            [-122.446489185128556, 37.80554845357441],
            [-122.446462996481614, 37.80553995860523],
            [-122.446437419711515, 37.805554801776253],
            [-122.446402597499727, 37.805547136014376],
            [-122.446377002372941, 37.805561292745764],
            [-122.446359483641928, 37.805553341395452],
            [-122.446335312891549, 37.805555800213412],
            [-122.446311412770896, 37.805568555772986],
            [-122.446295642000578, 37.805561262020625],
            [-122.44627666253902, 37.805563635428271],
            [-122.446249319434344, 37.805577134798497],
            [-122.446231800006771, 37.805569182891531],
            [-122.446148996869667, 37.805580163541499],
            [-122.446123402382483, 37.805594320480907],
            [-122.446104135009989, 37.805585710944754],
            [-122.44608171290129, 37.805588827858948],
            [-122.44605783038071, 37.805602270079603],
            [-122.446038580653479, 37.805594346696139],
            [-122.446017870868147, 37.805596748888597],
            [-122.445994006657656, 37.805610876973709],
            [-122.445976469264281, 37.80560223887116],
            [-122.445950586862267, 37.805605412856671],
            [-122.445928452266116, 37.805619512663846],
            [-122.445909185255772, 37.805610903090184],
            [-122.445885032816534, 37.805614048516972],
            [-122.445861132260902, 37.80562680426543],
            [-122.445845361169205, 37.805619510184115],
            [-122.445814305801534, 37.805623456219109],
            [-122.44579215352951, 37.805636869562669],
            [-122.445772886191605, 37.805628260247033],
            [-122.445750464048956, 37.80563137682369],
            [-122.445724833141924, 37.805644160817579],
            [-122.445709062413187, 37.805636866986909],
            [-122.445683179641605, 37.805640040919442],
            [-122.445655872372569, 37.805654912741964],
            [-122.445638335008098, 37.805646274589208],
            [-122.445605549302542, 37.805650249115246],
            [-122.445581648680047, 37.80566300453242],
            [-122.445565859972788, 37.805655024250306],
            [-122.445531361592955, 37.805659714013281],
            [-122.445505730631226, 37.805672497684945],
            [-122.445489959918007, 37.805665203825008],
            [-122.445462346810999, 37.80566840625292],
            [-122.445436715841595, 37.805681190184124],
            [-122.445420945133293, 37.805673896314971],
            [-122.445391619690682, 37.8056778137015],
            [-122.445362527733508, 37.805690654981625],
            [-122.445346757369364, 37.8056833608223],
            [-122.44531225895534, 37.805688050246587],
            [-122.445290052615164, 37.805699404198599],
            [-122.445276030220143, 37.805692768201546],
            [-122.445243244128591, 37.805696742632556],
            [-122.445217576794818, 37.805708153657022],
            [-122.445203554404628, 37.805701517651372],
            [-122.445170786636353, 37.80570617848889],
            [-122.445148507984058, 37.805714786690388],
            [-122.445105232410981, 37.805714813715646],
            [-122.445083008046993, 37.805725481196227],
            [-122.44507071598305, 37.80571881663689],
            [-122.445037947513853, 37.80572347772349],
            [-122.445017471439073, 37.805734803086857],
            [-122.445001701099429, 37.805727508881461],
            [-122.444908551660831, 37.805740032744836],
            [-122.44488456097811, 37.805749355858453],
            [-122.444846440036883, 37.805747924599146],
            [-122.444825945937126, 37.805758563222234],
            [-122.444811923572402, 37.805751927170057],
            [-122.44478259772076, 37.805755844410804],
            [-122.44476037365142, 37.805766512099389],
            [-122.444713600749751, 37.805765222919185],
            [-122.444691394641026, 37.805776576752621],
            [-122.444677372284929, 37.805769940684463],
            [-122.444653201761611, 37.805772399426502],
            [-122.444630958989393, 37.805782380395051],
            [-122.444585917098436, 37.805781062896116],
            [-122.444563710619391, 37.805792416711171],
            [-122.444549688278883, 37.80578578090244],
            [-122.444518632419573, 37.805789726327305],
            [-122.444494659650545, 37.805799735794025],
            [-122.444451329400607, 37.805797703293351],
            [-122.444429141227388, 37.805809743784408],
            [-122.444413370583575, 37.805802449506146],
            [-122.444390948345657, 37.805805566373394],
            [-122.44436699318581, 37.805816262252314],
            [-122.444352970844008, 37.805809625871085],
            [-122.444327105931421, 37.805813485938437],
            [-122.44430666567736, 37.805826184043205],
            [-122.444289129128734, 37.805817545953296],
            [-122.444266706866628, 37.805820662247768],
            [-122.444242769660434, 37.805832044533943],
            [-122.444228747333952, 37.805825408412545],
            [-122.444206307444119, 37.80582783853189],
            [-122.444182406178044, 37.805840593670816],
            [-122.44416661758342, 37.805832613201659],
            [-122.44414592563939, 37.805835701223295],
            [-122.444121953151352, 37.805845710608445],
            [-122.444025145055349, 37.805850740063669],
            [-122.444001189835404, 37.805861436142784],
            [-122.443959572249256, 37.805858688226643],
            [-122.443935671622995, 37.805871443304085],
            [-122.443919900675667, 37.805864149240215],
            [-122.443902651728223, 37.805866493739174],
            [-122.443880499045548, 37.805879906997674],
            [-122.443864710121758, 37.805871926219289],
            [-122.44378192426916, 37.805883591639486],
            [-122.443756257338379, 37.805895002334175],
            [-122.443714639749658, 37.805892254606199],
            [-122.443692432758084, 37.80590360826271],
            [-122.4436766621739, 37.805896314160641],
            [-122.443654240222742, 37.805899430882093],
            [-122.443630320868039, 37.805911499476395],
            [-122.443614550281069, 37.80590420509148],
            [-122.44359211035453, 37.805906635368508],
            [-122.443568208950381, 37.805919390108215],
            [-122.443552420405013, 37.80591140955697],
            [-122.443535171434974, 37.805913754002177],
            [-122.443511270025937, 37.805926509004905],
            [-122.443495481838426, 37.805918528714912],
            [-122.443473041543214, 37.805920958425858],
            [-122.443450852475209, 37.80593299846943],
            [-122.443435081915695, 37.805925704609677],
            [-122.443407468616002, 37.805928906281792],
            [-122.443388776471963, 37.805942262421105],
            [-122.443369509665189, 37.805933652158522],
            [-122.443347069022408, 37.805936082125754],
            [-122.443328395172557, 37.80595012440785],
            [-122.443309128031871, 37.805941514415672],
            [-122.443291878362203, 37.805943859111288],
            [-122.443267959626397, 37.805955927620595],
            [-122.443252189065603, 37.805948633187285],
            [-122.443233209414942, 37.805951006379615],
            [-122.443207595577817, 37.805964475989526],
            [-122.443174557723637, 37.805958839788218],
            [-122.443148908639841, 37.80597093678324],
            [-122.443134868425886, 37.805963614373887],
            [-122.443058967715231, 37.805973792109128],
            [-122.443036832460166, 37.805987891372702],
            [-122.443017547724423, 37.805978594894604],
            [-122.442981318355606, 37.805983312150161],
            [-122.442948532359026, 37.805987285937427],
            [-122.442926379114695, 37.806000698747546],
            [-122.44290884267825, 37.805992060178127],
            [-122.442839827294776, 37.806000751431881],
            [-122.442815943694384, 37.806014192451634],
            [-122.442798425230706, 37.806006240298515],
            [-122.442734582834518, 37.806014159544731],
            [-122.442707256867862, 37.806028343976273],
            [-122.44268971976544, 37.806019705660304],
            [-122.442636241331058, 37.806026767128834],
            [-122.442610646012994, 37.806040923030253],
            [-122.442591378939156, 37.80603231319558],
            [-122.442551688858117, 37.806037087047187],
            [-122.442547725650329, 37.806017923926198],
            [-122.443029120691975, 37.805957802366279],
            [-122.443387985849299, 37.805912059110995],
            [-122.443753825765924, 37.805868259987832],
            [-122.443769345089194, 37.805865944017846],
            [-122.443957339015583, 37.805839496905513],
            [-122.444492227815289, 37.805772993462419],
            [-122.444668235229059, 37.805751549942215],
            [-122.445284142224111, 37.805672032526566],
            [-122.445279062855903, 37.805610310694497],
            [-122.44527006920417, 37.805597411188494],
            [-122.444483346869873, 37.805698286438428],
            [-122.443744945559246, 37.805793553184138],
            [-122.443018600699929, 37.805886555905765],
            [-122.442516549650193, 37.805951138305055],
            [-122.442427410705633, 37.806050808392641],
            [-122.442522464016989, 37.806507977467341],
            [-122.442586642075881, 37.806579026869471],
            [-122.443131937777821, 37.806513045572309],
            [-122.443499493172467, 37.806468532301039],
            [-122.443667282141945, 37.806463706682081],
            [-122.443846679856065, 37.806439461357343],
            [-122.443959061743129, 37.806434175357609],
            [-122.443938050605254, 37.806358981524156],
            [-122.443116244562106, 37.806442570813587],
            [-122.442613848569025, 37.80649411140103],
            [-122.442611615303633, 37.806474919513256],
            [-122.442654765933469, 37.806470088368528],
            [-122.442661399886077, 37.806458991436592],
            [-122.442687570467214, 37.806466801090252],
            [-122.442708298579689, 37.80646508646474],
            [-122.442716537115061, 37.806449155723413],
            [-122.442746276492144, 37.806461026947929],
            [-122.442770051771902, 37.806443467084335],
            [-122.44279979080919, 37.80645533830107],
            [-122.442874033560784, 37.806447934694987],
            [-122.442882218173921, 37.806429944918698],
            [-122.442912011462568, 37.806443875399388],
            [-122.442927548550728, 37.806442245978758],
            [-122.442937481103471, 37.806424914130673],
            [-122.442965543726487, 37.806438873384522],
            [-122.442990995725921, 37.806419225391323],
            [-122.443019058349662, 37.806433184357886],
            [-122.443039786445084, 37.806431469674095],
            [-122.443047971009094, 37.806413479611678],
            [-122.443077764322211, 37.806427410050546],
            [-122.443098474448703, 37.80642500892381],
            [-122.443108388985991, 37.806406990354105],
            [-122.443136451627183, 37.806420949292765],
            [-122.443157179716479, 37.806419234588326],
            [-122.443165418150457, 37.806403303815522],
            [-122.443193426900422, 37.806415203442874],
            [-122.443215885660081, 37.806413459937652],
            [-122.443222483596756, 37.806400990383416],
            [-122.443248689797912, 37.806410172509004],
            [-122.443329817859791, 37.806401281706691],
            [-122.443338074230084, 37.806386037628911],
            [-122.443366083001223, 37.806397937215287],
            [-122.443447229004846, 37.806389732764778],
            [-122.443455467380517, 37.806373802246185],
            [-122.443480033821288, 37.806386445534933],
            [-122.443505916940026, 37.806383271811711],
            [-122.443512496848314, 37.806370115534087],
            [-122.443538721058857, 37.806379984576957],
            [-122.443562892155768, 37.806377525783311],
            [-122.443569490023762, 37.806365055935018],
            [-122.44359742694175, 37.80637420973634],
            [-122.443676842221919, 37.806366033924192],
            [-122.443672164594389, 37.806253487231395],
            [-122.443695462542081, 37.806349932284753],
            [-122.443707916670277, 37.806362774599044],
            [-122.44379596596373, 37.806353769679554],
            [-122.443802527838344, 37.806339926678575],
            [-122.443830500721077, 37.806350453289745],
            [-122.443861574478419, 37.806347194484687],
            [-122.443868190266627, 37.806335411052103],
            [-122.443896109229783, 37.80634387807568],
            [-122.443922010642723, 37.806341390962501],
            [-122.443913871646629, 37.806228901600704],
            [-122.443940541034891, 37.806321857121844],
            [-122.443956527422003, 37.806337388377891],
            [-122.44398415881686, 37.80633487273537],
            [-122.444004419522869, 37.806315310362876],
            [-122.444018675589732, 37.806330870132562],
            [-122.444044576647997, 37.806328382998174],
            [-122.444051174437902, 37.806315913397398],
            [-122.444077344761538, 37.806323722474062],
            [-122.444106688857119, 37.806320492116114],
            [-122.444113268646205, 37.806307335530214],
            [-122.444137744599871, 37.806316546256639],
            [-122.444163610043603, 37.806312686225482],
            [-122.444171919814423, 37.806299501392182],
            [-122.444198126803698, 37.806308683844726],
            [-122.44422572221977, 37.806304795006142],
            [-122.444232302000771, 37.806291638962733],
            [-122.444258508634277, 37.806300820858432],
            [-122.444287834382735, 37.806296903754081],
            [-122.44429446807581, 37.806285806729939],
            [-122.444320620790435, 37.806292929589091],
            [-122.444410328338193, 37.806281149679826],
            [-122.444398674018615, 37.806166658108886],
            [-122.444430732743257, 37.806267078693303],
            [-122.444443114393508, 37.806277175761053],
            [-122.44453626493052, 37.806264652260793],
            [-122.444546322932027, 37.806252125028941],
            [-122.444572511964111, 37.80626062069139],
            [-122.44466566211247, 37.806248097094617],
            [-122.444654277108668, 37.8061439020343],
            [-122.444684317803762, 37.806233368169231],
            [-122.444698448132328, 37.806244122830272],
            [-122.444729504511017, 37.806240177078124],
            [-122.444737832507585, 37.806227678906012],
            [-122.444765733548039, 37.806235459291536],
            [-122.444782982907213, 37.806233114935374],
            [-122.44479131087958, 37.806220616210318],
            [-122.444819211930195, 37.806228396857783],
            [-122.444886496978683, 37.806219733530369],
            [-122.44488089641429, 37.806138105148783],
            [-122.444906901269448, 37.806205662186763],
            [-122.444919282967007, 37.806215758930051],
            [-122.444986568338436, 37.806207095539854],
            [-122.444994931901647, 37.806195969945342],
            [-122.445021067006977, 37.806202405936702],
            [-122.445093525002505, 37.8061929701732],
            [-122.445087942204026, 37.80611202850794],
            [-122.445113929253864, 37.806178899068257],
            [-122.445128041656801, 37.806188967520207],
            [-122.445202229600525, 37.806179502882479],
            [-122.445210557849578, 37.806167004396592],
            [-122.445236728249824, 37.806174813490792],
            [-122.44525743822885, 37.806172411710314],
            [-122.445265766467799, 37.80615991322049],
            [-122.445267302625481, 37.806086407881679],
            [-122.445285033545986, 37.806168522898403],
            [-122.445310916864869, 37.806165349047845],
            [-122.445305315838027, 37.806083720685585],
            [-122.445331267107818, 37.80614921860834],
            [-122.445347145482373, 37.806160631088311],
            [-122.445366125472304, 37.806158257824791],
            [-122.445374453006437, 37.806145759613244],
            [-122.44540062410141, 37.806153568385149],
            [-122.445424776743849, 37.806150423332426],
            [-122.445433086611402, 37.80613723812958],
            [-122.445434730189021, 37.806067851662334],
            [-122.445459293346119, 37.806146420033315],
            [-122.445479985322095, 37.806143331781477],
            [-122.445489989537165, 37.806128745440887],
            [-122.445516214271365, 37.806138614038851],
            [-122.445543827543716, 37.806135411324078],
            [-122.445560788683153, 37.80612208366891],
            [-122.445567131287589, 37.806165929693421],
            [-122.445546061556797, 37.806154603157502],
            [-122.445523639245678, 37.806157719690731],
            [-122.445501522738013, 37.806172505842895],
            [-122.445489122634442, 37.806161722734075],
            [-122.44546670032598, 37.806164839531021],
            [-122.445442817508763, 37.806178281625698],
            [-122.445432201695837, 37.806169528989997],
            [-122.445352822460961, 37.806179079403755],
            [-122.445327226916191, 37.806193235905667],
            [-122.445316593481564, 37.806183797096139],
            [-122.445244135177305, 37.806193233002396],
            [-122.44522027063509, 37.806207361203953],
            [-122.445207906544567, 37.80619795120483],
            [-122.445188926532239, 37.806200324168309],
            [-122.445161708883106, 37.806218628036419],
            [-122.445135448551525, 37.806207386764015],
            [-122.445111565653477, 37.806220828516935],
            [-122.44509921920563, 37.806212104669896],
            [-122.445030203866864, 37.80622079693034],
            [-122.445008123555382, 37.806236955848796],
            [-122.444978438202398, 37.806227144485362],
            [-122.444954644838973, 37.806244018373903],
            [-122.444924959836314, 37.806234206991327],
            [-122.444902861169254, 37.806249679463384],
            [-122.444888730810021, 37.806238924826829],
            [-122.444823175735436, 37.806247559901692],
            [-122.444801113352611, 37.806264405213646],
            [-122.444785216712205, 37.806252306233745],
            [-122.444723104639422, 37.806260197747797],
            [-122.444699383130299, 37.80627981731422],
            [-122.444681702577071, 37.806265687549761],
            [-122.444619590489268, 37.806273579283847],
            [-122.444597491739671, 37.806289051423988],
            [-122.444583361417187, 37.806278296750953],
            [-122.444519536610485, 37.806286903400981],
            [-122.444493959540637, 37.806301746142793],
            [-122.44447984720945, 37.80629167788976],
            [-122.444386678651156, 37.806303514912976],
            [-122.444361209083098, 37.806322476775328],
            [-122.444343546554336, 37.806309033118175],
            [-122.444324566500356, 37.806311406491666],
            [-122.444297366567298, 37.806330396317819],
            [-122.444279722039454, 37.806317639632702],
            [-122.444255568948051, 37.806320784456545],
            [-122.444233506414719, 37.806337629662124],
            [-122.444217609851108, 37.806325530605875],
            [-122.444126171547992, 37.806337339172615],
            [-122.444102396615747, 37.806354899035341],
            [-122.444084751416256, 37.806342142057929],
            [-122.444034733554687, 37.806349147388161],
            [-122.443955318332002, 37.806357323441311],
            [-122.443976328801966, 37.806432517557667],
            [-122.444009133253417, 37.806429229637253],
            [-122.44401497169018, 37.80645385590833],
            [-122.443983915176943, 37.806457801197638],
            [-122.443991501564284, 37.806483085111559],
            [-122.444006566508079, 37.806529534342857],
            [-122.443998364182022, 37.80654683776438],
            [-122.444012889909018, 37.806572694020851],
            [-122.444137456251781, 37.806569953925113],
            [-122.444004705900142, 37.806590683869416],
            [-122.444008597616772, 37.806607101209622],
            [-122.444028224510816, 37.8066294400098],
            [-122.444014687364202, 37.806641337539759],
            [-122.444016813135761, 37.806656410256579],
            [-122.444032907804939, 37.806676060090197],
            [-122.4440210291, 37.806685183643154],
            [-122.444025100564104, 37.806708465032258],
            [-122.444042961537718, 37.806729459206764],
            [-122.444031118428768, 37.806739955631187],
            [-122.444035226540592, 37.806764609873134],
            [-122.444052799240296, 37.806774621138679],
            [-122.444173599989711, 37.806760268693552],
            [-122.444175761756156, 37.806776714546551],
            [-122.443903104192728, 37.806809364848277],
            [-122.443899212488802, 37.80679294750523],
            [-122.443999302417467, 37.806780996791801],
            [-122.444012857566491, 37.806769785696332],
            [-122.443998457621589, 37.806748734467796],
            [-122.444004821781832, 37.806727340974426],
            [-122.443985267126379, 37.806707748443934],
            [-122.443996768032036, 37.80668420981921],
            [-122.443979015619519, 37.806667334220748],
            [-122.443988858092823, 37.806646570397213],
            [-122.443972709865449, 37.806624861254427],
            [-122.443980822328029, 37.806604125398131],
            [-122.443978768461875, 37.806591798410317],
            [-122.443966422424324, 37.806583074165033],
            [-122.443972768605505, 37.806560994240272],
            [-122.443949501347888, 37.806531848697659],
            [-122.443975330928197, 37.806526615843026],
            [-122.443974234501226, 37.806484743188264],
            [-122.443966666100792, 37.806460145980267],
            [-122.443854499850644, 37.806473669177059],
            [-122.443860373479154, 37.806499667782823],
            [-122.443717402901086, 37.806526746415607],
            [-122.443667420469765, 37.806535124185942],
            [-122.443645087827377, 37.806541672798915],
            [-122.443622719585392, 37.806546848536961],
            [-122.443600333023568, 37.806551337843935],
            [-122.443577910179286, 37.806554454561891],
            [-122.443581820462299, 37.80657155833741],
            [-122.443586556699174, 37.806620238019541],
            [-122.443637961503612, 37.806864552713115],
            [-122.443633273319165, 37.806883858652405],
            [-122.443607138425932, 37.806877421799527],
            [-122.443529794028962, 37.806898611546323],
            [-122.443526675114754, 37.806911710787858],
            [-122.443502306167488, 37.806906618541966],
            [-122.443424944087113, 37.80692712178169],
            [-122.443421824461069, 37.806940221031809],
            [-122.443397438234925, 37.806934442320348],
            [-122.443318380993759, 37.806956346879609],
            [-122.443315262039832, 37.806969446115438],
            [-122.443289162740911, 37.806964382337512],
            [-122.443211818508658, 37.806985571869724],
            [-122.443208734784008, 37.807000044253662],
            [-122.443180869538779, 37.806993635816845],
            [-122.443103524899072, 37.807014825283645],
            [-122.443102154219687, 37.807028582437368],
            [-122.443076036948625, 37.80702283217979],
            [-122.442998692594642, 37.807044021572032],
            [-122.442995572888506, 37.807057120810583],
            [-122.442969456307765, 37.807051370518039],
            [-122.442895554290288, 37.807071816676462],
            [-122.442876807520932, 37.807083113165248],
            [-122.442860372447001, 37.807050420945309],
            [-122.44288643546534, 37.807054111684081],
            [-122.442950027240173, 37.807036582576075],
            [-122.442956535452808, 37.807020680875418],
            [-122.44298955579778, 37.807025630704103],
            [-122.443044549671924, 37.807010303103709],
            [-122.443051093786181, 37.806995773988241],
            [-122.443080653430101, 37.80700078080757],
            [-122.443137377283094, 37.806985425210136],
            [-122.443143903403268, 37.806970209382371],
            [-122.443176924084369, 37.806975159152948],
            [-122.443230187542511, 37.806959860250316],
            [-122.443236731623188, 37.806945331399028],
            [-122.443266291259548, 37.806950338171859],
            [-122.443323015021249, 37.806934981935846],
            [-122.443327829074263, 37.806920481311195],
            [-122.443311249747254, 37.806882297698685],
            [-122.443357388360823, 37.806925488066938],
            [-122.443415825168074, 37.806909417378883],
            [-122.443402365072131, 37.806858134260111],
            [-122.443446755408701, 37.806900666674323],
            [-122.443506922515155, 37.806884567152593],
            [-122.443513466527847, 37.806870038011155],
            [-122.443541295807862, 37.80687507323001],
            [-122.443611772372606, 37.806856057118701],
            [-122.443568098366953, 37.806642517527813],
            [-122.443490717910933, 37.80666233411602],
            [-122.443464637369544, 37.806657956797729],
            [-122.443447387531151, 37.806660301241159],
            [-122.443394142301429, 37.806676286675255],
            [-122.443369792101194, 37.80667188082289],
            [-122.443307715462936, 37.806681144456071],
            [-122.443302883453555, 37.806694958647995],
            [-122.443274946458374, 37.806685805052041],
            [-122.443204469968975, 37.806704820962679],
            [-122.443178370770624, 37.806699757160004],
            [-122.443107894250431, 37.806718773287464],
            [-122.44308352539521, 37.806713680954857],
            [-122.443013048491437, 37.806732697031315],
            [-122.442985237265603, 37.806728348120288],
            [-122.442950738216922, 37.806733036852982],
            [-122.44291647270785, 37.806746649473865],
            [-122.442888625547027, 37.806740927400313],
            [-122.442821555362244, 37.806757827053026],
            [-122.442793726174969, 37.806752791664266],
            [-122.442731613479054, 37.806760682403457],
            [-122.442721537132741, 37.806772522772178],
            [-122.442695384049358, 37.806765399290242],
            [-122.442678134861055, 37.806767743884308],
            [-122.442671608648851, 37.806782959137742],
            [-122.442640174735473, 37.806772489262421],
            [-122.44262290758212, 37.806774147415787],
            [-122.442611226258151, 37.806790821310969],
            [-122.442619566601024, 37.806844935481941],
            [-122.4425572741916, 37.806845961528367],
            [-122.442543113877818, 37.806767907443565],
            [-122.442812274930034, 37.80673394443496],
            [-122.442895043918895, 37.806721593264598],
            [-122.44288439854499, 37.806645541768312],
            [-122.44286390392358, 37.80665618032328],
            [-122.442620734223425, 37.806691089066426],
            [-122.442586432743397, 37.80670332845169],
            [-122.442569254711358, 37.806708418497294],
            [-122.442553843632766, 37.806714852893514],
            [-122.44253845015912, 37.806721973451488],
            [-122.442524957636692, 37.80672882453954],
            [-122.442523074304333, 37.806729780720396],
            [-122.44251132146853, 37.806743708869504],
            [-122.442504741349737, 37.806756865090371],
            [-122.442501639536246, 37.806770651023797],
            [-122.442501980779383, 37.80678369296961],
            [-122.442511153361352, 37.806803457290563],
            [-122.442513800037688, 37.806838436574978],
            [-122.442498190669355, 37.806837320216118],
            [-122.442500262610309, 37.806850333930662],
            [-122.442500855308538, 37.806872986207821],
            [-122.442513308640088, 37.806885829207545],
            [-122.442543448720272, 37.807045340228143],
            [-122.442550657494735, 37.807056209147177],
            [-122.442552729104918, 37.807069222865962],
            [-122.442549574089071, 37.807080949216051],
            [-122.442542975993348, 37.807093419280186],
            [-122.442532880918762, 37.80710457321085],
            [-122.442521020253452, 37.807114382489758],
            [-122.442507375020014, 37.80712216152461],
            [-122.442493693848277, 37.807128567143486],
            [-122.442476479790699, 37.807132284309965],
            [-122.44245921255002, 37.807133942439243],
            [-122.442443603113219, 37.807132825798654],
            [-122.442426210144987, 37.807129678620242],
            [-122.442401877121071, 37.807125959012424],
            [-122.442394668361601, 37.807115090084459],
            [-122.442382322776425, 37.807106365943092],
            [-122.442371670941014, 37.807096240723055],
            [-122.442357217513063, 37.80707312972298],
            [-122.442353415933297, 37.807060144492915],
            [-122.442352751441661, 37.807034746485243],
            [-122.442355888527402, 37.807022333707671],
            [-122.442327317913012, 37.80685661596673],
            [-122.442325228043273, 37.806842915816503],
            [-122.442319678177554, 37.80682927264953],
            [-122.442314163892661, 37.806817002627895],
            [-122.442303476176264, 37.806805503986638],
            [-122.442292807121106, 37.806794692040256],
            [-122.442278730911681, 37.806785996390175],
            [-122.44225259583861, 37.806779559791913],
            [-122.442263912071212, 37.806815083032639],
            [-122.442334351220893, 37.807191623601256],
            [-122.442574008114292, 37.807154713430769],
            [-122.442579917970377, 37.807182085225314],
            [-122.442316125837024, 37.807222826535309],
            [-122.442296128149565, 37.807120146892402],
            [-122.442249660075092, 37.807130526084627],
            [-122.442243205590515, 37.807148487593025],
            [-122.442218675723581, 37.80713721717698],
            [-122.442177362768064, 37.807146137987679],
            [-122.442169249735414, 37.807166873443258],
            [-122.44214120495144, 37.807153600709071],
            [-122.442110219881215, 37.807160291509724],
            [-122.442102143088249, 37.807182399820256],
            [-122.442074080353734, 37.807168440637511],
            [-122.441951871381676, 37.807195175211561],
            [-122.441943758626778, 37.807215910645752],
            [-122.441915713871779, 37.807202638132658],
            [-122.441829644720443, 37.807221223495034],
            [-122.441823243975179, 37.807241243729116],
            [-122.441796947879098, 37.807228628850183],
            [-122.441714321769382, 37.807246470710545],
            [-122.441706226203735, 37.807267892572305],
            [-122.441678163511327, 37.807253933295577],
            [-122.441590382530393, 37.807273233392451],
            [-122.441583945818934, 37.807291881022437],
            [-122.441559397367783, 37.80727992432282],
            [-122.441528412884566, 37.807286614959068],
            [-122.441522065914484, 37.807308694749302],
            [-122.4414922725324, 37.807294763645217],
            [-122.441459575632209, 37.807302169181312],
            [-122.441451444085047, 37.807322218159875],
            [-122.441425148030646, 37.807309603472838],
            [-122.441347676557456, 37.807325986488941],
            [-122.441341185930639, 37.807342574807244],
            [-122.441318422046436, 37.807332648592578],
            [-122.441240951224984, 37.807349031801699],
            [-122.441234550317162, 37.807369052277899],
            [-122.441208253583667, 37.807356437279445],
            [-122.44112907030356, 37.807373535328814],
            [-122.44112095660725, 37.807394270717083],
            [-122.44109464263579, 37.807380969523756],
            [-122.440999993407189, 37.807402442127575],
            [-122.440987126791967, 37.807373811300785],
            [-122.441006340540554, 37.807380362365826],
            [-122.441088966969374, 37.807362521001856],
            [-122.441071293907683, 37.807282464951484],
            [-122.441105839449861, 37.807345761826411],
            [-122.441121664279194, 37.807355115562864],
            [-122.441199135479366, 37.807338732426437],
            [-122.441181426400448, 37.807257303252058],
            [-122.441215936141603, 37.807319227778606],
            [-122.441235275185775, 37.807330583566994],
            [-122.44130240044376, 37.80731574411066],
            [-122.44131244119076, 37.80730253099884],
            [-122.441289899930467, 37.807234916217887],
            [-122.441336846017577, 37.807308996562313],
            [-122.441403970896872, 37.807294157328393],
            [-122.441389758204977, 37.807214043807704],
            [-122.441424286396526, 37.807276654700864],
            [-122.441440110897986, 37.807286008125857],
            [-122.441505522979043, 37.807271883482372],
            [-122.441489561884524, 37.807191112300579],
            [-122.441524179900497, 37.807257155053932],
            [-122.441538238159126, 37.807265164360558],
            [-122.441610518456187, 37.807248866405487],
            [-122.441598394609557, 37.807182453357271],
            [-122.441630905705154, 37.807234109473121],
            [-122.441643233270554, 37.80724214726019],
            [-122.441715531475523, 37.807226535673394],
            [-122.441722129729229, 37.807214065930424],
            [-122.441749959016704, 37.807219101571583],
            [-122.44181537098703, 37.807204977030693],
            [-122.441821969214871, 37.8071925070075],
            [-122.441804977662258, 37.807138535507519],
            [-122.441848068147848, 37.807197571115559],
            [-122.441911750066581, 37.807183474731303],
            [-122.441901356658576, 37.80711703321635],
            [-122.441942735164389, 37.807176783982825],
            [-122.442002974305893, 37.807163431240092],
            [-122.44201133876993, 37.807152305853435],
            [-122.442037401781846, 37.80715599677972],
            [-122.442094216092357, 37.807144073567486],
            [-122.44210250836673, 37.807130202449336],
            [-122.442130373562975, 37.807136610866159],
            [-122.442190612977058, 37.807123257747243],
            [-122.4421768301127, 37.807059618983033],
            [-122.442207521070316, 37.807107871278774],
            [-122.442221597332434, 37.80711656693682],
            [-122.442292164942742, 37.807100983492141],
            [-122.442243704644795, 37.806836704402386],
            [-122.442167767011739, 37.806845508971712],
            [-122.442147308147, 37.806857520267137],
            [-122.442072831477645, 37.806855999790052],
            [-122.442050696118415, 37.806870098860529],
            [-122.442038314362932, 37.806860002097636],
            [-122.44197618353418, 37.806867205731571],
            [-122.44195577849186, 37.806881276017322],
            [-122.441943396394166, 37.806871178975598],
            [-122.441881247592036, 37.806877696126804],
            [-122.441859148445275, 37.806893168021055],
            [-122.44184673044974, 37.806881698103723],
            [-122.441786329930238, 37.806888873147223],
            [-122.441762464513715, 37.80690300092192],
            [-122.441750082438688, 37.806892903859939],
            [-122.441684509153674, 37.806900850470612],
            [-122.441658930973958, 37.80691569315082],
            [-122.441646530958224, 37.806904909645212],
            [-122.441572305572137, 37.806912998636243],
            [-122.441548386244634, 37.806925066794669],
            [-122.441465311637984, 37.806925747662177],
            [-122.441443158191802, 37.806939160185685],
            [-122.44142908206166, 37.806930464709019],
            [-122.44136529221457, 37.806940441967662],
            [-122.441344958843104, 37.806957258153332],
            [-122.441327368515545, 37.806946560051927],
            [-122.441311849243505, 37.806948875968999],
            [-122.441293246205632, 37.806965663663163],
            [-122.441275637234966, 37.806954278858043],
            [-122.44126011795251, 37.806956594493755],
            [-122.441239730706059, 37.80697135136279],
            [-122.441223906642946, 37.806961997904651],
            [-122.441151465000161, 37.806972117453661],
            [-122.441129311490656, 37.806985530192655],
            [-122.441115235374099, 37.806976834129472],
            [-122.441037621302598, 37.806987725743447],
            [-122.44101719810962, 37.807001109708246],
            [-122.441003139964337, 37.806993100613703],
            [-122.440922064462001, 37.807004048844455],
            [-122.440901659189493, 37.807018119222057],
            [-122.440895696481135, 37.806988688312863],
            [-122.441218230630383, 37.806943549393232],
            [-122.441263058469275, 37.806936630972665],
            [-122.441435464921327, 37.80690975751326],
            [-122.441433016200833, 37.806882328691337],
            [-122.441372490336036, 37.806884698487615],
            [-122.441304935046745, 37.806883063866231],
            [-122.441274237201611, 37.806900737372722],
            [-122.441242947719005, 37.806895758576474],
            [-122.44119330612007, 37.806917177241274],
            [-122.441110393048419, 37.806924035754299],
            [-122.441042945411667, 37.806926519579946],
            [-122.440998117551175, 37.806933437642307],
            [-122.440918593700744, 37.806937493327403],
            [-122.440899792827196, 37.80694673020367],
            [-122.440782200958282, 37.806951412279737],
            [-122.440680218094201, 37.806957210845738],
            [-122.44054721454367, 37.806968326842338],
            [-122.440468121234176, 37.806988856613863],
            [-122.440371365223044, 37.806995942367976],
            [-122.440134737571853, 37.807016316747912],
            [-122.43989673886324, 37.807050447763743],
            [-122.43967267172718, 37.807087782808438],
            [-122.439538386124013, 37.807116087220599],
            [-122.439408914197855, 37.80712989048353],
            [-122.439239537222377, 37.807140229675355],
            [-122.439104802429114, 37.807151372502958],
            [-122.438766800452754, 37.807200879974303],
            [-122.438299128879564, 37.807256638299236],
            [-122.437960892936687, 37.807297219553782],
            [-122.437688625577763, 37.807344957007658],
            [-122.437514504314919, 37.807372539848515],
            [-122.437376577168436, 37.807394034049501],
            [-122.437259217227975, 37.807407636246566],
            [-122.437146815479664, 37.80741222942855],
            [-122.437031382840118, 37.807433353744614],
            [-122.436885215537345, 37.80747077743743],
            [-122.436714393247598, 37.807492124635075],
            [-122.436614801865048, 37.807523289038706],
            [-122.436563088290782, 37.807531692199284],
            [-122.436507376472989, 37.80751955916309],
            [-122.436298557575597, 37.807544276277241],
            [-122.436240083275962, 37.807558970839189],
            [-122.436155205939471, 37.807556930640864],
            [-122.435982097955772, 37.80755702547102],
            [-122.435828364056036, 37.807569849863164],
            [-122.435859235962624, 37.807691580598309],
            [-122.433925269093152, 37.807945122059223],
            [-122.433817271048738, 37.80791942385212],
            [-122.433787568621852, 37.807908923241605],
            [-122.433755903391244, 37.807889527355464],
            [-122.43376416154652, 37.807874283957823],
            [-122.433933527911989, 37.807929878638532],
            [-122.435838185171932, 37.807680938490563],
            [-122.435834169572829, 37.807659716129535],
            [-122.435737591220459, 37.807673662142683],
            [-122.433917274710794, 37.807904049527295],
            [-122.433913385157453, 37.807887631858222],
            [-122.434041074707324, 37.807871803440726],
            [-122.434044035083929, 37.807852526536877],
            [-122.434070401961165, 37.807867888872153],
            [-122.434160130921143, 37.807856803195897],
            [-122.434164803061421, 37.807836811488876],
            [-122.434189457816743, 37.807852888603414],
            [-122.434284359969311, 37.807841031264509],
            [-122.434289032075128, 37.807821039552501],
            [-122.434313686852093, 37.80783711664111],
            [-122.434406858247897, 37.807825287589175],
            [-122.434411548897913, 37.80780598229466],
            [-122.434437915834692, 37.807821344547961],
            [-122.434520741089443, 37.807811058557668],
            [-122.434525413482959, 37.8077910671051],
            [-122.434551797979211, 37.80780711577237],
            [-122.434636336023075, 37.807796114603541],
            [-122.434641025919433, 37.807776809311157],
            [-122.434665680757917, 37.807792886326304],
            [-122.434750218436946, 37.807781885630661],
            [-122.434754908641708, 37.807762580053435],
            [-122.434779544918584, 37.807777970622496],
            [-122.434871004379232, 37.807766856012883],
            [-122.434875676329611, 37.807746864551945],
            [-122.434900331208965, 37.807762941518149],
            [-122.434976252743482, 37.807753454920828],
            [-122.434979194289198, 37.807733491570779],
            [-122.435005579555238, 37.807749540125371],
            [-122.435084943914418, 37.807739310518855],
            [-122.43508961579829, 37.807719318774772],
            [-122.435116018975634, 37.807736053738346],
            [-122.435191922576223, 37.807725881117662],
            [-122.435196576876137, 37.807705202655406],
            [-122.43522297972649, 37.807721937600746],
            [-122.435302361927597, 37.807712394556091],
            [-122.435306998308789, 37.807691029930353],
            [-122.435333419066353, 37.8077084510101],
            [-122.435402436929863, 37.807699764700374],
            [-122.435407055040258, 37.807677713642711],
            [-122.435433494058017, 37.807695821128007],
            [-122.435507685095942, 37.807686362859421],
            [-122.435514015990663, 37.807663596960829],
            [-122.43554045469773, 37.807681704977007],
            [-122.435609472497859, 37.807673017996969],
            [-122.435614072648008, 37.807650280497519],
            [-122.435642259638655, 37.807669046525525],
            [-122.435711277415109, 37.807660359485872],
            [-122.43572966745738, 37.807635335465775],
            [-122.435735467093281, 37.807658589004994],
            [-122.435830350851532, 37.807646043988242],
            [-122.435804210559851, 37.807572993499143],
            [-122.435788619382777, 37.807572562680427],
            [-122.435772938706066, 37.807568699417203],
            [-122.435758952605468, 37.807563435158237],
            [-122.435746625277645, 37.807555396762375],
            [-122.435735992180923, 37.807545957377542],
            [-122.435727054339125, 37.807535116438025],
            [-122.435721558628927, 37.807523531999962],
            [-122.435719488549438, 37.807510518156661],
            [-122.435678807510797, 37.807410923656249],
            [-122.435671271850225, 37.807321086052454],
            [-122.435659314380757, 37.807260850297496],
            [-122.435635232905554, 37.807266739353338],
            [-122.435635716129568, 37.807285273061382],
            [-122.435609349135348, 37.807269911074314],
            [-122.435543792417761, 37.807278540984541],
            [-122.43552006850399, 37.80729815869541],
            [-122.435504101570785, 37.807283312732451],
            [-122.435441987649398, 37.807291199357643],
            [-122.435419994063011, 37.807310788651876],
            [-122.43540402680101, 37.807295942681101],
            [-122.435341912858448, 37.807303829253563],
            [-122.435318189229335, 37.807323446918055],
            [-122.435302222331032, 37.807308600927854],
            [-122.435234935185079, 37.80731725906076],
            [-122.435212941536335, 37.807336848316268],
            [-122.435196974310131, 37.807322002317541],
            [-122.435127956788023, 37.807330689056798],
            [-122.435105963445992, 37.807350278012088],
            [-122.435089996584352, 37.807335431993209],
            [-122.435019248678017, 37.807344147060114],
            [-122.4349972725025, 37.807364422440152],
            [-122.434981288114457, 37.807348889967201],
            [-122.434910540175395, 37.807357604694324],
            [-122.434888564319408, 37.807377880322939],
            [-122.434872579266241, 37.807362348121238],
            [-122.434798388810123, 37.807371805710694],
            [-122.434776412580376, 37.807392081598607],
            [-122.434758697865377, 37.807376577207712],
            [-122.434691410594411, 37.807385235030431],
            [-122.434667704309632, 37.80740553900322],
            [-122.434651719289548, 37.807390006497108],
            [-122.434575798078043, 37.807399492611601],
            [-122.434552092103161, 37.807419796555429],
            [-122.434536125337331, 37.807404950461788],
            [-122.434461916577604, 37.807413721960565],
            [-122.434439940575373, 37.80743399723081],
            [-122.434423973489999, 37.807419151402279],
            [-122.434349765034597, 37.807427922275664],
            [-122.43432605864993, 37.807448226454213],
            [-122.434310074038208, 37.807432693896239],
            [-122.434230709546782, 37.807442922713086],
            [-122.434208733825983, 37.807463198209049],
            [-122.434192749235578, 37.807447665635237],
            [-122.434111654710136, 37.807457923293533],
            [-122.434087948236439, 37.807478226874963],
            [-122.434071963321998, 37.807462694290493],
            [-122.433992599465014, 37.807472923210291],
            [-122.433970605449531, 37.807492512508169],
            [-122.433954638431118, 37.807477666067122],
            [-122.433870083452888, 37.807487980028228],
            [-122.433846376910722, 37.807508283835588],
            [-122.433830409920873, 37.80749343765234],
            [-122.43374412454402, 37.807503779895939],
            [-122.433722148333416, 37.807524055581261],
            [-122.433706163485638, 37.807508522947344],
            [-122.433606088798641, 37.807521151358706],
            [-122.433584112530909, 37.807541426469101],
            [-122.433574191011218, 37.807492831512612],
            [-122.433602216513336, 37.807505419848866],
            [-122.433678120078412, 37.807495247927321],
            [-122.433686343139499, 37.80747863165486],
            [-122.433714368662436, 37.807491220239072],
            [-122.433795462933048, 37.807480962859643],
            [-122.433803685966325, 37.807464346578953],
            [-122.433831693616042, 37.80747624842688],
            [-122.433911075733292, 37.807466706318117],
            [-122.433919280165583, 37.807449403606796],
            [-122.433947305702674, 37.807461991586599],
            [-122.434024939884253, 37.807451791061574],
            [-122.434034892878572, 37.807435146394688],
            [-122.434062900561514, 37.80744704846235],
            [-122.434135379039915, 37.807438305591944],
            [-122.434143601646298, 37.807421689293108],
            [-122.434171609334427, 37.807433591060409],
            [-122.434245800271043, 37.807424133585066],
            [-122.434254022851178, 37.80740751727847],
            [-122.434282048436359, 37.807420105453431],
            [-122.434352778623364, 37.807410704669572],
            [-122.434361000831984, 37.807394088361185],
            [-122.434389026430239, 37.807406676510716],
            [-122.43446148730483, 37.807397247549531],
            [-122.434471439847925, 37.807380602851318],
            [-122.43449944756594, 37.807392504266289],
            [-122.434571926300066, 37.807383761671048],
            [-122.434581860921966, 37.807366430255094],
            [-122.434609886547221, 37.807379018352258],
            [-122.434682347359626, 37.807369588980769],
            [-122.434690569836022, 37.807352972643585],
            [-122.434718577593046, 37.807364874555745],
            [-122.434784152364955, 37.807356931263477],
            [-122.43479237481715, 37.807340314919166],
            [-122.434820382585727, 37.807352216807175],
            [-122.434884226976308, 37.807344301846562],
            [-122.434894179763575, 37.807327657106839],
            [-122.434922187543705, 37.807339558970696],
            [-122.434987762271462, 37.807331615565204],
            [-122.434997697142578, 37.807314284382969],
            [-122.435025722825799, 37.807326872656006],
            [-122.43509127963911, 37.807318242759216],
            [-122.435101232376525, 37.807301598001935],
            [-122.435129240172827, 37.807313499542126],
            [-122.43519308450432, 37.807305584688869],
            [-122.435201306859327, 37.807288968315881],
            [-122.435231044678986, 37.807300841444686],
            [-122.435296619692778, 37.807292898136311],
            [-122.4353048420232, 37.807276281756089],
            [-122.435332849842581, 37.807288183247969],
            [-122.435398406593208, 37.807279553455011],
            [-122.435406628899386, 37.80726293706762],
            [-122.435436384982893, 37.8072754965727],
            [-122.435451904167508, 37.80727318170905],
            [-122.435460126807058, 37.807256565312237],
            [-122.435488134643933, 37.807268466767304],
            [-122.435508433635007, 37.807250278724965],
            [-122.435536459373509, 37.807262866602237],
            [-122.435602016078107, 37.80725423669606],
            [-122.435615572581426, 37.80724302656666],
            [-122.435634803373304, 37.807250264946127],
            [-122.435655496065394, 37.807247178418407],
            [-122.435588180541416, 37.806922774713847],
            [-122.435582667693723, 37.80691050382292],
            [-122.435534182131477, 37.806909926104069],
            [-122.435571873987683, 37.806894886513319],
            [-122.435559492755871, 37.80688478880149],
            [-122.435545453103273, 37.806877464940861],
            [-122.435529719250937, 37.806871542612598],
            [-122.435514074542013, 37.806869052731017],
            [-122.435493292470525, 37.806868707065597],
            [-122.435344768504805, 37.806882132076758],
            [-122.435121911744176, 37.806899523218981],
            [-122.434871780421872, 37.806933156410132],
            [-122.434433666315243, 37.806993908011997],
            [-122.434416381034183, 37.806994878255509],
            [-122.434278149661878, 37.807004699734037],
            [-122.434260827915324, 37.807004297098374],
            [-122.434243471085438, 37.807002521306472],
            [-122.434227808507927, 37.806999344820447],
            [-122.434210379805293, 37.806994823568417],
            [-122.434194645688478, 37.806988901067868],
            [-122.434180606150846, 37.806981577044944],
            [-122.434166548746745, 37.806973567135586],
            [-122.434154185915276, 37.806964155430045],
            [-122.434143535561248, 37.806954029186485],
            [-122.434134579447857, 37.806942501702544],
            [-122.434125606153387, 37.806930288047226],
            [-122.434123142595496, 37.806902172634167],
            [-122.434101162359013, 37.806855835376808],
            [-122.434090404384904, 37.806841590530418],
            [-122.434081359579054, 37.806826631135792],
            [-122.43406669419322, 37.806795281911626],
            [-122.434061091508866, 37.806779579065555],
            [-122.434055471636611, 37.80676318977391],
            [-122.434051599648825, 37.806747458545502],
            [-122.434049475890433, 37.80673238537485],
            [-122.434047316368137, 37.806715939336222],
            [-122.434046440132462, 37.806682304072865],
            [-122.43401902773472, 37.806493903623902],
            [-122.434011784506907, 37.806481661588982],
            [-122.434004523385283, 37.806468732570444],
            [-122.433998992958308, 37.806455775445059],
            [-122.433995192532976, 37.806442790224423],
            [-122.433964135838224, 37.806446732869858],
            [-122.433932703641176, 37.806436260667759],
            [-122.433886127202001, 37.806442518242726],
            [-122.433858853036313, 37.806458760199753],
            [-122.433839551447093, 37.806448775787949],
            [-122.433791244999313, 37.806455061692688],
            [-122.4337639708083, 37.80647130362771],
            [-122.433744668882483, 37.806461319206093],
            [-122.433694632079209, 37.806467633442772],
            [-122.433667357862433, 37.806483875355433],
            [-122.43364805594635, 37.806473890918021],
            [-122.433596288440668, 37.806480233488799],
            [-122.433569014197744, 37.806496475378673],
            [-122.433549712637699, 37.806486490919518],
            [-122.433503136480809, 37.806492748337497],
            [-122.433477574676203, 37.806508275404134],
            [-122.433458272433256, 37.806498290941384],
            [-122.433404793122563, 37.806505348218124],
            [-122.43337751882855, 37.806521590063653],
            [-122.433358216941642, 37.806511605578869],
            [-122.4333047372658, 37.806518662815925],
            [-122.433279192939949, 37.806534876279215],
            [-122.433259891408895, 37.80652489177271],
            [-122.433206393839583, 37.806531262531053],
            [-122.433179119492635, 37.806547504330624],
            [-122.433159817625679, 37.806537519813411],
            [-122.43309943408164, 37.806545377123399],
            [-122.43307215969898, 37.806561618623626],
            [-122.433052858195936, 37.806551634357852],
            [-122.432990744619175, 37.806559519418741],
            [-122.432963470221836, 37.806575761442943],
            [-122.43294416836936, 37.80656577661594],
            [-122.432885515114464, 37.806573605181946],
            [-122.432858276424469, 37.806591219775477],
            [-122.432851977723161, 37.806548745928424],
            [-122.432876452705358, 37.806557958985486],
            [-122.432950642939176, 37.806548502597778],
            [-122.432958937194059, 37.806534631840726],
            [-122.432985142526235, 37.806543816515223],
            [-122.433055872042729, 37.806534416507489],
            [-122.433064219557167, 37.806522605325611],
            [-122.433088659156226, 37.806530445464773],
            [-122.43316111864155, 37.80652101703766],
            [-122.433169413207281, 37.806507146534614],
            [-122.433195618216885, 37.806516331442637],
            [-122.433259444532922, 37.80650773092048],
            [-122.433269469079946, 37.806493832326176],
            [-122.433293944088703, 37.806503045022133],
            [-122.433357787918965, 37.806495131161043],
            [-122.433366082106133, 37.806481260924372],
            [-122.433392287462695, 37.806490445233919],
            [-122.433454400931879, 37.806482559686899],
            [-122.433462695099607, 37.806468689443392],
            [-122.433488900463672, 37.806477873731517],
            [-122.433552726373762, 37.806469273330841],
            [-122.433561038053369, 37.806456089520083],
            [-122.433587243771214, 37.806465273780709],
            [-122.433649339320041, 37.806456701696959],
            [-122.43365765098109, 37.806443517879387],
            [-122.433683838827505, 37.806452015684521],
            [-122.433745952233608, 37.806444129983937],
            [-122.433754245996482, 37.806430259725488],
            [-122.43378045172912, 37.806439443943233],
            [-122.433842565114432, 37.806431558191733],
            [-122.433850858857866, 37.806417687926462],
            [-122.433877064598036, 37.806426872122742],
            [-122.433932274491454, 37.806419786251801],
            [-122.433954393037553, 37.806405002549944],
            [-122.433958408377592, 37.806426224974288],
            [-122.43399121327684, 37.806422940114579],
            [-122.433989124957407, 37.806409239815579],
            [-122.433988785204093, 37.806396197569725],
            [-122.433991530954188, 37.80636868345389],
            [-122.433981985185667, 37.806334503629429],
            [-122.433942822534163, 37.806226642930824],
            [-122.433950330141514, 37.806182569274938],
            [-122.433940283395017, 37.806129169298679],
            [-122.433873424076822, 37.805821925113698],
            [-122.433853509955952, 37.80572198947479],
            [-122.433844483207295, 37.805707716218421],
            [-122.433823004146618, 37.805680599328511],
            [-122.433808821860836, 37.805667784061214],
            [-122.433796405313814, 37.805656313293774],
            [-122.433780528829729, 37.805644899532474],
            [-122.433766418068998, 37.805634829721896],
            [-122.43374886455932, 37.805625503361618],
            [-122.433731328933206, 37.805616863432853],
            [-122.433713811190202, 37.805608909935621],
            [-122.433675422356743, 37.805597178553839],
            [-122.433656263344702, 37.805592685320363],
            [-122.433637140790879, 37.805589565215314],
            [-122.433616323330028, 37.805587846350818],
            [-122.43359552375523, 37.805586814191379],
            [-122.433576472363242, 37.805586439544221],
            [-122.433535016220674, 37.805589866131839],
            [-122.433516072105618, 37.805593610629053],
            [-122.433498858293476, 37.805597326206154],
            [-122.432719648836795, 37.805721348282255],
            [-122.432704236424613, 37.805727781678655],
            [-122.432688842557212, 37.805734900946824],
            [-122.432673484086777, 37.805743393361759],
            [-122.432659891674504, 37.805753230287664],
            [-122.432648029581884, 37.805763038856455],
            [-122.432637933547895, 37.805774191937303],
            [-122.432627855379891, 37.805786031451547],
            [-122.432619525401748, 37.805798529044132],
            [-122.432612943621251, 37.805811684990026],
            [-122.432606379692928, 37.805825526820627],
            [-122.432603276080599, 37.805839312496055],
            [-122.432600137407348, 37.805851724742368],
            [-122.432500317433352, 37.805940575058216],
            [-122.432391913920043, 37.805965699763121],
            [-122.432397426855275, 37.805977970519415],
            [-122.432516390332239, 37.805959539768239],
            [-122.432628376560629, 37.805872550799698],
            [-122.432642540805432, 37.805884679499613],
            [-122.432527165744716, 37.805974471194816],
            [-122.432403189584164, 37.805999851361079],
            [-122.43238951051228, 37.806072868560939],
            [-122.432404443045669, 37.806114514237365],
            [-122.432490452847844, 37.806359639916195],
            [-122.43244910342851, 37.806367184726966],
            [-122.432520431119073, 37.806580274784345],
            [-122.432498061398036, 37.806585448423995],
            [-122.432424985907915, 37.806371700265615],
            [-122.432400868391511, 37.806376216073893],
            [-122.432301460176419, 37.806081865240721],
            [-122.43236869294482, 37.806071149476409],
            [-122.432380802509087, 37.806004338539104],
            [-122.43235326017701, 37.806010283635004],
            [-122.432347175872593, 37.805976047248159],
            [-122.432319651407369, 37.805982678495994],
            [-122.432302633632929, 37.805993944955773],
            [-122.432282173360747, 37.806005686719168],
            [-122.432280461289963, 37.806006669320666],
            [-122.432265120589491, 37.806015848390899],
            [-122.432249654811855, 37.806020221869829],
            [-122.432227231644546, 37.806023336155739],
            [-122.432194784491401, 37.806040349205666],
            [-122.432179693529363, 37.806059138076137],
            [-122.432171560304809, 37.806079186408191],
            [-122.432165157068255, 37.806099206671476],
            [-122.432169117939694, 37.806118369860684],
            [-122.432192469776069, 37.806150950175152],
            [-122.432209844223067, 37.806153412703416],
            [-122.432227007583123, 37.806214250207013],
            [-122.432213468614208, 37.806226146108848],
            [-122.432203354593938, 37.806236612991817],
            [-122.432202178080502, 37.806257920803567],
            [-122.43220649593593, 37.806290812956746],
            [-122.432221571326565, 37.806337949854225],
            [-122.432306430556167, 37.806804907302421],
            [-122.432383452345448, 37.807103744994606],
            [-122.432564682589728, 37.808479722911237],
            [-122.432615131844727, 37.808489197136744],
            [-122.432610261989339, 37.808501638018015],
            [-122.432598381927761, 37.808510760137189],
            [-122.432584628175405, 37.80851441914389],
            [-122.432342320320956, 37.808516329227118],
            [-122.432078432185492, 37.807223425689031],
            [-122.431999351719028, 37.807178023752513],
            [-122.431443837686672, 37.8072509882197],
            [-122.431386630568454, 37.807314417209206],
            [-122.431727121174518, 37.8090235974717],
            [-122.431341938476805, 37.809056687748011],
            [-122.430994999022246, 37.807365467556572],
            [-122.430915919059899, 37.807320064620313],
            [-122.430360402907354, 37.807393024257635],
            [-122.430303194747026, 37.8074564524454],
            [-122.43062118366457, 37.809166690185819],
            [-122.430108306409053, 37.8092156017048],
            [-122.429835000067499, 37.807825332620489],
            [-122.429264030219372, 37.807903346686288],
            [-122.429270969868725, 37.807970532619663],
            [-122.428236680346103, 37.808405663457563],
            [-122.427001622006514, 37.808109268493716],
            [-122.426995537909036, 37.808141644021028],
            [-122.427545144293163, 37.808640840008444],
            [-122.428014153033857, 37.808569308327186],
            [-122.428043639051282, 37.808704798333089],
            [-122.427533242566099, 37.808782500069931],
            [-122.427523467767188, 37.808739396087624],
            [-122.427301030953672, 37.808773247159571],
            [-122.427287243070779, 37.808708920235645],
            [-122.427490716316399, 37.808678126013014],
            [-122.426909232318224, 37.808151294840016],
            [-122.426839001555635, 37.808113298884024],
            [-122.426613230594512, 37.808152010516238],
            [-122.426560904719622, 37.807943556174827],
            [-122.426488519796493, 37.807651861239542],
            [-122.426357658303132, 37.807388412718332],
            [-122.426257507799036, 37.807185417079722],
            [-122.426066893674061, 37.80699787612533],
            [-122.4257796482039, 37.806715259689653],
            [-122.425627533230582, 37.806456787332273],
            [-122.425531817297653, 37.806150610629167],
            [-122.425487611207828, 37.806009959663712],
            [-122.425486832357592, 37.806006120121552],
            [-122.425298563577385, 37.80507790289635],
            [-122.425204919000421, 37.804616199985951],
            [-122.425109521046082, 37.804145845932808],
            [-122.424918804152185, 37.803205508171892],
            [-122.424808684502352, 37.802662664019884],
            [-122.424731259133807, 37.802280983275736],
            [-122.424731635083759, 37.802281009278651],
            [-122.424538324517613, 37.801303719934985],
            [-122.424517597070277, 37.801201189595353],
            [-122.424358667137113, 37.800415027771606],
            [-122.424242907462499, 37.799842398528341],
            [-122.42417056511286, 37.799484537126212],
            [-122.42417056430692, 37.799484532744323],
            [-122.423982145098208, 37.798552453684835],
            [-122.423982396975646, 37.798552421556877],
            [-122.423793785438747, 37.7976164776058],
            [-122.423792964234153, 37.797616581376253],
            [-122.423601296960271, 37.796691058659476],
            [-122.42360129621845, 37.796691056748735],
            [-122.423601876988513, 37.796690945913937],
            [-122.423601877370103, 37.796690947281171],
            [-122.425249874473522, 37.79648130315109],
            [-122.426892728667355, 37.796272251947869],
            [-122.428537813517494, 37.796062892623418],
            [-122.430182832162615, 37.795853517593606],
            [-122.431827832563371, 37.79564412085616],
            [-122.433469062960725, 37.795435179810816],
            [-122.435113289920963, 37.795225833115033],
            [-122.436760975027326, 37.795016021968365],
            [-122.438402484723895, 37.794806973138577]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {OBJECTID: 7, ZIP_CODE: 94133, ID: 94133},
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-122.418530631419571, 37.804999043218864],
            [-122.418718265666911, 37.805931520041717],
            [-122.418781807492508, 37.806241018338142],
            [-122.418781854642702, 37.806241248585302],
            [-122.418856183917853, 37.806607498073362],
            [-122.418908043871269, 37.806863030947284],
            [-122.419086067910683, 37.807803117635643],
            [-122.419223966222532, 37.808453096037454],
            [-122.419103158585543, 37.808467422639801],
            [-122.419122467317635, 37.808544708340989],
            [-122.418980965776527, 37.808562118993599],
            [-122.418965099874526, 37.808484090255142],
            [-122.417886530686005, 37.80861494396968],
            [-122.417923033396889, 37.808821741173873],
            [-122.417843612318336, 37.80882989992265],
            [-122.417811191268285, 37.808647071958433],
            [-122.417726330574766, 37.808645704666795],
            [-122.417731886802656, 37.808592736810425],
            [-122.417624531730937, 37.808591735208473],
            [-122.417601699719071, 37.808579058949235],
            [-122.41748929463067, 37.808583633129054],
            [-122.417485092698755, 37.808420948020817],
            [-122.417586902421718, 37.808408305143338],
            [-122.417575917233663, 37.808385134844094],
            [-122.417669145522396, 37.808375378317514],
            [-122.41765313920358, 37.808291858459306],
            [-122.41737529132557, 37.808325217992042],
            [-122.417344584298249, 37.808141675039998],
            [-122.416347061956941, 37.808260209523006],
            [-122.416354024690548, 37.808328768820694],
            [-122.416305697821443, 37.808334361125667],
            [-122.416338782629509, 37.80847597548388],
            [-122.41718410046191, 37.808496573566089],
            [-122.417183326975007, 37.808533669258267],
            [-122.416327431803367, 37.808505689336052],
            [-122.416281962820022, 37.808487886292838],
            [-122.416150789583881, 37.80850306555427],
            [-122.416144807019506, 37.808539558863203],
            [-122.416207242955323, 37.808544038257011],
            [-122.416187547333237, 37.808854071166344],
            [-122.41742892570683, 37.808927290365972],
            [-122.417412600540189, 37.80916653558441],
            [-122.418193962887401, 37.809680962781762],
            [-122.41929170565983, 37.810403664792204],
            [-122.41931534577914, 37.810380618458765],
            [-122.419422885954745, 37.810454266609824],
            [-122.419833484960733, 37.810735462513406],
            [-122.419807989843818, 37.810753732347422],
            [-122.420595101766708, 37.811266948659416],
            [-122.420353825913267, 37.811509857466909],
            [-122.420001661760068, 37.81128073132367],
            [-122.419845148459302, 37.811320361929653],
            [-122.419951835473171, 37.811563099184333],
            [-122.419915762044113, 37.811573987538154],
            [-122.419724362099529, 37.811134852199615],
            [-122.41972295750638, 37.81113418613959],
            [-122.419216088646508, 37.810893843097361],
            [-122.419185739151644, 37.810925239548666],
            [-122.419097184597589, 37.810915006165231],
            [-122.418987802638568, 37.810835752698928],
            [-122.418935347953351, 37.810882616404598],
            [-122.419125945102621, 37.811023040645175],
            [-122.419048154317267, 37.811094352280243],
            [-122.419465867632354, 37.811381473037407],
            [-122.419350858543552, 37.811486353332427],
            [-122.418846744437559, 37.811473267417028],
            [-122.416831664498375, 37.810133272229294],
            [-122.415352404138332, 37.809160867759147],
            [-122.415205531523597, 37.809171493557926],
            [-122.415205867990196, 37.809184535850846],
            [-122.415200978155667, 37.80919628956385],
            [-122.415187329670815, 37.809204065160294],
            [-122.415151663626474, 37.809230739831797],
            [-122.415171052667063, 37.809244159741915],
            [-122.415194871121983, 37.809227978313764],
            [-122.415413019588954, 37.809363153673537],
            [-122.415370856947149, 37.809406415569271],
            [-122.415142166917732, 37.809265230241984],
            [-122.415155744585249, 37.809254708904987],
            [-122.415139781310558, 37.809239860465802],
            [-122.415039713249854, 37.809185860695372],
            [-122.41488880052961, 37.80924118848273],
            [-122.414968316086458, 37.80930376277346],
            [-122.414992913705149, 37.809317784591791],
            [-122.415006420575594, 37.809304517526144],
            [-122.415222785388849, 37.809437662297633],
            [-122.415180622939999, 37.809480924119129],
            [-122.41496425806919, 37.809347778996823],
            [-122.414981136896941, 37.8093310235652],
            [-122.41495316698277, 37.809320490118694],
            [-122.414845930117963, 37.809256992445782],
            [-122.414780776445994, 37.809281398852669],
            [-122.414774461081151, 37.809372149219335],
            [-122.415340036749569, 37.80975508488244],
            [-122.415288518799699, 37.809838328383556],
            [-122.41456302792659, 37.80956443044294],
            [-122.414023978762671, 37.809471544827012],
            [-122.413420668373689, 37.809236173514122],
            [-122.41337430449579, 37.809317959368158],
            [-122.413395600212141, 37.809338215320878],
            [-122.413411510435665, 37.809351004954635],
            [-122.413425672211702, 37.809363136228626],
            [-122.413441564407123, 37.809375239427176],
            [-122.413455726199771, 37.809387370972054],
            [-122.413471618398191, 37.809399473891929],
            [-122.413487492569899, 37.80941089065314],
            [-122.413505097854454, 37.809422279326348],
            [-122.413520972382244, 37.809433696077356],
            [-122.413538559637843, 37.80944439831444],
            [-122.413554416481929, 37.809455128624236],
            [-122.413572003401356, 37.809465830861896],
            [-122.413607142559428, 37.809485862444731],
            [-122.413624694804525, 37.809495192064489],
            [-122.414282035042135, 37.809946003161961],
            [-122.414200903764723, 37.81002217256772],
            [-122.414027337823839, 37.810138985552911],
            [-122.413780738047123, 37.809907441000853],
            [-122.413857049972947, 37.809845771015681],
            [-122.412616832608151, 37.809078904365926],
            [-122.412498775807535, 37.80906571088461],
            [-122.412398060995869, 37.809120908451149],
            [-122.412400109349747, 37.809133236262518],
            [-122.412396967167027, 37.809145648237823],
            [-122.412390346141294, 37.809157430172931],
            [-122.412380210884578, 37.809167208369729],
            [-122.412426492762847, 37.809216588736774],
            [-122.412450629760414, 37.809212763732177],
            [-122.41262839277087, 37.809393236325491],
            [-122.412573868329858, 37.809427083257212],
            [-122.412396105370902, 37.809246610582868],
            [-122.412412861666652, 37.809225050449037],
            [-122.412356250722411, 37.809177897728922],
            [-122.41234073008107, 37.809180209833173],
            [-122.412323390603305, 37.809179117259049],
            [-122.412307675451856, 37.809173878278465],
            [-122.412099340782589, 37.809285071655154],
            [-122.412099676704088, 37.809298113956672],
            [-122.412096516784118, 37.809309839486673],
            [-122.412089895696084, 37.809321621404543],
            [-122.412078012629308, 37.8093307411864],
            [-122.412124294062423, 37.809380121676121],
            [-122.412148413801376, 37.809375610565525],
            [-122.412315935400727, 37.809561743172587],
            [-122.412252793608843, 37.809597103119742],
            [-122.412093889154491, 37.809409457275514],
            [-122.41211066290181, 37.809388583353197],
            [-122.412057512853792, 37.809341374382768],
            [-122.412040244067796, 37.809343027789311],
            [-122.412024634631933, 37.809341907398313],
            [-122.412008919813204, 37.809336668372488],
            [-122.411894272206808, 37.809388657747697],
            [-122.412861765933144, 37.810522545447967],
            [-122.412718336607824, 37.810599724430624],
            [-122.412705816724809, 37.810584132828346],
            [-122.411509089676429, 37.81123738012537],
            [-122.41148957739901, 37.811219154555417],
            [-122.412686215557258, 37.810562475550952],
            [-122.411452462026304, 37.809105334882879],
            [-122.411423380532113, 37.809118854220145],
            [-122.411248622782082, 37.808920476073887],
            [-122.411085557936261, 37.808907323817536],
            [-122.411283571142818, 37.809134854169606],
            [-122.411256255700124, 37.809149718017444],
            [-122.411031438641331, 37.808889659210472],
            [-122.410955336187001, 37.808892265747417],
            [-122.410765573350616, 37.808850703243849],
            [-122.410736033164511, 37.808846374759867],
            [-122.410731512966407, 37.808872543480319],
            [-122.410649866328171, 37.808861505447226],
            [-122.410652655797975, 37.808835364493682],
            [-122.410546641899074, 37.808819227353638],
            [-122.410441958004114, 37.809325664485378],
            [-122.410406413493931, 37.809289843904054],
            [-122.410401787512413, 37.809311893981061],
            [-122.410630331289113, 37.809716792194763],
            [-122.410709259423612, 37.809689418065965],
            [-122.410633083668301, 37.809554681184579],
            [-122.41064851611452, 37.809548937394226],
            [-122.410729547478269, 37.809670547859675],
            [-122.410757004560026, 37.809661175631867],
            [-122.410712947997226, 37.809563688219221],
            [-122.410728380093076, 37.809557944424022],
            [-122.410791312651469, 37.80964894551029],
            [-122.410822177556227, 37.809637457886339],
            [-122.410778085579025, 37.80953859734884],
            [-122.410793518010678, 37.809532853539501],
            [-122.410858216047515, 37.809625199709956],
            [-122.410889098254941, 37.809614398511123],
            [-122.410843240792332, 37.809514193154044],
            [-122.410858672867818, 37.809508449341749],
            [-122.410923406302985, 37.809602168351013],
            [-122.410950845665482, 37.809592109640889],
            [-122.410904952795121, 37.809490531433248],
            [-122.410920384860916, 37.809484787612853],
            [-122.410985153693048, 37.809579879462774],
            [-122.411024617975485, 37.809566192280315],
            [-122.410978689334627, 37.809463241232329],
            [-122.410994104065225, 37.809456810959603],
            [-122.411058925978935, 37.809553962080649],
            [-122.411089808473605, 37.809543160823544],
            [-122.411042113998747, 37.809438864964896],
            [-122.411057546043196, 37.809433121126496],
            [-122.411195348876859, 37.80967536169041],
            [-122.41117818636998, 37.809681133587063],
            [-122.411116453591873, 37.809569511282646],
            [-122.41104955067469, 37.80959325722408],
            [-122.41111476155065, 37.809705510201134],
            [-122.411097598684464, 37.809711282091641],
            [-122.411034100233891, 37.80959831463543],
            [-122.410977509113948, 37.809619146556997],
            [-122.411041007143098, 37.809732113774253],
            [-122.411025592359422, 37.809738544052792],
            [-122.410960346257056, 37.809624918427609],
            [-122.410907162593759, 37.809643635209717],
            [-122.410972426300958, 37.809757947300923],
            [-122.410956993836351, 37.80976369113344],
            [-122.410891730147881, 37.809649379033807],
            [-122.410835138249837, 37.809670210623501],
            [-122.410900419538606, 37.809785209191027],
            [-122.410884987408849, 37.809790953008481],
            [-122.410819706138938, 37.809675954432528],
            [-122.410764809648242, 37.809695385622547],
            [-122.410830108511632, 37.809811070390921],
            [-122.41081467602497, 37.809816814204737],
            [-122.410747646757216, 37.80970115746215],
            [-122.410639354408318, 37.809731067210933],
            [-122.410896947885561, 37.810188372007936],
            [-122.410975841429376, 37.810159624823598],
            [-122.410901536485113, 37.810030351311333],
            [-122.410916969009435, 37.810024607486383],
            [-122.410997965998874, 37.810144845157168],
            [-122.41103912533255, 37.810129757339681],
            [-122.410977003992286, 37.810003033077805],
            [-122.410992436505126, 37.809997289242951],
            [-122.411075146003029, 37.810116812392209],
            [-122.411112880121649, 37.810103153220581],
            [-122.411050758345823, 37.809976429551675],
            [-122.411066208857108, 37.809971371863952],
            [-122.411147188358683, 37.810090922996501],
            [-122.411190078057032, 37.810075806811575],
            [-122.411127956511336, 37.809949082902484],
            [-122.411143389001253, 37.809943339047805],
            [-122.411224368596535, 37.81006289012803],
            [-122.411256964037719, 37.810051374350031],
            [-122.411194842059288, 37.809924650755768],
            [-122.41121027488505, 37.809918906886708],
            [-122.4112929849924, 37.810038429879377],
            [-122.411332431435511, 37.81002405588923],
            [-122.411270309344076, 37.809897332059471],
            [-122.411285742158299, 37.809891588180513],
            [-122.411366721926342, 37.810011139164168],
            [-122.411401047752832, 37.809999595302976],
            [-122.411337195490745, 37.809872899820583],
            [-122.411354358375661, 37.809867127895387],
            [-122.411435338227506, 37.809986678832487],
            [-122.411471359105562, 37.809973733758071],
            [-122.411409237165202, 37.809847009994684],
            [-122.411424669612117, 37.809841266103092],
            [-122.41150566722375, 37.80996150342942],
            [-122.411546826352634, 37.809946415434261],
            [-122.411484704299241, 37.809819691435401],
            [-122.411500136734659, 37.809813947533918],
            [-122.411582846845619, 37.809933470331323],
            [-122.4116188680253, 37.809920525480692],
            [-122.411556745877689, 37.809793801793724],
            [-122.411572177956074, 37.809788057888397],
            [-122.411653176094603, 37.809908295109032],
            [-122.4116909096619, 37.809894636032141],
            [-122.411628787405917, 37.809767912107915],
            [-122.411644219819436, 37.809762168187518],
            [-122.411725217707357, 37.809882405639449],
            [-122.411759525734439, 37.809870174962185],
            [-122.411697403388885, 37.809743451348098],
            [-122.411712835792031, 37.809737707418712],
            [-122.411881278427131, 37.810026834486933],
            [-122.41186411554628, 37.81003260648864],
            [-122.411782586611622, 37.809891776308959],
            [-122.411719126796399, 37.80991478009306],
            [-122.411802385721074, 37.810055582271964],
            [-122.411785222827419, 37.810061354262146],
            [-122.411703694356945, 37.809920524023092],
            [-122.411645389734517, 37.809942070760108],
            [-122.411726900787329, 37.810082214596392],
            [-122.411711467967621, 37.810087958532876],
            [-122.411628227200978, 37.809947842721932],
            [-122.41156305384375, 37.809971560917056],
            [-122.411644564773539, 37.810111704809465],
            [-122.411629131941311, 37.810117448735141],
            [-122.411547621726527, 37.809977304820983],
            [-122.411485874174801, 37.809999594002001],
            [-122.411567384297499, 37.810139737958238],
            [-122.411551952145643, 37.810145481862563],
            [-122.411470441699677, 37.81000533790143],
            [-122.411408676427612, 37.810026940604999],
            [-122.411490204455376, 37.81016777104513],
            [-122.41147477194562, 37.81017351494495],
            [-122.411393243940836, 37.810032684494281],
            [-122.411328070780158, 37.81005640255357],
            [-122.41140959834128, 37.810197233054254],
            [-122.411394148491496, 37.81020229050096],
            [-122.41131090784944, 37.810062174474744],
            [-122.411249177828495, 37.810085149968437],
            [-122.411330687944414, 37.810225294080347],
            [-122.4113152554104, 37.810231037959227],
            [-122.411232014885002, 37.810090921878086],
            [-122.411175405434363, 37.810111067735896],
            [-122.411256933104966, 37.81025189806045],
            [-122.411241500559697, 37.810257641929645],
            [-122.411159972912074, 37.810116811594561],
            [-122.411103380733024, 37.810137643311123],
            [-122.411184890977466, 37.810277787516789],
            [-122.411169458075165, 37.810283531382133],
            [-122.411087948545713, 37.810143387154753],
            [-122.411017619235537, 37.810168562307894],
            [-122.411099128998927, 37.810308706303054],
            [-122.411083696429642, 37.810314450151544],
            [-122.411004005467134, 37.81017771001823],
            [-122.410905971459442, 37.810202646996828],
            [-122.411216101543474, 37.810750434096292],
            [-122.411307020324173, 37.810718058221234],
            [-122.411214614556201, 37.8105581756828],
            [-122.411231794935318, 37.81055309021869],
            [-122.411325542368957, 37.810697843090367],
            [-122.411366719609191, 37.810683441322411],
            [-122.411291830600106, 37.810531515646439],
            [-122.411307262852333, 37.810525771776568],
            [-122.411402864908169, 37.810675301597549],
            [-122.411522935608915, 37.810632152260467],
            [-122.411446209498621, 37.810476136111049],
            [-122.411461659747943, 37.810471078652185],
            [-122.411555407533228, 37.810615831617966],
            [-122.41160859172949, 37.810597114547022],
            [-122.411624041992908, 37.810592057067005],
            [-122.411677226161913, 37.810573340239586],
            [-122.411600605842565, 37.810421442809904],
            [-122.411617768833821, 37.810415670846979],
            [-122.411711534523249, 37.810561109852458],
            [-122.411738974133357, 37.810551050960818],
            [-122.411686385419046, 37.810391210096554],
            [-122.411701817957677, 37.810385466169308],
            [-122.411764700631707, 37.810541706828857],
            [-122.411829892102887, 37.810518674961713],
            [-122.41176529620391, 37.810363148827776],
            [-122.411780746061879, 37.81035809133261],
            [-122.411847054752684, 37.810512902971148],
            [-122.411915671345156, 37.810488441813206],
            [-122.411840781416544, 37.810336516754752],
            [-122.411856213585779, 37.81033077281284],
            [-122.411935941632692, 37.810468884965481],
            [-122.411921351800245, 37.810305681309181],
            [-122.411938638145514, 37.810304714362765],
            [-122.411953405498025, 37.81047478237366],
            [-122.412071780474818, 37.810433033401743],
            [-122.412010591984938, 37.810275392256564],
            [-122.412115642263785, 37.810455670909619],
            [-122.412100192408317, 37.810460728448561],
            [-122.412084406280471, 37.810452743692409],
            [-122.41176878056207, 37.810565675738737],
            [-122.41175334799118, 37.810571419674538],
            [-122.411684748938015, 37.810596566899896],
            [-122.411669298331702, 37.810601624393506],
            [-122.411598969130708, 37.810626799885483],
            [-122.411583536533968, 37.810632543799024],
            [-122.411518344886403, 37.810655575529537],
            [-122.411502912623547, 37.810661319426885],
            [-122.411432582949345, 37.810686494275835],
            [-122.411417150327338, 37.81069223816754],
            [-122.411223323763636, 37.810761991358582],
            [-122.41132311146211, 37.810939609065692],
            [-122.411244573940635, 37.811116682909216],
            [-122.410949479920689, 37.811220352571489],
            [-122.410930216342933, 37.811279036146971],
            [-122.410681455051716, 37.81136684679597],
            [-122.410613578346386, 37.811352838185535],
            [-122.410419696661208, 37.811420531005773],
            [-122.410148367227194, 37.811505958616635],
            [-122.408511879957302, 37.811283856992631],
            [-122.407577358643394, 37.808803424612513],
            [-122.407596251976869, 37.808797625245276],
            [-122.408535735474004, 37.811269050069917],
            [-122.410153064417187, 37.811486654300801],
            [-122.41040703579597, 37.811399447392162],
            [-122.410397994853795, 37.811384485925792],
            [-122.410199185064457, 37.81132796106332],
            [-122.410033026138677, 37.811396577420801],
            [-122.410028523199003, 37.811423432538689],
            [-122.408569038736545, 37.811217693403208],
            [-122.408604939400348, 37.811065346992223],
            [-122.408622314546491, 37.811067812437848],
            [-122.408601547208733, 37.811202746444437],
            [-122.408639776140404, 37.811208308039326],
            [-122.408681379486623, 37.811075784005041],
            [-122.408700502750108, 37.811078908147074],
            [-122.408681466003685, 37.811213813888727],
            [-122.408723173522517, 37.811220006160561],
            [-122.408763046269982, 37.811087510102226],
            [-122.408782169539933, 37.811090634230986],
            [-122.40876313259281, 37.811225539991135],
            [-122.408803092361268, 37.811231073796982],
            [-122.408842964625947, 37.811098577717516],
            [-122.408862088248199, 37.811101701827724],
            [-122.408843051796623, 37.811236607869454],
            [-122.408881280424794, 37.811242169666208],
            [-122.408921153248102, 37.811109673549396],
            [-122.408942006980325, 37.811112769370261],
            [-122.408921240203938, 37.811247703157434],
            [-122.408964677875915, 37.811253867342053],
            [-122.409004568208587, 37.811122057634492],
            [-122.409025404309773, 37.811124467552588],
            [-122.409006385440833, 37.811260059513721],
            [-122.409042866672721, 37.811264962818356],
            [-122.409082738873835, 37.811132466653085],
            [-122.409101862168811, 37.811135590729982],
            [-122.409082825791046, 37.81127049654058],
            [-122.409126264189027, 37.81127666092906],
            [-122.409166136247578, 37.811144164735886],
            [-122.409185259542042, 37.811147288524687],
            [-122.409166223312823, 37.811282194348451],
            [-122.409211409832309, 37.811289016857089],
            [-122.409251281745554, 37.811156520635443],
            [-122.40927213551177, 37.811159616672512],
            [-122.40925136932222, 37.811294550516585],
            [-122.409279162626277, 37.81129822094033],
            [-122.40932078253644, 37.811166383119904],
            [-122.409339888202226, 37.811168820995697],
            [-122.409320870242325, 37.811304413000762],
            [-122.409364308333835, 37.811310577307111],
            [-122.409405910098016, 37.811178053025465],
            [-122.409425033757373, 37.811181176769772],
            [-122.409405998308287, 37.811316082900326],
            [-122.40944074878638, 37.811321014101964],
            [-122.40948063795679, 37.811189203966087],
            [-122.409501474085218, 37.811191613525516],
            [-122.409480725959895, 37.811327233846249],
            [-122.409527624648632, 37.811333341792235],
            [-122.409567496367472, 37.811200845459226],
            [-122.409588350159311, 37.811203941440354],
            [-122.40956758453207, 37.81133887533899],
            [-122.409607544075371, 37.811344408877801],
            [-122.409647432976385, 37.811212599235269],
            [-122.409666538650669, 37.811215036508962],
            [-122.4096475212896, 37.811350629114692],
            [-122.409687480492039, 37.811356162357413],
            [-122.409729082397121, 37.811223637951706],
            [-122.409748205742758, 37.811226761923784],
            [-122.40972917051603, 37.811361667836366],
            [-122.40976739996718, 37.811367229334621],
            [-122.409807270930216, 37.811234732926998],
            [-122.409826394289098, 37.811237857160975],
            [-122.409807359540622, 37.811372762805725],
            [-122.409849067242604, 37.811378954679277],
            [-122.409888938066231, 37.811246458244362],
            [-122.409909791884289, 37.81124955416864],
            [-122.409890757298484, 37.811384460375677],
            [-122.409934195469972, 37.811390623922954],
            [-122.409972335687982, 37.811258155482349],
            [-122.409991388408557, 37.811258533667043],
            [-122.410051001542016, 37.811355083215751],
            [-122.410080225111116, 37.811347055723829],
            [-122.410039452733983, 37.811242647397464],
            [-122.410060076955276, 37.811236819614464],
            [-122.410111355764599, 37.81134586484395],
            [-122.410186754248173, 37.811315801374953],
            [-122.410002034752523, 37.810999466686859],
            [-122.410015948336749, 37.810934689402742],
            [-122.410036236914948, 37.810915819594705],
            [-122.410045418985376, 37.810868973454134],
            [-122.40995683043738, 37.810857360334786],
            [-122.409929090780366, 37.810990347084882],
            [-122.409911715601922, 37.810987881557118],
            [-122.409936471227283, 37.810873484930354],
            [-122.409873927744698, 37.810864883322409],
            [-122.409849172039969, 37.810979280485419],
            [-122.409831796859692, 37.810976814671307],
            [-122.409859730943055, 37.810851378751366],
            [-122.409793708942289, 37.810842147255194],
            [-122.409767522509881, 37.810968241308018],
            [-122.409751878141279, 37.810965747731309],
            [-122.409778063900148, 37.81083965341854],
            [-122.409713790367476, 37.810831080014538],
            [-122.409685856045158, 37.810956515900401],
            [-122.409668480889763, 37.810954050611365],
            [-122.409696415233427, 37.810828614454991],
            [-122.40963387182353, 37.810820012994292],
            [-122.409609415933446, 37.810946079263672],
            [-122.409592040775962, 37.810943613688799],
            [-122.409616496701801, 37.810817547697539],
            [-122.409552222853762, 37.810808973936524],
            [-122.409527766835737, 37.810935040463818],
            [-122.4095103913304, 37.810932574607932],
            [-122.409534847384165, 37.81080650835878],
            [-122.409470556252117, 37.810797248385086],
            [-122.4094443696399, 37.810923342636215],
            [-122.409426994147125, 37.810920877042648],
            [-122.409453181134111, 37.810794782789721],
            [-122.40938717688249, 37.810786237228463],
            [-122.409360972477401, 37.810911645024227],
            [-122.409343596990126, 37.810909179418339],
            [-122.409371532226004, 37.810783743881395],
            [-122.409307258435504, 37.810775169986833],
            [-122.409279323454484, 37.810900606052307],
            [-122.409261948311553, 37.810898140154237],
            [-122.409289883328043, 37.810772704367388],
            [-122.409222130673314, 37.810763500569543],
            [-122.409194195884822, 37.810888936060401],
            [-122.409178551206097, 37.810886442413199],
            [-122.409204755910437, 37.810761034657382],
            [-122.409142194961319, 37.810751746498703],
            [-122.409114277009948, 37.810877868693844],
            [-122.409096902238019, 37.810875403314995],
            [-122.409124837171674, 37.81074996729771],
            [-122.409062293894237, 37.810741365533815],
            [-122.409034358851102, 37.810866801261916],
            [-122.409016983385186, 37.810864335607896],
            [-122.409044919155974, 37.810738900147257],
            [-122.408982375890048, 37.810730298066382],
            [-122.408954440030968, 37.81085573406159],
            [-122.408937065255401, 37.810853268110044],
            [-122.408965000457812, 37.810727832404666],
            [-122.408898979017181, 37.810718600127345],
            [-122.408871043014514, 37.810844035828495],
            [-122.408853668258587, 37.8108415704138],
            [-122.408881603590444, 37.810716134453337],
            [-122.408815582170575, 37.810706902129297],
            [-122.408787646031413, 37.810832337810972],
            [-122.408770288923606, 37.810830558546641],
            [-122.408798206756401, 37.810704436717558],
            [-122.408730454910014, 37.810695232351428],
            [-122.408702518970472, 37.810820667733054],
            [-122.408686891971527, 37.810818860457857],
            [-122.408713079833362, 37.810692766372398],
            [-122.408650536651805, 37.810684164390111],
            [-122.408622600588473, 37.810809600027646],
            [-122.408605243143839, 37.810807820744628],
            [-122.408633161587474, 37.810681698673903],
            [-122.408556510134844, 37.810663024107164],
            [-122.408588984612706, 37.810512106294745],
            [-122.408606359289806, 37.810514572023159],
            [-122.408587340511048, 37.810650164195629],
            [-122.408629047705375, 37.810656356501411],
            [-122.408668902323384, 37.810523174029143],
            [-122.408686277704945, 37.81052564000916],
            [-122.40866552792356, 37.81066125993452],
            [-122.408708965930458, 37.810667424477344],
            [-122.408748820750048, 37.810534241698186],
            [-122.40876619543765, 37.81053670740306],
            [-122.40874717695219, 37.810672299875314],
            [-122.408794093155748, 37.810679094270796],
            [-122.408833947835987, 37.810545911737734],
            [-122.408849592085303, 37.810548405436371],
            [-122.40883057374208, 37.810683997647232],
            [-122.408875741869977, 37.810690133853562],
            [-122.408915614060632, 37.81055763773044],
            [-122.408932971115192, 37.810559417248072],
            [-122.408913970565308, 37.81069569563472],
            [-122.408960869161646, 37.810701804075741],
            [-122.409000741206668, 37.810569307924148],
            [-122.409018098597954, 37.810571086874475],
            [-122.40899736742189, 37.810707393837795],
            [-122.409040787124908, 37.810712871283229],
            [-122.409080641733894, 37.810579688936649],
            [-122.409096286337629, 37.810582182322406],
            [-122.409077268090201, 37.810717774577761],
            [-122.40911897536337, 37.810723966710214],
            [-122.409158829484909, 37.81059078406853],
            [-122.409176204199355, 37.810593249712966],
            [-122.409157186441121, 37.810728841975312],
            [-122.409200623829136, 37.810735006073635],
            [-122.409240478156264, 37.81060182339904],
            [-122.409257853229136, 37.810604289300421],
            [-122.409238852918037, 37.810740567743849],
            [-122.409285751569428, 37.810746676055665],
            [-122.409325605404021, 37.810613493358183],
            [-122.409341250023104, 37.81061598671144],
            [-122.40932224986912, 37.810752265442567],
            [-122.4093656699755, 37.81075774303735],
            [-122.40940554098205, 37.810625246755905],
            [-122.409422898749284, 37.810627025915643],
            [-122.409403898742326, 37.810763304659638],
            [-122.409447336517104, 37.810769468661483],
            [-122.40948544197218, 37.810635627488516],
            [-122.409502816715019, 37.810638093359387],
            [-122.409485547293727, 37.810774343825763],
            [-122.409528985434875, 37.8107805080665],
            [-122.409565359949454, 37.810646694615322],
            [-122.409582735382628, 37.810649160188639],
            [-122.409567196568673, 37.810785383198734],
            [-122.409612364812048, 37.81079151884834],
            [-122.409648756853613, 37.810658392357979],
            [-122.409666132285238, 37.810660857644436],
            [-122.409648863165444, 37.8107971084087],
            [-122.409690552872675, 37.810802613901892],
            [-122.409730423669671, 37.810670117506156],
            [-122.409747781109076, 37.81067189662366],
            [-122.409728781340874, 37.810808175424455],
            [-122.409772201856015, 37.810813652863935],
            [-122.409810324407417, 37.810680498024219],
            [-122.409827699517621, 37.810682963841622],
            [-122.409810430682086, 37.810819214354417],
            [-122.4098555989803, 37.810825350459979],
            [-122.409895451834942, 37.810692167571958],
            [-122.409912826590485, 37.810694632833282],
            [-122.409895222374288, 37.810817841328777],
            [-122.409936876790525, 37.81082197386079],
            [-122.409973639826163, 37.810703262163521],
            [-122.409991014940061, 37.810705727682269],
            [-122.409959938125212, 37.81084357554878],
            [-122.410048526318235, 37.810855188946014],
            [-122.41005622518567, 37.810817980946432],
            [-122.410043511556253, 37.810794838529432],
            [-122.410054194116455, 37.810739040961913],
            [-122.410078049482479, 37.810724233171044],
            [-122.410094488114893, 37.810623018930904],
            [-122.410081703845862, 37.810597130219826],
            [-122.410092509988729, 37.810546137980772],
            [-122.410117989755761, 37.810527183534326],
            [-122.410136070412563, 37.810422508799753],
            [-122.410119930917134, 37.810400795044814],
            [-122.41012762970874, 37.810363587311961],
            [-122.410156217048225, 37.810330848613937],
            [-122.41017620465729, 37.81023300994017],
            [-122.410158299784257, 37.810209951610261],
            [-122.410179752853338, 37.810101788351538],
            [-122.410076402542387, 37.809920107344034],
            [-122.410041882266327, 37.809924099736733],
            [-122.410019086454341, 37.809912794612728],
            [-122.409979357246016, 37.809916185169463],
            [-122.409958274206915, 37.809904165299031],
            [-122.409922023510461, 37.809908185953802],
            [-122.409899227375504, 37.80989688081219],
            [-122.409856019993072, 37.80989964065347],
            [-122.409833224216882, 37.809888335493483],
            [-122.409796955869524, 37.80989166994722],
            [-122.409774159751635, 37.809880364506853],
            [-122.40973616131653, 37.809883726681605],
            [-122.409715095991231, 37.809872393479395],
            [-122.409673618697951, 37.809875125240453],
            [-122.409650822957047, 37.809863820045173],
            [-122.409611093758144, 37.809867210477904],
            [-122.409590028449543, 37.809855876978752],
            [-122.409552029326491, 37.809859239105428],
            [-122.40952923395507, 37.809847933880995],
            [-122.409489504405954, 37.809851324003851],
            [-122.409466709046484, 37.809840018767318],
            [-122.409426961850301, 37.809842722706414],
            [-122.409405896576772, 37.809831389174342],
            [-122.409362689214092, 37.809834148834945],
            [-122.409339893540192, 37.80982284385405],
            [-122.40930537326976, 37.809826836031277],
            [-122.409282577599768, 37.809815530764716],
            [-122.409239369556644, 37.809818290665945],
            [-122.409216574238357, 37.809806985106434],
            [-122.409183784056154, 37.809810949516532],
            [-122.409160988755644, 37.809799644220845],
            [-122.409117781056253, 37.80980240379737],
            [-122.409096715848435, 37.809791070484557],
            [-122.409062177941692, 37.809794376702477],
            [-122.40903938231871, 37.80978307138885],
            [-122.409001401198537, 37.80978711949534],
            [-122.408980336012803, 37.809775786161715],
            [-122.408940588826241, 37.809778489662385],
            [-122.408917793572726, 37.809767184319618],
            [-122.408872855464537, 37.809769972088361],
            [-122.408850059531787, 37.809758666743676],
            [-122.408812061110055, 37.80976202834627],
            [-122.408789265535077, 37.809750722984248],
            [-122.40874778827569, 37.809753454419798],
            [-122.408724992367041, 37.80974214905094],
            [-122.408688724387432, 37.809745483158423],
            [-122.408665928836285, 37.809734177772519],
            [-122.408627929726592, 37.809737539327024],
            [-122.408605134533261, 37.809726233923747],
            [-122.40856886620287, 37.809729567725441],
            [-122.408546070674888, 37.809718262316345],
            [-122.408502862660981, 37.80972102194783],
            [-122.408480067491766, 37.809709716520373],
            [-122.408442068732256, 37.809713078009395],
            [-122.408419272882526, 37.809701772581377],
            [-122.40838475263304, 37.809705765038423],
            [-122.408363687557454, 37.809694431319926],
            [-122.408318732173385, 37.809696532434543],
            [-122.408295936693619, 37.809685226977031],
            [-122.408254459445629, 37.809687957964584],
            [-122.408238053815026, 37.809790545390122],
            [-122.40821721811372, 37.809788135332319],
            [-122.408256439046454, 37.809562942360742],
            [-122.408275562248491, 37.809566066566916],
            [-122.408269450984477, 37.809665053549438],
            [-122.408286825452777, 37.809667519325309],
            [-122.40832766898086, 37.809572777430049],
            [-122.408321557439706, 37.809671764420713],
            [-122.408342410750109, 37.809674860622998],
            [-122.408383254218379, 37.809580118983206],
            [-122.408377142750709, 37.809679105976613],
            [-122.408394517910963, 37.809681571450852],
            [-122.408435360963296, 37.809586829524143],
            [-122.408429249910625, 37.809685816514552],
            [-122.408451833660507, 37.80968888497187],
            [-122.408492676297627, 37.809594143031056],
            [-122.408484852889558, 37.809693844457087],
            [-122.408503958134872, 37.809696281919784],
            [-122.408544801055655, 37.809601539955445],
            [-122.408536959377372, 37.809700554958617],
            [-122.408557795064482, 37.809702964959982],
            [-122.408598638259278, 37.809608222696959],
            [-122.408592544731249, 37.809707896412988],
            [-122.408615128826568, 37.809710964284278],
            [-122.40865597161357, 37.809616222281704],
            [-122.408639231230907, 37.809705767179551],
            [-122.408663757193779, 37.809717044567101],
            [-122.408704599922103, 37.80962230254778],
            [-122.408696758454738, 37.809721317561177],
            [-122.408722821063833, 37.809725016115578],
            [-122.408763663375069, 37.80963027408157],
            [-122.408757553102589, 37.809729261082566],
            [-122.408776676029532, 37.8097323854876],
            [-122.408817518615137, 37.809637643154893],
            [-122.408811408067763, 37.809736630164153],
            [-122.408839165466787, 37.809738927817939],
            [-122.408880043284086, 37.809645558612985],
            [-122.408873932819418, 37.809744545625371],
            [-122.40889130733342, 37.809747011586715],
            [-122.408932150126873, 37.809652269208989],
            [-122.408926057042962, 37.809751942941425],
            [-122.408946892742989, 37.809754352324887],
            [-122.408987735476614, 37.809659610202615],
            [-122.408979894728986, 37.80975862522854],
            [-122.409002478177683, 37.809761693586005],
            [-122.409043320837327, 37.809666951170023],
            [-122.40903548016307, 37.809765966199507],
            [-122.409052855026459, 37.809768431856902],
            [-122.409093697286551, 37.809673689703786],
            [-122.409085856332652, 37.809772704742095],
            [-122.409106709703295, 37.809775800809213],
            [-122.409147552244775, 37.809681058631973],
            [-122.409141441787753, 37.809780045663132],
            [-122.409162295162758, 37.809783141720409],
            [-122.409203137637348, 37.809688399524063],
            [-122.409195297173937, 37.809787414563765],
            [-122.409214402473708, 37.809789852185943],
            [-122.409255244539409, 37.809695109977277],
            [-122.409249134570899, 37.809794097008144],
            [-122.409268257528154, 37.809797221058851],
            [-122.409309099536273, 37.809702479106257],
            [-122.40930298963896, 37.809801466139774],
            [-122.409325573445983, 37.809804533880602],
            [-122.409366415377917, 37.809709791633715],
            [-122.409360305556405, 37.809808778670053],
            [-122.409379410874138, 37.809811216540062],
            [-122.409420252741057, 37.809716474274637],
            [-122.409412429873498, 37.809816175771125],
            [-122.409431535526792, 37.809818613077915],
            [-122.409472376985178, 37.809723870800191],
            [-122.409466267649847, 37.80982285783616],
            [-122.409488851138192, 37.809825926100473],
            [-122.409529693219639, 37.809731183791826],
            [-122.409521853187186, 37.809830198852438],
            [-122.409544436665897, 37.809833266556943],
            [-122.409585278680453, 37.809738524229203],
            [-122.409577438721357, 37.809837539293362],
            [-122.409600022218754, 37.809840607536366],
            [-122.409640864166391, 37.809745865189505],
            [-122.409624124935263, 37.809835409950374],
            [-122.409648668402042, 37.809847373575664],
            [-122.409694718878129, 37.809753233598798],
            [-122.409683400550946, 37.809851618269946],
            [-122.40970946326199, 37.809855316880828],
            [-122.409750304385923, 37.809760574507528],
            [-122.409744195418114, 37.809859561557211],
            [-122.409763300747386, 37.809861998815862],
            [-122.409800681301817, 37.809767312459051],
            [-122.409798050568668, 37.809866929913561],
            [-122.409813677394268, 37.809868737041889],
            [-122.409859727674416, 37.809774597001002],
            [-122.409848409562613, 37.809872981687576],
            [-122.409872741508423, 37.809876708014343],
            [-122.409896207540612, 37.809779500054304],
            [-122.409902917913584, 37.809838449581335],
            [-122.409927956256155, 37.809869633383848],
            [-122.410058214833967, 37.809886065459693],
            [-122.40978805552237, 37.809411107578008],
            [-122.409692176324654, 37.809452490025258],
            [-122.409753394315103, 37.809476907533615],
            [-122.409795083288799, 37.80948241299123],
            [-122.409790439454952, 37.809503776606206],
            [-122.409767643810284, 37.809492471432705],
            [-122.409733123723498, 37.809496464009918],
            [-122.40971032808983, 37.809485158825325],
            [-122.40967926884106, 37.809489095348837],
            [-122.409656473217836, 37.809477790153814],
            [-122.409630622889722, 37.80948232932171],
            [-122.409609557687361, 37.809470995825244],
            [-122.409573289526762, 37.809474329935902],
            [-122.409550493924201, 37.809463024720365],
            [-122.40952291317636, 37.809467591881273],
            [-122.409500117230408, 37.809456286387039],
            [-122.409465597146067, 37.809460278886],
            [-122.409442784254765, 37.809448287206727],
            [-122.409413473087668, 37.809452882357093],
            [-122.409390677508952, 37.809441576836036],
            [-122.409354409006824, 37.809444910885041],
            [-122.409331613792688, 37.809433605621535],
            [-122.409304033042332, 37.809438172731298],
            [-122.409281237484791, 37.809426867189075],
            [-122.409251926309096, 37.809431462024762],
            [-122.40922913042256, 37.809420156752616],
            [-122.409192844962547, 37.809422804303409],
            [-122.409170049433754, 37.809411499014253],
            [-122.409133798935159, 37.809415519427169],
            [-122.409110985426068, 37.809403527969394],
            [-122.409076465338302, 37.809407520079958],
            [-122.409053670177968, 37.809396214762678],
            [-122.409027819488273, 37.809400753529559],
            [-122.409005024337446, 37.809389448202872],
            [-122.408973965091334, 37.809393384540734],
            [-122.408951169258785, 37.809382079214799],
            [-122.40891837994225, 37.80938604354025],
            [-122.408895584120444, 37.809374738203552],
            [-122.408862794804193, 37.809378702513534],
            [-122.408839998993102, 37.809367397166127],
            [-122.408808940093522, 37.809371333454934],
            [-122.408786144638981, 37.809360028091476],
            [-122.408756815463747, 37.809363936372364],
            [-122.4087340203655, 37.80935263099321],
            [-122.408701230358204, 37.809356595269499],
            [-122.408678435270645, 37.809345289879595],
            [-122.408645645263661, 37.809349254140457],
            [-122.408622850186802, 37.809337948739781],
            [-122.408591790941983, 37.809341884977052],
            [-122.408568995183444, 37.809330579577171],
            [-122.408536205869268, 37.809334543796403],
            [-122.408513410121444, 37.809323238385751],
            [-122.408482351223043, 37.809327174588631],
            [-122.408459555831755, 37.809315869161935],
            [-122.408426766172141, 37.809319833356362],
            [-122.408403970791582, 37.809308527918944],
            [-122.408371181132239, 37.809312492097938],
            [-122.408350116177374, 37.809301158650754],
            [-122.408315578458229, 37.809304464375806],
            [-122.408292783099327, 37.809293158916844],
            [-122.408263471569185, 37.80929775351261],
            [-122.408240676566351, 37.80928644803798],
            [-122.408207886561954, 37.809290412177198],
            [-122.408185073925949, 37.809278420254287],
            [-122.408155762741032, 37.809283014817716],
            [-122.408132967413039, 37.809271709327838],
            [-122.408100177755486, 37.809275673431507],
            [-122.408077382438208, 37.809264367930865],
            [-122.408039154542493, 37.809258805877114],
            [-122.408058756181504, 37.809145866471148],
            [-122.408066594168815, 37.809248747837302],
            [-122.408087429706811, 37.809251157647353],
            [-122.408126507222988, 37.809155071214583],
            [-122.408120448716886, 37.809256117235002],
            [-122.408137823084502, 37.809258583032992],
            [-122.408178631290198, 37.80916246830698],
            [-122.408172554871641, 37.809262828172606],
            [-122.408196869235468, 37.809265868402413],
            [-122.408235946617765, 37.809169781933626],
            [-122.408229888259399, 37.809270827959395],
            [-122.408254202289157, 37.809273868457552],
            [-122.408293279587355, 37.809177781420765],
            [-122.408287221320464, 37.809278827998476],
            [-122.408308056867014, 37.809281237494979],
            [-122.408347134113498, 37.809185150989656],
            [-122.408332158807269, 37.809276040458201],
            [-122.408356702573101, 37.809288004342378],
            [-122.408397510165557, 37.809191889546774],
            [-122.408391452032305, 37.809292935854977],
            [-122.408412287593251, 37.809295345607659],
            [-122.408453095124827, 37.809199231067545],
            [-122.408447037059574, 37.809300277103894],
            [-122.408471350761801, 37.809303317562879],
            [-122.408512158553279, 37.809207202447709],
            [-122.408506100235769, 37.809308249041685],
            [-122.408521727251397, 37.8093100560612],
            [-122.408560804236558, 37.809213969485583],
            [-122.408554745970605, 37.809315015532796],
            [-122.408577329958945, 37.809318083960704],
            [-122.408618119627377, 37.809221282377308],
            [-122.40861206179197, 37.80932232869629],
            [-122.408636375847209, 37.809325368841058],
            [-122.408677182759092, 37.809229254229557],
            [-122.408671125342451, 37.80933030027127],
            [-122.40868850009889, 37.809332766257086],
            [-122.408727576866028, 37.809236679077507],
            [-122.408721501183379, 37.80933703897],
            [-122.408740606697776, 37.80933947666351],
            [-122.408781413482515, 37.80924336201619],
            [-122.408775356206561, 37.809344408062977],
            [-122.40879620945104, 37.809347504459829],
            [-122.408837016154081, 37.809251389244281],
            [-122.408830941310313, 37.809351749130926],
            [-122.408848316070006, 37.809354214818633],
            [-122.4088891230695, 37.809258100128716],
            [-122.40888306559286, 37.80935914618636],
            [-122.408902170426074, 37.809361583864899],
            [-122.408942977698928, 37.809265468876312],
            [-122.408936919955934, 37.809366515216752],
            [-122.408959503968703, 37.809369583296906],
            [-122.408998562767209, 37.809272810139959],
            [-122.408992505092215, 37.809373856208545],
            [-122.409013358354017, 37.809376952566957],
            [-122.409054147832379, 37.809280150828236],
            [-122.409048090239509, 37.809381197174098],
            [-122.409070674261315, 37.809384265232971],
            [-122.409109750575112, 37.809288178476827],
            [-122.40910369305017, 37.809389224550813],
            [-122.409122798597593, 37.809391662456981],
            [-122.409161857180791, 37.809294888697217],
            [-122.409155800079347, 37.809395935042737],
            [-122.409180113834879, 37.809398975080981],
            [-122.409220920775525, 37.809302860271487],
            [-122.409214863400692, 37.809403906350916],
            [-122.409233968955562, 37.809406344239079],
            [-122.409273045055528, 37.809310256880117],
            [-122.409266988111227, 37.80941130350562],
            [-122.40929130186926, 37.809414343246381],
            [-122.409332108667385, 37.80931822812412],
            [-122.409326033795196, 37.809418588046228],
            [-122.409343408940103, 37.809421053929945],
            [-122.40938421532131, 37.809324938520824],
            [-122.409378158527119, 37.809425985151776],
            [-122.40939901180549, 37.809429080892826],
            [-122.409438070062492, 37.809332307591447],
            [-122.409432013326835, 37.809433353675857],
            [-122.409477180743622, 37.809439489653357],
            [-122.409529287502835, 37.809446200260403],
            [-122.409588351243272, 37.809454171101315],
            [-122.40962830977378, 37.809459704635067],
            [-122.409632794735771, 37.809432163090825],
            [-122.409672911837845, 37.809443874825128],
            [-122.409782563727632, 37.809399522210484],
            [-122.409759009148317, 37.809358700227392],
            [-122.409646479104083, 37.809089266648215],
            [-122.409583548723262, 37.809065563811615],
            [-122.409522825494292, 37.80906036618412],
            [-122.409518181262428, 37.809081729795679],
            [-122.409495386134864, 37.809070424563046],
            [-122.409466075113144, 37.809075019452258],
            [-122.409443262001091, 37.809063028052371],
            [-122.409410472498593, 37.80906699224586],
            [-122.409387677045885, 37.809055686998015],
            [-122.409356617959673, 37.80905962343688],
            [-122.409333822524488, 37.809048318453144],
            [-122.409299302613846, 37.809052310629191],
            [-122.40927823759111, 37.809040977347202],
            [-122.409247178159163, 37.809044913762847],
            [-122.409226113153551, 37.80903358074611],
            [-122.409193341651701, 37.809038231311064],
            [-122.409172276649144, 37.80902689801011],
            [-122.409141217563558, 37.809030834392281],
            [-122.409118422162948, 37.809019529092303],
            [-122.409083884609018, 37.809022835042484],
            [-122.409061089219591, 37.809011529731414],
            [-122.409026569318456, 37.809015522102243],
            [-122.409005504354852, 37.809004189046036],
            [-122.408972714854954, 37.80900815311788],
            [-122.408949919486972, 37.808996847785302],
            [-122.408918860402167, 37.809000784108946],
            [-122.408896065051678, 37.808989479040513],
            [-122.408865005613961, 37.808993415081005],
            [-122.408842210612988, 37.80898210972196],
            [-122.408807673071223, 37.808985415865877],
            [-122.408784877735343, 37.808974110501353],
            [-122.408753818298166, 37.808978046512571],
            [-122.408732753379752, 37.808966713133003],
            [-122.40870344269787, 37.808971307827179],
            [-122.408680647389247, 37.80896000271705],
            [-122.408653066760635, 37.80896456912587],
            [-122.408630271454712, 37.808953263731418],
            [-122.408595751557471, 37.808957255976196],
            [-122.408574686669112, 37.808945922568363],
            [-122.40853841837243, 37.808949256366759],
            [-122.4085173534951, 37.808937922948687],
            [-122.408484564351539, 37.808941887153871],
            [-122.408461768739215, 37.80893058200698],
            [-122.408432440401654, 37.808934489921761],
            [-122.408409645138534, 37.808923184484605],
            [-122.408375125243424, 37.808927176664845],
            [-122.408354060404321, 37.808915843492116],
            [-122.408319522857553, 37.808919148943978],
            [-122.408296727616332, 37.808907843484988],
            [-122.408265686178666, 37.808912466074247],
            [-122.408242890954767, 37.808901160879408],
            [-122.408208353409876, 37.808904466298728],
            [-122.408185558190112, 37.808893160818222],
            [-122.408154499115199, 37.808897097215251],
            [-122.40813170390588, 37.808885791724293],
            [-122.40810064447102, 37.808889727563603],
            [-122.408077849618252, 37.808878422056637],
            [-122.408048538584595, 37.808883016593732],
            [-122.408027473807891, 37.80887168336259],
            [-122.407989475110696, 37.808875044711961],
            [-122.407968410338185, 37.808863711195677],
            [-122.40793908201519, 37.808867619537004],
            [-122.407916286847737, 37.808856314004366],
            [-122.407867659098386, 37.808850233137854],
            [-122.407892470076433, 37.808737895932389],
            [-122.407895080955839, 37.808839488699526],
            [-122.407919412118858, 37.808843215435566],
            [-122.407965428881198, 37.808747703240833],
            [-122.407954143699186, 37.808847460639832],
            [-122.407971518664866, 37.808849926725884],
            [-122.408015804954957, 37.808754442230494],
            [-122.408004537488765, 37.808854886346353],
            [-122.408030581417677, 37.80885789835331],
            [-122.408074867989683, 37.808762414104869],
            [-122.408063600595128, 37.808862857951631],
            [-122.408080957579173, 37.808864637589593],
            [-122.408126991783163, 37.808769811495232],
            [-122.408115706821903, 37.808869569183827],
            [-122.408134811496907, 37.808872006712299],
            [-122.408175637137717, 37.80877657841792],
            [-122.408167830687617, 37.808876966281417],
            [-122.408188666131636, 37.808879376348344],
            [-122.408234682562991, 37.808783863774664],
            [-122.40822341538842, 37.808884307910851],
            [-122.4082459985258, 37.808887375864508],
            [-122.408292014895409, 37.808791863543163],
            [-122.408280730145464, 37.80889162097256],
            [-122.408299853182712, 37.808894745449784],
            [-122.408345869480527, 37.808799232832989],
            [-122.408334584808884, 37.808898990541991],
            [-122.40835716795533, 37.808902058474338],
            [-122.408401454133696, 37.808806574104075],
            [-122.408390187174248, 37.808907017981177],
            [-122.408412770332475, 37.808910086177463],
            [-122.408457056451198, 37.808814602061034],
            [-122.408447501979367, 37.808914331510991],
            [-122.408464876962967, 37.808916796975197],
            [-122.408510893069277, 37.808821284568992],
            [-122.408499626255633, 37.808921728456291],
            [-122.408520461722972, 37.808924138464597],
            [-122.408564747351377, 37.808828653764436],
            [-122.408553480616533, 37.808929097931319],
            [-122.40857606412726, 37.808932165816167],
            [-122.408622080100045, 37.808836653366868],
            [-122.408610795786757, 37.808936410826988],
            [-122.408633379309109, 37.808939478975418],
            [-122.408677664815599, 37.808843994782293],
            [-122.408666398217051, 37.808944438410528],
            [-122.408683754881451, 37.808946217690789],
            [-122.408728058314978, 37.808851419636184],
            [-122.408718504202398, 37.808951149107379],
            [-122.40873414881105, 37.808953643085459],
            [-122.40878016458673, 37.808858130300308],
            [-122.408768880489617, 37.80895788804974],
            [-122.408788002858174, 37.808961011909815],
            [-122.408832288517658, 37.808865527378856],
            [-122.408822734543293, 37.808965256858244],
            [-122.40884531843632, 37.808968325235043],
            [-122.408891334078092, 37.80887281240679],
            [-122.408880067778369, 37.808973256604034],
            [-122.40889917250513, 37.808975694008623],
            [-122.408943458030421, 37.808880209436197],
            [-122.408933921854199, 37.808980625361755],
            [-122.408953027290934, 37.808983063295585],
            [-122.408997312398199, 37.808887578434081],
            [-122.408987758995764, 37.808987308195377],
            [-122.409008612134684, 37.808990404005712],
            [-122.409052897181908, 37.808894919398057],
            [-122.409041631090304, 37.808995363335725],
            [-122.40906421464841, 37.808998431401648],
            [-122.409110230041378, 37.808902919037678],
            [-122.409098946373874, 37.809002676543273],
            [-122.409121529583416, 37.809005744329234],
            [-122.409165814840676, 37.808910259673837],
            [-122.409154548899522, 37.809010703622],
            [-122.409175384406026, 37.80901311324002],
            [-122.4092196692594, 37.808917628844746],
            [-122.409208385736662, 37.80901738636053],
            [-122.409229238893218, 37.809020482131849],
            [-122.409273523674656, 37.808924997441885],
            [-122.4092622402232, 37.809024754962692],
            [-122.40927961492774, 37.809027220861601],
            [-122.409325630047334, 37.808931707864964],
            [-122.409314364326178, 37.80903215210256],
            [-122.409336947553612, 37.809035219847274],
            [-122.409381232551411, 37.808939735111537],
            [-122.409369949242404, 37.809039492642384],
            [-122.409390802418955, 37.809042588659686],
            [-122.409422921195898, 37.808945240701227],
            [-122.409422903348997, 37.809011853140163],
            [-122.40946679914822, 37.809035864508125],
            [-122.409564019832658, 37.809046651478369],
            [-122.409549629214183, 37.809025596054688],
            [-122.409548887643922, 37.80899676568643],
            [-122.409387695818651, 37.808719879048233],
            [-122.409342422574227, 37.808709624416799],
            [-122.409302270626966, 37.808696540242821],
            [-122.409262612300481, 37.808769974638814],
            [-122.409243366033195, 37.808762045524638],
            [-122.409286290635848, 37.808681004303558],
            [-122.409251523749987, 37.808675386616557],
            [-122.409211865384634, 37.808748820995767],
            [-122.409192619474325, 37.8087408918677],
            [-122.409232277847408, 37.808667457220274],
            [-122.409218046276052, 37.808652579691525],
            [-122.409199082493714, 37.808655633568947],
            [-122.409183155837965, 37.808642156922303],
            [-122.409146746495978, 37.80863999940842],
            [-122.409132550252011, 37.808626494744182],
            [-122.409097906968512, 37.808625682074002],
            [-122.409081980690672, 37.808612205682593],
            [-122.409045571705349, 37.808610047857293],
            [-122.409029645094293, 37.808596571464371],
            [-122.40899498416762, 37.808595072051922],
            [-122.408979057222851, 37.808581595657749],
            [-122.408939170155094, 37.808578807372939],
            [-122.408923243223967, 37.808565330971156],
            [-122.40887636397639, 37.80855990894463],
            [-122.408862167796897, 37.808546404247657],
            [-122.40882402846016, 37.808544274635025],
            [-122.408771338418944, 37.808649509314336],
            [-122.408752144836185, 37.80864363943796],
            [-122.408804834900437, 37.808538404767106],
            [-122.408755995512777, 37.808524087565431],
            [-122.40870503613472, 37.808629294204955],
            [-122.408684130157809, 37.808624138753608],
            [-122.408736802648747, 37.808518217400646],
            [-122.408686214896832, 37.808503241742777],
            [-122.408633542337299, 37.808609162798888],
            [-122.40861434946801, 37.808603292888833],
            [-122.408665291301503, 37.808497399575863],
            [-122.408618182709631, 37.808483054307779],
            [-122.408565527707552, 37.808589661496853],
            [-122.408546334502589, 37.808583791581334],
            [-122.408598989528059, 37.808477184400701],
            [-122.408550150206281, 37.808462866564483],
            [-122.408494192805264, 37.808575707944065],
            [-122.408475017602044, 37.808570524448861],
            [-122.408530957042373, 37.808456996920889],
            [-122.408475143235307, 37.808440732021886],
            [-122.408419203721877, 37.80855425952376],
            [-122.408400010537662, 37.808548389584381],
            [-122.40845594972285, 37.808434861822526],
            [-122.408401884334964, 37.808419255320196],
            [-122.408345944732787, 37.808532783062383],
            [-122.408326768858856, 37.808527599554232],
            [-122.408382691187029, 37.808413385377861],
            [-122.408326877445205, 37.808397120408593],
            [-122.40827095504342, 37.808511334558837],
            [-122.408251779872415, 37.808506151027288],
            [-122.408325818753553, 37.80835593442692],
            [-122.408307261690325, 37.808307477072752],
            [-122.408233773949888, 37.808277076846032],
            [-122.408190831757594, 37.808290132648246],
            [-122.408103813680896, 37.80847420912815],
            [-122.408070707145512, 37.808465817066804],
            [-122.408167524728952, 37.808258920751598],
            [-122.408046540290897, 37.80819907276836],
            [-122.408024204007958, 37.808205614634559],
            [-122.407919104249203, 37.808427066268948],
            [-122.407885997416685, 37.80841867443587],
            [-122.407996041444051, 37.808187528721767],
            [-122.407913795821727, 37.808153149917878],
            [-122.407807565173499, 37.808397968053718],
            [-122.407786659324017, 37.808392812443081],
            [-122.407868398033912, 37.808205388267609],
            [-122.407660185387385, 37.808254079991599],
            [-122.407706584592447, 37.808375566178441],
            [-122.407613672832028, 37.80839767070411],
            [-122.407507720833991, 37.808114394328115],
            [-122.407549056121539, 37.808106171825735],
            [-122.407536061536263, 37.808072046122568],
            [-122.407462591282297, 37.808042331588446],
            [-122.40744611868692, 37.808007575403529],
            [-122.407487420240358, 37.807930680888951],
            [-122.407431324879042, 37.807903432764398],
            [-122.407355431147764, 37.80804887173035],
            [-122.406644940711814, 37.807817946705647],
            [-122.406816836689401, 37.809994826134172],
            [-122.406786252768356, 37.810017295716854],
            [-122.40617819806161, 37.810068327706666],
            [-122.406151660268563, 37.810046094760864],
            [-122.406135997898389, 37.810042914277616],
            [-122.406123656094778, 37.810034186621294],
            [-122.405904441804637, 37.807159674056429],
            [-122.405322208784199, 37.806866923600786],
            [-122.404400300125417, 37.808853394598287],
            [-122.404390181819835, 37.80886385881621],
            [-122.404376497046869, 37.808870260285914],
            [-122.404359263409262, 37.808873285169796],
            [-122.404316325011152, 37.808819040682266],
            [-122.403937477028578, 37.80876197892308],
            [-122.403923457745378, 37.80875533773979],
            [-122.403912828869224, 37.808745895483341],
            [-122.403907320429198, 37.80873362312807],
            [-122.403906985949291, 37.808720580801918],
            [-122.404717282916977, 37.806971462592401],
            [-122.403955936424254, 37.806579276399596],
            [-122.402761932327437, 37.808014567794245],
            [-122.402746534430648, 37.808021683436984],
            [-122.402731014070881, 37.808023993997161],
            [-122.402715370212889, 37.808021499491424],
            [-122.40235585639897, 37.807840510524542],
            [-122.402346922703828, 37.807829667068134],
            [-122.402341415289797, 37.807817394901065],
            [-122.402339367950134, 37.807805066923208],
            [-122.402340764477955, 37.807791996673913],
            [-122.402345656255733, 37.807780243491045],
            [-122.403421726415289, 37.806471156550586],
            [-122.402804368682325, 37.806023074735968],
            [-122.400943288973451, 37.807638041928655],
            [-122.40092780379058, 37.807641725129315],
            [-122.400912142497489, 37.807638543945465],
            [-122.400398744529411, 37.807261566606726],
            [-122.400572958659495, 37.806120993590262],
            [-122.401732349384048, 37.805192215433102],
            [-122.403194419486127, 37.805118563841738],
            [-122.403587277644846, 37.805412029499024],
            [-122.404128809815958, 37.80582849738515],
            [-122.404696069838451, 37.806264743038192],
            [-122.405495723806581, 37.806640585378162],
            [-122.405545441190654, 37.806634177056651],
            [-122.405362337774832, 37.805695301990511],
            [-122.405357241074242, 37.805695943874476],
            [-122.405356257037084, 37.805690948342658],
            [-122.405173536628851, 37.804763212222298],
            [-122.404986245080067, 37.803832670552438],
            [-122.404798316633176, 37.802900762043983],
            [-122.40352117840483, 37.80305477917063],
            [-122.40315960682554, 37.803098380641011],
            [-122.402973676735002, 37.802166749844929],
            [-122.402973611142329, 37.802166419353441],
            [-122.402883459886269, 37.801713453423041],
            [-122.402789664410264, 37.801242172237629],
            [-122.402604124590809, 37.800307129616797],
            [-122.402603736644934, 37.800305175692849],
            [-122.402420666593613, 37.799382141273902],
            [-122.402228639238132, 37.798429701815799],
            [-122.402040983242472, 37.797504944420098],
            [-122.401906946643678, 37.796875708196644],
            [-122.401853390100442, 37.796626165074152],
            [-122.402402444702886, 37.796554566975963],
            [-122.40291796673857, 37.796490379340391],
            [-122.403496709817034, 37.796417485859841],
            [-122.404412160626791, 37.796302098196776],
            [-122.405142977212691, 37.796210954635839],
            [-122.405862652252878, 37.796122174218517],
            [-122.406224736410849, 37.796077505131322],
            [-122.406350669109713, 37.796061968858353],
            [-122.406652352369846, 37.796024750165536],
            [-122.407083680819795, 37.795970583772274],
            [-122.407319877605971, 37.795940921047873],
            [-122.407432089697608, 37.795926828732469],
            [-122.407563768850565, 37.795910291726024],
            [-122.40779730388941, 37.795880962818103],
            [-122.408253202051654, 37.795823706218044],
            [-122.408704654154022, 37.795766841471867],
            [-122.408743234497422, 37.795761981540487],
            [-122.409075520379659, 37.795720125786943],
            [-122.409077868767497, 37.795719830108119],
            [-122.409343544204319, 37.795686363949223],
            [-122.40954722057397, 37.795660707190791],
            [-122.40989875147848, 37.795616424537307],
            [-122.411081667103218, 37.795467382264249],
            [-122.411541226025591, 37.795408552082151],
            [-122.411541229133036, 37.795408565216896],
            [-122.411541531721369, 37.795408526524874],
            [-122.411893657029495, 37.795363458292385],
            [-122.412335878555311, 37.795306857217497],
            [-122.413187771447625, 37.795197816725128],
            [-122.414825631965456, 37.794988155997579],
            [-122.415005455310151, 37.795877318912275],
            [-122.415094279286492, 37.796316514471208],
            [-122.415172033219093, 37.796700969266084],
            [-122.41519297245145, 37.796804503853558],
            [-122.415290513107706, 37.797286788953464],
            [-122.415384105347158, 37.79774954140936],
            [-122.415384693800732, 37.797752451808172],
            [-122.415571551794869, 37.798676329254079],
            [-122.415572319635913, 37.798680127283284],
            [-122.415667503417794, 37.799150732537029],
            [-122.41576151132729, 37.799616465113374],
            [-122.416491256558686, 37.799525268171301],
            [-122.417385454528372, 37.799413513042644],
            [-122.417492539304973, 37.799906258247788],
            [-122.417586974866069, 37.800340791478632],
            [-122.417798642975782, 37.801267347943607],
            [-122.41787748762404, 37.801706751150704],
            [-122.417966229723234, 37.802201308768375],
            [-122.418151092101994, 37.803135399210959],
            [-122.418255886912107, 37.803650215613203],
            [-122.418215611082957, 37.803687299847837],
            [-122.418280954876565, 37.804023161939504],
            [-122.418341342522965, 37.804070022432718],
            [-122.418530631419571, 37.804999043218864]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {OBJECTID: 8, ZIP_CODE: 94109, ID: 94109},
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-122.413915879652706, 37.790463115032836],
            [-122.412266187164306, 37.790672783986288],
            [-122.412154318600955, 37.79012444884593],
            [-122.412075867445836, 37.789739906579548],
            [-122.411885657146456, 37.788807543703371],
            [-122.413541442066688, 37.788598204045492],
            [-122.415185269301574, 37.788387930678724],
            [-122.414995423274036, 37.787453843784689],
            [-122.414806647966373, 37.786519819325378],
            [-122.414617207572036, 37.785582474657787],
            [-122.414430198422409, 37.784657140813145],
            [-122.414241572919337, 37.783723783021379],
            [-122.415882538254209, 37.783515640872785],
            [-122.417528773439201, 37.78331088958533],
            [-122.419181703937824, 37.783101400150407],
            [-122.420816620257895, 37.78289417046458],
            [-122.420817002825672, 37.782894121654586],
            [-122.422463744273344, 37.782685368786026],
            [-122.422597534917514, 37.782659914421728],
            [-122.424108200948226, 37.782477051425644],
            [-122.427396397680198, 37.782056939506091],
            [-122.427490665181679, 37.782522998381459],
            [-122.427584325166535, 37.78298604740867],
            [-122.427778871361184, 37.783924735360486],
            [-122.427988927379005, 37.784953879052303],
            [-122.428148186422831, 37.785784488173462],
            [-122.428241496400901, 37.78624657727314],
            [-122.428241829261111, 37.786248226022003],
            [-122.428335613076769, 37.786712655890966],
            [-122.428525011003728, 37.78765056176524],
            [-122.428712111452299, 37.788577067507021],
            [-122.428905308896674, 37.789533740830485],
            [-122.429092268257477, 37.790459499306614],
            [-122.429269817037863, 37.791338636935983],
            [-122.429447192175289, 37.79221689778025],
            [-122.429625242377327, 37.793098475947545],
            [-122.429803981887915, 37.793977244761322],
            [-122.429989276973558, 37.794894937362344],
            [-122.430182832162615, 37.795853517593606],
            [-122.428537813517494, 37.796062892623418],
            [-122.426892728667355, 37.796272251947869],
            [-122.425249874473522, 37.79648130315109],
            [-122.423601877370103, 37.796690947281171],
            [-122.423601876988513, 37.796690945913937],
            [-122.42360129621845, 37.796691056748735],
            [-122.423601296960271, 37.796691058659476],
            [-122.423792964234153, 37.797616581376253],
            [-122.423793785438747, 37.7976164776058],
            [-122.423982396975646, 37.798552421556877],
            [-122.423982145098208, 37.798552453684835],
            [-122.42417056430692, 37.799484532744323],
            [-122.42417056511286, 37.799484537126212],
            [-122.424242907462499, 37.799842398528341],
            [-122.424358667137113, 37.800415027771606],
            [-122.424517597070277, 37.801201189595353],
            [-122.424538324517613, 37.801303719934985],
            [-122.424731635083759, 37.802281009278651],
            [-122.424731259133807, 37.802280983275736],
            [-122.424808684502352, 37.802662664019884],
            [-122.424918804152185, 37.803205508171892],
            [-122.425109521046082, 37.804145845932808],
            [-122.425204919000421, 37.804616199985951],
            [-122.425298563577385, 37.80507790289635],
            [-122.425486832357592, 37.806006120121552],
            [-122.425487611207828, 37.806009959663712],
            [-122.425531817297653, 37.806150610629167],
            [-122.425627533230582, 37.806456787332273],
            [-122.4257796482039, 37.806715259689653],
            [-122.426066893674061, 37.80699787612533],
            [-122.426256728575282, 37.807185221316665],
            [-122.426357658303132, 37.807388412718332],
            [-122.426488519796493, 37.807651861239542],
            [-122.426560904719622, 37.807943556174827],
            [-122.426613230594512, 37.808152010516238],
            [-122.426749407153778, 37.80832970781308],
            [-122.426815901093192, 37.808623913624309],
            [-122.42681099272437, 37.808701593834883],
            [-122.426830737473963, 37.808795352699491],
            [-122.426826276753118, 37.808823581609779],
            [-122.426828951398363, 37.808859934107588],
            [-122.426829913470996, 37.808897001584555],
            [-122.426829127336148, 37.808933411171161],
            [-122.426830071586494, 37.80896979193826],
            [-122.426848658020631, 37.809018932542891],
            [-122.426823913850725, 37.809066034426849],
            [-122.426821397293551, 37.809102471733105],
            [-122.426817149990782, 37.809138937589218],
            [-122.426811172632014, 37.809175431983689],
            [-122.42680517743706, 37.809211239393754],
            [-122.426799200066583, 37.80924773378711],
            [-122.426791474798563, 37.809283569459971],
            [-122.426783766999961, 37.80932009184702],
            [-122.426764854928408, 37.809391820287793],
            [-122.426753650652387, 37.809427026340984],
            [-122.426742463842274, 37.809462919107801],
            [-122.42673125988388, 37.809498124878161],
            [-122.426718325162497, 37.809533359195932],
            [-122.426703641860442, 37.809567935625843],
            [-122.426690707106644, 37.80960316966555],
            [-122.426674294047132, 37.809637774073536],
            [-122.426659593228109, 37.809671663782375],
            [-122.426641449382515, 37.809706296733168],
            [-122.426624999956104, 37.809739528275571],
            [-122.426606838595305, 37.809773474231129],
            [-122.426586928644923, 37.809806762295736],
            [-122.426568749097328, 37.809840022090548],
            [-122.426547090883986, 37.809872652254199],
            [-122.426527163066623, 37.80990525387346],
            [-122.426505504455619, 37.809937883485567],
            [-122.426482098287991, 37.809969855187106],
            [-122.426435249574482, 37.810032425717694],
            [-122.426410094762232, 37.810063739239673],
            [-122.426384921777455, 37.810094366601653],
            [-122.426359731637717, 37.810124306962969],
            [-122.426305889769012, 37.810184245028879],
            [-122.426277202393095, 37.810212869038814],
            [-122.426248533505472, 37.810242179739554],
            [-122.426219828627396, 37.810270117569488],
            [-122.426165541280753, 37.810312894703067],
            [-122.426148806543424, 37.810335143220563],
            [-122.426077517869416, 37.810389871747489],
            [-122.426029956191201, 37.810424984999884],
            [-122.426004427087875, 37.810441883304833],
            [-122.425978879818175, 37.810458095175186],
            [-122.425953351037933, 37.810474993463338],
            [-122.425902221511379, 37.810506044020848],
            [-122.425874926298846, 37.810521597684627],
            [-122.425847613267436, 37.810536464907365],
            [-122.425792951557781, 37.810564826464294],
            [-122.425738254193391, 37.810591815126337],
            [-122.425709157251291, 37.810604651266786],
            [-122.425621812948378, 37.810641100340696],
            [-122.425563512153047, 37.810662654222938],
            [-122.425532631291532, 37.810673458992433],
            [-122.425501732623886, 37.810683577593657],
            [-122.425472546238581, 37.810692981507543],
            [-122.425441630096913, 37.810702413652621],
            [-122.425410695451745, 37.810711159366136],
            [-122.425348791232992, 37.810727278162595],
            [-122.425317821646317, 37.810734650696368],
            [-122.42528512127241, 37.810742051749649],
            [-122.425254133532235, 37.81074873811216],
            [-122.425221397542259, 37.810754766278279],
            [-122.425190391643511, 37.810760766194903],
            [-122.425157620386827, 37.810765421468112],
            [-122.425124866580816, 37.810770763172656],
            [-122.425093807273001, 37.810774704034145],
            [-122.425028228777975, 37.810782641379291],
            [-122.424962578393604, 37.810787833509224],
            [-122.424931484149809, 37.810790400897922],
            [-122.424898623523902, 37.810791623930832],
            [-122.424876305744775, 37.810798855419677],
            [-122.424848476260408, 37.810793815800935],
            [-122.424819040922628, 37.810793609459935],
            [-122.42478787514149, 37.810793431351755],
            [-122.424758404216234, 37.810791852400563],
            [-122.42472891548077, 37.810789586458021],
            [-122.424699408618324, 37.810786634628094],
            [-122.424640324731897, 37.810777984365998],
            [-122.424610747039267, 37.810772286768845],
            [-122.424582881984065, 37.810765873943147],
            [-122.42455326835632, 37.810758803192932],
            [-122.424525367734788, 37.810751018033073],
            [-122.424497431514737, 37.810741859447681],
            [-122.42447122609704, 37.810732672889145],
            [-122.424443254308628, 37.810722141695749],
            [-122.424406843510837, 37.810719989167595],
            [-122.424404739729965, 37.810705601989262],
            [-122.424392430564922, 37.810698249126709],
            [-122.424380086492334, 37.810689522832604],
            [-122.424367724289866, 37.810680110382542],
            [-122.424357092185232, 37.810670669703008],
            [-122.424346425188247, 37.810659856141378],
            [-122.424337488288586, 37.810649014350894],
            [-122.424328533252009, 37.810637486130467],
            [-122.424321309004071, 37.810625929670387],
            [-122.424315797750651, 37.810613658536091],
            [-122.424310250566421, 37.810600014537307],
            [-122.42430472117745, 37.810587056973155],
            [-122.4243009222361, 37.810574071450297],
            [-122.424298835580885, 37.810560370715905],
            [-122.424298497510776, 37.810547328452351],
            [-122.424299872431348, 37.810533571515215],
            [-122.424301264798501, 37.810520501018615],
            [-122.424304387263248, 37.810507402569137],
            [-122.424309258634793, 37.810494961760924],
            [-122.424315860102183, 37.810482492999512],
            [-122.424324191657433, 37.810469996010013],
            [-122.424332559488974, 37.810458871878474],
            [-122.42434440529064, 37.810448377725301],
            [-122.424354539139387, 37.810438598228359],
            [-122.424368151310617, 37.810429448977779],
            [-122.424380050823189, 37.810421013845534],
            [-122.424395446797789, 37.810413895387818],
            [-122.424410860570717, 37.810407463637567],
            [-122.424426309569299, 37.810402404211651],
            [-122.424441794853934, 37.810398717916826],
            [-122.42445902802703, 37.810395690099803],
            [-122.424474548198873, 37.810393376407241],
            [-122.424495313410532, 37.810393037578869],
            [-122.424512653696851, 37.810394128357849],
            [-122.424528280984248, 37.810395933262043],
            [-122.424545674311858, 37.810399083346539],
            [-122.424561354987802, 37.810402947551076],
            [-122.424577071263883, 37.810408184897881],
            [-122.424591092706251, 37.810414823624235],
            [-122.424605131932822, 37.810422148234672],
            [-122.424619206768625, 37.810430846262342],
            [-122.424631551158143, 37.810439571977035],
            [-122.424642200368709, 37.810449699078426],
            [-122.424652868070766, 37.810460512602432],
            [-122.424661822790284, 37.810472040804292],
            [-122.424669047076236, 37.810483597243831],
            [-122.424676306964855, 37.810496526827265],
            [-122.424683904979332, 37.810522498123575],
            [-122.424685973208497, 37.810535512153116],
            [-122.424686685078399, 37.810562969547746],
            [-122.424688754001352, 37.810575983565833],
            [-122.424694265313605, 37.810588254682798],
            [-122.424703220408176, 37.810599783150167],
            [-122.424713852193449, 37.810609223529688],
            [-122.424727909273159, 37.81061723483468],
            [-122.424743643057568, 37.81062315859959],
            [-122.424759306354005, 37.810626336886287],
            [-122.424774915898695, 37.810627455322866],
            [-122.424844204676688, 37.810629071443891],
            [-122.424883986990039, 37.810627735460123],
            [-122.424942750746894, 37.810624029768022],
            [-122.424970402172974, 37.810622204741975],
            [-122.424999748098813, 37.810618978876803],
            [-122.425029112521329, 37.810616439702436],
            [-122.42505844098109, 37.810612527107622],
            [-122.425086039005805, 37.810608643024629],
            [-122.425115367473737, 37.810604730964819],
            [-122.425142947684478, 37.810600160159147],
            [-122.425172240190349, 37.810594874946659],
            [-122.42519980259955, 37.810589617967473],
            [-122.425229077987609, 37.810583646294816],
            [-122.425311658363697, 37.810563756689383],
            [-122.425339167350202, 37.810556440647844],
            [-122.425394149679065, 37.810540434852271],
            [-122.425449096383744, 37.810523056436082],
            [-122.425474821139559, 37.810513709039498],
            [-122.42550225886724, 37.810503646946287],
            [-122.425553673774345, 37.810483579237776],
            [-122.425579363239436, 37.810472858943186],
            [-122.425656378173159, 37.810438638721514],
            [-122.425680301215294, 37.81042657379389],
            [-122.425705937577163, 37.810413794436336],
            [-122.425729843135883, 37.81040104278366],
            [-122.425777618636445, 37.81037416741794],
            [-122.425799775930017, 37.810360757570926],
            [-122.425823645502135, 37.810346633309891],
            [-122.425845767517558, 37.810331850853636],
            [-122.425869619617202, 37.810317040417416],
            [-122.425891740915375, 37.81030225768918],
            [-122.425912114318606, 37.810286817047619],
            [-122.425934218490383, 37.810271348139892],
            [-122.42595457407505, 37.810255221330763],
            [-122.425976660073871, 37.81023906598594],
            [-122.426033069704985, 37.810211362243855],
            [-122.426044381296308, 37.810180274872565],
            [-122.426071409213066, 37.810154424922551],
            [-122.426098419287058, 37.810127887982347],
            [-122.426123698921984, 37.810101379570156],
            [-122.42617422251692, 37.810046989859728],
            [-122.426197736051108, 37.810019136822319],
            [-122.426222979645814, 37.809991255524551],
            [-122.426244745255502, 37.809962744298282],
            [-122.426268240925296, 37.809934204811682],
            [-122.426289987997293, 37.809905007153375],
            [-122.426310004983833, 37.8098758380223],
            [-122.426331734895541, 37.809845953635381],
            [-122.426350003264446, 37.809816126056347],
            [-122.426370002384175, 37.809786270205322],
            [-122.42640650446053, 37.80972524214534],
            [-122.426423024539801, 37.809694756383479],
            [-122.426439527484902, 37.809663584173109],
            [-122.426456011918219, 37.809631725811407],
            [-122.426470784413283, 37.809600581586317],
            [-122.426485538743833, 37.809568751204715],
            [-122.426498562648177, 37.809536949086315],
            [-122.426511568735094, 37.809504460806153],
            [-122.426524592609866, 37.809472658409931],
            [-122.426535868255684, 37.809440198117713],
            [-122.426547125731901, 37.809407051395155],
            [-122.426556671294222, 37.80937461936086],
            [-122.42657572607385, 37.809308382431155],
            [-122.426583523043476, 37.809275292231341],
            [-122.426589589599459, 37.809242230297407],
            [-122.426597386209863, 37.809209140101942],
            [-122.426601704881108, 37.809175419993217],
            [-122.42660775360666, 37.809141671622967],
            [-122.426612089737361, 37.809108637953877],
            [-122.42661985311382, 37.809007562446936],
            [-122.426622425964752, 37.808906571727555],
            [-122.426632418849564, 37.808824688117525],
            [-122.426616150524296, 37.80879817156422],
            [-122.426607002185577, 37.808712480555535],
            [-122.426596123115345, 37.808626817267942],
            [-122.42658353220007, 37.808541869217166],
            [-122.426569192751245, 37.808456262451642],
            [-122.426553140769713, 37.808371370658513],
            [-122.426535358440475, 37.808286507127633],
            [-122.426521448780022, 37.808150762619441],
            [-122.42648716178519, 37.808163683754294],
            [-122.426478316482672, 37.808089661844356],
            [-122.426472145992449, 37.808051992713068],
            [-122.426465992974997, 37.808015010021762],
            [-122.42645810959354, 37.807978055869093],
            [-122.426450244018099, 37.807941787601465],
            [-122.426431016184523, 37.807867935277343],
            [-122.426421420613309, 37.807831695540209],
            [-122.426410094332368, 37.807795484071661],
            [-122.426383981060937, 37.807723117657737],
            [-122.426370941909852, 37.807687620888885],
            [-122.426356154936116, 37.8076514659409],
            [-122.42634140359948, 37.807616683860772],
            [-122.426324904443447, 37.807581243600652],
            [-122.426289370917274, 37.807546114229226],
            [-122.426116990256872, 37.807640950874436],
            [-122.426004575599805, 37.807511622087709],
            [-122.425948221432193, 37.807541385135394],
            [-122.426072979790121, 37.807679439549148],
            [-122.426043902201883, 37.807692962208542],
            [-122.425788908967789, 37.807405954455511],
            [-122.425811101339534, 37.807393917738004],
            [-122.425841407866244, 37.807427759425885],
            [-122.425860156968014, 37.807416465651144],
            [-122.425910013941177, 37.807469902573231],
            [-122.425894653990497, 37.807478394108394],
            [-122.425932202930852, 37.807524478297722],
            [-122.425969647726248, 37.80749983141159],
            [-122.425933954139211, 37.807458524016887],
            [-122.426097611558333, 37.807361083192824],
            [-122.42613200511353, 37.807352281054179],
            [-122.426091315966914, 37.80731860900228],
            [-122.4260559073373, 37.80728828460429],
            [-122.425981701022749, 37.807230438026032],
            [-122.425942884837923, 37.807202229419872],
            [-122.425865288869659, 37.807147185302298],
            [-122.425824778720127, 37.807120377771732],
            [-122.425784286059837, 37.807094256667916],
            [-122.425743811226624, 37.807068821710658],
            [-122.425659436564132, 37.807019381954113],
            [-122.425575133216185, 37.806972687328404],
            [-122.425531269042693, 37.806950055090923],
            [-122.425487422692115, 37.806928108997688],
            [-122.425396304969212, 37.806885646130702],
            [-122.425305258549756, 37.806845928659463],
            [-122.425259770989555, 37.806827443179728],
            [-122.425212552741186, 37.806808985385324],
            [-122.425165353022919, 37.806791214545072],
            [-122.425118188573762, 37.806774816287508],
            [-122.425069293788937, 37.80675844598079],
            [-122.4250204168317, 37.806742762363598],
            [-122.424973288049415, 37.806727737193157],
            [-122.42492444672159, 37.806713426132198],
            [-122.424873892869243, 37.806699830002309],
            [-122.424802432493848, 37.806681081528858],
            [-122.424772802670631, 37.806673324118421],
            [-122.424744921357572, 37.806666225439869],
            [-122.424689194317793, 37.806653400109965],
            [-122.424659600807814, 37.806647015805055],
            [-122.424631755098972, 37.806641289695882],
            [-122.42460219684277, 37.806636278252959],
            [-122.42457436893713, 37.806631238565636],
            [-122.424544828483292, 37.806626913543731],
            [-122.424517018379291, 37.806622560278207],
            [-122.424487495380134, 37.806618921682983],
            [-122.424428486015572, 37.806613017324239],
            [-122.424398998964037, 37.806610751846591],
            [-122.42437124224621, 37.806608457578399],
            [-122.424341772644766, 37.806606878527504],
            [-122.424282870046667, 37.806605092433877],
            [-122.424224002349433, 37.806604679467583],
            [-122.424165170926941, 37.806605639331515],
            [-122.424135772832813, 37.80660680569077],
            [-122.424077012229233, 37.806610511532789],
            [-122.424018287184794, 37.806615589667317],
            [-122.42398895989578, 37.806619501737501],
            [-122.423959615506732, 37.806622727353634],
            [-122.423932018904594, 37.806626611175993],
            [-122.423873400581527, 37.806635808400436],
            [-122.423845839538984, 37.806641064799031],
            [-122.423816565594137, 37.806647036132823],
            [-122.423789022338056, 37.806652979228197],
            [-122.423759766870432, 37.806659637246682],
            [-122.423706445903605, 37.806672867782268],
            [-122.423653321266002, 37.806693649347707],
            [-122.423589920527235, 37.806718718849552],
            [-122.423526538222887, 37.806744474741464],
            [-122.423399843925978, 37.80679873217619],
            [-122.423338262626473, 37.806827205494514],
            [-122.423215171014846, 37.806886897776501],
            [-122.423155391052063, 37.806918088524029],
            [-122.423095628820221, 37.806949965676615],
            [-122.423037614673063, 37.806982501019867],
            [-122.422979636035322, 37.807016409205524],
            [-122.422923387701616, 37.807050289149693],
            [-122.422867174874767, 37.807085541937973],
            [-122.422807430162962, 37.807118105379153],
            [-122.422669617719095, 37.80721100017012],
            [-122.422538512716017, 37.807295544473774],
            [-122.422410922154015, 37.807382091240839],
            [-122.422406568873129, 37.807385156047935],
            [-122.422285114644055, 37.807470669252126],
            [-122.422159360151895, 37.8075613064347],
            [-122.422037101638551, 37.807653259953362],
            [-122.421916608736879, 37.807746558017001],
            [-122.421799629592272, 37.807841858870269],
            [-122.42168270310637, 37.807939218918449],
            [-122.421532057745097, 37.808071464473507],
            [-122.421789175548739, 37.808374241220797],
            [-122.421758561641454, 37.808395342089796],
            [-122.421493253559859, 37.808110553294661],
            [-122.421324496714121, 37.808278803348081],
            [-122.421367127445279, 37.808320685807196],
            [-122.421400626951964, 37.808344175435167],
            [-122.421417984134223, 37.808345953110788],
            [-122.421538848573221, 37.808467594219884],
            [-122.421521846706554, 37.808479545548913],
            [-122.421585810928775, 37.808543055557919],
            [-122.421558551068415, 37.808559981099798],
            [-122.421494604621685, 37.808497157511823],
            [-122.421482722503114, 37.808506278522707],
            [-122.42136546133365, 37.808390072182092],
            [-122.421343808401488, 37.808356088677073],
            [-122.421300875659668, 37.808302536803509],
            [-122.421061625998746, 37.808556401980894],
            [-122.421102646347336, 37.808803641534986],
            [-122.421495500883367, 37.809133737012722],
            [-122.421447795704026, 37.809163356667042],
            [-122.422886026597482, 37.810219448665336],
            [-122.422843690020329, 37.8102558485987],
            [-122.42136637775458, 37.809161249445332],
            [-122.421209585435776, 37.809189899457976],
            [-122.421035643651535, 37.808957186122555],
            [-122.420944163231766, 37.808967603286121],
            [-122.420910323787112, 37.808797159929568],
            [-122.420858358549751, 37.808795946109164],
            [-122.420717381312784, 37.80890056409217],
            [-122.420760227934167, 37.809084595303112],
            [-122.420694330112809, 37.809080174685604],
            [-122.420677247269424, 37.809022081268409],
            [-122.420415813879998, 37.809020844655912],
            [-122.420359979289643, 37.809003898946663],
            [-122.420384124514499, 37.808933459866985],
            [-122.420668674045118, 37.808958355470025],
            [-122.420635748727079, 37.808756307812423],
            [-122.420540860637956, 37.808768840609403],
            [-122.420461300526242, 37.808303163202581],
            [-122.419223966222532, 37.808453096037454],
            [-122.419086067910683, 37.807803117635643],
            [-122.418908043871269, 37.806863030947284],
            [-122.418856183917853, 37.806607498073362],
            [-122.418781854642702, 37.806241248585302],
            [-122.418781807492508, 37.806241018338142],
            [-122.418718265666911, 37.805931520041717],
            [-122.418530631419571, 37.804999043218864],
            [-122.418341342522965, 37.804070022432718],
            [-122.418280954876565, 37.804023161939504],
            [-122.418215611082957, 37.803687299847837],
            [-122.418255886912107, 37.803650215613203],
            [-122.418151092101994, 37.803135399210959],
            [-122.417966229723234, 37.802201308768375],
            [-122.41787748762404, 37.801706751150704],
            [-122.417798642975782, 37.801267347943607],
            [-122.417586974866069, 37.800340791478632],
            [-122.417492539304973, 37.799906258247788],
            [-122.417385454528372, 37.799413513042644],
            [-122.416491256558686, 37.799525268171301],
            [-122.41576151132729, 37.799616465113374],
            [-122.415667503417794, 37.799150732537029],
            [-122.415572319635913, 37.798680127283284],
            [-122.415571551794869, 37.798676329254079],
            [-122.415384693800732, 37.797752451808172],
            [-122.415384105347158, 37.79774954140936],
            [-122.415290513107706, 37.797286788953464],
            [-122.41519297245145, 37.796804503853558],
            [-122.415172033219093, 37.796700969266084],
            [-122.415094279286492, 37.796316514471208],
            [-122.415005455310151, 37.795877318912275],
            [-122.414825631965456, 37.794988155997579],
            [-122.414647632176155, 37.794109807074861],
            [-122.414470074462415, 37.79322314646798],
            [-122.414381908270244, 37.792784070108439],
            [-122.414293264567746, 37.792342610236801],
            [-122.414107303557273, 37.79141647884336],
            [-122.413915879652706, 37.790463115032836]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {OBJECTID: 9, ZIP_CODE: 94111, ID: 94111},
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-122.400058259594957, 37.793693587424592],
            [-122.400148778887171, 37.794134234665414],
            [-122.400149325778898, 37.794134165695652],
            [-122.401314504615144, 37.793987063215781],
            [-122.402133431503088, 37.793883778773662],
            [-122.40215951272063, 37.793880489466119],
            [-122.402957360909014, 37.793779857671261],
            [-122.40308689535884, 37.793763518993806],
            [-122.404016114128936, 37.793646309359175],
            [-122.404370134182003, 37.793598168205968],
            [-122.404613421373455, 37.793565084338127],
            [-122.404710582177955, 37.794021380197684],
            [-122.404796472837063, 37.794453004909116],
            [-122.404875610619072, 37.794859533373135],
            [-122.404957208224928, 37.795326691921687],
            [-122.405142977212691, 37.796210954635839],
            [-122.404412160626791, 37.796302098196776],
            [-122.403496709817034, 37.796417485859841],
            [-122.40291796673857, 37.796490379340391],
            [-122.402402444702886, 37.796554566975963],
            [-122.401853390100442, 37.796626165074152],
            [-122.401906946643678, 37.796875708196644],
            [-122.402040983242472, 37.797504944420098],
            [-122.402228639238132, 37.798429701815799],
            [-122.402420666593613, 37.799382141273902],
            [-122.402603736644934, 37.800305175692849],
            [-122.402604124590809, 37.800307129616797],
            [-122.402789664410264, 37.801242172237629],
            [-122.402883459886269, 37.801713453423041],
            [-122.402973611142329, 37.802166419353441],
            [-122.402973676735002, 37.802166749844929],
            [-122.40315960682554, 37.803098380641011],
            [-122.40352117840483, 37.80305477917063],
            [-122.404798316633176, 37.802900762043983],
            [-122.404986245080067, 37.803832670552438],
            [-122.405173536628851, 37.804763212222298],
            [-122.405356257037084, 37.805690948342658],
            [-122.405357241074242, 37.805695943874476],
            [-122.405362337774832, 37.805695301990511],
            [-122.405545441190654, 37.806634177056651],
            [-122.405495723806581, 37.806640585378162],
            [-122.404696069838451, 37.806264743038192],
            [-122.404128809815958, 37.80582849738515],
            [-122.403587277644846, 37.805412029499024],
            [-122.403194419486127, 37.805118563841738],
            [-122.401732349384048, 37.805192215433102],
            [-122.400572958659495, 37.806120993590262],
            [-122.400963593501643, 37.803563391134098],
            [-122.400842454396695, 37.803429372376385],
            [-122.400479886428016, 37.803466118528789],
            [-122.398551197769294, 37.804602806142064],
            [-122.398535712754665, 37.804606489036345],
            [-122.398520052204233, 37.804603307533085],
            [-122.398559631153262, 37.804526444219782],
            [-122.398227927335071, 37.804281130126874],
            [-122.398222420518948, 37.804268857764917],
            [-122.398225564864617, 37.80425644615601],
            [-122.399971727587683, 37.803225025895152],
            [-122.399602741790233, 37.802807948916175],
            [-122.397824683987196, 37.803810348092696],
            [-122.397809199101829, 37.803814030892141],
            [-122.397793538749667, 37.803810849291956],
            [-122.397517150597622, 37.803494597437428],
            [-122.397511661501127, 37.80348301148031],
            [-122.3975148062854, 37.803470600157546],
            [-122.399615259663278, 37.802282404799911],
            [-122.39972332623249, 37.802176282179168],
            [-122.399409670069147, 37.801824238674413],
            [-122.399371692841143, 37.801828283680663],
            [-122.399347556878283, 37.801832106025373],
            [-122.399325151849467, 37.801835900487347],
            [-122.399302764032285, 37.801840381390434],
            [-122.39928039377223, 37.801845548729034],
            [-122.399258040722614, 37.801851402508781],
            [-122.399235705920944, 37.801857942712921],
            [-122.399215101014406, 37.801864455053376],
            [-122.399192800984025, 37.8018723684091],
            [-122.399172231180287, 37.801880253347079],
            [-122.399151696503523, 37.801889511710215],
            [-122.397115576147101, 37.803021039584841],
            [-122.397100091038084, 37.803024722022734],
            [-122.397084431235825, 37.80302154059693],
            [-122.396146888856933, 37.801962584949095],
            [-122.396143112804936, 37.801950284664713],
            [-122.396146275276891, 37.801938559540567],
            [-122.396156183429241, 37.801919858733392],
            [-122.398383194135846, 37.80067265166084],
            [-122.398279805658603, 37.800555512940733],
            [-122.397989357773142, 37.800230561089471],
            [-122.395767421385884, 37.801472872307706],
            [-122.395751936546873, 37.801476555118818],
            [-122.395736277114864, 37.801473372963947],
            [-122.395444597217249, 37.801167663046662],
            [-122.395439108270097, 37.801156076993678],
            [-122.395442253641278, 37.801143665440662],
            [-122.397525741108808, 37.799970200398498],
            [-122.397542727338319, 37.799957565794791],
            [-122.397573204312565, 37.79993098020509],
            [-122.397588407347527, 37.799916314120374],
            [-122.397601862985724, 37.799900989703779],
            [-122.397613588764841, 37.799885693121588],
            [-122.397625296656045, 37.799869710378033],
            [-122.397635256446222, 37.799853068765884],
            [-122.397583045956239, 37.799774248814408],
            [-122.397381692278955, 37.799548810060863],
            [-122.397362923291766, 37.799559412884541],
            [-122.397350478314067, 37.799546565387622],
            [-122.39725607725606, 37.79944232919879],
            [-122.396973022275191, 37.799609635784066],
            [-122.396895724416169, 37.799632854304804],
            [-122.396944532454214, 37.799578505110418],
            [-122.39725156444139, 37.799401198172731],
            [-122.397069823583166, 37.79919810547964],
            [-122.39674205306757, 37.798834607866056],
            [-122.396702784737215, 37.798855840868825],
            [-122.396669034992286, 37.798822047566397],
            [-122.396624664146429, 37.798846796498019],
            [-122.396609180236553, 37.798850479143326],
            [-122.396595251158345, 37.798847269554258],
            [-122.396579311359616, 37.798833104740751],
            [-122.395709347701867, 37.79933397933474],
            [-122.395681634538477, 37.799401037179429],
            [-122.395581007954107, 37.799459652414193],
            [-122.395491073098484, 37.799462471471649],
            [-122.39520444855259, 37.799625711063314],
            [-122.394470973718072, 37.800049529845779],
            [-122.394485183177821, 37.80006372301127],
            [-122.394463863656298, 37.80011007561265],
            [-122.394495883468409, 37.800143897322769],
            [-122.394436254505337, 37.800181251519263],
            [-122.394338714865782, 37.800157409688907],
            [-122.39425176311174, 37.800073652886503],
            [-122.394244541007424, 37.799994109133792],
            [-122.39430588261277, 37.79995604107372],
            [-122.39433954456824, 37.799986402561352],
            [-122.394405256913004, 37.79998397351315],
            [-122.394419466347642, 37.799998166686734],
            [-122.395383240540369, 37.799442229567333],
            [-122.3954446687179, 37.79940759283992],
            [-122.395460481077649, 37.799348967284097],
            [-122.395564480002861, 37.799286864055659],
            [-122.395650954616428, 37.799284100562168],
            [-122.396137291028239, 37.799011206820815],
            [-122.39652596834469, 37.798777651667436],
            [-122.396513506102295, 37.798764117365188],
            [-122.396508017858096, 37.798752531345663],
            [-122.396511162609784, 37.798740120038758],
            [-122.396521298172757, 37.798730342643047],
            [-122.396562296308161, 37.798709081605075],
            [-122.396530276519627, 37.798675260441449],
            [-122.396574647301449, 37.798650511819105],
            [-122.396522999163949, 37.798593657491452],
            [-122.396499841034597, 37.79856793447253],
            [-122.396467423337157, 37.798586310883579],
            [-122.396357190239343, 37.798472027219738],
            [-122.396393032843889, 37.798452222590186],
            [-122.395860656588496, 37.797870888391557],
            [-122.395839947322898, 37.79787328122778],
            [-122.395814065475506, 37.797876444215788],
            [-122.395788200806479, 37.797880293644518],
            [-122.395762353661098, 37.797884829508355],
            [-122.395738254199486, 37.7978900242679],
            [-122.395712442099452, 37.797895933002444],
            [-122.395664348290325, 37.797910440317423],
            [-122.395640318568425, 37.797918380825799],
            [-122.395616307044421, 37.797927007209815],
            [-122.39557006603053, 37.797946292034375],
            [-122.395547836878862, 37.797956950195463],
            [-122.395525625244971, 37.797968294793179],
            [-122.395505143760289, 37.797979611576075],
            [-122.393842000273821, 37.798938215357374],
            [-122.393826533722603, 37.798942584352829],
            [-122.39381087421539, 37.798939401951962],
            [-122.393557994085199, 37.798661220282753],
            [-122.393552505963697, 37.798649634131031],
            [-122.393557381363038, 37.798637194571512],
            [-122.395454327884067, 37.797548480176857],
            [-122.395493853667872, 37.797469558194479],
            [-122.395422650268614, 37.797392416327632],
            [-122.395305000587612, 37.797394307309993],
            [-122.395131013605095, 37.797494618186263],
            [-122.394995545751499, 37.797340909474201],
            [-122.395176347980751, 37.797236368651362],
            [-122.395203657816268, 37.797153523030403],
            [-122.395175134630833, 37.797121018758673],
            [-122.395015962104765, 37.797123576784635],
            [-122.394842063300572, 37.797227319439131],
            [-122.394877471902745, 37.797258339703205],
            [-122.393211663425149, 37.798247880172283],
            [-122.393197909634068, 37.798251534593128],
            [-122.393182250998592, 37.798248352371843],
            [-122.392924377254829, 37.797977803222231],
            [-122.392918871782612, 37.79796553059834],
            [-122.392922034593937, 37.797953805551998],
            [-122.392933760337485, 37.797938509440698],
            [-122.393022573378389, 37.797891760094423],
            [-122.393418332763261, 37.797664281733844],
            [-122.39349443929828, 37.797594387482981],
            [-122.393614723501102, 37.797492194551531],
            [-122.39379620770903, 37.797346441866999],
            [-122.393858891962495, 37.797293244534764],
            [-122.39453577454303, 37.796890939592352],
            [-122.394518070397197, 37.796875429409333],
            [-122.394797677744066, 37.796708870398604],
            [-122.394681926486655, 37.796581626428896],
            [-122.394272580881463, 37.796818941592662],
            [-122.39351702175675, 37.797258217667746],
            [-122.39355080472113, 37.797293385033349],
            [-122.39316857384685, 37.797508285701419],
            [-122.393092042374221, 37.797425733952373],
            [-122.393468994757654, 37.797207484670842],
            [-122.393490421626595, 37.797233236341413],
            [-122.39412658804784, 37.796863176781166],
            [-122.393932453058198, 37.796648603921177],
            [-122.393850369991199, 37.796687691964301],
            [-122.393741908884792, 37.796574751186853],
            [-122.393880385256736, 37.796507288896663],
            [-122.393597295890373, 37.796198002709581],
            [-122.393523863725633, 37.796236951615114],
            [-122.393397437145097, 37.796098203833878],
            [-122.393481197043371, 37.796057028727645],
            [-122.393264277786542, 37.795831146645604],
            [-122.39319930347132, 37.795862405337601],
            [-122.393014017140644, 37.7956552428926],
            [-122.39305487457618, 37.795628491529783],
            [-122.392997761288825, 37.795560736430133],
            [-122.392816418294032, 37.795643993697439],
            [-122.391589731865537, 37.796205501614423],
            [-122.391196361068637, 37.795779176166889],
            [-122.39241116638668, 37.794819563891082],
            [-122.39226709396803, 37.794667363398794],
            [-122.391941265746169, 37.794853886332461],
            [-122.391649609982679, 37.794547480215279],
            [-122.391828732520565, 37.794445031825084],
            [-122.391802064349278, 37.794417304057546],
            [-122.391945361729881, 37.794335345459139],
            [-122.391890260341384, 37.794278544568918],
            [-122.392507683750154, 37.79377708635252],
            [-122.39249932896719, 37.793768814133983],
            [-122.392702063215523, 37.793608792659974],
            [-122.39270797067924, 37.793614415765255],
            [-122.394150899798674, 37.794987788593353],
            [-122.394745701490038, 37.794478274267938],
            [-122.394745733667804, 37.794478246556643],
            [-122.394747579547172, 37.794479718347191],
            [-122.394971722038662, 37.794300351169447],
            [-122.395317307728533, 37.794023797689903],
            [-122.39533276386878, 37.794011429145591],
            [-122.395622922555773, 37.793779228585429],
            [-122.395983670970253, 37.793501461560965],
            [-122.396302004290646, 37.793256350429786],
            [-122.396302004629632, 37.793256350149633],
            [-122.396376076969489, 37.793198086984006],
            [-122.396504486670068, 37.793097082520163],
            [-122.39738344591872, 37.792405521295422],
            [-122.397840810091907, 37.792047595331439],
            [-122.39826444614279, 37.791716060417308],
            [-122.398264448861653, 37.791716058450703],
            [-122.399148598683425, 37.79101664916432],
            [-122.39914859901539, 37.791016648609592],
            [-122.399148705293825, 37.791016743863253],
            [-122.399148704954868, 37.791016744143391],
            [-122.399494165511513, 37.791324916192721],
            [-122.399572029409299, 37.791326533708947],
            [-122.399763353084495, 37.792257948007119],
            [-122.399958735737897, 37.793209101900771],
            [-122.400058259594957, 37.793693587424592]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {OBJECTID: 10, ZIP_CODE: 94104, ID: 94104},
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-122.400067228055164, 37.790303858609981],
            [-122.401375490979433, 37.789264321921429],
            [-122.4018939793784, 37.788856309111516],
            [-122.402065730098272, 37.788721152097366],
            [-122.401960433993054, 37.788922171387867],
            [-122.401997470431979, 37.789102650051042],
            [-122.402189645264357, 37.790039096806382],
            [-122.402532679537515, 37.789995540560724],
            [-122.40273920526738, 37.789969317269424],
            [-122.403841563913829, 37.789829338872408],
            [-122.403934377264903, 37.790286026286218],
            [-122.404030724679231, 37.790760095776051],
            [-122.404219835191427, 37.791690583910508],
            [-122.40441842761642, 37.79263865633952],
            [-122.404613389070732, 37.793564931583006],
            [-122.404613421373455, 37.793565084338127],
            [-122.404370134182003, 37.793598168205968],
            [-122.404016114128936, 37.793646309359175],
            [-122.40308689535884, 37.793763518993806],
            [-122.402957360909014, 37.793779857671261],
            [-122.40215951272063, 37.793880489466119],
            [-122.402133431503088, 37.793883778773662],
            [-122.401314504615144, 37.793987063215781],
            [-122.400149325778898, 37.794134165695652],
            [-122.400148778887171, 37.794134234665414],
            [-122.400058259594957, 37.793693587424592],
            [-122.399958735737897, 37.793209101900771],
            [-122.399763353084495, 37.792257948007119],
            [-122.399572029409299, 37.791326533708947],
            [-122.399494165511513, 37.791324916192721],
            [-122.399148704954868, 37.791016744143391],
            [-122.399148705293825, 37.791016743863253],
            [-122.39914859901539, 37.791016648609592],
            [-122.399222136170906, 37.790956214990921],
            [-122.399480001759599, 37.790744297277485],
            [-122.399919790020746, 37.790414442896498],
            [-122.400024135710936, 37.790336179680637],
            [-122.400067228055164, 37.790303858609981]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {OBJECTID: 11, ZIP_CODE: 94108, ID: 94108},
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-122.404219835191427, 37.791690583910508],
            [-122.404030724679231, 37.790760095776051],
            [-122.403934377264903, 37.790286026286218],
            [-122.403841563913829, 37.789829338872408],
            [-122.40273920526738, 37.789969317269424],
            [-122.402532679537515, 37.789995540560724],
            [-122.402189645264357, 37.790039096806382],
            [-122.401997470431979, 37.789102650051042],
            [-122.401960433993054, 37.788922171387867],
            [-122.402065730098272, 37.788721152097366],
            [-122.402404665507532, 37.788463925757384],
            [-122.402903089488873, 37.788085654318181],
            [-122.40290309900054, 37.788085647297414],
            [-122.403239953883428, 37.787802352067843],
            [-122.403430800369534, 37.787641848645734],
            [-122.403925775648347, 37.787250481113581],
            [-122.404583316787637, 37.786730565897571],
            [-122.404583317133643, 37.786730565891986],
            [-122.404583317818549, 37.786730565606241],
            [-122.4045836593057, 37.786730668317922],
            [-122.404583659644615, 37.786730668037741],
            [-122.404849901045083, 37.78680995410096],
            [-122.405346079234604, 37.786747618574395],
            [-122.40639887788349, 37.786615347203238],
            [-122.408036236552462, 37.786409613336666],
            [-122.408226725993813, 37.78735926231473],
            [-122.408401550373739, 37.788293193957799],
            [-122.408595045382015, 37.789225614946417],
            [-122.408595692092703, 37.789225606675593],
            [-122.410242438640608, 37.789016337723744],
            [-122.411885657146456, 37.788807543703371],
            [-122.412075867445836, 37.789739906579548],
            [-122.412154318600955, 37.79012444884593],
            [-122.412266187164306, 37.790672783986288],
            [-122.413915879652706, 37.790463115032836],
            [-122.414107303557273, 37.79141647884336],
            [-122.414293264567746, 37.792342610236801],
            [-122.414381908270244, 37.792784070108439],
            [-122.414470074462415, 37.79322314646798],
            [-122.414647632176155, 37.794109807074861],
            [-122.414825631965456, 37.794988155997579],
            [-122.413187771447625, 37.795197816725128],
            [-122.412335878555311, 37.795306857217497],
            [-122.411893657029495, 37.795363458292385],
            [-122.411541531721369, 37.795408526524874],
            [-122.411081667103218, 37.795467382264249],
            [-122.40989875147848, 37.795616424537307],
            [-122.40954722057397, 37.795660707190791],
            [-122.409343544204319, 37.795686363949223],
            [-122.409077868767497, 37.795719830108119],
            [-122.409075520379659, 37.795720125786943],
            [-122.408743234497422, 37.795761981540487],
            [-122.408704654154022, 37.795766841471867],
            [-122.408253202051654, 37.795823706218044],
            [-122.40779730388941, 37.795880962818103],
            [-122.407563768850565, 37.795910291726024],
            [-122.407432089697608, 37.795926828732469],
            [-122.407319877605971, 37.795940921047873],
            [-122.407083680819795, 37.795970583772274],
            [-122.406652352369846, 37.796024750165536],
            [-122.406350669109713, 37.796061968858353],
            [-122.406224736410849, 37.796077505131322],
            [-122.405862652252878, 37.796122174218517],
            [-122.405142977212691, 37.796210954635839],
            [-122.404957208224928, 37.795326691921687],
            [-122.404875610619072, 37.794859533373135],
            [-122.404796472837063, 37.794453004909116],
            [-122.404710582177955, 37.794021380197684],
            [-122.404613421373455, 37.793565084338127],
            [-122.404613389070732, 37.793564931583006],
            [-122.40441842761642, 37.79263865633952],
            [-122.404219835191427, 37.791690583910508]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {OBJECTID: 12, ZIP_CODE: 94103, ID: 94103},
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-122.403877699904385, 37.770062866265505],
            [-122.403615112128733, 37.769893190404822],
            [-122.403406518421917, 37.769807099957397],
            [-122.403037758616776, 37.769828657390953],
            [-122.402926809989424, 37.76864812762463],
            [-122.401962350744, 37.768706209224241],
            [-122.401842503677628, 37.76743077711658],
            [-122.400877239583821, 37.76748837440357],
            [-122.400680751363893, 37.767503407870436],
            [-122.4004285874814, 37.76730030349627],
            [-122.399677637243116, 37.766695444602661],
            [-122.39980174760619, 37.766587745781216],
            [-122.399760960198876, 37.766250252443854],
            [-122.40075504647362, 37.766190486570189],
            [-122.401720515816834, 37.766132520250999],
            [-122.401604204317508, 37.764894634517518],
            [-122.401598999326723, 37.764839236400867],
            [-122.402563396844656, 37.764781034314389],
            [-122.403527034519726, 37.764722870371436],
            [-122.404496977488066, 37.764664317561468],
            [-122.404841911264157, 37.764643492872132],
            [-122.405089602982216, 37.764628538373131],
            [-122.405089603673972, 37.764628538361961],
            [-122.405463420216606, 37.764605967981389],
            [-122.406005237363416, 37.764573252226405],
            [-122.406429152848446, 37.764547653527842],
            [-122.406429154577822, 37.764547653499882],
            [-122.406859230067056, 37.764521681123377],
            [-122.407419737953433, 37.764487829924626],
            [-122.407534229395537, 37.765783299286987],
            [-122.408544242939584, 37.765722599679115],
            [-122.410486689274492, 37.765605838622655],
            [-122.411455262151748, 37.765547605227276],
            [-122.412416426589019, 37.765489809283601],
            [-122.413105243007919, 37.765447608576679],
            [-122.415308388038014, 37.765314639624691],
            [-122.416387522888556, 37.765249494040667],
            [-122.41748659577631, 37.765183134636899],
            [-122.418579138459435, 37.765117159398407],
            [-122.418698425401715, 37.765109955145007],
            [-122.419668972681833, 37.765051337054757],
            [-122.420482492120144, 37.765002197009743],
            [-122.420580607922048, 37.764996270018614],
            [-122.420901270224292, 37.764976898858535],
            [-122.421239593012103, 37.764956459387825],
            [-122.421381475659516, 37.764947887797014],
            [-122.421886445840627, 37.764917378530825],
            [-122.42285341443899, 37.764858950163855],
            [-122.423112421134832, 37.764843298770074],
            [-122.424102683503691, 37.764783452170008],
            [-122.424574375550648, 37.764754942537614],
            [-122.426381062356072, 37.764645726997848],
            [-122.426381062758907, 37.764645729188807],
            [-122.426381708477521, 37.764645690891633],
            [-122.426490697526233, 37.765773605772118],
            [-122.426518991136163, 37.766066400051031],
            [-122.426538465047457, 37.766267922745747],
            [-122.426572006355102, 37.766615035704866],
            [-122.426615944414863, 37.767069730096857],
            [-122.426693183296933, 37.76786901846797],
            [-122.426693183304053, 37.767869018742559],
            [-122.426902347012131, 37.769049368265463],
            [-122.426309438735913, 37.769602597220121],
            [-122.424852598682307, 37.770747745074537],
            [-122.423971653706317, 37.771401668385572],
            [-122.423707555870649, 37.771638138620823],
            [-122.42361952356508, 37.771716961429995],
            [-122.423479344850293, 37.771827141530693],
            [-122.423258913662679, 37.772000399157754],
            [-122.422619690282815, 37.772502817311128],
            [-122.422169936976104, 37.77285593639396],
            [-122.421941247178026, 37.773036050819961],
            [-122.421284370393934, 37.77356039048216],
            [-122.421008229272687, 37.773780811646674],
            [-122.420910608715644, 37.773852419132908],
            [-122.420699239041511, 37.774007568561714],
            [-122.420698854806645, 37.774007872313192],
            [-122.42069877383058, 37.774007805509001],
            [-122.420254278900828, 37.774358674888319],
            [-122.420254205644639, 37.774358732668077],
            [-122.419544527888206, 37.774918988504218],
            [-122.419256088091217, 37.775146694295351],
            [-122.419256086565611, 37.775146688826375],
            [-122.419255604623004, 37.775147068879761],
            [-122.419255606501622, 37.775147074617692],
            [-122.419255600381447, 37.775147078837719],
            [-122.418683590110874, 37.775586568849455],
            [-122.417757669457401, 37.776334062520824],
            [-122.417501462863584, 37.776540893581355],
            [-122.416757677810395, 37.777126789723972],
            [-122.416291701725271, 37.777493842582118],
            [-122.416291701393504, 37.777493843136881],
            [-122.416024573316548, 37.777713893977598],
            [-122.415925978170975, 37.777795112873314],
            [-122.414741221622947, 37.778719429321896],
            [-122.412512255967954, 37.78047851222005],
            [-122.412243715889375, 37.780689421480552],
            [-122.411972359306191, 37.780902540886757],
            [-122.411972358960256, 37.78090254089237],
            [-122.411625130786987, 37.781189627190479],
            [-122.410716598656492, 37.781899054565059],
            [-122.410292026384454, 37.782230575136197],
            [-122.40895215871069, 37.783287852576514],
            [-122.408597310055299, 37.783569788681966],
            [-122.408066548174432, 37.783991486066526],
            [-122.408066547510714, 37.783991487176031],
            [-122.407625723544982, 37.784337071806426],
            [-122.406821367207598, 37.78496763543707],
            [-122.405831011063668, 37.78574398921409],
            [-122.405371564397683, 37.786107287119592],
            [-122.404583317818549, 37.786730565606241],
            [-122.404583317133643, 37.786730565891986],
            [-122.404583316787637, 37.786730565897571],
            [-122.403925775648347, 37.787250481113581],
            [-122.403430800369534, 37.787641848645734],
            [-122.403342641535644, 37.787274627660381],
            [-122.403028734856406, 37.78702485040828],
            [-122.403028193190352, 37.787024418822838],
            [-122.402575227394536, 37.786678208153539],
            [-122.402025419766176, 37.786248152290575],
            [-122.401489835489045, 37.785829214187501],
            [-122.401480059865179, 37.785821567351917],
            [-122.400998469557948, 37.785444857061968],
            [-122.400994549885382, 37.785441790992316],
            [-122.400468483886854, 37.785030285141588],
            [-122.399369533643153, 37.785899247741973],
            [-122.397811613142864, 37.784666586003652],
            [-122.398930331092998, 37.783784933304034],
            [-122.399891477967842, 37.783025880124256],
            [-122.400019020063766, 37.782925153640136],
            [-122.400374366843309, 37.782644515545172],
            [-122.401159718585049, 37.782024266952142],
            [-122.403387209275081, 37.78026497235011],
            [-122.404431250807633, 37.779440334605447],
            [-122.405615266425855, 37.778505104539292],
            [-122.405068508898097, 37.778068981419388],
            [-122.404605505853894, 37.777699659794813],
            [-122.404070256642925, 37.777272702482797],
            [-122.403673439982725, 37.776956165214415],
            [-122.403505778866929, 37.776822422431877],
            [-122.40337073826143, 37.776714700215486],
            [-122.402524096584528, 37.776039321403807],
            [-122.400981567656032, 37.774808775969753],
            [-122.400592319049849, 37.774498244536282],
            [-122.400212340771517, 37.774195105423317],
            [-122.400212340411557, 37.77419510487973],
            [-122.399433130909728, 37.773573455617395],
            [-122.401656680421155, 37.7718171255028],
            [-122.403877699904385, 37.770062866265505]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {OBJECTID: 13, ZIP_CODE: 94115, ID: 94115},
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-122.447679208068394, 37.79170289872647],
            [-122.44720637942703, 37.791763091830468],
            [-122.446299547924625, 37.791878529215651],
            [-122.446299573716246, 37.791878694429421],
            [-122.446446033268856, 37.792810866507708],
            [-122.446446456540414, 37.792813716046261],
            [-122.446587034424141, 37.793765298555968],
            [-122.445035345747925, 37.79396273368863],
            [-122.443384198876302, 37.794172877898092],
            [-122.441712771485612, 37.794385578392699],
            [-122.440870170501768, 37.794492795601883],
            [-122.440868123190498, 37.794493055920753],
            [-122.440045216960385, 37.794597761146619],
            [-122.438402484723895, 37.794806973138577],
            [-122.436760975027326, 37.795016021968365],
            [-122.435113289920963, 37.795225833115033],
            [-122.433469062960725, 37.795435179810816],
            [-122.431827832563371, 37.79564412085616],
            [-122.430182832162615, 37.795853517593606],
            [-122.429989276973558, 37.794894937362344],
            [-122.429803981887915, 37.793977244761322],
            [-122.429625242377327, 37.793098475947545],
            [-122.429447192175289, 37.79221689778025],
            [-122.429269817037863, 37.791338636935983],
            [-122.429092268257477, 37.790459499306614],
            [-122.428905308896674, 37.789533740830485],
            [-122.428712111452299, 37.788577067507021],
            [-122.428525011003728, 37.78765056176524],
            [-122.428335613076769, 37.786712655890966],
            [-122.428241829261111, 37.786248226022003],
            [-122.428241496400901, 37.78624657727314],
            [-122.428148186422831, 37.785784488173462],
            [-122.427988927379005, 37.784953879052303],
            [-122.427778871361184, 37.783924735360486],
            [-122.427584325166535, 37.78298604740867],
            [-122.427490665181679, 37.782522998381459],
            [-122.427396397680198, 37.782056939506091],
            [-122.42720275579525, 37.781117127328834],
            [-122.427016756808811, 37.780193030481158],
            [-122.42868554474839, 37.779980201690215],
            [-122.430233236584385, 37.779782794230314],
            [-122.431951802315041, 37.779564148987781],
            [-122.433595938040227, 37.779354585436536],
            [-122.435241012398947, 37.779144878458894],
            [-122.436884629197735, 37.778937753600381],
            [-122.437707163233824, 37.778832380147421],
            [-122.43855227772093, 37.778724107938281],
            [-122.440213334218711, 37.778511463388014],
            [-122.441865640580161, 37.778299553615973],
            [-122.441865640558632, 37.778299552792262],
            [-122.441865967212379, 37.778299511152262],
            [-122.441865967226732, 37.778299511701405],
            [-122.443506919728407, 37.778089213415292],
            [-122.445155752336433, 37.777886506805444],
            [-122.446846469920573, 37.777669108909684],
            [-122.447039806751391, 37.778622307248391],
            [-122.447351927163439, 37.780152061280916],
            [-122.447517982733274, 37.781069510753063],
            [-122.447576361567485, 37.781175778551805],
            [-122.447655108274333, 37.781537309189886],
            [-122.447637300982407, 37.781719177617617],
            [-122.447450898997985, 37.782195217632704],
            [-122.447301513844337, 37.78239164221629],
            [-122.447283893261542, 37.782434393634787],
            [-122.447225622636566, 37.782575775503396],
            [-122.447173033991248, 37.782710075581413],
            [-122.447149436147441, 37.783030677550911],
            [-122.447549635601661, 37.784906798974511],
            [-122.447578549915917, 37.784998355250835],
            [-122.447620107068687, 37.785083635258417],
            [-122.447621599012791, 37.785194684567394],
            [-122.447605133356163, 37.785275579171099],
            [-122.447533801639068, 37.785411415165207],
            [-122.446849274413296, 37.786186897081585],
            [-122.446738337622591, 37.786243163870765],
            [-122.446610465639836, 37.786302298311156],
            [-122.446792779960703, 37.787261853518181],
            [-122.4469741664482, 37.788186460801001],
            [-122.448656220796209, 37.787977164570449],
            [-122.448835781299294, 37.788856511426609],
            [-122.449011564525605, 37.789726786022129],
            [-122.449189583391288, 37.790608108274284],
            [-122.449367313308201, 37.791487980191171],
            [-122.447679208068394, 37.79170289872647]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {OBJECTID: 14, name: '16th St. Mission (16TH)'},
      geometry: {type: 'Point', coordinates: [-122.419694, 37.765062]}
    },
    {
      type: 'Feature',
      properties: {OBJECTID: 15, name: '19th St. Oakland (19TH)'},
      geometry: {type: 'Point', coordinates: [-122.269029, 37.80787]}
    },
    {
      type: 'Feature',
      properties: {OBJECTID: 16, name: '24th St. Mission (24TH)'},
      geometry: {type: 'Point', coordinates: [-122.418466, 37.752254]}
    },
    {
      type: 'Feature',
      properties: {OBJECTID: 17, STREETNAME: null, CNN: null, CNNTEXT: null, LAYER: null},
      geometry: {
        type: 'LineString',
        coordinates: [
          [-122.404496510855935, 37.747208431159258, 0.0],
          [-122.404724947212969, 37.746505061621882, 0.0],
          [-122.404910121756458, 37.745826557926733, 0.0],
          [-122.40505115991364, 37.745369647146362, 0.0],
          [-122.405179629589213, 37.744981134594937, 0.0],
          [-122.405475696208015, 37.744427002056398, 0.0],
          [-122.405747110770719, 37.74402859882732, 0.0],
          [-122.406047832261379, 37.743656241938524, 0.0],
          [-122.406881612819447, 37.742665294624537, 0.0],
          [-122.407209492100122, 37.742235665881928, 0.0],
          [-122.407448074495264, 37.741860522092949, 0.0],
          [-122.407625696930154, 37.741528038899268, 0.0],
          [-122.407757063324084, 37.741253133458535, 0.0],
          [-122.407846654066077, 37.741024367212859, 0.0],
          [-122.407964646258392, 37.74066255255704, 0.0],
          [-122.408049229599797, 37.74033911017515, 0.0],
          [-122.40811407182305, 37.739818087474802, 0.0],
          [-122.408155426277474, 37.739489700638032, 0.0],
          [-122.4081815622297, 37.739061925772134, 0.0]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {OBJECTID: 18, STREETNAME: null, CNN: null, CNNTEXT: null, LAYER: null},
      geometry: {
        type: 'LineString',
        coordinates: [
          [-122.423396761198774, 37.771885644205057, 0.0],
          [-122.423341877997842, 37.7716970422617, 0.0],
          [-122.42310057516444, 37.771322004989457, 0.0],
          [-122.423023389959624, 37.771214151829795, 0.0],
          [-122.422909336817526, 37.771075536726087, 0.0],
          [-122.422813562263059, 37.770970841731483, 0.0],
          [-122.422687528244538, 37.770851679988603, 0.0],
          [-122.422548319806467, 37.770735086967235, 0.0],
          [-122.422398678994213, 37.770624666937692, 0.0],
          [-122.422251635554701, 37.770526810613305, 0.0],
          [-122.422118196802614, 37.770448774473365, 0.0],
          [-122.421934187850198, 37.770355122684251, 0.0],
          [-122.421813265154583, 37.770301864818435, 0.0],
          [-122.421699352349904, 37.770256296204039, 0.0],
          [-122.421444606183769, 37.77017071999213, 0.0],
          [-122.42115970557785, 37.770096121272886, 0.0],
          [-122.420898240339739, 37.770049954636129, 0.0],
          [-122.420722192307608, 37.770030010784517, 0.0],
          [-122.420585860012409, 37.770019508727906, 0.0],
          [-122.419997377433887, 37.769997815936115, 0.0],
          [-122.419496824292551, 37.769981089772898, 0.0],
          [-122.419358230344216, 37.7699709673944, 0.0],
          [-122.419180619296924, 37.769953778292248, 0.0],
          [-122.418926623491956, 37.769918930266449, 0.0],
          [-122.416139450807378, 37.769545473811675, 0.0]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {OBJECTID: 19, STREETNAME: null, CNN: null, CNNTEXT: null, LAYER: null},
      geometry: {
        type: 'LineString',
        coordinates: [
          [-122.416338879874303, 37.769687518927974, 0.0],
          [-122.418400932566996, 37.769948381534682, 0.0],
          [-122.419176763922451, 37.770054187185572, 0.0],
          [-122.419354003754208, 37.770073213616591, 0.0],
          [-122.419542138973512, 37.770086427945351, 0.0],
          [-122.419723964918447, 37.770092686385524, 0.0],
          [-122.420100214695708, 37.770105478471756, 0.0],
          [-122.420476463491056, 37.770118270276519, 0.0],
          [-122.420616194034608, 37.770125614199095, 0.0],
          [-122.420816021735661, 37.770145216687936, 0.0],
          [-122.421007563773117, 37.770174292292772, 0.0],
          [-122.421149554735379, 37.770202567397305, 0.0],
          [-122.421323625825579, 37.770245387827444, 0.0],
          [-122.42150000102616, 37.770298447039025, 0.0],
          [-122.421757333137421, 37.770394874007152, 0.0],
          [-122.421886515500674, 37.770452654763503, 0.0],
          [-122.422041292168728, 37.770530023310897, 0.0],
          [-122.422168383585031, 37.770601574230888, 0.0],
          [-122.42227536100421, 37.770668224151905, 0.0],
          [-122.422351617622013, 37.770720521989226, 0.0],
          [-122.422517355438828, 37.770847486375189, 0.0],
          [-122.422654966009191, 37.770969406462996, 0.0],
          [-122.422814001010366, 37.771134535526315, 0.0],
          [-122.422907046260278, 37.77124703002864, 0.0],
          [-122.422985096055257, 37.771353508317482, 0.0],
          [-122.423251598467544, 37.771769674548985, 0.0],
          [-122.423396761198774, 37.771885644205057, 0.0]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {OBJECTID: 20, name: 'FRMT-DALY (ROUTE 5/6)', color: '#4db848'},
      geometry: {
        type: 'MultiLineString',
        coordinates: [
          [
            [-122.117691, 37.690853],
            [-122.115804, 37.689526],
            [-122.114714, 37.688759],
            [-122.113653, 37.688024],
            [-122.111942, 37.686838],
            [-122.108067, 37.684181],
            [-122.105053, 37.682106],
            [-122.102954, 37.68066],
            [-122.102038, 37.680022],
            [-122.101587, 37.679705],
            [-122.101264, 37.679484],
            [-122.100991, 37.679307],
            [-122.099792, 37.678482],
            [-122.099169, 37.678052],
            [-122.098553, 37.677627],
            [-122.098007, 37.677245],
            [-122.095037, 37.675203],
            [-122.094074, 37.674541],
            [-122.090903, 37.672359],
            [-122.089886, 37.671685],
            [-122.089195, 37.671243],
            [-122.088304, 37.670637],
            [-122.087763, 37.670258],
            [-122.08744, 37.670036],
            [-122.086993, 37.669721],
            [-122.086371, 37.669288],
            [-122.085998, 37.669034],
            [-122.084869, 37.668261],
            [-122.084598, 37.668069],
            [-122.08442, 37.667945],
            [-122.084211, 37.667804],
            [-122.084084, 37.667711],
            [-122.083897, 37.667578],
            [-122.08372, 37.667449],
            [-122.083589, 37.66735],
            [-122.083479, 37.667265],
            [-122.083322, 37.66714],
            [-122.083076, 37.666953],
            [-122.082935, 37.66683],
            [-122.082632, 37.666538],
            [-122.082446, 37.666354],
            [-122.082369, 37.666272],
            [-122.082333, 37.666234],
            [-122.082284, 37.666184],
            [-122.082226, 37.666121],
            [-122.082156, 37.666044],
            [-122.082064, 37.665942],
            [-122.081967, 37.665832],
            [-122.081859, 37.665707],
            [-122.081619, 37.665418],
            [-122.081437, 37.66521],
            [-122.08108, 37.664741],
            [-122.080772, 37.66435],
            [-122.080436, 37.663925],
            [-122.080142, 37.663548],
            [-122.079515, 37.66275],
            [-122.079077, 37.662191],
            [-122.078544, 37.661513],
            [-122.078221, 37.661104],
            [-122.077928, 37.660729],
            [-122.076837, 37.659338],
            [-122.076609, 37.659057],
            [-122.076483, 37.658895],
            [-122.076067, 37.658358],
            [-122.075285, 37.657361],
            [-122.074609, 37.656503],
            [-122.074027, 37.655761],
            [-122.07354, 37.65514],
            [-122.07297, 37.654414],
            [-122.071948, 37.653108],
            [-122.071259, 37.652248],
            [-122.070921, 37.651817],
            [-122.070654, 37.651473],
            [-122.070295, 37.651016],
            [-122.069886, 37.650495],
            [-122.069584, 37.650128],
            [-122.069135, 37.649539],
            [-122.068707, 37.648992],
            [-122.067593, 37.647577],
            [-122.066986, 37.646801],
            [-122.066533, 37.646228],
            [-122.065976, 37.645512],
            [-122.065554, 37.644979],
            [-122.065403, 37.644785],
            [-122.064328, 37.643416],
            [-122.064026, 37.643029],
            [-122.06333, 37.642146],
            [-122.062654, 37.641281],
            [-122.062072, 37.640542],
            [-122.061487, 37.639797],
            [-122.061192, 37.639424],
            [-122.06063, 37.638707],
            [-122.060059, 37.637982],
            [-122.05983, 37.637697],
            [-122.059604, 37.637414],
            [-122.059404, 37.637168],
            [-122.059164, 37.636868],
            [-122.058808, 37.636417],
            [-122.058253, 37.635703],
            [-122.057911, 37.635273],
            [-122.05747, 37.63471],
            [-122.05725, 37.634427],
            [-122.057054, 37.634176],
            [-122.056852, 37.633926],
            [-122.056006, 37.632842],
            [-122.055549, 37.63226],
            [-122.054814, 37.631328],
            [-122.054167, 37.630498],
            [-122.053868, 37.63011],
            [-122.053568, 37.629681],
            [-122.053468, 37.629507],
            [-122.053338, 37.629302],
            [-122.053222, 37.629103],
            [-122.053084, 37.628859],
            [-122.05294, 37.628593],
            [-122.052839, 37.628415],
            [-122.0527, 37.62811],
            [-122.052452, 37.627612],
            [-122.051964, 37.626617],
            [-122.051772, 37.626229],
            [-122.051609, 37.625908],
            [-122.050977, 37.624599],
            [-122.050737, 37.624113],
            [-122.050523, 37.623678],
            [-122.050316, 37.623254],
            [-122.049984, 37.622579],
            [-122.04972, 37.622073],
            [-122.049565, 37.621804],
            [-122.049416, 37.621558],
            [-122.049302, 37.621378],
            [-122.04918, 37.621195],
            [-122.049031, 37.620985],
            [-122.048878, 37.620777],
            [-122.048723, 37.620579],
            [-122.048556, 37.620373],
            [-122.04842, 37.620214],
            [-122.048146, 37.619908],
            [-122.047999, 37.619757],
            [-122.04792, 37.619676],
            [-122.047835, 37.619592],
            [-122.047736, 37.619493],
            [-122.047497, 37.619263],
            [-122.047325, 37.619105],
            [-122.047063, 37.618871],
            [-122.046236, 37.618155],
            [-122.045398, 37.617408],
            [-122.044619, 37.616726],
            [-122.043788, 37.615997],
            [-122.037595, 37.610563],
            [-122.037278, 37.610274],
            [-122.036229, 37.60925],
            [-122.036117, 37.609133],
            [-122.034705, 37.607718],
            [-122.033443, 37.606397],
            [-122.03295, 37.605879],
            [-122.030835, 37.603662],
            [-122.029644, 37.602411],
            [-122.029135, 37.601873],
            [-122.028693, 37.601412],
            [-122.02835, 37.601054],
            [-122.028222, 37.600917],
            [-122.028091, 37.600781],
            [-122.027998, 37.600684],
            [-122.02774, 37.600412],
            [-122.027534, 37.600196],
            [-122.02729, 37.599942],
            [-122.027101, 37.599745],
            [-122.026868, 37.599512],
            [-122.026728, 37.599375],
            [-122.026611, 37.599264],
            [-122.026452, 37.599123],
            [-122.026324, 37.599004],
            [-122.026214, 37.598906],
            [-122.025593, 37.598354],
            [-122.025281, 37.598081],
            [-122.025, 37.597834],
            [-122.024688, 37.597564],
            [-122.024296, 37.59722],
            [-122.023757, 37.596736],
            [-122.023642, 37.596631],
            [-122.023542, 37.596538],
            [-122.023369, 37.596378],
            [-122.023206, 37.596218],
            [-122.023154, 37.596168],
            [-122.023115, 37.59613],
            [-122.023079, 37.596097],
            [-122.023029, 37.596045],
            [-122.022965, 37.595978],
            [-122.02275, 37.595756],
            [-122.022531, 37.595514],
            [-122.022291, 37.595242],
            [-122.022234, 37.595174],
            [-122.022161, 37.595086],
            [-122.022103, 37.595019],
            [-122.022034, 37.594939],
            [-122.021966, 37.594859],
            [-122.021915, 37.594795],
            [-122.021817, 37.594675],
            [-122.021658, 37.594495],
            [-122.021426, 37.594212],
            [-122.021219, 37.593972],
            [-122.021065, 37.593801],
            [-122.021007, 37.593736],
            [-122.020967, 37.593694],
            [-122.020929, 37.593655],
            [-122.020872, 37.593597],
            [-122.020802, 37.593526],
            [-122.020647, 37.593377],
            [-122.020549, 37.593284],
            [-122.020461, 37.593199],
            [-122.020412, 37.593156],
            [-122.020354, 37.593104],
            [-122.020183, 37.592954],
            [-122.020048, 37.592838],
            [-122.019885, 37.592705],
            [-122.019793, 37.592635],
            [-122.01972, 37.592576],
            [-122.01965, 37.592525],
            [-122.019557, 37.592457],
            [-122.019385, 37.592326],
            [-122.019085, 37.592102],
            [-122.018765, 37.591865],
            [-122.018204, 37.591448],
            [-122.017895, 37.591219],
            [-122.0171, 37.590622],
            [-122.016692, 37.59032],
            [-122.016371, 37.590089],
            [-122.015817, 37.589669],
            [-122.015497, 37.589431],
            [-122.01515, 37.589169],
            [-122.014159, 37.588415],
            [-122.013847, 37.588182],
            [-122.011853, 37.586658],
            [-122.011481, 37.586373],
            [-122.011229, 37.586182],
            [-122.01049, 37.585619],
            [-122.010333, 37.585498],
            [-122.010143, 37.585354],
            [-122.009574, 37.584919],
            [-122.00888, 37.584388],
            [-122.008313, 37.583958],
            [-122.007269, 37.583164],
            [-122.006446, 37.58254],
            [-122.005567, 37.58186],
            [-122.004923, 37.581365],
            [-122.004537, 37.581069],
            [-122.003136, 37.580005],
            [-122.002242, 37.579319],
            [-122.001715, 37.578913],
            [-122.001253, 37.578556],
            [-122.000564, 37.578025],
            [-121.999847, 37.577472],
            [-121.997932, 37.576006],
            [-121.995922, 37.574459],
            [-121.995619, 37.574225],
            [-121.994714, 37.573527],
            [-121.99397, 37.572962],
            [-121.993694, 37.572743],
            [-121.993273, 37.57242],
            [-121.991502, 37.571059],
            [-121.990996, 37.57067],
            [-121.990659, 37.570401],
            [-121.990182, 37.569997],
            [-121.989955, 37.569795],
            [-121.989463, 37.569339],
            [-121.98896, 37.568829],
            [-121.988807, 37.568679],
            [-121.988626, 37.568481],
            [-121.988448, 37.568282],
            [-121.988089, 37.567844],
            [-121.987733, 37.567417],
            [-121.986703, 37.566157],
            [-121.986537, 37.56595],
            [-121.986376, 37.565751],
            [-121.986181, 37.565514],
            [-121.985957, 37.56525],
            [-121.985776, 37.565041],
            [-121.985623, 37.564863],
            [-121.985499, 37.56472],
            [-121.985318, 37.56452],
            [-121.985027, 37.564218],
            [-121.984899, 37.564089],
            [-121.984774, 37.563963],
            [-121.984676, 37.563865],
            [-121.984603, 37.563796],
            [-121.984412, 37.563618],
            [-121.984246, 37.563464],
            [-121.984127, 37.563356],
            [-121.983855, 37.563112],
            [-121.983641, 37.562932],
            [-121.983256, 37.562582],
            [-121.982572, 37.561982],
            [-121.982033, 37.561511],
            [-121.981559, 37.561092],
            [-121.981106, 37.560701],
            [-121.980652, 37.560324],
            [-121.980387, 37.560105],
            [-121.980102, 37.559882],
            [-121.979814, 37.559666],
            [-121.979434, 37.559423],
            [-121.978995, 37.559116],
            [-121.978639, 37.558864],
            [-121.978169, 37.558551],
            [-121.977623, 37.55817],
            [-121.977417, 37.558024],
            [-121.977121, 37.557831],
            [-121.976865, 37.557655],
            [-121.976568, 37.557436],
            [-121.976395, 37.557353]
          ],
          [
            [-122.270713, 37.799861],
            [-122.270179, 37.799654],
            [-122.269529, 37.799396],
            [-122.268525, 37.798992],
            [-122.267377, 37.798517],
            [-122.267183, 37.798395],
            [-122.26691, 37.79824],
            [-122.266683, 37.798083],
            [-122.266323, 37.797875],
            [-122.265589, 37.797472],
            [-122.265182, 37.797248],
            [-122.264574, 37.796939],
            [-122.264202, 37.79674],
            [-122.26366, 37.796465],
            [-122.262696, 37.795886],
            [-122.261985, 37.79539],
            [-122.261091, 37.794706],
            [-122.25951, 37.793439],
            [-122.25895, 37.793028],
            [-122.258557, 37.792739],
            [-122.258382, 37.79261],
            [-122.258303, 37.792553],
            [-122.258165, 37.792459],
            [-122.258031, 37.79237],
            [-122.257893, 37.792285],
            [-122.257676, 37.792154],
            [-122.257415, 37.791995],
            [-122.257306, 37.791933],
            [-122.257196, 37.791872],
            [-122.256969, 37.791744],
            [-122.256716, 37.791614],
            [-122.256498, 37.791511],
            [-122.256259, 37.7914],
            [-122.25612, 37.791336],
            [-122.256014, 37.791289],
            [-122.255908, 37.791246],
            [-122.255851, 37.791221],
            [-122.255652, 37.791139],
            [-122.255356, 37.791024],
            [-122.255004, 37.790899],
            [-122.254959, 37.790879],
            [-122.254782, 37.79082],
            [-122.254661, 37.790779],
            [-122.254394, 37.790691],
            [-122.254234, 37.790639],
            [-122.25379, 37.790503],
            [-122.253541, 37.790425],
            [-122.25316, 37.79031],
            [-122.252814, 37.790202],
            [-122.252551, 37.790121],
            [-122.252439, 37.790085],
            [-122.252299, 37.790038],
            [-122.252153, 37.789989],
            [-122.251745, 37.789843],
            [-122.251551, 37.789773],
            [-122.250857, 37.789496],
            [-122.24971, 37.788996],
            [-122.248543, 37.788495],
            [-122.246809, 37.787751],
            [-122.245552, 37.787202],
            [-122.244862, 37.786885],
            [-122.244353, 37.786636],
            [-122.243912, 37.786423],
            [-122.243421, 37.786186],
            [-122.243086, 37.786023],
            [-122.24279, 37.785882],
            [-122.242285, 37.785636],
            [-122.241987, 37.785491],
            [-122.241666, 37.785326],
            [-122.241364, 37.785177],
            [-122.241185, 37.785089],
            [-122.241043, 37.785018],
            [-122.240807, 37.7849],
            [-122.240536, 37.78476],
            [-122.240049, 37.784497],
            [-122.239549, 37.784216],
            [-122.23922, 37.784016],
            [-122.238971, 37.783868],
            [-122.238817, 37.783777],
            [-122.238699, 37.783707],
            [-122.238569, 37.783631],
            [-122.238397, 37.783525],
            [-122.238274, 37.783455],
            [-122.238181, 37.7834],
            [-122.238025, 37.783314],
            [-122.237927, 37.783256],
            [-122.237796, 37.783181],
            [-122.237656, 37.783095],
            [-122.237312, 37.782888],
            [-122.237159, 37.782797],
            [-122.236743, 37.782548],
            [-122.236563, 37.78244],
            [-122.236442, 37.782368],
            [-122.236194, 37.782221],
            [-122.236047, 37.782134],
            [-122.235734, 37.781944],
            [-122.235587, 37.781855],
            [-122.235446, 37.781769],
            [-122.235044, 37.781514],
            [-122.234858, 37.781391],
            [-122.234693, 37.781277],
            [-122.234605, 37.781216],
            [-122.234475, 37.781124],
            [-122.234323, 37.781014],
            [-122.234195, 37.780916],
            [-122.233983, 37.78075],
            [-122.2332, 37.780127],
            [-122.232935, 37.779904],
            [-122.232743, 37.77975],
            [-122.232408, 37.779492],
            [-122.232055, 37.779233],
            [-122.231803, 37.779057],
            [-122.231595, 37.778921],
            [-122.231321, 37.778746],
            [-122.231123, 37.778624],
            [-122.230862, 37.778473],
            [-122.230571, 37.778311],
            [-122.230383, 37.778209],
            [-122.23023, 37.778127],
            [-122.230001, 37.778007],
            [-122.229772, 37.777891],
            [-122.229105, 37.777549],
            [-122.228728, 37.777359],
            [-122.228307, 37.77714],
            [-122.22813, 37.777051],
            [-122.227894, 37.776929],
            [-122.227597, 37.77678],
            [-122.22656, 37.776269],
            [-122.226374, 37.776174],
            [-122.226171, 37.776069],
            [-122.226094, 37.776027],
            [-122.225862, 37.775897],
            [-122.225558, 37.775724],
            [-122.225047, 37.775422],
            [-122.224572, 37.775141],
            [-122.22382, 37.774706],
            [-122.223652, 37.77461],
            [-122.223298, 37.774402],
            [-122.222984, 37.774223],
            [-122.222818, 37.774124],
            [-122.222585, 37.773986],
            [-122.222329, 37.773839],
            [-122.222026, 37.773662],
            [-122.22163, 37.773441],
            [-122.221151, 37.773194],
            [-122.220924, 37.773077],
            [-122.220649, 37.772945],
            [-122.220236, 37.772752],
            [-122.219737, 37.772515],
            [-122.219285, 37.7723],
            [-122.218757, 37.772057],
            [-122.218323, 37.771832],
            [-122.218171, 37.771751],
            [-122.218089, 37.771708],
            [-122.217913, 37.771608],
            [-122.217764, 37.771525],
            [-122.217523, 37.771389],
            [-122.217314, 37.77126],
            [-122.217092, 37.771119],
            [-122.216791, 37.770914],
            [-122.216585, 37.770767],
            [-122.216384, 37.770616],
            [-122.216272, 37.770528],
            [-122.216187, 37.77046],
            [-122.2161, 37.770392],
            [-122.215956, 37.770275],
            [-122.215834, 37.770169],
            [-122.215617, 37.769975],
            [-122.215391, 37.769768],
            [-122.215127, 37.76951],
            [-122.214725, 37.769102],
            [-122.213975, 37.768328],
            [-122.213715, 37.768059],
            [-122.213622, 37.767966],
            [-122.213373, 37.767709],
            [-122.213171, 37.767508],
            [-122.213032, 37.767372],
            [-122.212766, 37.767121],
            [-122.21262, 37.766983],
            [-122.212323, 37.766721],
            [-122.211957, 37.766401],
            [-122.211802, 37.766276],
            [-122.211492, 37.766011],
            [-122.211363, 37.765908],
            [-122.211146, 37.765721],
            [-122.210737, 37.765378],
            [-122.210451, 37.765136],
            [-122.210161, 37.764895],
            [-122.209748, 37.76455],
            [-122.209532, 37.764369],
            [-122.209231, 37.764115],
            [-122.209064, 37.76398],
            [-122.208445, 37.763457],
            [-122.206766, 37.762054],
            [-122.205483, 37.760979],
            [-122.205025, 37.760595],
            [-122.203892, 37.759651],
            [-122.20063, 37.756912],
            [-122.199879, 37.756274],
            [-122.198766, 37.755271],
            [-122.198327, 37.754895],
            [-122.196884, 37.753678],
            [-122.196409, 37.753284],
            [-122.195922, 37.752873],
            [-122.19573, 37.752712],
            [-122.195487, 37.75251],
            [-122.19528, 37.752335],
            [-122.194969, 37.752074],
            [-122.194684, 37.751843],
            [-122.194409, 37.751629],
            [-122.193529, 37.750938],
            [-122.192961, 37.750466],
            [-122.191093, 37.748907],
            [-122.190632, 37.748524],
            [-122.188553, 37.746778],
            [-122.186353, 37.744931],
            [-122.185911, 37.744555],
            [-122.184359, 37.743261],
            [-122.180251, 37.73981],
            [-122.179614, 37.739272],
            [-122.17726, 37.737349],
            [-122.174961, 37.735423],
            [-122.174445, 37.734989],
            [-122.167116, 37.728838],
            [-122.165421, 37.727412],
            [-122.164801, 37.726886],
            [-122.164287, 37.72643],
            [-122.164047, 37.726194],
            [-122.16369, 37.725831],
            [-122.163281, 37.725371],
            [-122.16291, 37.724904],
            [-122.162513, 37.724379],
            [-122.162009, 37.723643],
            [-122.161361, 37.722695],
            [-122.159669, 37.720244],
            [-122.15952, 37.72003],
            [-122.159398, 37.719865],
            [-122.159334, 37.71978],
            [-122.159273, 37.719699],
            [-122.15918, 37.719588],
            [-122.159048, 37.719437],
            [-122.15897, 37.719351],
            [-122.158889, 37.719271],
            [-122.158804, 37.719185],
            [-122.158779, 37.71916],
            [-122.158714, 37.719101],
            [-122.158639, 37.719034],
            [-122.158541, 37.718949],
            [-122.158298, 37.718757],
            [-122.158132, 37.718635],
            [-122.157878, 37.718452],
            [-122.157566, 37.718237],
            [-122.156866, 37.717754],
            [-122.155854, 37.717057],
            [-122.154863, 37.716379],
            [-122.154301, 37.715991],
            [-122.154006, 37.715787],
            [-122.15375, 37.715612],
            [-122.153029, 37.715119],
            [-122.148444, 37.711966],
            [-122.147591, 37.711379],
            [-122.146414, 37.710571],
            [-122.144545, 37.709282],
            [-122.142296, 37.707738],
            [-122.138726, 37.70528],
            [-122.137211, 37.704236],
            [-122.133704, 37.701825],
            [-122.130722, 37.699774],
            [-122.130305, 37.699488],
            [-122.130015, 37.699288],
            [-122.12982, 37.699153],
            [-122.128081, 37.697997],
            [-122.124181, 37.695383],
            [-122.124181, 37.695383],
            [-122.121564, 37.693512],
            [-122.119058, 37.691789],
            [-122.117691, 37.690853]
          ],
          [
            [-122.270713, 37.799861],
            [-122.270928, 37.799942],
            [-122.271097, 37.799987],
            [-122.271322, 37.800023],
            [-122.272291, 37.799938],
            [-122.27243, 37.799896],
            [-122.272781, 37.799796],
            [-122.2732, 37.79959],
            [-122.273728, 37.799315],
            [-122.274691, 37.79884],
            [-122.274868, 37.798753],
            [-122.276054, 37.798516],
            [-122.276236, 37.798476],
            [-122.276856, 37.798527]
          ],
          [
            [-122.469106, 37.706105],
            [-122.468903, 37.706333],
            [-122.468809, 37.706437],
            [-122.468678, 37.706588],
            [-122.468434, 37.706903],
            [-122.468029, 37.707393],
            [-122.467923, 37.707522],
            [-122.467832, 37.707627],
            [-122.466801, 37.708779],
            [-122.466732, 37.708861],
            [-122.46667, 37.708939],
            [-122.4666, 37.709019],
            [-122.466526, 37.709095],
            [-122.466449, 37.709166],
            [-122.466376, 37.709237],
            [-122.466284, 37.709309],
            [-122.466215, 37.709364],
            [-122.466126, 37.709428],
            [-122.466028, 37.709493],
            [-122.465941, 37.709544],
            [-122.465846, 37.709608],
            [-122.465752, 37.709656],
            [-122.465664, 37.709709],
            [-122.465569, 37.709755],
            [-122.465466, 37.709801],
            [-122.465351, 37.709849],
            [-122.465245, 37.70989],
            [-122.465148, 37.709922],
            [-122.465035, 37.709958],
            [-122.464925, 37.709987],
            [-122.46481, 37.710013],
            [-122.464685, 37.710036],
            [-122.464576, 37.71006],
            [-122.464464, 37.710078],
            [-122.464349, 37.710097],
            [-122.464248, 37.710106],
            [-122.464125, 37.710117],
            [-122.464, 37.710122],
            [-122.463871, 37.710128],
            [-122.463753, 37.710132],
            [-122.463654, 37.710127],
            [-122.462673, 37.710117],
            [-122.461932, 37.710109],
            [-122.461456, 37.710106],
            [-122.461205, 37.710107],
            [-122.460612, 37.710103],
            [-122.460513, 37.710103],
            [-122.460089, 37.7101],
            [-122.459798, 37.710097],
            [-122.459371, 37.710095],
            [-122.458818, 37.710096],
            [-122.458429, 37.710097],
            [-122.458239, 37.710103],
            [-122.458046, 37.710114],
            [-122.457854, 37.710123],
            [-122.457689, 37.710132],
            [-122.457494, 37.710148],
            [-122.457301, 37.710168],
            [-122.45712, 37.710193],
            [-122.456943, 37.71022],
            [-122.456714, 37.710261],
            [-122.45647, 37.710314],
            [-122.456253, 37.710367],
            [-122.456029, 37.710421],
            [-122.455812, 37.710483],
            [-122.455588, 37.710559],
            [-122.455342, 37.710654],
            [-122.455158, 37.710734],
            [-122.454985, 37.71082],
            [-122.454815, 37.710906],
            [-122.454757, 37.710939],
            [-122.454638, 37.711002],
            [-122.454466, 37.711098],
            [-122.454306, 37.711201],
            [-122.454132, 37.711315],
            [-122.453978, 37.711421],
            [-122.453808, 37.711542],
            [-122.453514, 37.711768],
            [-122.453207, 37.712002],
            [-122.452952, 37.712213],
            [-122.452635, 37.712477],
            [-122.45215, 37.712868],
            [-122.451705, 37.713224],
            [-122.451441, 37.713439],
            [-122.451107, 37.713707],
            [-122.450884, 37.713896],
            [-122.450715, 37.714043],
            [-122.450556, 37.714184],
            [-122.450426, 37.714317],
            [-122.450264, 37.714469],
            [-122.450109, 37.714616],
            [-122.449961, 37.714764],
            [-122.449842, 37.714875],
            [-122.449687, 37.715039],
            [-122.449586, 37.715155],
            [-122.449493, 37.715256],
            [-122.449409, 37.715351],
            [-122.449317, 37.71545],
            [-122.449226, 37.715551],
            [-122.449141, 37.715654],
            [-122.449058, 37.71576],
            [-122.448989, 37.715852],
            [-122.448913, 37.715962],
            [-122.448844, 37.716072],
            [-122.448783, 37.716173],
            [-122.448722, 37.716283],
            [-122.448661, 37.716398],
            [-122.448609, 37.716502],
            [-122.448567, 37.716602],
            [-122.448514, 37.716725],
            [-122.448431, 37.716914],
            [-122.448349, 37.717127],
            [-122.448303, 37.717282],
            [-122.448233, 37.71749],
            [-122.448165, 37.717655],
            [-122.448122, 37.717956],
            [-122.448092, 37.718172],
            [-122.448092, 37.718314],
            [-122.448061, 37.718552],
            [-122.448055, 37.718621],
            [-122.448051, 37.718656],
            [-122.448034, 37.718801],
            [-122.448005, 37.719277],
            [-122.447846, 37.720179],
            [-122.447631, 37.721123],
            [-122.447624, 37.721147],
            [-122.447593, 37.721264],
            [-122.447372, 37.722221],
            [-122.447196, 37.723],
            [-122.446967, 37.723855],
            [-122.446671, 37.724539],
            [-122.446363, 37.725104],
            [-122.446308, 37.725188],
            [-122.446245, 37.72529],
            [-122.446186, 37.725395],
            [-122.44613, 37.725479],
            [-122.446059, 37.725571],
            [-122.445995, 37.725663],
            [-122.44593, 37.725755],
            [-122.445865, 37.725839],
            [-122.445526, 37.726234],
            [-122.445164, 37.726612],
            [-122.445034, 37.726729],
            [-122.444943, 37.726806],
            [-122.444845, 37.726909],
            [-122.444723, 37.727013],
            [-122.44461, 37.727109],
            [-122.444507, 37.727194],
            [-122.444392, 37.727285],
            [-122.444267, 37.727381],
            [-122.443613, 37.727828],
            [-122.443394, 37.727959],
            [-122.44319, 37.728081],
            [-122.442962, 37.728209],
            [-122.442869, 37.728256],
            [-122.442575, 37.728409],
            [-122.442264, 37.72856],
            [-122.441807, 37.728764],
            [-122.441408, 37.728925],
            [-122.440789, 37.729147],
            [-122.43985, 37.729516],
            [-122.439205, 37.72978],
            [-122.43892, 37.72988],
            [-122.438031, 37.730328],
            [-122.437495, 37.730633],
            [-122.437173, 37.730829],
            [-122.436901, 37.731003],
            [-122.43666, 37.731183],
            [-122.436385, 37.731366],
            [-122.436179, 37.731508],
            [-122.43605, 37.731595],
            [-122.435966, 37.731656],
            [-122.435706, 37.731839],
            [-122.435447, 37.732004],
            [-122.435241, 37.732136],
            [-122.435117, 37.732222],
            [-122.435026, 37.732295],
            [-122.434642, 37.732542],
            [-122.434329, 37.732752],
            [-122.433801, 37.733121],
            [-122.433405, 37.733368],
            [-122.432847, 37.733721],
            [-122.432582, 37.733918],
            [-122.431811, 37.734415],
            [-122.431274, 37.734758],
            [-122.430172, 37.735479],
            [-122.428873, 37.736323],
            [-122.427615, 37.737145],
            [-122.426334, 37.737984],
            [-122.425826, 37.738339],
            [-122.425538, 37.738547],
            [-122.425326, 37.738713],
            [-122.424999, 37.73895],
            [-122.424828, 37.739072],
            [-122.424649, 37.739215],
            [-122.424537, 37.739296],
            [-122.424351, 37.739428],
            [-122.42411, 37.739622],
            [-122.424011, 37.739738],
            [-122.423827, 37.739869],
            [-122.423179, 37.740563],
            [-122.422476, 37.741588],
            [-122.422061, 37.742264],
            [-122.420958, 37.743961],
            [-122.419834, 37.745675],
            [-122.419392, 37.746361],
            [-122.418916, 37.747089],
            [-122.418687, 37.747518],
            [-122.41859, 37.747722],
            [-122.418544, 37.747813],
            [-122.41849, 37.747912],
            [-122.418397, 37.748166],
            [-122.41836, 37.748248],
            [-122.418323, 37.748339],
            [-122.41829, 37.748442],
            [-122.418259, 37.748552],
            [-122.418218, 37.748731],
            [-122.418186, 37.748868],
            [-122.41816, 37.749093],
            [-122.418301, 37.75055],
            [-122.41844, 37.752086],
            [-122.418615, 37.753786],
            [-122.418742, 37.755411],
            [-122.4189, 37.756821],
            [-122.418962, 37.757461],
            [-122.419053, 37.758554],
            [-122.419231, 37.76021],
            [-122.419372, 37.761849],
            [-122.419543, 37.763429],
            [-122.41967, 37.764723],
            [-122.419692, 37.765024],
            [-122.419854, 37.766637],
            [-122.419892, 37.767184],
            [-122.419996, 37.768204],
            [-122.420043, 37.768923],
            [-122.420062, 37.769113],
            [-122.420119, 37.769442],
            [-122.420128, 37.769528],
            [-122.42014, 37.769621],
            [-122.420147, 37.76977],
            [-122.420152, 37.769886],
            [-122.420176, 37.770065],
            [-122.420215, 37.770362],
            [-122.420327, 37.771558],
            [-122.420316, 37.771965],
            [-122.420322, 37.772277],
            [-122.420317, 37.772531],
            [-122.420281, 37.772812],
            [-122.420153, 37.773345],
            [-122.420104, 37.773593],
            [-122.420038, 37.773762],
            [-122.419906, 37.774022],
            [-122.419471, 37.774777],
            [-122.419429, 37.774913],
            [-122.419406, 37.774983],
            [-122.419377, 37.775045],
            [-122.419321, 37.775113],
            [-122.419239, 37.775191],
            [-122.418701, 37.775596],
            [-122.417492, 37.776574],
            [-122.41652, 37.777348],
            [-122.416228, 37.77756],
            [-122.414798, 37.7787],
            [-122.412528, 37.780489],
            [-122.41145, 37.781351],
            [-122.410319, 37.782234],
            [-122.408084, 37.784002],
            [-122.405876, 37.785769],
            [-122.404718, 37.786653],
            [-122.404003, 37.787215],
            [-122.403499, 37.787631],
            [-122.402875, 37.788109],
            [-122.402102, 37.788723],
            [-122.401386, 37.789267],
            [-122.399138, 37.791042],
            [-122.398258, 37.791728],
            [-122.397415, 37.792407],
            [-122.396506, 37.793169],
            [-122.395321, 37.794057],
            [-122.394828, 37.794362],
            [-122.394659, 37.794469],
            [-122.394508, 37.79455],
            [-122.394366, 37.794631],
            [-122.394072, 37.794782],
            [-122.393814, 37.794904],
            [-122.393498, 37.79506],
            [-122.393151, 37.795219],
            [-122.392537, 37.795517],
            [-122.391751, 37.795841],
            [-122.391448, 37.795976],
            [-122.391302, 37.796041],
            [-122.390733, 37.796294],
            [-122.38985, 37.796687],
            [-122.389027, 37.797053],
            [-122.388439, 37.797315],
            [-122.387975, 37.797522],
            [-122.387476, 37.797743],
            [-122.386946, 37.797979],
            [-122.386305, 37.798265],
            [-122.385701, 37.798534],
            [-122.385193, 37.79876],
            [-122.384824, 37.798924],
            [-122.38453, 37.799055],
            [-122.384152, 37.799223],
            [-122.383849, 37.799358],
            [-122.383682, 37.799432],
            [-122.383442, 37.799539],
            [-122.383164, 37.799663],
            [-122.382839, 37.799808],
            [-122.382558, 37.799933],
            [-122.382295, 37.80005],
            [-122.381886, 37.800232],
            [-122.381553, 37.80038],
            [-122.381386, 37.800454],
            [-122.381017, 37.800618],
            [-122.380655, 37.800779],
            [-122.380293, 37.800941],
            [-122.379997, 37.801072],
            [-122.379566, 37.801264],
            [-122.379333, 37.801367],
            [-122.379061, 37.801484],
            [-122.378788, 37.801599],
            [-122.378485, 37.801723],
            [-122.378206, 37.801835],
            [-122.377961, 37.801929],
            [-122.377783, 37.801997],
            [-122.377556, 37.802081],
            [-122.377278, 37.802182],
            [-122.377102, 37.802244],
            [-122.376862, 37.802327],
            [-122.376663, 37.802394],
            [-122.37642, 37.802474],
            [-122.376049, 37.802592],
            [-122.375907, 37.802636],
            [-122.375677, 37.802705],
            [-122.375582, 37.802734],
            [-122.374975, 37.802906],
            [-122.374499, 37.803034],
            [-122.374181, 37.803113],
            [-122.373835, 37.803197],
            [-122.373325, 37.803313],
            [-122.37284, 37.803416],
            [-122.372496, 37.803485],
            [-122.37218, 37.803544],
            [-122.372018, 37.803573],
            [-122.371873, 37.803599],
            [-122.371594, 37.803647],
            [-122.37109, 37.803733],
            [-122.370628, 37.803811],
            [-122.370395, 37.80385],
            [-122.370216, 37.803881],
            [-122.370018, 37.803914],
            [-122.369691, 37.803969],
            [-122.369393, 37.80402],
            [-122.369234, 37.804047],
            [-122.368983, 37.804089],
            [-122.36873, 37.804132],
            [-122.368345, 37.804197],
            [-122.367904, 37.804272],
            [-122.367638, 37.804317],
            [-122.367375, 37.804361],
            [-122.367188, 37.804393],
            [-122.366998, 37.804425],
            [-122.366678, 37.804479],
            [-122.366367, 37.804532],
            [-122.366027, 37.804589],
            [-122.365735, 37.804639],
            [-122.365328, 37.804708],
            [-122.365107, 37.804745],
            [-122.364819, 37.804794],
            [-122.364621, 37.804827],
            [-122.364322, 37.804878],
            [-122.364022, 37.804929],
            [-122.363705, 37.804982],
            [-122.363326, 37.805046],
            [-122.363004, 37.805101],
            [-122.362666, 37.805158],
            [-122.362384, 37.805206],
            [-122.362149, 37.805246],
            [-122.361906, 37.805287],
            [-122.361806, 37.805303],
            [-122.361615, 37.805336],
            [-122.361334, 37.805383],
            [-122.361157, 37.805413],
            [-122.360916, 37.805454],
            [-122.360766, 37.805479],
            [-122.360571, 37.805512],
            [-122.360333, 37.805553],
            [-122.360139, 37.805586],
            [-122.359966, 37.805615],
            [-122.359805, 37.805642],
            [-122.359603, 37.805676],
            [-122.359438, 37.805704],
            [-122.359239, 37.805738],
            [-122.359127, 37.805757],
            [-122.358849, 37.805804],
            [-122.358639, 37.805839],
            [-122.358458, 37.80587],
            [-122.35819, 37.805915],
            [-122.358054, 37.805938],
            [-122.357891, 37.805966],
            [-122.357755, 37.805989],
            [-122.357578, 37.806019],
            [-122.357468, 37.806037],
            [-122.357171, 37.806087],
            [-122.356963, 37.806122],
            [-122.356845, 37.806143],
            [-122.35676, 37.806157],
            [-122.356589, 37.806186],
            [-122.356403, 37.806217],
            [-122.356282, 37.806238],
            [-122.356198, 37.806252],
            [-122.356066, 37.806274],
            [-122.355882, 37.806305],
            [-122.355686, 37.806339],
            [-122.355403, 37.806386],
            [-122.355272, 37.806408],
            [-122.355008, 37.806453],
            [-122.354917, 37.806468],
            [-122.35485, 37.80648],
            [-122.35476, 37.806495],
            [-122.354695, 37.806506],
            [-122.354525, 37.806535],
            [-122.354409, 37.806554],
            [-122.354325, 37.806569],
            [-122.354227, 37.806585],
            [-122.354086, 37.806609],
            [-122.354017, 37.806621],
            [-122.353947, 37.806633],
            [-122.353904, 37.80664],
            [-122.353765, 37.806663],
            [-122.353575, 37.806695],
            [-122.353343, 37.806735],
            [-122.353173, 37.806763],
            [-122.35303, 37.806788],
            [-122.352832, 37.806821],
            [-122.352675, 37.806848],
            [-122.352471, 37.806882],
            [-122.35208, 37.806948],
            [-122.351678, 37.807016],
            [-122.351343, 37.807073],
            [-122.351125, 37.80711],
            [-122.350989, 37.807133],
            [-122.350903, 37.807147],
            [-122.350826, 37.80716],
            [-122.350549, 37.807207],
            [-122.350215, 37.807264],
            [-122.349855, 37.807325],
            [-122.349491, 37.807386],
            [-122.349227, 37.807431],
            [-122.348673, 37.807524],
            [-122.34762, 37.807702],
            [-122.346954, 37.807817],
            [-122.346269, 37.807931],
            [-122.345982, 37.807981],
            [-122.345735, 37.808021],
            [-122.34529, 37.808096],
            [-122.344754, 37.808186],
            [-122.342008, 37.808651],
            [-122.341598, 37.80872],
            [-122.341341, 37.808763],
            [-122.340242, 37.808948],
            [-122.339687, 37.809041],
            [-122.339143, 37.809133],
            [-122.338773, 37.809194],
            [-122.338187, 37.809285],
            [-122.337648, 37.809363],
            [-122.337162, 37.809429],
            [-122.336553, 37.809505],
            [-122.336131, 37.809552],
            [-122.3358, 37.809588],
            [-122.335224, 37.809645],
            [-122.334668, 37.809694],
            [-122.334142, 37.809735],
            [-122.333583, 37.809772],
            [-122.33315, 37.809797],
            [-122.332755, 37.809816],
            [-122.332116, 37.809842],
            [-122.33108, 37.809866],
            [-122.330735, 37.80987],
            [-122.330014, 37.80987],
            [-122.329757, 37.809867],
            [-122.329449, 37.809862],
            [-122.32917, 37.809857],
            [-122.328638, 37.809842],
            [-122.328189, 37.809825],
            [-122.328029, 37.809818],
            [-122.327321, 37.809778],
            [-122.326497, 37.809718],
            [-122.326137, 37.809687],
            [-122.325817, 37.809649],
            [-122.323554, 37.809392],
            [-122.322814, 37.809368],
            [-122.322059, 37.809327],
            [-122.320701, 37.80925],
            [-122.320136, 37.80922],
            [-122.31951, 37.809162],
            [-122.318885, 37.809106],
            [-122.316062, 37.808815],
            [-122.315696, 37.808781],
            [-122.315482, 37.808758],
            [-122.315185, 37.808731],
            [-122.314429, 37.808664],
            [-122.312583, 37.808473],
            [-122.312057, 37.808422],
            [-122.308982, 37.808129],
            [-122.308486, 37.808084],
            [-122.308295, 37.808064],
            [-122.306411, 37.807806],
            [-122.305541, 37.807685],
            [-122.305182, 37.807598],
            [-122.30506, 37.807577],
            [-122.304526, 37.807461],
            [-122.30445, 37.807442],
            [-122.304175, 37.807385],
            [-122.303977, 37.807343],
            [-122.303794, 37.807301],
            [-122.302436, 37.806996],
            [-122.302398, 37.806989],
            [-122.298135, 37.806031],
            [-122.297836, 37.805959],
            [-122.297584, 37.805879],
            [-122.297324, 37.805794],
            [-122.297073, 37.805706],
            [-122.296836, 37.805615],
            [-122.296599, 37.805523],
            [-122.296356, 37.805421],
            [-122.296134, 37.805318],
            [-122.296096, 37.805302],
            [-122.295089, 37.804897],
            [-122.293883, 37.80441],
            [-122.29341, 37.804204],
            [-122.292579, 37.803875],
            [-122.292563, 37.803872],
            [-122.29206, 37.803669],
            [-122.291923, 37.803616],
            [-122.291747, 37.803548],
            [-122.291663, 37.803513],
            [-122.291564, 37.803468],
            [-122.291335, 37.803381],
            [-122.29132, 37.803376],
            [-122.291312, 37.803371],
            [-122.291297, 37.803365],
            [-122.291137, 37.803291],
            [-122.290946, 37.803223],
            [-122.284796, 37.801721],
            [-122.284606, 37.801668],
            [-122.284431, 37.801611],
            [-122.284095, 37.801496],
            [-122.283744, 37.801381],
            [-122.283645, 37.801347],
            [-122.283523, 37.801296],
            [-122.283386, 37.801237],
            [-122.283157, 37.801141],
            [-122.282943, 37.801045],
            [-122.282546, 37.800853],
            [-122.282294, 37.800744],
            [-122.282272, 37.800732],
            [-122.28218, 37.800693],
            [-122.281188, 37.800214],
            [-122.280051, 37.799664],
            [-122.280044, 37.79966],
            [-122.279952, 37.799607],
            [-122.279907, 37.799584],
            [-122.279716, 37.799493],
            [-122.279471, 37.799368],
            [-122.279183, 37.799217],
            [-122.278686, 37.798956],
            [-122.278478, 37.798859],
            [-122.278369, 37.798811],
            [-122.278197, 37.798746],
            [-122.278051, 37.798694],
            [-122.277819, 37.798637],
            [-122.277697, 37.798614],
            [-122.277507, 37.798583],
            [-122.277358, 37.798568],
            [-122.276984, 37.798532],
            [-122.276923, 37.798528],
            [-122.276856, 37.798527]
          ]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {OBJECTID: 21, name: 'PITT-SFIA (ROUTE 1/2)', color: '#ffe800'},
      geometry: {
        type: 'MultiLineString',
        coordinates: [
          [
            [-121.942073, 38.018937],
            [-121.942449, 38.01892],
            [-121.942633, 38.018917],
            [-121.94282, 38.018919],
            [-121.943121, 38.018915],
            [-121.943447, 38.018913],
            [-121.943743, 38.018913],
            [-121.944108, 38.018909],
            [-121.94449, 38.01891],
            [-121.944892, 38.018911],
            [-121.945267, 38.018911],
            [-121.9456, 38.018911],
            [-121.945852, 38.018909],
            [-121.946445, 38.018912],
            [-121.946981, 38.018924],
            [-121.947611, 38.018963],
            [-121.948062, 38.019005],
            [-121.948319, 38.019033],
            [-121.948534, 38.019066],
            [-121.948917, 38.019132],
            [-121.949248, 38.0192],
            [-121.949597, 38.019284],
            [-121.94979, 38.019335],
            [-121.950002, 38.019394],
            [-121.950206, 38.019454],
            [-121.950605, 38.019575],
            [-121.950798, 38.019635],
            [-121.951102, 38.019731],
            [-121.951338, 38.019803],
            [-121.95161, 38.019887],
            [-121.951874, 38.019969],
            [-121.952, 38.020008],
            [-121.952239, 38.020082],
            [-121.952554, 38.020179],
            [-121.952843, 38.020269],
            [-121.953136, 38.020357],
            [-121.953308, 38.020406],
            [-121.953643, 38.020503],
            [-121.953936, 38.020584],
            [-121.954182, 38.02065],
            [-121.954427, 38.020712],
            [-121.954624, 38.020762],
            [-121.954938, 38.020838],
            [-121.955164, 38.020892],
            [-121.9554, 38.020944],
            [-121.955637, 38.020996],
            [-121.955805, 38.021031],
            [-121.955926, 38.021057],
            [-121.956017, 38.021075],
            [-121.956428, 38.021157],
            [-121.956689, 38.021207],
            [-121.957004, 38.021266],
            [-121.95732, 38.021325],
            [-121.957584, 38.021376],
            [-121.957925, 38.021441],
            [-121.958182, 38.021489],
            [-121.958478, 38.021547],
            [-121.958713, 38.02159],
            [-121.958968, 38.021638],
            [-121.959195, 38.02168],
            [-121.959414, 38.021721],
            [-121.959704, 38.021777],
            [-121.959955, 38.021825],
            [-121.960349, 38.0219],
            [-121.960645, 38.021956],
            [-121.961001, 38.022024],
            [-121.96136, 38.022091],
            [-121.961901, 38.022194],
            [-121.962517, 38.022311],
            [-121.962991, 38.022401],
            [-121.963184, 38.022438],
            [-121.96357, 38.022509],
            [-121.963898, 38.022572],
            [-121.964273, 38.022644],
            [-121.964605, 38.022706],
            [-121.965156, 38.02281],
            [-121.965598, 38.022894],
            [-121.966146, 38.022998],
            [-121.966646, 38.023093],
            [-121.967215, 38.0232],
            [-121.967743, 38.0233],
            [-121.96817, 38.023381],
            [-121.968312, 38.023408],
            [-121.96833, 38.023412],
            [-121.968348, 38.023416],
            [-121.96836, 38.023418],
            [-121.968371, 38.02342],
            [-121.968384, 38.023422],
            [-121.968431, 38.023431],
            [-121.968606, 38.023462],
            [-121.968714, 38.023483],
            [-121.968898, 38.023518],
            [-121.969114, 38.023556],
            [-121.969264, 38.023582],
            [-121.969396, 38.023604],
            [-121.969728, 38.023657],
            [-121.970104, 38.023708],
            [-121.970512, 38.023755],
            [-121.970877, 38.02379],
            [-121.970942, 38.023793],
            [-121.971315, 38.023818],
            [-121.971738, 38.023836],
            [-121.972116, 38.023844],
            [-121.972593, 38.023843],
            [-121.972882, 38.023833],
            [-121.973374, 38.023809],
            [-121.973674, 38.023789],
            [-121.974088, 38.02375],
            [-121.974252, 38.023734],
            [-121.974485, 38.023705],
            [-121.974717, 38.023673],
            [-121.975026, 38.023627],
            [-121.975275, 38.023585],
            [-121.975607, 38.023523],
            [-121.976055, 38.023429],
            [-121.976189, 38.023397],
            [-121.976447, 38.023336],
            [-121.976794, 38.023244],
            [-121.977226, 38.02312],
            [-121.977574, 38.02301],
            [-121.978322, 38.022747],
            [-121.978744, 38.022577],
            [-121.979167, 38.022398],
            [-121.979561, 38.022228],
            [-121.979989, 38.022042],
            [-121.980224, 38.021939],
            [-121.980495, 38.021823],
            [-121.980797, 38.021691],
            [-121.981043, 38.021584],
            [-121.981329, 38.02146],
            [-121.981452, 38.021406],
            [-121.981598, 38.021343],
            [-121.98182, 38.021247],
            [-121.982059, 38.021142],
            [-121.982358, 38.021012],
            [-121.982668, 38.020878],
            [-121.982765, 38.020837],
            [-121.982911, 38.020771],
            [-121.983045, 38.020712],
            [-121.983301, 38.020603],
            [-121.983564, 38.02049],
            [-121.98378, 38.020399],
            [-121.983998, 38.020308],
            [-121.984221, 38.020212],
            [-121.984539, 38.020075],
            [-121.984759, 38.019977],
            [-121.985049, 38.019844],
            [-121.985239, 38.019761],
            [-121.985631, 38.019591],
            [-121.98587, 38.019486],
            [-121.986149, 38.019364],
            [-121.986548, 38.019193],
            [-121.986814, 38.019074],
            [-121.986944, 38.019018],
            [-121.987103, 38.018949],
            [-121.987383, 38.018825],
            [-121.987605, 38.018731],
            [-121.987787, 38.018649],
            [-121.988059, 38.018527],
            [-121.98833, 38.018402],
            [-121.988546, 38.018296],
            [-121.988731, 38.018205],
            [-121.988833, 38.018152],
            [-121.988994, 38.01807],
            [-121.989134, 38.017995],
            [-121.989373, 38.017865],
            [-121.989611, 38.017729],
            [-121.989789, 38.017623],
            [-121.990001, 38.017498],
            [-121.990232, 38.017355],
            [-121.9904, 38.017249],
            [-121.990604, 38.017119],
            [-121.990891, 38.016935],
            [-121.991101, 38.0168],
            [-121.991406, 38.016606],
            [-121.991625, 38.016471],
            [-121.991832, 38.016339],
            [-121.992061, 38.016198],
            [-121.99226, 38.016074],
            [-121.99242, 38.01597],
            [-121.992677, 38.01581],
            [-121.992931, 38.015657],
            [-121.99325, 38.015474],
            [-121.993406, 38.015387],
            [-121.993527, 38.015321],
            [-121.993695, 38.015231],
            [-121.993836, 38.015157],
            [-121.994145, 38.014999],
            [-121.994326, 38.01491],
            [-121.994522, 38.014818],
            [-121.994656, 38.014758],
            [-121.995046, 38.014586],
            [-121.995326, 38.014469],
            [-121.995546, 38.01438],
            [-121.99591, 38.014241],
            [-121.996157, 38.01415],
            [-121.996489, 38.014036],
            [-121.996811, 38.01393],
            [-121.99707, 38.013846],
            [-121.997424, 38.013739],
            [-121.997933, 38.013589],
            [-121.998366, 38.013486],
            [-121.998717, 38.013412],
            [-121.999094, 38.013332],
            [-121.99933, 38.013286],
            [-121.999656, 38.013227],
            [-121.999918, 38.013184],
            [-122.000255, 38.013132],
            [-122.000681, 38.013064],
            [-122.001179, 38.012989],
            [-122.001466, 38.012943],
            [-122.001936, 38.012871],
            [-122.002351, 38.012808],
            [-122.002858, 38.01273],
            [-122.003721, 38.012599],
            [-122.004356, 38.012501],
            [-122.004993, 38.012403],
            [-122.005781, 38.012282],
            [-122.006144, 38.012227],
            [-122.006602, 38.012159],
            [-122.007324, 38.012048],
            [-122.008053, 38.011937],
            [-122.008585, 38.011856],
            [-122.009173, 38.011766],
            [-122.009755, 38.011677],
            [-122.010711, 38.011532],
            [-122.01142, 38.011425],
            [-122.012111, 38.011321],
            [-122.012819, 38.011211],
            [-122.013204, 38.011152],
            [-122.013766, 38.011067],
            [-122.014316, 38.010984],
            [-122.014971, 38.010884],
            [-122.015295, 38.010835],
            [-122.015508, 38.010804],
            [-122.015974, 38.010733],
            [-122.016267, 38.010687],
            [-122.016695, 38.01062],
            [-122.016966, 38.010569],
            [-122.01727, 38.010498],
            [-122.017495, 38.010426],
            [-122.017728, 38.010344],
            [-122.018126, 38.010192],
            [-122.018407, 38.010064],
            [-122.018543, 38.009996],
            [-122.018649, 38.009941],
            [-122.018963, 38.009755],
            [-122.019068, 38.009691],
            [-122.019212, 38.009595],
            [-122.019342, 38.0095],
            [-122.01949, 38.009386],
            [-122.019647, 38.009251],
            [-122.019919, 38.008995],
            [-122.02003, 38.008878],
            [-122.020287, 38.008581],
            [-122.020469, 38.008361],
            [-122.020641, 38.008152],
            [-122.020727, 38.008044],
            [-122.020874, 38.007862],
            [-122.021006, 38.007698],
            [-122.021128, 38.007545],
            [-122.021212, 38.007436],
            [-122.021328, 38.007292],
            [-122.021457, 38.007135],
            [-122.021712, 38.006806],
            [-122.021812, 38.006683],
            [-122.022092, 38.006338],
            [-122.022378, 38.005996],
            [-122.022525, 38.005806],
            [-122.022894, 38.005373],
            [-122.023019, 38.005212],
            [-122.0231, 38.005107],
            [-122.02322, 38.004959],
            [-122.023369, 38.004781],
            [-122.023504, 38.004629],
            [-122.02377, 38.004309],
            [-122.023902, 38.004159],
            [-122.024144, 38.003848],
            [-122.024449, 38.003457],
            [-122.024759, 38.003083],
            [-122.025006, 38.002785],
            [-122.025391, 38.002335],
            [-122.025883, 38.001722],
            [-122.026355, 38.001156],
            [-122.026752, 38.000666],
            [-122.02711, 38.000188],
            [-122.027332, 37.999882],
            [-122.027812, 37.999224],
            [-122.028239, 37.998637],
            [-122.028478, 37.99831],
            [-122.028674, 37.998043],
            [-122.028856, 37.997791],
            [-122.029139, 37.997397],
            [-122.02948, 37.996925],
            [-122.029684, 37.996642],
            [-122.029926, 37.996302],
            [-122.030118, 37.996029],
            [-122.030299, 37.995784],
            [-122.030406, 37.995633],
            [-122.030454, 37.995568],
            [-122.030556, 37.995433],
            [-122.030663, 37.995291],
            [-122.030729, 37.995194],
            [-122.030811, 37.995078],
            [-122.031045, 37.994757],
            [-122.031277, 37.994439],
            [-122.031429, 37.994227],
            [-122.031513, 37.994114],
            [-122.031621, 37.993966],
            [-122.031827, 37.993685],
            [-122.031997, 37.99345],
            [-122.032141, 37.99325],
            [-122.032285, 37.993048],
            [-122.032442, 37.992816],
            [-122.032583, 37.992598],
            [-122.032652, 37.992485],
            [-122.032726, 37.992358],
            [-122.032846, 37.992139],
            [-122.032926, 37.991986],
            [-122.033011, 37.991807],
            [-122.033088, 37.991637],
            [-122.033156, 37.99147],
            [-122.033223, 37.991295],
            [-122.033284, 37.991123],
            [-122.033344, 37.990938],
            [-122.033396, 37.990756],
            [-122.033422, 37.990656],
            [-122.033454, 37.990521],
            [-122.033503, 37.990288],
            [-122.033543, 37.990063],
            [-122.033572, 37.989836],
            [-122.033576, 37.989801],
            [-122.033594, 37.989496],
            [-122.033606, 37.9893],
            [-122.033608, 37.989183],
            [-122.03361, 37.989022],
            [-122.033606, 37.988848],
            [-122.033596, 37.988684],
            [-122.033583, 37.988529],
            [-122.033567, 37.988374],
            [-122.033544, 37.988195],
            [-122.033524, 37.988076],
            [-122.033494, 37.987894],
            [-122.033465, 37.987749],
            [-122.033406, 37.987515],
            [-122.033336, 37.987262],
            [-122.033277, 37.987087],
            [-122.033176, 37.986795],
            [-122.033066, 37.986501],
            [-122.032884, 37.986057],
            [-122.032782, 37.985814],
            [-122.032673, 37.985558],
            [-122.032566, 37.985305],
            [-122.032466, 37.985074],
            [-122.032339, 37.984774],
            [-122.032246, 37.984552],
            [-122.032128, 37.984277],
            [-122.032074, 37.984151],
            [-122.031941, 37.983837],
            [-122.031813, 37.983541],
            [-122.0317, 37.983267],
            [-122.031642, 37.983134],
            [-122.03159, 37.983009],
            [-122.031521, 37.982852],
            [-122.031437, 37.982651],
            [-122.031284, 37.982289],
            [-122.031154, 37.981975],
            [-122.03108, 37.981803],
            [-122.031004, 37.981624],
            [-122.03087, 37.981305],
            [-122.030754, 37.981029],
            [-122.03063, 37.980742],
            [-122.030506, 37.980451],
            [-122.030448, 37.980322],
            [-122.030372, 37.980158],
            [-122.030297, 37.979999],
            [-122.030255, 37.979918],
            [-122.030232, 37.97987],
            [-122.030155, 37.97973],
            [-122.030078, 37.979592],
            [-122.029968, 37.979416],
            [-122.029916, 37.979332],
            [-122.029858, 37.979243],
            [-122.029822, 37.979191],
            [-122.029779, 37.979128],
            [-122.029734, 37.979063],
            [-122.029696, 37.979011],
            [-122.029613, 37.978894],
            [-122.029577, 37.978846],
            [-122.029555, 37.978813],
            [-122.029516, 37.978762],
            [-122.029494, 37.978732],
            [-122.029475, 37.978706],
            [-122.02945, 37.978672],
            [-122.02943, 37.978644],
            [-122.029413, 37.978621],
            [-122.029398, 37.978603],
            [-122.029381, 37.978579],
            [-122.029296, 37.978464],
            [-122.029225, 37.97837],
            [-122.029165, 37.978289],
            [-122.029068, 37.978157],
            [-122.029045, 37.978128],
            [-122.029019, 37.97809],
            [-122.029009, 37.978077],
            [-122.028998, 37.978065],
            [-122.028982, 37.978042],
            [-122.028967, 37.978024],
            [-122.028956, 37.978007],
            [-122.028936, 37.977978],
            [-122.028902, 37.97793],
            [-122.028862, 37.977876],
            [-122.028819, 37.977812],
            [-122.02878, 37.977756],
            [-122.028722, 37.977667],
            [-122.028649, 37.977548],
            [-122.02862, 37.977497],
            [-122.028565, 37.977386],
            [-122.028527, 37.977311],
            [-122.028499, 37.977249],
            [-122.028458, 37.977152],
            [-122.028427, 37.977059],
            [-122.028385, 37.976924],
            [-122.028361, 37.976832],
            [-122.028332, 37.976699],
            [-122.028315, 37.976598],
            [-122.028302, 37.976504],
            [-122.028289, 37.976372],
            [-122.028281, 37.976257],
            [-122.028273, 37.976102],
            [-122.028277, 37.97599],
            [-122.028282, 37.975917],
            [-122.028297, 37.975822],
            [-122.028317, 37.975692],
            [-122.028363, 37.975495],
            [-122.028398, 37.97538],
            [-122.028425, 37.975301],
            [-122.028437, 37.975263],
            [-122.028455, 37.975212],
            [-122.028476, 37.975155],
            [-122.028485, 37.97513],
            [-122.028501, 37.975094],
            [-122.028507, 37.975079],
            [-122.028514, 37.975066],
            [-122.028526, 37.975037],
            [-122.028535, 37.975017],
            [-122.028543, 37.974995],
            [-122.02855, 37.974971],
            [-122.028561, 37.974941],
            [-122.02859, 37.974878],
            [-122.028669, 37.974696],
            [-122.028749, 37.974538],
            [-122.028823, 37.974372],
            [-122.028913, 37.974168],
            [-122.028976, 37.974023],
            [-122.02905, 37.973841],
            [-122.029177, 37.973532],
            [-122.029447, 37.972906],
            [-122.029506, 37.972792],
            [-122.029548, 37.972709],
            [-122.029641, 37.972496],
            [-122.029753, 37.97223],
            [-122.029834, 37.97204],
            [-122.029901, 37.97189],
            [-122.030006, 37.971655],
            [-122.030049, 37.971567],
            [-122.030071, 37.971525],
            [-122.030117, 37.971418],
            [-122.030184, 37.971265],
            [-122.030245, 37.971121],
            [-122.030273, 37.97105],
            [-122.030301, 37.970982],
            [-122.03034, 37.970893],
            [-122.030397, 37.970764],
            [-122.030466, 37.970607],
            [-122.0305, 37.97052],
            [-122.030517, 37.970481],
            [-122.030544, 37.970415],
            [-122.030564, 37.970373],
            [-122.030596, 37.970301],
            [-122.030645, 37.970173],
            [-122.030681, 37.970087],
            [-122.030705, 37.970022],
            [-122.030757, 37.969912],
            [-122.030799, 37.96981],
            [-122.030852, 37.96967],
            [-122.030892, 37.969562],
            [-122.030944, 37.969422],
            [-122.030996, 37.969283],
            [-122.031036, 37.969181],
            [-122.031057, 37.969118],
            [-122.031085, 37.969033],
            [-122.031093, 37.969004],
            [-122.031105, 37.968969],
            [-122.031114, 37.968943],
            [-122.031119, 37.968926],
            [-122.031126, 37.968905],
            [-122.031132, 37.968882],
            [-122.031142, 37.968849],
            [-122.031156, 37.968801],
            [-122.03117, 37.968755],
            [-122.031174, 37.968743],
            [-122.031183, 37.968707],
            [-122.031191, 37.968675],
            [-122.031212, 37.968598],
            [-122.03122, 37.968569],
            [-122.031227, 37.96854],
            [-122.031233, 37.968514],
            [-122.03124, 37.96849],
            [-122.031245, 37.968472],
            [-122.031251, 37.968445],
            [-122.031255, 37.968426],
            [-122.03126, 37.968402],
            [-122.031266, 37.968378],
            [-122.031271, 37.968353],
            [-122.031276, 37.968327],
            [-122.031282, 37.968292],
            [-122.031289, 37.968263],
            [-122.031293, 37.968242],
            [-122.031297, 37.96822],
            [-122.031301, 37.968197],
            [-122.031305, 37.968176],
            [-122.03131, 37.968152],
            [-122.031314, 37.968129],
            [-122.031317, 37.96811],
            [-122.031321, 37.968089],
            [-122.031324, 37.968076],
            [-122.031327, 37.968062],
            [-122.031329, 37.96805],
            [-122.031332, 37.968032],
            [-122.031335, 37.96801],
            [-122.031338, 37.967993],
            [-122.031343, 37.967961],
            [-122.031347, 37.96793],
            [-122.031349, 37.967915],
            [-122.031352, 37.967891],
            [-122.031354, 37.967873],
            [-122.031357, 37.967853],
            [-122.031359, 37.967838],
            [-122.03136, 37.967826],
            [-122.031363, 37.967805],
            [-122.031366, 37.967786],
            [-122.031368, 37.967767],
            [-122.031369, 37.967751],
            [-122.031373, 37.967724],
            [-122.031375, 37.967707],
            [-122.031377, 37.96769],
            [-122.031379, 37.967666],
            [-122.031382, 37.967642],
            [-122.031384, 37.967621],
            [-122.031386, 37.967602],
            [-122.031388, 37.967588],
            [-122.03139, 37.967566],
            [-122.031391, 37.967545],
            [-122.031393, 37.967525],
            [-122.031395, 37.967502],
            [-122.031397, 37.96748],
            [-122.031399, 37.967463],
            [-122.031401, 37.967436],
            [-122.031404, 37.967403],
            [-122.031406, 37.967362],
            [-122.031408, 37.967328],
            [-122.03141, 37.967292],
            [-122.031412, 37.967258],
            [-122.031414, 37.967214],
            [-122.031415, 37.967187],
            [-122.031416, 37.967168],
            [-122.031417, 37.967141],
            [-122.031418, 37.967096],
            [-122.031421, 37.967005],
            [-122.031421, 37.966932],
            [-122.031422, 37.96688],
            [-122.031422, 37.966844],
            [-122.031422, 37.966818],
            [-122.031421, 37.966793],
            [-122.03142, 37.966776],
            [-122.031419, 37.966742],
            [-122.031418, 37.966715],
            [-122.031418, 37.966673],
            [-122.031416, 37.966641],
            [-122.031414, 37.966595],
            [-122.031411, 37.966552],
            [-122.031407, 37.966459],
            [-122.031404, 37.966417],
            [-122.031401, 37.966357],
            [-122.031396, 37.966288],
            [-122.03139, 37.966219],
            [-122.031383, 37.966143],
            [-122.031373, 37.966073],
            [-122.031366, 37.96601],
            [-122.031357, 37.965943],
            [-122.031351, 37.965904],
            [-122.031346, 37.965868],
            [-122.03134, 37.965837],
            [-122.031336, 37.965808],
            [-122.031326, 37.965747],
            [-122.031304, 37.965629],
            [-122.031285, 37.965546],
            [-122.03128, 37.965518],
            [-122.03127, 37.965474],
            [-122.03125, 37.965388],
            [-122.031209, 37.965223],
            [-122.031178, 37.965118],
            [-122.031139, 37.964994],
            [-122.0311, 37.964873],
            [-122.031052, 37.964731],
            [-122.030978, 37.964522],
            [-122.030912, 37.964355],
            [-122.030833, 37.964146],
            [-122.030788, 37.964035],
            [-122.030745, 37.963927],
            [-122.030729, 37.963886],
            [-122.030703, 37.96382],
            [-122.030657, 37.96371],
            [-122.030575, 37.963524],
            [-122.030531, 37.96341],
            [-122.030474, 37.963254],
            [-122.030417, 37.963108],
            [-122.030371, 37.96299],
            [-122.030313, 37.962844],
            [-122.030234, 37.962649],
            [-122.030175, 37.962502],
            [-122.030122, 37.962367],
            [-122.030044, 37.962167],
            [-122.029973, 37.961995],
            [-122.029899, 37.961811],
            [-122.029821, 37.961613],
            [-122.029687, 37.961274],
            [-122.029537, 37.960899],
            [-122.029496, 37.960799],
            [-122.029292, 37.96029],
            [-122.029097, 37.959802],
            [-122.028931, 37.959381],
            [-122.028776, 37.959001],
            [-122.028643, 37.958666],
            [-122.028194, 37.957541],
            [-122.027773, 37.956486],
            [-122.027168, 37.95498],
            [-122.026893, 37.954328],
            [-122.026552, 37.953546],
            [-122.026283, 37.952933],
            [-122.026082, 37.952465],
            [-122.025991, 37.952245],
            [-122.025824, 37.951824],
            [-122.025655, 37.951438],
            [-122.025597, 37.951264],
            [-122.025457, 37.950904],
            [-122.02532, 37.950553],
            [-122.025247, 37.950361],
            [-122.025161, 37.950118],
            [-122.025134, 37.950042],
            [-122.025078, 37.949857],
            [-122.025008, 37.94961],
            [-122.024986, 37.949495],
            [-122.024956, 37.949362],
            [-122.024921, 37.94917],
            [-122.024889, 37.948918],
            [-122.024875, 37.948681],
            [-122.024868, 37.948419],
            [-122.024876, 37.948247],
            [-122.024882, 37.948137],
            [-122.024891, 37.948034],
            [-122.024915, 37.947829],
            [-122.024956, 37.947611],
            [-122.024996, 37.947429],
            [-122.025018, 37.947326],
            [-122.025064, 37.947173],
            [-122.025117, 37.947005],
            [-122.025205, 37.946765],
            [-122.02538, 37.946375],
            [-122.025441, 37.946257],
            [-122.025523, 37.94611],
            [-122.025604, 37.945977],
            [-122.025727, 37.945789],
            [-122.025847, 37.945617],
            [-122.026003, 37.945413],
            [-122.026147, 37.945243],
            [-122.026314, 37.945063],
            [-122.026501, 37.944873],
            [-122.026633, 37.944749],
            [-122.02667, 37.944717],
            [-122.026777, 37.944622],
            [-122.027002, 37.94444],
            [-122.027186, 37.9443],
            [-122.027358, 37.944178],
            [-122.027635, 37.943997],
            [-122.027835, 37.943876],
            [-122.028005, 37.943777],
            [-122.028411, 37.943553],
            [-122.028725, 37.943386],
            [-122.029026, 37.94323],
            [-122.02917, 37.943155],
            [-122.029623, 37.942923],
            [-122.029932, 37.942764],
            [-122.030779, 37.942327],
            [-122.031436, 37.941989],
            [-122.032056, 37.941668],
            [-122.0329, 37.941234],
            [-122.033731, 37.940806],
            [-122.034252, 37.940538],
            [-122.034962, 37.940173],
            [-122.035604, 37.939842],
            [-122.03631, 37.939478],
            [-122.037001, 37.939123],
            [-122.037792, 37.938716],
            [-122.038461, 37.93837],
            [-122.039014, 37.938086],
            [-122.039425, 37.937874],
            [-122.04021, 37.93747],
            [-122.040958, 37.937085],
            [-122.041682, 37.936713],
            [-122.042314, 37.936386],
            [-122.043008, 37.936028],
            [-122.043736, 37.935653],
            [-122.04448, 37.935271],
            [-122.045119, 37.934941],
            [-122.045894, 37.934541],
            [-122.046614, 37.93417],
            [-122.046874, 37.934035],
            [-122.04711, 37.933915],
            [-122.047342, 37.933796],
            [-122.047998, 37.933456],
            [-122.048771, 37.933055],
            [-122.049464, 37.932703],
            [-122.050202, 37.93232],
            [-122.050837, 37.931991],
            [-122.05118, 37.931818],
            [-122.051502, 37.931646],
            [-122.051814, 37.931467],
            [-122.052129, 37.931285],
            [-122.05244, 37.931096],
            [-122.052729, 37.930911],
            [-122.053008, 37.930724],
            [-122.053296, 37.93052],
            [-122.05357, 37.93032],
            [-122.053868, 37.930092],
            [-122.054121, 37.929895],
            [-122.054361, 37.929705],
            [-122.054593, 37.929521],
            [-122.055089, 37.929129],
            [-122.055619, 37.928707],
            [-122.056244, 37.928208],
            [-122.05647, 37.928033],
            [-122.056722, 37.927837],
            [-122.057279, 37.927393],
            [-122.057696, 37.927061],
            [-122.057855, 37.926933],
            [-122.05804, 37.92678],
            [-122.058216, 37.926635],
            [-122.058403, 37.926469],
            [-122.058554, 37.926333],
            [-122.058817, 37.926078],
            [-122.059009, 37.925877],
            [-122.059179, 37.925686],
            [-122.059314, 37.925523],
            [-122.059395, 37.925421],
            [-122.059477, 37.925312],
            [-122.059556, 37.925203],
            [-122.05962, 37.925112],
            [-122.059743, 37.924921],
            [-122.059868, 37.924717],
            [-122.059981, 37.92451],
            [-122.060046, 37.924384],
            [-122.060111, 37.924247],
            [-122.060178, 37.924106],
            [-122.060236, 37.923973],
            [-122.060295, 37.923831],
            [-122.060358, 37.923674],
            [-122.060454, 37.923416],
            [-122.060536, 37.92319],
            [-122.060644, 37.922884],
            [-122.06078, 37.922499],
            [-122.060897, 37.92216],
            [-122.060987, 37.921901],
            [-122.061017, 37.921815],
            [-122.061041, 37.921745],
            [-122.061071, 37.921666],
            [-122.061195, 37.921303],
            [-122.061333, 37.920914],
            [-122.061504, 37.920448],
            [-122.061695, 37.919982],
            [-122.061817, 37.919706],
            [-122.061928, 37.919469],
            [-122.062064, 37.919196],
            [-122.062192, 37.918943],
            [-122.062299, 37.918736],
            [-122.062327, 37.918687],
            [-122.062471, 37.918407],
            [-122.062555, 37.918243],
            [-122.062633, 37.918086],
            [-122.062708, 37.917938],
            [-122.062784, 37.91778],
            [-122.062855, 37.917628],
            [-122.062926, 37.917467],
            [-122.062988, 37.917323],
            [-122.063052, 37.917164],
            [-122.063109, 37.917009],
            [-122.063168, 37.916848],
            [-122.063221, 37.916687],
            [-122.063271, 37.916535],
            [-122.06335, 37.916259],
            [-122.06344, 37.915883],
            [-122.063484, 37.915677],
            [-122.063517, 37.915499],
            [-122.063579, 37.91509],
            [-122.063642, 37.914584],
            [-122.063711, 37.913988],
            [-122.063759, 37.913583],
            [-122.06382, 37.91308],
            [-122.063873, 37.91274],
            [-122.063904, 37.912556],
            [-122.063959, 37.91229],
            [-122.064019, 37.912056],
            [-122.064078, 37.911834],
            [-122.064133, 37.911658],
            [-122.064186, 37.911493],
            [-122.064231, 37.911363],
            [-122.064281, 37.911226],
            [-122.064362, 37.911021],
            [-122.064456, 37.910802],
            [-122.064548, 37.910601],
            [-122.064633, 37.910421],
            [-122.064704, 37.910279],
            [-122.064781, 37.910128],
            [-122.064867, 37.90997],
            [-122.064951, 37.909823],
            [-122.065061, 37.909621],
            [-122.065168, 37.909435],
            [-122.065297, 37.909212],
            [-122.065406, 37.909031],
            [-122.065497, 37.908876],
            [-122.065705, 37.908513],
            [-122.065934, 37.908128],
            [-122.066039, 37.907949],
            [-122.066252, 37.907593],
            [-122.066313, 37.90749],
            [-122.066378, 37.90738],
            [-122.066518, 37.907146],
            [-122.066837, 37.906625],
            [-122.067124, 37.906142],
            [-122.067453, 37.905586],
            [-122.06768, 37.905209],
            [-122.06785, 37.904925],
            [-122.067963, 37.904732],
            [-122.068106, 37.90449],
            [-122.068172, 37.904377],
            [-122.06837, 37.90404],
            [-122.068521, 37.903785],
            [-122.068696, 37.903488],
            [-122.068846, 37.903233],
            [-122.069023, 37.902935],
            [-122.069233, 37.902581],
            [-122.069374, 37.902342],
            [-122.069546, 37.90206],
            [-122.069745, 37.901742],
            [-122.069955, 37.901435],
            [-122.070226, 37.901058],
            [-122.070387, 37.900856],
            [-122.070531, 37.900686],
            [-122.070698, 37.900507],
            [-122.070853, 37.900347],
            [-122.07097, 37.90023],
            [-122.071092, 37.900117],
            [-122.071225, 37.899993],
            [-122.07137, 37.899868],
            [-122.071467, 37.899781],
            [-122.071596, 37.899679],
            [-122.071826, 37.899498],
            [-122.072064, 37.899326],
            [-122.072297, 37.899169],
            [-122.072422, 37.899091],
            [-122.072551, 37.899008],
            [-122.072811, 37.898856],
            [-122.072935, 37.898786],
            [-122.07307, 37.898712],
            [-122.073338, 37.898578],
            [-122.073473, 37.898513],
            [-122.073625, 37.898447],
            [-122.073896, 37.898319],
            [-122.074181, 37.898201],
            [-122.074426, 37.898107],
            [-122.07464, 37.898032],
            [-122.074892, 37.897949],
            [-122.075117, 37.89788],
            [-122.075421, 37.897795],
            [-122.075666, 37.897735],
            [-122.075937, 37.897674],
            [-122.076224, 37.897615],
            [-122.076442, 37.897576],
            [-122.076568, 37.897555],
            [-122.076814, 37.897519],
            [-122.077104, 37.897482],
            [-122.077399, 37.897452],
            [-122.077705, 37.897429],
            [-122.077981, 37.897416],
            [-122.078272, 37.897409],
            [-122.078572, 37.897406],
            [-122.078865, 37.897412],
            [-122.079159, 37.89743],
            [-122.079336, 37.897433],
            [-122.07943, 37.89744],
            [-122.079926, 37.897488],
            [-122.080699, 37.897578],
            [-122.081421, 37.897673],
            [-122.083043, 37.897865],
            [-122.083481, 37.897906],
            [-122.083709, 37.897931],
            [-122.083917, 37.897949],
            [-122.08412, 37.897966],
            [-122.084325, 37.897983],
            [-122.084931, 37.898011],
            [-122.085042, 37.898017],
            [-122.085254, 37.898012],
            [-122.08556, 37.898012],
            [-122.08585, 37.89801],
            [-122.086564, 37.897997],
            [-122.087033, 37.897984],
            [-122.08768, 37.897964],
            [-122.08832, 37.897946],
            [-122.088961, 37.897927],
            [-122.089679, 37.897907],
            [-122.090239, 37.89789],
            [-122.09084, 37.897871],
            [-122.091431, 37.897855],
            [-122.091908, 37.897842],
            [-122.092559, 37.897824],
            [-122.093164, 37.897805],
            [-122.093314, 37.8978],
            [-122.093488, 37.897795],
            [-122.093626, 37.897791],
            [-122.094135, 37.897777],
            [-122.094551, 37.897764],
            [-122.095063, 37.89775],
            [-122.095476, 37.897737],
            [-122.095941, 37.897724],
            [-122.09632, 37.897713],
            [-122.096785, 37.897698],
            [-122.097061, 37.897686],
            [-122.097323, 37.897674],
            [-122.09755, 37.897661],
            [-122.097964, 37.897631],
            [-122.098179, 37.897614],
            [-122.098377, 37.897595],
            [-122.098681, 37.897566],
            [-122.099021, 37.897527],
            [-122.099365, 37.897483],
            [-122.099709, 37.897435],
            [-122.10006, 37.897382],
            [-122.10031, 37.897343],
            [-122.100744, 37.897273],
            [-122.101295, 37.897183],
            [-122.101782, 37.897103],
            [-122.102573, 37.896973],
            [-122.103007, 37.896902],
            [-122.103468, 37.896827],
            [-122.104145, 37.896717],
            [-122.104747, 37.896618],
            [-122.105289, 37.89653],
            [-122.105754, 37.896454],
            [-122.106463, 37.896337],
            [-122.106742, 37.896291],
            [-122.107287, 37.896201],
            [-122.107736, 37.896128],
            [-122.108122, 37.896064],
            [-122.108822, 37.89595],
            [-122.109287, 37.895875],
            [-122.110045, 37.89575],
            [-122.110363, 37.895698],
            [-122.110735, 37.895635],
            [-122.111323, 37.895541],
            [-122.111839, 37.895457],
            [-122.112545, 37.895345],
            [-122.112906, 37.89529],
            [-122.113536, 37.895201],
            [-122.113836, 37.895153],
            [-122.115183, 37.894937],
            [-122.116589, 37.894701],
            [-122.117119, 37.894617],
            [-122.117675, 37.894523],
            [-122.118452, 37.894397],
            [-122.119625, 37.894206],
            [-122.120367, 37.89409],
            [-122.120872, 37.894005],
            [-122.121193, 37.893954],
            [-122.121403, 37.893915],
            [-122.121903, 37.89383],
            [-122.122213, 37.893769],
            [-122.122628, 37.893677],
            [-122.122909, 37.893606],
            [-122.123403, 37.893484],
            [-122.124118, 37.893311],
            [-122.12495, 37.893104],
            [-122.125285, 37.893019],
            [-122.125808, 37.892903],
            [-122.126042, 37.892839],
            [-122.126427, 37.892744],
            [-122.127333, 37.892528],
            [-122.127831, 37.892398],
            [-122.128357, 37.892274],
            [-122.128562, 37.892222],
            [-122.128766, 37.892165],
            [-122.129335, 37.892021],
            [-122.129545, 37.891966],
            [-122.129806, 37.891897],
            [-122.130207, 37.891793],
            [-122.130382, 37.89175],
            [-122.131627, 37.891443],
            [-122.132914, 37.891131],
            [-122.133472, 37.890998],
            [-122.133882, 37.890906],
            [-122.134253, 37.890829],
            [-122.134444, 37.890794],
            [-122.13467, 37.890756],
            [-122.134915, 37.890719],
            [-122.135158, 37.890689],
            [-122.135349, 37.89067],
            [-122.135582, 37.89065],
            [-122.135962, 37.890629],
            [-122.136245, 37.890623],
            [-122.136644, 37.890627],
            [-122.137026, 37.890646],
            [-122.137212, 37.890659],
            [-122.137401, 37.890675],
            [-122.13773, 37.890712],
            [-122.137928, 37.890737],
            [-122.138236, 37.890783],
            [-122.138664, 37.890853],
            [-122.139894, 37.891076],
            [-122.140433, 37.891173],
            [-122.141124, 37.891287],
            [-122.141428, 37.89133],
            [-122.141695, 37.891364],
            [-122.142026, 37.8914],
            [-122.142256, 37.89142],
            [-122.142363, 37.891428],
            [-122.142603, 37.891441],
            [-122.142884, 37.891453],
            [-122.143173, 37.891458],
            [-122.143432, 37.891456],
            [-122.143614, 37.891455],
            [-122.143783, 37.891449],
            [-122.144097, 37.891434],
            [-122.14452, 37.891406],
            [-122.145264, 37.891339],
            [-122.145699, 37.8913],
            [-122.146021, 37.89127],
            [-122.146321, 37.891245],
            [-122.146627, 37.891222],
            [-122.146881, 37.891205],
            [-122.147078, 37.891194],
            [-122.147274, 37.891186],
            [-122.147564, 37.891178],
            [-122.147984, 37.891177],
            [-122.148174, 37.89118],
            [-122.148425, 37.89119],
            [-122.148708, 37.891205],
            [-122.149008, 37.891228],
            [-122.149326, 37.89126],
            [-122.149509, 37.891281],
            [-122.149724, 37.891307],
            [-122.149939, 37.891335],
            [-122.150395, 37.8914],
            [-122.150773, 37.891456],
            [-122.152034, 37.891647],
            [-122.153092, 37.891808],
            [-122.153961, 37.89194],
            [-122.15428, 37.891987],
            [-122.154442, 37.892011],
            [-122.154684, 37.892048],
            [-122.156106, 37.892264],
            [-122.156886, 37.892382],
            [-122.157639, 37.892495],
            [-122.158295, 37.892597],
            [-122.158883, 37.892685],
            [-122.159525, 37.892771],
            [-122.160152, 37.892842],
            [-122.160362, 37.892863],
            [-122.160584, 37.892883],
            [-122.160983, 37.892914],
            [-122.161209, 37.892928],
            [-122.161427, 37.892941],
            [-122.161788, 37.892956],
            [-122.16202, 37.892966],
            [-122.162237, 37.892971],
            [-122.162843, 37.892977],
            [-122.163443, 37.892969],
            [-122.163803, 37.892959],
            [-122.163997, 37.89295],
            [-122.164168, 37.892941],
            [-122.164748, 37.892906],
            [-122.164954, 37.892889],
            [-122.165192, 37.892869],
            [-122.165395, 37.892848],
            [-122.165963, 37.892787],
            [-122.166357, 37.892737],
            [-122.16679, 37.892673],
            [-122.167103, 37.892625],
            [-122.167703, 37.892517],
            [-122.168181, 37.892423],
            [-122.168619, 37.892326],
            [-122.169012, 37.892231],
            [-122.169292, 37.892162],
            [-122.169577, 37.892085],
            [-122.170122, 37.891931],
            [-122.170348, 37.891863],
            [-122.170679, 37.89176],
            [-122.170928, 37.891676],
            [-122.171169, 37.891598],
            [-122.171346, 37.891532],
            [-122.171523, 37.891469],
            [-122.17171, 37.8914],
            [-122.17207, 37.891259],
            [-122.17235, 37.891142],
            [-122.172659, 37.891005],
            [-122.172857, 37.890914],
            [-122.172967, 37.890863],
            [-122.173243, 37.890727],
            [-122.173438, 37.890625],
            [-122.173613, 37.890532],
            [-122.173756, 37.890453],
            [-122.173961, 37.890337],
            [-122.174309, 37.890128],
            [-122.17455, 37.889975],
            [-122.174793, 37.889815],
            [-122.175003, 37.889669],
            [-122.17512, 37.889586],
            [-122.175233, 37.889504],
            [-122.175375, 37.889397],
            [-122.175491, 37.889308],
            [-122.175728, 37.889122],
            [-122.175947, 37.888936],
            [-122.176169, 37.88874],
            [-122.176403, 37.888529],
            [-122.176594, 37.888345],
            [-122.176726, 37.888213],
            [-122.177005, 37.88792],
            [-122.177185, 37.887721],
            [-122.177404, 37.887464],
            [-122.17751, 37.887334],
            [-122.177607, 37.887212],
            [-122.177831, 37.886916],
            [-122.177958, 37.886737],
            [-122.178057, 37.886592],
            [-122.178133, 37.886478],
            [-122.178166, 37.886428],
            [-122.178221, 37.886328],
            [-122.178249, 37.886286],
            [-122.178282, 37.886231],
            [-122.178491, 37.885903],
            [-122.178658, 37.885629],
            [-122.178805, 37.885391],
            [-122.178936, 37.885179],
            [-122.179086, 37.884933],
            [-122.179286, 37.884618],
            [-122.179609, 37.884089],
            [-122.179896, 37.88362],
            [-122.180111, 37.883276],
            [-122.180331, 37.882937],
            [-122.18064, 37.882486],
            [-122.180931, 37.882091],
            [-122.18106, 37.881908],
            [-122.181226, 37.881703],
            [-122.181584, 37.881226],
            [-122.181925, 37.880777],
            [-122.182287, 37.880304],
            [-122.18262, 37.879865],
            [-122.183026, 37.879327],
            [-122.18341, 37.878845],
            [-122.183629, 37.878562],
            [-122.183821, 37.878329],
            [-122.184077, 37.878018],
            [-122.184302, 37.877691],
            [-122.184466, 37.877463],
            [-122.184618, 37.877259],
            [-122.184736, 37.877106],
            [-122.184881, 37.876927],
            [-122.185022, 37.876763],
            [-122.185167, 37.876611],
            [-122.185308, 37.876457],
            [-122.18547, 37.876306],
            [-122.185633, 37.876164],
            [-122.185768, 37.87604],
            [-122.185975, 37.875879],
            [-122.186184, 37.875725],
            [-122.186388, 37.875574],
            [-122.186626, 37.875423],
            [-122.187309, 37.874958],
            [-122.187429, 37.874876],
            [-122.187586, 37.874776],
            [-122.187872, 37.874583],
            [-122.18847, 37.874243],
            [-122.189997, 37.873426],
            [-122.193628, 37.871592],
            [-122.194625, 37.871135],
            [-122.196606, 37.870307],
            [-122.200967, 37.868313],
            [-122.202143, 37.867772],
            [-122.202946, 37.867403],
            [-122.203586, 37.867107],
            [-122.204374, 37.866714],
            [-122.205596, 37.866208],
            [-122.206474, 37.865838],
            [-122.207471, 37.86537],
            [-122.208153, 37.86506],
            [-122.208629, 37.864843],
            [-122.209415, 37.864488],
            [-122.209843, 37.864253],
            [-122.21151, 37.863523],
            [-122.213367, 37.862676],
            [-122.214723, 37.861989],
            [-122.216104, 37.861378],
            [-122.217319, 37.860864],
            [-122.217962, 37.860569],
            [-122.218938, 37.860135],
            [-122.219915, 37.859701],
            [-122.221355, 37.859134],
            [-122.238479, 37.85134],
            [-122.239586, 37.850655],
            [-122.240056, 37.850393],
            [-122.24046, 37.850169],
            [-122.240901, 37.849925],
            [-122.241351, 37.849656],
            [-122.241571, 37.849537],
            [-122.241747, 37.849444],
            [-122.241906, 37.849356],
            [-122.242039, 37.84928],
            [-122.242168, 37.849198],
            [-122.24231, 37.849119],
            [-122.242393, 37.849075],
            [-122.24309, 37.848686],
            [-122.244161, 37.848091],
            [-122.244611, 37.847838],
            [-122.245911, 37.847108],
            [-122.246404, 37.846842],
            [-122.24683, 37.846623],
            [-122.247307, 37.846394],
            [-122.247714, 37.846214],
            [-122.248267, 37.845983],
            [-122.248551, 37.845869],
            [-122.250023, 37.845295],
            [-122.251032, 37.844906],
            [-122.25165, 37.844656],
            [-122.251927, 37.84455],
            [-122.252371, 37.84438],
            [-122.252694, 37.844257],
            [-122.253644, 37.843886],
            [-122.254002, 37.843748],
            [-122.254171, 37.843683],
            [-122.254359, 37.843613],
            [-122.254953, 37.843397],
            [-122.255366, 37.843258],
            [-122.25581, 37.843113],
            [-122.256061, 37.843031],
            [-122.256377, 37.842936],
            [-122.256568, 37.842878],
            [-122.256817, 37.842799],
            [-122.257179, 37.842685],
            [-122.257785, 37.842494],
            [-122.258124, 37.842388],
            [-122.258415, 37.8423],
            [-122.261228, 37.841409],
            [-122.261533, 37.841308],
            [-122.26165, 37.841266],
            [-122.261805, 37.841212],
            [-122.262011, 37.841133],
            [-122.262221, 37.841049],
            [-122.262335, 37.841001],
            [-122.262437, 37.840953],
            [-122.262577, 37.84089],
            [-122.262721, 37.840818],
            [-122.262872, 37.840737],
            [-122.263007, 37.840665],
            [-122.263158, 37.840567],
            [-122.263312, 37.840471],
            [-122.263383, 37.840424],
            [-122.263466, 37.840369],
            [-122.26358, 37.840286],
            [-122.263696, 37.8402],
            [-122.263846, 37.840079],
            [-122.263985, 37.839962],
            [-122.264121, 37.83984],
            [-122.264219, 37.839736],
            [-122.264333, 37.839628],
            [-122.264435, 37.839517],
            [-122.264553, 37.839378],
            [-122.264616, 37.839303],
            [-122.2647, 37.839194],
            [-122.264797, 37.839055],
            [-122.264888, 37.838934],
            [-122.264962, 37.838812],
            [-122.265035, 37.838697],
            [-122.265115, 37.838542],
            [-122.265151, 37.838467],
            [-122.265228, 37.83831],
            [-122.265286, 37.838169],
            [-122.265343, 37.838018],
            [-122.265376, 37.837926],
            [-122.265434, 37.837748],
            [-122.265506, 37.837498],
            [-122.265559, 37.837282],
            [-122.265609, 37.837041],
            [-122.265703, 37.836541],
            [-122.265822, 37.835868],
            [-122.265861, 37.835581],
            [-122.265932, 37.835121],
            [-122.265967, 37.834891],
            [-122.26608, 37.834117],
            [-122.266182, 37.833521],
            [-122.266209, 37.833347],
            [-122.266223, 37.833272]
          ],
          [
            [-122.266223, 37.833272],
            [-122.266242, 37.833187],
            [-122.266289, 37.832956],
            [-122.266551, 37.831691],
            [-122.266637, 37.831245],
            [-122.26672, 37.830865],
            [-122.266969, 37.829645],
            [-122.266993, 37.829541],
            [-122.26701, 37.829461],
            [-122.2674, 37.827569],
            [-122.267504, 37.827066],
            [-122.267547, 37.826888],
            [-122.267602, 37.826666],
            [-122.26769, 37.826358],
            [-122.267849, 37.825838],
            [-122.268149, 37.824951],
            [-122.268228, 37.824702],
            [-122.268284, 37.824541],
            [-122.268331, 37.824388],
            [-122.26836, 37.824292],
            [-122.268384, 37.824222],
            [-122.26841, 37.824145],
            [-122.26843, 37.824084],
            [-122.268459, 37.823999],
            [-122.268482, 37.823931],
            [-122.2685, 37.823877],
            [-122.268547, 37.823729],
            [-122.26858, 37.823624],
            [-122.268612, 37.82349],
            [-122.268674, 37.823233],
            [-122.268719, 37.823044],
            [-122.268774, 37.822819],
            [-122.268855, 37.822479],
            [-122.268918, 37.822252],
            [-122.269016, 37.821886],
            [-122.269583, 37.819828],
            [-122.269692, 37.819431],
            [-122.269854, 37.818831],
            [-122.27016, 37.817787],
            [-122.270474, 37.816811],
            [-122.270625, 37.816364],
            [-122.270726, 37.816043],
            [-122.270784, 37.815843],
            [-122.270811, 37.815732],
            [-122.270865, 37.815487],
            [-122.270876, 37.815432],
            [-122.270896, 37.815301],
            [-122.27093, 37.81504],
            [-122.270936, 37.814932],
            [-122.270938, 37.814854],
            [-122.270938, 37.814854],
            [-122.270858, 37.814403],
            [-122.270767, 37.814035],
            [-122.270547, 37.813539],
            [-122.270027, 37.812683],
            [-122.268951, 37.811691],
            [-122.267838, 37.810589],
            [-122.267688, 37.810365],
            [-122.267591, 37.810093],
            [-122.268034, 37.809454],
            [-122.268034, 37.809454],
            [-122.268106, 37.809342],
            [-122.268211, 37.809176],
            [-122.268251, 37.809113],
            [-122.26828, 37.809066],
            [-122.268426, 37.808835],
            [-122.269092, 37.80776],
            [-122.269489, 37.807113],
            [-122.269779, 37.80664],
            [-122.270603, 37.805288],
            [-122.271205, 37.8043],
            [-122.271335, 37.804087],
            [-122.271633, 37.803634],
            [-122.27206, 37.802936],
            [-122.272386, 37.802362]
          ],
          [
            [-122.276856, 37.798527],
            [-122.276827, 37.798521],
            [-122.276602, 37.798505],
            [-122.276496, 37.798504],
            [-122.276426, 37.798505],
            [-122.27637, 37.798508],
            [-122.276299, 37.798511],
            [-122.276219, 37.798509],
            [-122.276139, 37.798509],
            [-122.27606, 37.798511],
            [-122.27598, 37.798516],
            [-122.2759, 37.798523],
            [-122.275821, 37.798533],
            [-122.275742, 37.798546],
            [-122.275664, 37.798561],
            [-122.275586, 37.798578],
            [-122.275509, 37.798598],
            [-122.275432, 37.79862],
            [-122.275356, 37.798644],
            [-122.275281, 37.798671],
            [-122.275207, 37.798701],
            [-122.275133, 37.798732],
            [-122.275061, 37.798766],
            [-122.27499, 37.798803],
            [-122.27492, 37.798841],
            [-122.274851, 37.798882],
            [-122.274783, 37.798924],
            [-122.274717, 37.798969],
            [-122.274653, 37.799016],
            [-122.27459, 37.799065],
            [-122.274528, 37.799116],
            [-122.274468, 37.799169],
            [-122.27441, 37.799223],
            [-122.274354, 37.79928],
            [-122.274299, 37.799338],
            [-122.274246, 37.799398],
            [-122.274239, 37.799405],
            [-122.274232, 37.799413],
            [-122.274225, 37.799421],
            [-122.274218, 37.799429],
            [-122.274211, 37.799437],
            [-122.274204, 37.799445],
            [-122.274198, 37.799452],
            [-122.274191, 37.79946],
            [-122.274184, 37.799468],
            [-122.274177, 37.799476],
            [-122.274171, 37.799484],
            [-122.274164, 37.799492],
            [-122.274157, 37.7995],
            [-122.274151, 37.799508],
            [-122.274144, 37.799516],
            [-122.274138, 37.799524],
            [-122.274131, 37.799532],
            [-122.274125, 37.799541],
            [-122.274118, 37.799549],
            [-122.274112, 37.799557],
            [-122.274105, 37.799565],
            [-122.274099, 37.799573],
            [-122.274093, 37.799582],
            [-122.274086, 37.79959],
            [-122.27408, 37.799598],
            [-122.274074, 37.799606],
            [-122.274068, 37.799615],
            [-122.274062, 37.799623],
            [-122.274055, 37.799632],
            [-122.273734, 37.800156],
            [-122.273306, 37.800852],
            [-122.27275, 37.80177],
            [-122.27246, 37.802239],
            [-122.272386, 37.802362]
          ],
          [
            [-122.469106, 37.706105],
            [-122.468903, 37.706333],
            [-122.468809, 37.706437],
            [-122.468678, 37.706588],
            [-122.468434, 37.706903],
            [-122.468029, 37.707393],
            [-122.467923, 37.707522],
            [-122.467832, 37.707627],
            [-122.466801, 37.708779],
            [-122.466732, 37.708861],
            [-122.46667, 37.708939],
            [-122.4666, 37.709019],
            [-122.466526, 37.709095],
            [-122.466449, 37.709166],
            [-122.466376, 37.709237],
            [-122.466284, 37.709309],
            [-122.466215, 37.709364],
            [-122.466126, 37.709428],
            [-122.466028, 37.709493],
            [-122.465941, 37.709544],
            [-122.465846, 37.709608],
            [-122.465752, 37.709656],
            [-122.465664, 37.709709],
            [-122.465569, 37.709755],
            [-122.465466, 37.709801],
            [-122.465351, 37.709849],
            [-122.465245, 37.70989],
            [-122.465148, 37.709922],
            [-122.465035, 37.709958],
            [-122.464925, 37.709987],
            [-122.46481, 37.710013],
            [-122.464685, 37.710036],
            [-122.464576, 37.71006],
            [-122.464464, 37.710078],
            [-122.464349, 37.710097],
            [-122.464248, 37.710106],
            [-122.464125, 37.710117],
            [-122.464, 37.710122],
            [-122.463871, 37.710128],
            [-122.463753, 37.710132],
            [-122.463654, 37.710127],
            [-122.462673, 37.710117],
            [-122.461932, 37.710109],
            [-122.461456, 37.710106],
            [-122.461205, 37.710107],
            [-122.460612, 37.710103],
            [-122.460513, 37.710103],
            [-122.460089, 37.7101],
            [-122.459798, 37.710097],
            [-122.459371, 37.710095],
            [-122.458818, 37.710096],
            [-122.458429, 37.710097],
            [-122.458239, 37.710103],
            [-122.458046, 37.710114],
            [-122.457854, 37.710123],
            [-122.457689, 37.710132],
            [-122.457494, 37.710148],
            [-122.457301, 37.710168],
            [-122.45712, 37.710193],
            [-122.456943, 37.71022],
            [-122.456714, 37.710261],
            [-122.45647, 37.710314],
            [-122.456253, 37.710367],
            [-122.456029, 37.710421],
            [-122.455812, 37.710483],
            [-122.455588, 37.710559],
            [-122.455342, 37.710654],
            [-122.455158, 37.710734],
            [-122.454985, 37.71082],
            [-122.454815, 37.710906],
            [-122.454757, 37.710939],
            [-122.454638, 37.711002],
            [-122.454466, 37.711098],
            [-122.454306, 37.711201],
            [-122.454132, 37.711315],
            [-122.453978, 37.711421],
            [-122.453808, 37.711542],
            [-122.453514, 37.711768],
            [-122.453207, 37.712002],
            [-122.452952, 37.712213],
            [-122.452635, 37.712477],
            [-122.45215, 37.712868],
            [-122.451705, 37.713224],
            [-122.451441, 37.713439],
            [-122.451107, 37.713707],
            [-122.450884, 37.713896],
            [-122.450715, 37.714043],
            [-122.450556, 37.714184],
            [-122.450426, 37.714317],
            [-122.450264, 37.714469],
            [-122.450109, 37.714616],
            [-122.449961, 37.714764],
            [-122.449842, 37.714875],
            [-122.449687, 37.715039],
            [-122.449586, 37.715155],
            [-122.449493, 37.715256],
            [-122.449409, 37.715351],
            [-122.449317, 37.71545],
            [-122.449226, 37.715551],
            [-122.449141, 37.715654],
            [-122.449058, 37.71576],
            [-122.448989, 37.715852],
            [-122.448913, 37.715962],
            [-122.448844, 37.716072],
            [-122.448783, 37.716173],
            [-122.448722, 37.716283],
            [-122.448661, 37.716398],
            [-122.448609, 37.716502],
            [-122.448567, 37.716602],
            [-122.448514, 37.716725],
            [-122.448431, 37.716914],
            [-122.448349, 37.717127],
            [-122.448303, 37.717282],
            [-122.448233, 37.71749],
            [-122.448165, 37.717655],
            [-122.448122, 37.717956],
            [-122.448092, 37.718172],
            [-122.448092, 37.718314],
            [-122.448061, 37.718552],
            [-122.448055, 37.718621],
            [-122.448051, 37.718656],
            [-122.448034, 37.718801],
            [-122.448005, 37.719277],
            [-122.447846, 37.720179],
            [-122.447631, 37.721123],
            [-122.447624, 37.721147],
            [-122.447593, 37.721264],
            [-122.447372, 37.722221],
            [-122.447196, 37.723],
            [-122.446967, 37.723855],
            [-122.446671, 37.724539],
            [-122.446363, 37.725104],
            [-122.446308, 37.725188],
            [-122.446245, 37.72529],
            [-122.446186, 37.725395],
            [-122.44613, 37.725479],
            [-122.446059, 37.725571],
            [-122.445995, 37.725663],
            [-122.44593, 37.725755],
            [-122.445865, 37.725839],
            [-122.445526, 37.726234],
            [-122.445164, 37.726612],
            [-122.445034, 37.726729],
            [-122.444943, 37.726806],
            [-122.444845, 37.726909],
            [-122.444723, 37.727013],
            [-122.44461, 37.727109],
            [-122.444507, 37.727194],
            [-122.444392, 37.727285],
            [-122.444267, 37.727381],
            [-122.443613, 37.727828],
            [-122.443394, 37.727959],
            [-122.44319, 37.728081],
            [-122.442962, 37.728209],
            [-122.442869, 37.728256],
            [-122.442575, 37.728409],
            [-122.442264, 37.72856],
            [-122.441807, 37.728764],
            [-122.441408, 37.728925],
            [-122.440789, 37.729147],
            [-122.43985, 37.729516],
            [-122.439205, 37.72978],
            [-122.43892, 37.72988],
            [-122.438031, 37.730328],
            [-122.437495, 37.730633],
            [-122.437173, 37.730829],
            [-122.436901, 37.731003],
            [-122.43666, 37.731183],
            [-122.436385, 37.731366],
            [-122.436179, 37.731508],
            [-122.43605, 37.731595],
            [-122.435966, 37.731656],
            [-122.435706, 37.731839],
            [-122.435447, 37.732004],
            [-122.435241, 37.732136],
            [-122.435117, 37.732222],
            [-122.435026, 37.732295],
            [-122.434642, 37.732542],
            [-122.434329, 37.732752],
            [-122.433801, 37.733121],
            [-122.433405, 37.733368],
            [-122.432847, 37.733721],
            [-122.432582, 37.733918],
            [-122.431811, 37.734415],
            [-122.431274, 37.734758],
            [-122.430172, 37.735479],
            [-122.428873, 37.736323],
            [-122.427615, 37.737145],
            [-122.426334, 37.737984],
            [-122.425826, 37.738339],
            [-122.425538, 37.738547],
            [-122.425326, 37.738713],
            [-122.424999, 37.73895],
            [-122.424828, 37.739072],
            [-122.424649, 37.739215],
            [-122.424537, 37.739296],
            [-122.424351, 37.739428],
            [-122.42411, 37.739622],
            [-122.424011, 37.739738],
            [-122.423827, 37.739869],
            [-122.423179, 37.740563],
            [-122.422476, 37.741588],
            [-122.422061, 37.742264],
            [-122.420958, 37.743961],
            [-122.419834, 37.745675],
            [-122.419392, 37.746361],
            [-122.418916, 37.747089],
            [-122.418687, 37.747518],
            [-122.41859, 37.747722],
            [-122.418544, 37.747813],
            [-122.41849, 37.747912],
            [-122.418397, 37.748166],
            [-122.41836, 37.748248],
            [-122.418323, 37.748339],
            [-122.41829, 37.748442],
            [-122.418259, 37.748552],
            [-122.418218, 37.748731],
            [-122.418186, 37.748868],
            [-122.41816, 37.749093],
            [-122.418301, 37.75055],
            [-122.41844, 37.752086],
            [-122.418615, 37.753786],
            [-122.418742, 37.755411],
            [-122.4189, 37.756821],
            [-122.418962, 37.757461],
            [-122.419053, 37.758554],
            [-122.419231, 37.76021],
            [-122.419372, 37.761849],
            [-122.419543, 37.763429],
            [-122.41967, 37.764723],
            [-122.419692, 37.765024],
            [-122.419854, 37.766637],
            [-122.419892, 37.767184],
            [-122.419996, 37.768204],
            [-122.420043, 37.768923],
            [-122.420062, 37.769113],
            [-122.420119, 37.769442],
            [-122.420128, 37.769528],
            [-122.42014, 37.769621],
            [-122.420147, 37.76977],
            [-122.420152, 37.769886],
            [-122.420176, 37.770065],
            [-122.420215, 37.770362],
            [-122.420327, 37.771558],
            [-122.420316, 37.771965],
            [-122.420322, 37.772277],
            [-122.420317, 37.772531],
            [-122.420281, 37.772812],
            [-122.420153, 37.773345],
            [-122.420104, 37.773593],
            [-122.420038, 37.773762],
            [-122.419906, 37.774022],
            [-122.419471, 37.774777],
            [-122.419429, 37.774913],
            [-122.419406, 37.774983],
            [-122.419377, 37.775045],
            [-122.419321, 37.775113],
            [-122.419239, 37.775191],
            [-122.418701, 37.775596],
            [-122.417492, 37.776574],
            [-122.41652, 37.777348],
            [-122.416228, 37.77756],
            [-122.414798, 37.7787],
            [-122.412528, 37.780489],
            [-122.41145, 37.781351],
            [-122.410319, 37.782234],
            [-122.408084, 37.784002],
            [-122.405876, 37.785769],
            [-122.404718, 37.786653],
            [-122.404003, 37.787215],
            [-122.403499, 37.787631],
            [-122.402875, 37.788109],
            [-122.402102, 37.788723],
            [-122.401386, 37.789267],
            [-122.399138, 37.791042],
            [-122.398258, 37.791728],
            [-122.397415, 37.792407],
            [-122.396506, 37.793169],
            [-122.395321, 37.794057],
            [-122.394828, 37.794362],
            [-122.394659, 37.794469],
            [-122.394508, 37.79455],
            [-122.394366, 37.794631],
            [-122.394072, 37.794782],
            [-122.393814, 37.794904],
            [-122.393498, 37.79506],
            [-122.393151, 37.795219],
            [-122.392537, 37.795517],
            [-122.391751, 37.795841],
            [-122.391448, 37.795976],
            [-122.391302, 37.796041],
            [-122.390733, 37.796294],
            [-122.38985, 37.796687],
            [-122.389027, 37.797053],
            [-122.388439, 37.797315],
            [-122.387975, 37.797522],
            [-122.387476, 37.797743],
            [-122.386946, 37.797979],
            [-122.386305, 37.798265],
            [-122.385701, 37.798534],
            [-122.385193, 37.79876],
            [-122.384824, 37.798924],
            [-122.38453, 37.799055],
            [-122.384152, 37.799223],
            [-122.383849, 37.799358],
            [-122.383682, 37.799432],
            [-122.383442, 37.799539],
            [-122.383164, 37.799663],
            [-122.382839, 37.799808],
            [-122.382558, 37.799933],
            [-122.382295, 37.80005],
            [-122.381886, 37.800232],
            [-122.381553, 37.80038],
            [-122.381386, 37.800454],
            [-122.381017, 37.800618],
            [-122.380655, 37.800779],
            [-122.380293, 37.800941],
            [-122.379997, 37.801072],
            [-122.379566, 37.801264],
            [-122.379333, 37.801367],
            [-122.379061, 37.801484],
            [-122.378788, 37.801599],
            [-122.378485, 37.801723],
            [-122.378206, 37.801835],
            [-122.377961, 37.801929],
            [-122.377783, 37.801997],
            [-122.377556, 37.802081],
            [-122.377278, 37.802182],
            [-122.377102, 37.802244],
            [-122.376862, 37.802327],
            [-122.376663, 37.802394],
            [-122.37642, 37.802474],
            [-122.376049, 37.802592],
            [-122.375907, 37.802636],
            [-122.375677, 37.802705],
            [-122.375582, 37.802734],
            [-122.374975, 37.802906],
            [-122.374499, 37.803034],
            [-122.374181, 37.803113],
            [-122.373835, 37.803197],
            [-122.373325, 37.803313],
            [-122.37284, 37.803416],
            [-122.372496, 37.803485],
            [-122.37218, 37.803544],
            [-122.372018, 37.803573],
            [-122.371873, 37.803599],
            [-122.371594, 37.803647],
            [-122.37109, 37.803733],
            [-122.370628, 37.803811],
            [-122.370395, 37.80385],
            [-122.370216, 37.803881],
            [-122.370018, 37.803914],
            [-122.369691, 37.803969],
            [-122.369393, 37.80402],
            [-122.369234, 37.804047],
            [-122.368983, 37.804089],
            [-122.36873, 37.804132],
            [-122.368345, 37.804197],
            [-122.367904, 37.804272],
            [-122.367638, 37.804317],
            [-122.367375, 37.804361],
            [-122.367188, 37.804393],
            [-122.366998, 37.804425],
            [-122.366678, 37.804479],
            [-122.366367, 37.804532],
            [-122.366027, 37.804589],
            [-122.365735, 37.804639],
            [-122.365328, 37.804708],
            [-122.365107, 37.804745],
            [-122.364819, 37.804794],
            [-122.364621, 37.804827],
            [-122.364322, 37.804878],
            [-122.364022, 37.804929],
            [-122.363705, 37.804982],
            [-122.363326, 37.805046],
            [-122.363004, 37.805101],
            [-122.362666, 37.805158],
            [-122.362384, 37.805206],
            [-122.362149, 37.805246],
            [-122.361906, 37.805287],
            [-122.361806, 37.805303],
            [-122.361615, 37.805336],
            [-122.361334, 37.805383],
            [-122.361157, 37.805413],
            [-122.360916, 37.805454],
            [-122.360766, 37.805479],
            [-122.360571, 37.805512],
            [-122.360333, 37.805553],
            [-122.360139, 37.805586],
            [-122.359966, 37.805615],
            [-122.359805, 37.805642],
            [-122.359603, 37.805676],
            [-122.359438, 37.805704],
            [-122.359239, 37.805738],
            [-122.359127, 37.805757],
            [-122.358849, 37.805804],
            [-122.358639, 37.805839],
            [-122.358458, 37.80587],
            [-122.35819, 37.805915],
            [-122.358054, 37.805938],
            [-122.357891, 37.805966],
            [-122.357755, 37.805989],
            [-122.357578, 37.806019],
            [-122.357468, 37.806037],
            [-122.357171, 37.806087],
            [-122.356963, 37.806122],
            [-122.356845, 37.806143],
            [-122.35676, 37.806157],
            [-122.356589, 37.806186],
            [-122.356403, 37.806217],
            [-122.356282, 37.806238],
            [-122.356198, 37.806252],
            [-122.356066, 37.806274],
            [-122.355882, 37.806305],
            [-122.355686, 37.806339],
            [-122.355403, 37.806386],
            [-122.355272, 37.806408],
            [-122.355008, 37.806453],
            [-122.354917, 37.806468],
            [-122.35485, 37.80648],
            [-122.35476, 37.806495],
            [-122.354695, 37.806506],
            [-122.354525, 37.806535],
            [-122.354409, 37.806554],
            [-122.354325, 37.806569],
            [-122.354227, 37.806585],
            [-122.354086, 37.806609],
            [-122.354017, 37.806621],
            [-122.353947, 37.806633],
            [-122.353904, 37.80664],
            [-122.353765, 37.806663],
            [-122.353575, 37.806695],
            [-122.353343, 37.806735],
            [-122.353173, 37.806763],
            [-122.35303, 37.806788],
            [-122.352832, 37.806821],
            [-122.352675, 37.806848],
            [-122.352471, 37.806882],
            [-122.35208, 37.806948],
            [-122.351678, 37.807016],
            [-122.351343, 37.807073],
            [-122.351125, 37.80711],
            [-122.350989, 37.807133],
            [-122.350903, 37.807147],
            [-122.350826, 37.80716],
            [-122.350549, 37.807207],
            [-122.350215, 37.807264],
            [-122.349855, 37.807325],
            [-122.349491, 37.807386],
            [-122.349227, 37.807431],
            [-122.348673, 37.807524],
            [-122.34762, 37.807702],
            [-122.346954, 37.807817],
            [-122.346269, 37.807931],
            [-122.345982, 37.807981],
            [-122.345735, 37.808021],
            [-122.34529, 37.808096],
            [-122.344754, 37.808186],
            [-122.342008, 37.808651],
            [-122.341598, 37.80872],
            [-122.341341, 37.808763],
            [-122.340242, 37.808948],
            [-122.339687, 37.809041],
            [-122.339143, 37.809133],
            [-122.338773, 37.809194],
            [-122.338187, 37.809285],
            [-122.337648, 37.809363],
            [-122.337162, 37.809429],
            [-122.336553, 37.809505],
            [-122.336131, 37.809552],
            [-122.3358, 37.809588],
            [-122.335224, 37.809645],
            [-122.334668, 37.809694],
            [-122.334142, 37.809735],
            [-122.333583, 37.809772],
            [-122.33315, 37.809797],
            [-122.332755, 37.809816],
            [-122.332116, 37.809842],
            [-122.33108, 37.809866],
            [-122.330735, 37.80987],
            [-122.330014, 37.80987],
            [-122.329757, 37.809867],
            [-122.329449, 37.809862],
            [-122.32917, 37.809857],
            [-122.328638, 37.809842],
            [-122.328189, 37.809825],
            [-122.328029, 37.809818],
            [-122.327321, 37.809778],
            [-122.326497, 37.809718],
            [-122.326137, 37.809687],
            [-122.325817, 37.809649],
            [-122.323554, 37.809392],
            [-122.322814, 37.809368],
            [-122.322059, 37.809327],
            [-122.320701, 37.80925],
            [-122.320136, 37.80922],
            [-122.31951, 37.809162],
            [-122.318885, 37.809106],
            [-122.316062, 37.808815],
            [-122.315696, 37.808781],
            [-122.315482, 37.808758],
            [-122.315185, 37.808731],
            [-122.314429, 37.808664],
            [-122.312583, 37.808473],
            [-122.312057, 37.808422],
            [-122.308982, 37.808129],
            [-122.308486, 37.808084],
            [-122.308295, 37.808064],
            [-122.306411, 37.807806],
            [-122.305541, 37.807685],
            [-122.305182, 37.807598],
            [-122.30506, 37.807577],
            [-122.304526, 37.807461],
            [-122.30445, 37.807442],
            [-122.304175, 37.807385],
            [-122.303977, 37.807343],
            [-122.303794, 37.807301],
            [-122.302436, 37.806996],
            [-122.302398, 37.806989],
            [-122.298135, 37.806031],
            [-122.297836, 37.805959],
            [-122.297584, 37.805879],
            [-122.297324, 37.805794],
            [-122.297073, 37.805706],
            [-122.296836, 37.805615],
            [-122.296599, 37.805523],
            [-122.296356, 37.805421],
            [-122.296134, 37.805318],
            [-122.296096, 37.805302],
            [-122.295089, 37.804897],
            [-122.293883, 37.80441],
            [-122.29341, 37.804204],
            [-122.292579, 37.803875],
            [-122.292563, 37.803872],
            [-122.29206, 37.803669],
            [-122.291923, 37.803616],
            [-122.291747, 37.803548],
            [-122.291663, 37.803513],
            [-122.291564, 37.803468],
            [-122.291335, 37.803381],
            [-122.29132, 37.803376],
            [-122.291312, 37.803371],
            [-122.291297, 37.803365],
            [-122.291137, 37.803291],
            [-122.290946, 37.803223],
            [-122.284796, 37.801721],
            [-122.284606, 37.801668],
            [-122.284431, 37.801611],
            [-122.284095, 37.801496],
            [-122.283744, 37.801381],
            [-122.283645, 37.801347],
            [-122.283523, 37.801296],
            [-122.283386, 37.801237],
            [-122.283157, 37.801141],
            [-122.282943, 37.801045],
            [-122.282546, 37.800853],
            [-122.282294, 37.800744],
            [-122.282272, 37.800732],
            [-122.28218, 37.800693],
            [-122.281188, 37.800214],
            [-122.280051, 37.799664],
            [-122.280044, 37.79966],
            [-122.279952, 37.799607],
            [-122.279907, 37.799584],
            [-122.279716, 37.799493],
            [-122.279471, 37.799368],
            [-122.279183, 37.799217],
            [-122.278686, 37.798956],
            [-122.278478, 37.798859],
            [-122.278369, 37.798811],
            [-122.278197, 37.798746],
            [-122.278051, 37.798694],
            [-122.277819, 37.798637],
            [-122.277697, 37.798614],
            [-122.277507, 37.798583],
            [-122.277358, 37.798568],
            [-122.276984, 37.798532],
            [-122.276923, 37.798528],
            [-122.276856, 37.798527]
          ],
          [
            [-122.466727, 37.684953],
            [-122.467276, 37.685356],
            [-122.467791, 37.685769],
            [-122.468086, 37.686119],
            [-122.468184, 37.686287],
            [-122.468285, 37.686457],
            [-122.468473, 37.68675],
            [-122.468667, 37.687103],
            [-122.468809, 37.687399],
            [-122.468959, 37.687724],
            [-122.469114, 37.688025],
            [-122.469228, 37.688263],
            [-122.469306, 37.688412],
            [-122.469413, 37.688604],
            [-122.469451, 37.68868],
            [-122.469482, 37.688755],
            [-122.46955, 37.688926],
            [-122.469611, 37.689098],
            [-122.469665, 37.689285],
            [-122.46971, 37.689477],
            [-122.469749, 37.68968],
            [-122.469779, 37.689901],
            [-122.469795, 37.690102],
            [-122.46981, 37.690338],
            [-122.469808, 37.690623],
            [-122.469825, 37.690832],
            [-122.469818, 37.691068],
            [-122.46982, 37.691295],
            [-122.469832, 37.69178],
            [-122.469833, 37.691812],
            [-122.46984, 37.691968],
            [-122.469855, 37.692544],
            [-122.469851, 37.693124],
            [-122.469835, 37.693391],
            [-122.469838, 37.69367],
            [-122.46984, 37.693948],
            [-122.469848, 37.694165],
            [-122.469856, 37.694261],
            [-122.469871, 37.694482],
            [-122.469894, 37.694687],
            [-122.469944, 37.694924],
            [-122.469987, 37.695075],
            [-122.470029, 37.695191],
            [-122.470073, 37.695321],
            [-122.470334, 37.696002],
            [-122.470462, 37.696332],
            [-122.470493, 37.696415],
            [-122.470511, 37.696473],
            [-122.470563, 37.696611],
            [-122.470682, 37.696913],
            [-122.470741, 37.697087],
            [-122.470871, 37.697466],
            [-122.470884, 37.697511],
            [-122.470916, 37.697629],
            [-122.470942, 37.697747],
            [-122.470957, 37.697838],
            [-122.470971, 37.697921],
            [-122.47098, 37.698007],
            [-122.470996, 37.698132],
            [-122.471008, 37.698336],
            [-122.47101, 37.698393],
            [-122.471006, 37.69852],
            [-122.471002, 37.698636],
            [-122.470998, 37.699043],
            [-122.471013, 37.699549],
            [-122.471023, 37.700169],
            [-122.471041, 37.700673],
            [-122.471052, 37.7012],
            [-122.47106, 37.701706],
            [-122.471064, 37.701856],
            [-122.471063, 37.701909],
            [-122.471067, 37.702173],
            [-122.471074, 37.702402],
            [-122.47108, 37.702639],
            [-122.471085, 37.70278],
            [-122.471081, 37.703002],
            [-122.471075, 37.703124],
            [-122.471063, 37.703206],
            [-122.471046, 37.703305],
            [-122.471016, 37.703421],
            [-122.470989, 37.703498],
            [-122.470959, 37.703591],
            [-122.470914, 37.703706],
            [-122.470846, 37.703849],
            [-122.470808, 37.703916],
            [-122.470779, 37.703972],
            [-122.470713, 37.704079],
            [-122.470583, 37.704263],
            [-122.470461, 37.704413],
            [-122.4703, 37.704608],
            [-122.470082, 37.704878],
            [-122.469934, 37.705059],
            [-122.469864, 37.705149],
            [-122.46976, 37.705276],
            [-122.469524, 37.705566],
            [-122.469423, 37.705687],
            [-122.469351, 37.705767],
            [-122.469106, 37.706105]
          ],
          [
            [-122.386655, 37.599782],
            [-122.386721, 37.599826],
            [-122.386987, 37.600082],
            [-122.387483, 37.600584],
            [-122.387696, 37.600796],
            [-122.388117, 37.601234],
            [-122.388787, 37.601899],
            [-122.389715, 37.602821],
            [-122.390234, 37.603307],
            [-122.390656, 37.603728],
            [-122.391122, 37.604193],
            [-122.391435, 37.6045],
            [-122.392204, 37.605233],
            [-122.392459, 37.605484],
            [-122.392981, 37.606019],
            [-122.393405, 37.606423],
            [-122.393745, 37.606752],
            [-122.394104, 37.607121],
            [-122.394396, 37.607411],
            [-122.395019, 37.607982],
            [-122.395445, 37.608416],
            [-122.395726, 37.608689],
            [-122.396003, 37.608957],
            [-122.396505, 37.609462],
            [-122.396853, 37.609811],
            [-122.397283, 37.610218],
            [-122.397707, 37.610639],
            [-122.397815, 37.610748],
            [-122.398332, 37.611257],
            [-122.398737, 37.611677],
            [-122.398866, 37.611829],
            [-122.399232, 37.612239],
            [-122.399469, 37.612547],
            [-122.399673, 37.612791],
            [-122.399816, 37.612964],
            [-122.400005, 37.613219],
            [-122.40019, 37.613484],
            [-122.400655, 37.614099],
            [-122.400809, 37.614317],
            [-122.401288, 37.614932],
            [-122.401645, 37.61541],
            [-122.402026, 37.615909],
            [-122.402329, 37.61632],
            [-122.402734, 37.616842],
            [-122.403059, 37.617274],
            [-122.403159, 37.617412],
            [-122.403482, 37.617826],
            [-122.404185, 37.618738],
            [-122.404687, 37.619429],
            [-122.404838, 37.619635],
            [-122.404945, 37.619781],
            [-122.405191, 37.620098],
            [-122.405634, 37.620702],
            [-122.405913, 37.621072],
            [-122.406123, 37.621365],
            [-122.406399, 37.621748],
            [-122.40655, 37.621948],
            [-122.406647, 37.622075],
            [-122.406818, 37.622328],
            [-122.407048, 37.622664],
            [-122.407201, 37.622907],
            [-122.407346, 37.623149],
            [-122.40764, 37.623538],
            [-122.407808, 37.623749],
            [-122.408078, 37.624106],
            [-122.408262, 37.624418],
            [-122.40848, 37.624752],
            [-122.40868, 37.625073],
            [-122.408929, 37.625483],
            [-122.409273, 37.626104],
            [-122.40947, 37.626419],
            [-122.409804, 37.627],
            [-122.410307, 37.627847],
            [-122.410538, 37.628272],
            [-122.411056, 37.629165],
            [-122.41148, 37.62992],
            [-122.411672, 37.630225],
            [-122.411909, 37.630664],
            [-122.412351, 37.631448],
            [-122.412497, 37.631688],
            [-122.41268, 37.631993],
            [-122.412775, 37.632167],
            [-122.412868, 37.632301],
            [-122.413103, 37.632709],
            [-122.41348, 37.633364],
            [-122.41365, 37.633687],
            [-122.413836, 37.633927],
            [-122.414039, 37.634292],
            [-122.414355, 37.634856],
            [-122.414708, 37.635469],
            [-122.415165, 37.636273],
            [-122.41549, 37.636822],
            [-122.415885, 37.637521],
            [-122.416411, 37.638367],
            [-122.416686, 37.638913],
            [-122.416983, 37.639438],
            [-122.417237, 37.639874],
            [-122.417473, 37.64031],
            [-122.417764, 37.640799],
            [-122.418178, 37.641489],
            [-122.418474, 37.641967],
            [-122.418611, 37.642212],
            [-122.419044, 37.642799],
            [-122.419639, 37.643561],
            [-122.420638, 37.644768],
            [-122.421338, 37.645655],
            [-122.421632, 37.645985],
            [-122.421809, 37.646193],
            [-122.422173, 37.646622],
            [-122.42266, 37.64716],
            [-122.422992, 37.647552],
            [-122.423255, 37.647852],
            [-122.424112, 37.648831],
            [-122.424499, 37.649253],
            [-122.424816, 37.649632],
            [-122.425071, 37.649901],
            [-122.425651, 37.650544],
            [-122.426269, 37.651204],
            [-122.426586, 37.651474],
            [-122.42674, 37.651596],
            [-122.427119, 37.651804],
            [-122.427977, 37.652324],
            [-122.42868, 37.652758],
            [-122.42953, 37.653266],
            [-122.430249, 37.653645],
            [-122.431587, 37.654355],
            [-122.43297, 37.655126],
            [-122.433503, 37.655414],
            [-122.434075, 37.655707],
            [-122.434354, 37.65586],
            [-122.435243, 37.656491],
            [-122.436224, 37.657237],
            [-122.436487, 37.657488],
            [-122.436819, 37.657818],
            [-122.43712, 37.658112],
            [-122.437662, 37.658669],
            [-122.438148, 37.659299],
            [-122.438396, 37.659623],
            [-122.438844, 37.660186],
            [-122.439284, 37.660718],
            [-122.440065, 37.661422],
            [-122.440281, 37.661599],
            [-122.440451, 37.661752],
            [-122.440707, 37.661942],
            [-122.441224, 37.662279],
            [-122.441766, 37.662676],
            [-122.442384, 37.663116],
            [-122.442964, 37.663502],
            [-122.443829, 37.66401],
            [-122.444363, 37.664328],
            [-122.444698, 37.66455],
            [-122.44533, 37.664973],
            [-122.446086, 37.665483],
            [-122.446569, 37.66579],
            [-122.446723, 37.665896],
            [-122.447202, 37.666243],
            [-122.447444, 37.666429],
            [-122.447734, 37.666663],
            [-122.448252, 37.667151],
            [-122.448492, 37.667392],
            [-122.448971, 37.667918],
            [-122.449348, 37.668414],
            [-122.449595, 37.668741],
            [-122.450034, 37.669376],
            [-122.450358, 37.669848],
            [-122.450805, 37.670495],
            [-122.451185, 37.67117],
            [-122.45139, 37.6715],
            [-122.451614, 37.671864],
            [-122.45178, 37.672032],
            [-122.452161, 37.672407],
            [-122.452625, 37.67286],
            [-122.453015, 37.673251],
            [-122.453539, 37.673757],
            [-122.453718, 37.673939],
            [-122.454356, 37.674569],
            [-122.454764, 37.674973],
            [-122.455485, 37.675425],
            [-122.456053, 37.675782],
            [-122.456609, 37.676257],
            [-122.456889, 37.676488],
            [-122.457171, 37.676727],
            [-122.457542, 37.677108],
            [-122.457737, 37.677313],
            [-122.457903, 37.677484],
            [-122.458269, 37.67786],
            [-122.458418, 37.678013],
            [-122.458949, 37.678518],
            [-122.459194, 37.678758],
            [-122.459724, 37.679272],
            [-122.460147, 37.679686],
            [-122.460462, 37.679992],
            [-122.460925, 37.680441],
            [-122.461428, 37.680942],
            [-122.462044, 37.681564],
            [-122.462282, 37.681772],
            [-122.462617, 37.682144],
            [-122.463067, 37.682468],
            [-122.463327, 37.68265],
            [-122.463441, 37.682734],
            [-122.463563, 37.682817],
            [-122.463861, 37.683022],
            [-122.464151, 37.683224],
            [-122.465059, 37.683883],
            [-122.465089, 37.683902],
            [-122.465768, 37.684349],
            [-122.466727, 37.684953]
          ],
          [
            [-122.392604, 37.616029],
            [-122.39316, 37.615899],
            [-122.394211, 37.615653],
            [-122.394879, 37.615632],
            [-122.395393, 37.615625],
            [-122.395757, 37.615619],
            [-122.396337, 37.615623],
            [-122.396751, 37.615627],
            [-122.397311, 37.615639],
            [-122.397686, 37.615645],
            [-122.398004, 37.61564],
            [-122.398469, 37.615641],
            [-122.398924, 37.61566],
            [-122.399647, 37.615699],
            [-122.40019, 37.615773],
            [-122.400629, 37.615881],
            [-122.400993, 37.616]
          ],
          [
            [-122.394208, 37.615656],
            [-122.394307, 37.615647],
            [-122.39487, 37.615607],
            [-122.3957, 37.615596],
            [-122.396902, 37.615596],
            [-122.397654, 37.615572],
            [-122.39827, 37.615514],
            [-122.398487, 37.615453],
            [-122.398597, 37.615423],
            [-122.398814, 37.615336],
            [-122.398959, 37.615264],
            [-122.39913, 37.615157],
            [-122.399239, 37.615086],
            [-122.399404, 37.61495],
            [-122.399567, 37.614761],
            [-122.399671, 37.614614],
            [-122.399722, 37.614507],
            [-122.399838, 37.614246],
            [-122.39987, 37.614087],
            [-122.399876, 37.613952],
            [-122.399879, 37.613814],
            [-122.399851, 37.613635],
            [-122.399811, 37.613464],
            [-122.399774, 37.613352],
            [-122.399698, 37.613176],
            [-122.399612, 37.613027],
            [-122.399534, 37.612906],
            [-122.399232, 37.612239]
          ]
        ]
      }
    }
  ]
};
